if (function() {
    var t, e = "Expected a function",
        n = 1,
        i = 2,
        r = 1,
        o = 9007199254740991,
        s = "[object Arguments]",
        a = "[object Array]",
        l = "[object AsyncFunction]",
        u = "[object Boolean]",
        c = "[object Date]",
        d = "[object Error]",
        h = "[object Function]",
        p = "[object GeneratorFunction]",
        f = "[object Number]",
        m = "[object Object]",
        g = "[object Proxy]",
        y = "[object RegExp]",
        v = "[object String]",
        _ = /[&<>"']/g,
        b = RegExp(_.source),
        w = /^(?:0|[1-9]\d*)$/,
        x = "object" == typeof global && global && global.Object === Object && global,
        S = "object" == typeof self && self && self.Object === Object && self,
        T = x || S || Function("return this")(),
        k = "object" == typeof exports && exports && !exports.nodeType && exports,
        C = k && "object" == typeof module && module && !module.nodeType && module;

    function E(t, e) {
        return t.push.apply(t, e), t
    }

    function A(e) {
        return function(n) {
            return null == n ? t : n[e]
        }
    }
    var D, P, O, I = (D = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;"
        }, function(e) {
            return null == D ? t : D[e]
        }),
        M = Array.prototype,
        L = Object.prototype,
        j = L.hasOwnProperty,
        N = 0,
        $ = L.toString,
        z = T._,
        F = Object.create,
        R = L.propertyIsEnumerable,
        H = T.isFinite,
        q = (P = Object.keys, O = Object, function(t) {
            return P(O(t))
        }),
        B = Math.max;

    function U(t) {
        return t instanceof X ? t : new X(t)
    }
    var W = function() {
        function e() {}
        return function(n) {
            if (!Ft(n)) return {};
            if (F) return F(n);
            e.prototype = n;
            var i = new e;
            return e.prototype = t, i
        }
    }();

    function X(t, e) {
        this.__wrapped__ = t, this.__actions__ = [], this.__chain__ = !!e
    }

    function Y(t, e, n) {
        t[e] = n
    }

    function Z(n, i, r) {
        if ("function" != typeof n) throw new TypeError(e);
        return setTimeout(function() {
            n.apply(t, r)
        }, i)
    }
    X.prototype = W(U.prototype), X.prototype.constructor = X;
    var V, G = (V = et, function(t, e) {
        if (null == t) return t;
        if (!$t(t)) return V(t, e);
        for (var n = t.length, i = -1, r = Object(t); ++i < n && !1 !== e(r[i], i, r););
        return t
    });

    function Q(e, n, i) {
        for (var r = -1, o = e.length; ++r < o;) {
            var s = e[r],
                a = n(s);
            if (null != a && (l === t ? a == a : i(a, l))) var l = a,
                u = s
        }
        return u
    }

    function K(t, e) {
        var n = [];
        return G(t, function(t, i, r) {
            e(t, i, r) && n.push(t)
        }), n
    }

    function J(t, e, n, i, r) {
        var o = -1,
            s = t.length;
        for (n || (n = vt), r || (r = []); ++o < s;) {
            var a = t[o];
            e > 0 && n(a) ? e > 1 ? J(a, e - 1, n, i, r) : E(r, a) : i || (r[r.length] = a)
        }
        return r
    }
    var tt = function(t, e, n) {
        for (var i = -1, r = Object(t), o = n(t), s = o.length; s--;) {
            var a = o[++i];
            if (!1 === e(r[a], a, r)) break
        }
        return t
    };

    function et(t, e) {
        return t && tt(t, e, Gt)
    }

    function nt(t, e) {
        return K(e, function(e) {
            return zt(t[e])
        })
    }

    function it(t) {
        return e = t, $.call(e);
        var e
    }

    function rt(t, e) {
        return t > e
    }
    var ot = re;

    function st(e, r, o, l, h) {
        return e === r || (null == e || null == r || !Rt(e) && !Rt(r) ? e != e && r != r : function(e, r, o, l, h, p) {
            var g = Nt(e),
                _ = Nt(r),
                b = g ? a : it(e),
                w = _ ? a : it(r),
                x = (b = b == s ? m : b) == m,
                S = (w = w == s ? m : w) == m,
                T = b == w;
            p || (p = []);
            var k = Et(p, function(t) {
                    return t[0] == e
                }),
                C = Et(p, function(t) {
                    return t[0] == r
                });
            if (k && C) return k[1] == r;
            if (p.push([e, r]), p.push([r, e]), T && !x) {
                var E = g ? function(e, r, o, s, a, l) {
                    var u = o & n,
                        c = e.length,
                        d = r.length;
                    if (c != d && !(u && d > c)) return !1;
                    for (var h = -1, p = !0, f = o & i ? [] : t; ++h < c;) {
                        var m = e[h],
                            g = r[h];
                        if (void 0 !== t) {
                            p = !1;
                            break
                        }
                        if (f) {
                            if (!ft(r, function(t, e) {
                                    if (!kt(f, e) && (m === t || a(m, t, o, s, l))) return f.push(e)
                                })) {
                                p = !1;
                                break
                            }
                        } else if (m !== g && !a(m, g, o, s, l)) {
                            p = !1;
                            break
                        }
                    }
                    return p
                }(e, r, o, l, h, p) : function(t, e, n, i, r, o, s) {
                    switch (b) {
                        case u:
                        case c:
                        case f:
                            return Lt(+t, +e);
                        case d:
                            return t.name == e.name && t.message == e.message;
                        case y:
                        case v:
                            return t == e + ""
                    }
                    return !1
                }(e, r);
                return p.pop(), E
            }
            if (!(o & n)) {
                var A = x && j.call(e, "__wrapped__"),
                    D = S && j.call(r, "__wrapped__");
                if (A || D) {
                    E = h(A ? e.value() : e, D ? r.value() : r, o, l, p);
                    return p.pop(), E
                }
            }
            if (!T) return !1;
            E = function(e, i, r, o, s, a) {
                var l = r & n,
                    u = Gt(e),
                    c = u.length;
                if (c != Gt(i).length && !l) return !1;
                for (var d = c; d--;) {
                    var h = u[d];
                    if (!(l ? h in i : j.call(i, h))) return !1
                }
                for (var p = !0, f = l; ++d < c;) {
                    var m = e[h = u[d]],
                        g = i[h];
                    if (!(void 0 === t ? m === g || s(m, g, r, o, a) : void 0)) {
                        p = !1;
                        break
                    }
                    f || (f = "constructor" == h)
                }
                if (p && !f) {
                    var y = e.constructor,
                        v = i.constructor;
                    y != v && "constructor" in e && "constructor" in i && !("function" == typeof y && y instanceof y && "function" == typeof v && v instanceof v) && (p = !1)
                }
                return p
            }(e, r, o, l, h, p);
            return p.pop(), E
        }(e, r, o, l, st, h))
    }

    function at(t) {
        return "function" == typeof t ? t : null == t ? te : ("object" == typeof t ? ct : A)(t)
    }

    function lt(t, e) {
        return t < e
    }

    function ut(t, e) {
        var n = -1,
            i = $t(t) ? Array(t.length) : [];
        return G(t, function(t, r, o) {
            i[++n] = e(t, r, o)
        }), i
    }

    function ct(t) {
        var e = q(t);
        return function(r) {
            var o = e.length;
            if (null == r) return !o;
            for (r = Object(r); o--;) {
                var s = e[o];
                if (!(s in r && st(t[s], r[s], n | i))) return !1
            }
            return !0
        }
    }

    function dt(t, e) {
        return xt(wt(t, e, te), t + "")
    }

    function ht(t, e, n) {
        var i = -1,
            r = t.length;
        e < 0 && (e = -e > r ? 0 : r + e), (n = n > r ? r : n) < 0 && (n += r), r = e > n ? 0 : n - e >>> 0, e >>>= 0;
        for (var o = Array(r); ++i < r;) o[i] = t[i + e];
        return o
    }

    function pt(t) {
        return ht(t, 0, t.length)
    }

    function ft(t, e) {
        var n;
        return G(t, function(t, i, r) {
            return !(n = e(t, i, r))
        }), !!n
    }

    function mt(e, n, i, r) {
        var o = !i;
        i || (i = {});
        for (var s, a, l, u, c = -1, d = n.length; ++c < d;) {
            var h = n[c],
                p = r ? r(i[h], e[h], h, i, e) : t;
            p === t && (p = e[h]), o ? Y(i, h, p) : (l = p, u = (s = i)[a = h], j.call(s, a) && Lt(u, l) && (l !== t || a in s) || Y(s, a, l))
        }
        return i
    }

    function gt(e) {
        return dt(function(n, i) {
            var r = -1,
                o = i.length,
                s = o > 1 ? i[o - 1] : t;
            for (s = e.length > 3 && "function" == typeof s ? (o--, s) : t, n = Object(n); ++r < o;) {
                var a = i[r];
                a && e(n, a, r, s)
            }
            return n
        })
    }

    function yt(t, n, i, o) {
        if ("function" != typeof t) throw new TypeError(e);
        var s, a = n & r,
            l = (s = t, function() {
                var t = arguments,
                    e = W(s.prototype),
                    n = s.apply(e, t);
                return Ft(n) ? n : e
            });
        return function e() {
            for (var n = -1, r = arguments.length, s = -1, u = o.length, c = Array(u + r), d = this && this !== T && this instanceof e ? l : t; ++s < u;) c[s] = o[s];
            for (; r--;) c[s++] = arguments[++n];
            return d.apply(a ? i : this, c)
        }
    }

    function vt(t) {
        return Nt(t) || jt(t)
    }

    function _t(t, e, n) {
        if (!Ft(n)) return !1;
        var i, r, s, a = typeof e;
        return !!("number" == a ? $t(n) && (i = e, r = n.length, s = typeof i, (r = null == r ? o : r) && ("number" == s || "symbol" != s && w.test(i)) && i > -1 && i % 1 == 0 && i < r) : "string" == a && e in n) && Lt(n[e], t)
    }

    function bt(t) {
        var e = [];
        if (null != t)
            for (var n in Object(t)) e.push(n);
        return e
    }

    function wt(e, n, i) {
        return n = B(n === t ? e.length - 1 : n, 0),
            function() {
                for (var t = arguments, r = -1, o = B(t.length - n, 0), s = Array(o); ++r < o;) s[r] = t[n + r];
                r = -1;
                for (var a = Array(n + 1); ++r < n;) a[r] = t[r];
                return a[n] = i(s), e.apply(this, a)
            }
    }
    var xt = te;

    function St(t) {
        return null != t && t.length ? J(t, 1) : []
    }

    function Tt(e) {
        return e && e.length ? e[0] : t
    }

    function kt(t, e, n) {
        for (var i = null == t ? 0 : t.length, r = ((n = "number" == typeof n ? n < 0 ? B(i + n, 0) : n : 0) || 0) - 1, o = e == e; ++r < i;) {
            var s = t[r];
            if (o ? s === e : s != s) return r
        }
        return -1
    }
    var Ct, Et = (Ct = function(t, e, n) {
        var i = null == t ? 0 : t.length;
        if (!i) return -1;
        var r = null == n ? 0 : Bt(n);
        return r < 0 && (r = B(i + r, 0)),
            function(t, e, n, i) {
                for (var r = t.length, o = n + -1; ++o < r;)
                    if (e(t[o], o, t)) return o;
                return -1
            }(t, at(e), r)
    }, function(e, n, i) {
        var r = Object(e);
        if (!$t(e)) {
            var o = at(n);
            e = Gt(e), n = function(t) {
                return o(r[t], t, r)
            }
        }
        var s = Ct(e, n, i);
        return s > -1 ? r[o ? e[s] : s] : t
    });

    function At(t, e) {
        return G(t, at(e))
    }

    function Dt(t, e, n) {
        return i = t, r = at(e), o = n, s = arguments.length < 3, G(i, function(t, e, n) {
            o = s ? (s = !1, t) : r(o, t, e, n)
        }), o;
        var i, r, o, s
    }

    function Pt(n, i) {
        var r;
        if ("function" != typeof i) throw new TypeError(e);
        return n = Bt(n),
            function() {
                return --n > 0 && (r = i.apply(this, arguments)), n <= 1 && (i = t), r
            }
    }
    var Ot = dt(function(t, e, n) {
            return yt(t, 32 | r, e, n)
        }),
        It = dt(function(t, e) {
            return Z(t, 1, e)
        }),
        Mt = dt(function(t, e, n) {
            return Z(t, Ut(e) || 0, n)
        });

    function Lt(t, e) {
        return t === e || t != t && e != e
    }
    var jt = ot(function() {
            return arguments
        }()) ? ot : function(t) {
            return Rt(t) && j.call(t, "callee") && !R.call(t, "callee")
        },
        Nt = Array.isArray;

    function $t(t) {
        return null != t && "number" == typeof(e = t.length) && e > -1 && e % 1 == 0 && e <= o && !zt(t);
        var e
    }

    function zt(t) {
        if (!Ft(t)) return !1;
        var e = it(t);
        return e == h || e == p || e == l || e == g
    }

    function Ft(t) {
        var e = typeof t;
        return null != t && ("object" == e || "function" == e)
    }

    function Rt(t) {
        return null != t && "object" == typeof t
    }

    function Ht(t) {
        return "number" == typeof t || Rt(t) && it(t) == f
    }

    function qt(t) {
        return "string" == typeof t || !Nt(t) && Rt(t) && it(t) == v
    }
    var Bt = Number,
        Ut = Number;

    function Wt(t) {
        return "string" == typeof t ? t : null == t ? "" : t + ""
    }
    var Xt, Yt = gt(function(t, e) {
            mt(e, q(e), t)
        }),
        Zt = gt(function(t, e) {
            mt(e, bt(e), t)
        }),
        Vt = dt(function(e, n) {
            e = Object(e);
            var i = -1,
                r = n.length,
                o = r > 2 ? n[2] : t;
            for (o && _t(n[0], n[1], o) && (r = 1); ++i < r;)
                for (var s = n[i], a = Qt(s), l = -1, u = a.length; ++l < u;) {
                    var c = a[l],
                        d = e[c];
                    (d === t || Lt(d, L[c]) && !j.call(e, c)) && (e[c] = s[c])
                }
            return e
        }),
        Gt = q,
        Qt = bt,
        Kt = xt(wt(Xt = function(t, e) {
            return null == t ? {} : (n = t, i = e, n = Object(n), Dt(i, function(t, e) {
                return e in n && (t[e] = n[e]), t
            }, {}));
            var n, i
        }, t, St), Xt + "");

    function Jt(t) {
        return null == t ? [] : (e = t, ut(Gt(t), function(t) {
            return e[t]
        }));
        var e
    }

    function te(t) {
        return t
    }
    var ee, ne = at;

    function ie(t, e, n) {
        var i = Gt(e),
            r = nt(e, i);
        null != n || Ft(e) && (r.length || !i.length) || (n = e, e = t, t = this, r = nt(e, Gt(e)));
        var o = !(Ft(n) && "chain" in n && !n.chain),
            s = zt(t);
        return G(r, function(n) {
            var i = e[n];
            t[n] = i, s && (t.prototype[n] = function() {
                var e = this.__chain__;
                if (o || e) {
                    var n = t(this.__wrapped__);
                    return (n.__actions__ = pt(this.__actions__)).push({
                        func: i,
                        args: arguments,
                        thisArg: t
                    }), n.__chain__ = e, n
                }
                return i.apply(t, E([this.value()], arguments))
            })
        }), t
    }

    function re() {}
    U.assignIn = Zt, U.before = Pt, U.bind = Ot, U.chain = function(t) {
        var e = U(t);
        return e.__chain__ = !0, e
    }, U.compact = function(t) {
        return K(t, Boolean)
    }, U.concat = function() {
        var t = arguments.length;
        if (!t) return [];
        for (var e = Array(t - 1), n = arguments[0], i = t; i--;) e[i - 1] = arguments[i];
        return E(Nt(n) ? pt(n) : [n], J(e, 1))
    }, U.create = function(t, e) {
        var n = W(t);
        return null == e ? n : Yt(n, e)
    }, U.defaults = Vt, U.defer = It, U.delay = Mt, U.filter = function(t, e) {
        return K(t, at(e))
    }, U.flatten = St, U.flattenDeep = function(t) {
        return null != t && t.length ? J(t, 1 / 0) : []
    }, U.iteratee = ne, U.keys = Gt, U.map = function(t, e) {
        return ut(t, at(e))
    }, U.matches = function(t) {
        return ct(Yt({}, t))
    }, U.mixin = ie, U.negate = function(t) {
        if ("function" != typeof t) throw new TypeError(e);
        return function() {
            var e = arguments;
            return !t.apply(this, e)
        }
    }, U.once = function(t) {
        return Pt(2, t)
    }, U.pick = Kt, U.slice = function(e, n, i) {
        var r = null == e ? 0 : e.length;
        return n = null == n ? 0 : +n, i = i === t ? r : +i, r ? ht(e, n, i) : []
    }, U.sortBy = function(e, n) {
        var i = 0;
        return n = at(n), ut(ut(e, function(t, e, r) {
            return {
                value: t,
                index: i++,
                criteria: n(t, e, r)
            }
        }).sort(function(e, n) {
            return function(e, n) {
                if (e !== n) {
                    var i = e !== t,
                        r = null === e,
                        o = e == e,
                        s = n !== t,
                        a = null === n,
                        l = n == n;
                    if (!a && e > n || r && s && l || !i && l || !o) return 1;
                    if (!r && e < n || a && i && o || !s && o || !l) return -1
                }
                return 0
            }(e.criteria, n.criteria) || e.index - n.index
        }), A("value"))
    }, U.tap = function(t, e) {
        return e(t), t
    }, U.thru = function(t, e) {
        return e(t)
    }, U.toArray = function(t) {
        return $t(t) ? t.length ? pt(t) : [] : Jt(t)
    }, U.values = Jt, U.extend = Zt, ie(U, U), U.clone = function(t) {
        return Ft(t) ? Nt(t) ? pt(t) : mt(t, q(t)) : t
    }, U.escape = function(t) {
        return (t = Wt(t)) && b.test(t) ? t.replace(_, I) : t
    }, U.every = function(e, n, i) {
        return r = e, o = at(n = i ? t : n), s = !0, G(r, function(t, e, n) {
            return s = !!o(t, e, n)
        }), s;
        var r, o, s
    }, U.find = Et, U.forEach = At, U.has = function(t, e) {
        return null != t && j.call(t, e)
    }, U.head = Tt, U.identity = te, U.indexOf = kt, U.isArguments = jt, U.isArray = Nt, U.isBoolean = function(t) {
        return !0 === t || !1 === t || Rt(t) && it(t) == u
    }, U.isDate = function(t) {
        return Rt(t) && it(t) == c
    }, U.isEmpty = function(t) {
        return $t(t) && (Nt(t) || qt(t) || zt(t.splice) || jt(t)) ? !t.length : !q(t).length
    }, U.isEqual = function(t, e) {
        return st(t, e)
    }, U.isFinite = function(t) {
        return "number" == typeof t && H(t)
    }, U.isFunction = zt, U.isNaN = function(t) {
        return Ht(t) && t != +t
    }, U.isNull = function(t) {
        return null === t
    }, U.isNumber = Ht, U.isObject = Ft, U.isRegExp = function(t) {
        return Rt(t) && it(t) == y
    }, U.isString = qt, U.isUndefined = function(e) {
        return e === t
    }, U.last = function(e) {
        var n = null == e ? 0 : e.length;
        return n ? e[n - 1] : t
    }, U.max = function(e) {
        return e && e.length ? Q(e, te, rt) : t
    }, U.min = function(e) {
        return e && e.length ? Q(e, te, lt) : t
    }, U.noConflict = function() {
        return T._ === this && (T._ = z), this
    }, U.noop = re, U.reduce = Dt, U.result = function(e, n, i) {
        var r = null == e ? t : e[n];
        return r === t && (r = i), zt(r) ? r.call(e) : r
    }, U.size = function(t) {
        return null == t ? 0 : (t = $t(t) ? t : q(t)).length
    }, U.some = function(e, n, i) {
        return ft(e, at(n = i ? t : n))
    }, U.uniqueId = function(t) {
        var e = ++N;
        return Wt(t) + e
    }, U.each = At, U.first = Tt, ie(U, (ee = {}, et(U, function(t, e) {
        j.call(U.prototype, e) || (ee[e] = t)
    }), ee), {
        chain: !1
    }), U.VERSION = "4.17.10", G(["pop", "join", "replace", "reverse", "split", "push", "shift", "sort", "splice", "unshift"], function(t) {
        var e = (/^(?:replace|split)$/.test(t) ? String.prototype : M)[t],
            n = /^(?:push|sort|unshift)$/.test(t) ? "tap" : "thru",
            i = /^(?:pop|join|replace|shift)$/.test(t);
        U.prototype[t] = function() {
            var t = arguments;
            if (i && !this.__chain__) {
                var r = this.value();
                return e.apply(Nt(r) ? r : [], t)
            }
            return this[n](function(n) {
                return e.apply(Nt(n) ? n : [], t)
            })
        }
    }), U.prototype.toJSON = U.prototype.valueOf = U.prototype.value = function() {
        return t = this.__wrapped__, Dt(this.__actions__, function(t, e) {
            return e.func.apply(e.thisArg, E([t], e.args))
        }, t);
        var t
    }, "function" == typeof define && "object" == typeof define.amd && define.amd ? (T._ = U, define(function() {
        return U
    })) : C ? ((C.exports = U)._ = U, k._ = U) : T._ = U
}.call(this), void 0 === window.Shopify && (window.Shopify = {}), Shopify.bind = function(t, e) {
    return function() {
        return t.apply(e, arguments)
    }
}, Shopify.setSelectorByValue = function(t, e) {
    for (var n = 0, i = t.options.length; i > n; n++) {
        var r = t.options[n];
        if (e == r.value || e == r.innerHTML) return t.selectedIndex = n, n
    }
}, Shopify.addListener = function(t, e, n) {
    t.addEventListener ? t.addEventListener(e, n, !1) : t.attachEvent("on" + e, n)
}, Shopify.postLink = function(t, e) {
    var n = (e = e || {}).method || "post",
        i = e.parameters || {},
        r = document.createElement("form");
    for (var o in r.setAttribute("method", n), r.setAttribute("action", t), i) {
        var s = document.createElement("input");
        s.setAttribute("type", "hidden"), s.setAttribute("name", o), s.setAttribute("value", i[o]), r.appendChild(s)
    }
    document.body.appendChild(r), r.submit(), document.body.removeChild(r)
}, Shopify.CountryProvinceSelector = function(t, e, n) {
    this.countryEl = document.getElementById(t), this.provinceEl = document.getElementById(e), this.provinceContainer = document.getElementById(n.hideElement || e), Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)), this.initCountry(), this.initProvince()
}, Shopify.CountryProvinceSelector.prototype = {
    initCountry: function() {
        var t = this.countryEl.getAttribute("data-default");
        Shopify.setSelectorByValue(this.countryEl, t), this.countryHandler()
    },
    initProvince: function() {
        var t = this.provinceEl.getAttribute("data-default");
        t && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, t)
    },
    countryHandler: function(t) {
        var e = (r = this.countryEl.options[this.countryEl.selectedIndex]).getAttribute("data-provinces"),
            n = JSON.parse(e);
        if (this.clearOptions(this.provinceEl), n && 0 == n.length) this.provinceContainer.style.display = "none";
        else {
            for (var i = 0; i < n.length; i++) {
                var r;
                (r = document.createElement("option")).value = n[i][0], r.innerHTML = n[i][1], this.provinceEl.appendChild(r)
            }
            this.provinceContainer.style.display = ""
        }
    },
    clearOptions: function(t) {
        for (; t.firstChild;) t.removeChild(t.firstChild)
    },
    setOptions: function(t, e) {
        var n = 0;
        for (e.length; n < e.length; n++) {
            var i = document.createElement("option");
            i.value = e[n], i.innerHTML = e[n], t.appendChild(i)
        }
    }
}, Shopify.CustomerAddress = {
    toggleForm: function(t) {
        var e = document.getElementById("view_addresses"),
            n = document.getElementById("edit_address_" + t);
        return e.style.display = "none" == e.style.display ? "" : "none", n.style.display = "none" == n.style.display ? "" : "none", !1
    },
    toggleNewForm: function() {
        var t = document.getElementById("add_address"),
            e = document.getElementById("address_tables");
        return t.style.display = "none" == t.style.display ? "" : "none", e.style.display = "none" == t.style.display ? "" : "none", !1
    },
    destroy: function(t, e) {
        confirm(e || "Are you sure you wish to delete this address?") && Shopify.postLink("/account/addresses/" + t, {
            parameters: {
                _method: "delete"
            }
        })
    }
}, Shopify.queryParams = {}, location.search.length)
for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split("&"); i < aCouples.length; i++) aKeyValue = aCouples[i].split("="), aKeyValue.length > 1 && (Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]));
if (function(t, e, n) {
    var i = window.matchMedia;
    "undefined" != typeof module && module.exports ? module.exports = n(i) : "function" == typeof define && define.amd ? define(function() {
        return e[t] = n(i)
    }) : e[t] = n(i)
}("enquire", this, function(t) {
    "use strict";

    function e(t, e) {
        for (var n = 0, i = t.length; i > n && !1 !== e(t[n], n); n++);
    }

    function n(t) {
        return "function" == typeof t
    }

    function i(t) {
        this.options = t, !t.deferSetup && this.setup()
    }

    function r(e, n) {
        this.query = e, this.isUnconditional = n, this.handlers = [], this.mql = t(e);
        var i = this;
        this.listener = function(t) {
            i.mql = t, i.assess()
        }, this.mql.addListener(this.listener)
    }

    function o() {
        if (!t) throw new Error("matchMedia not present, legacy browsers require a polyfill");
        this.queries = {}, this.browserIsIncapable = !t("only all").matches
    }
    return i.prototype = {
        setup: function() {
            this.options.setup && this.options.setup(), this.initialised = !0
        },
        on: function() {
            !this.initialised && this.setup(), this.options.match && this.options.match()
        },
        off: function() {
            this.options.unmatch && this.options.unmatch()
        },
        destroy: function() {
            this.options.destroy ? this.options.destroy() : this.off()
        },
        equals: function(t) {
            return this.options === t || this.options.match === t
        }
    }, r.prototype = {
        addHandler: function(t) {
            var e = new i(t);
            this.handlers.push(e), this.matches() && e.on()
        },
        removeHandler: function(t) {
            var n = this.handlers;
            e(n, function(e, i) {
                return e.equals(t) ? (e.destroy(), !n.splice(i, 1)) : void 0
            })
        },
        matches: function() {
            return this.mql.matches || this.isUnconditional
        },
        clear: function() {
            e(this.handlers, function(t) {
                t.destroy()
            }), this.mql.removeListener(this.listener), this.handlers.length = 0
        },
        assess: function() {
            var t = this.matches() ? "on" : "off";
            e(this.handlers, function(e) {
                e[t]()
            })
        }
    }, o.prototype = {
        register: function(t, i, o) {
            var s, a = this.queries,
                l = o && this.browserIsIncapable;
            return a[t] || (a[t] = new r(t, l)), n(i) && (i = {
                match: i
            }), s = i, "[object Array]" === Object.prototype.toString.apply(s) || (i = [i]), e(i, function(e) {
                n(e) && (e = {
                    match: e
                }), a[t].addHandler(e)
            }), this
        },
        unregister: function(t, e) {
            var n = this.queries[t];
            return n && (e ? n.removeHandler(e) : (n.clear(), delete this.queries[t])), this
        }
    }, new o
}), function(t, e) {
    "object" == typeof module && "object" == typeof module.exports ? module.exports = t.document ? e(t, !0) : function(t) {
        if (!t.document) throw new Error("jQuery requires a window with a document");
        return e(t)
    } : e(t)
}("undefined" != typeof window ? window : this, function(t, e) {
    var n = [],
        i = t.document,
        r = n.slice,
        o = n.concat,
        s = n.push,
        a = n.indexOf,
        l = {},
        u = l.toString,
        c = l.hasOwnProperty,
        d = {},
        h = "2.2.3",
        p = function(t, e) {
            return new p.fn.init(t, e)
        },
        f = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
        m = /^-ms-/,
        g = /-([\da-z])/gi,
        y = function(t, e) {
            return e.toUpperCase()
        };

    function v(t) {
        var e = !!t && "length" in t && t.length,
            n = p.type(t);
        return "function" !== n && !p.isWindow(t) && ("array" === n || 0 === e || "number" == typeof e && e > 0 && e - 1 in t)
    }
    p.fn = p.prototype = {
        jquery: h,
        constructor: p,
        selector: "",
        length: 0,
        toArray: function() {
            return r.call(this)
        },
        get: function(t) {
            return null != t ? 0 > t ? this[t + this.length] : this[t] : r.call(this)
        },
        pushStack: function(t) {
            var e = p.merge(this.constructor(), t);
            return e.prevObject = this, e.context = this.context, e
        },
        each: function(t) {
            return p.each(this, t)
        },
        map: function(t) {
            return this.pushStack(p.map(this, function(e, n) {
                return t.call(e, n, e)
            }))
        },
        slice: function() {
            return this.pushStack(r.apply(this, arguments))
        },
        first: function() {
            return this.eq(0)
        },
        last: function() {
            return this.eq(-1)
        },
        eq: function(t) {
            var e = this.length,
                n = +t + (0 > t ? e : 0);
            return this.pushStack(n >= 0 && e > n ? [this[n]] : [])
        },
        end: function() {
            return this.prevObject || this.constructor()
        },
        push: s,
        sort: n.sort,
        splice: n.splice
    }, p.extend = p.fn.extend = function() {
        var t, e, n, i, r, o, s = arguments[0] || {},
            a = 1,
            l = arguments.length,
            u = !1;
        for ("boolean" == typeof s && (u = s, s = arguments[a] || {}, a++), "object" == typeof s || p.isFunction(s) || (s = {}), a === l && (s = this, a--); l > a; a++)
            if (null != (t = arguments[a]))
                for (e in t) n = s[e], s !== (i = t[e]) && (u && i && (p.isPlainObject(i) || (r = p.isArray(i))) ? (r ? (r = !1, o = n && p.isArray(n) ? n : []) : o = n && p.isPlainObject(n) ? n : {}, s[e] = p.extend(u, o, i)) : void 0 !== i && (s[e] = i));
        return s
    }, p.extend({
        expando: "jQuery" + (h + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function(t) {
            throw new Error(t)
        },
        noop: function() {},
        isFunction: function(t) {
            return "function" === p.type(t)
        },
        isArray: Array.isArray,
        isWindow: function(t) {
            return null != t && t === t.window
        },
        isNumeric: function(t) {
            var e = t && t.toString();
            return !p.isArray(t) && e - parseFloat(e) + 1 >= 0
        },
        isPlainObject: function(t) {
            var e;
            if ("object" !== p.type(t) || t.nodeType || p.isWindow(t)) return !1;
            if (t.constructor && !c.call(t, "constructor") && !c.call(t.constructor.prototype || {}, "isPrototypeOf")) return !1;
            for (e in t);
            return void 0 === e || c.call(t, e)
        },
        isEmptyObject: function(t) {
            var e;
            for (e in t) return !1;
            return !0
        },
        type: function(t) {
            return null == t ? t + "" : "object" == typeof t || "function" == typeof t ? l[u.call(t)] || "object" : typeof t
        },
        globalEval: function(t) {
            var e, n = eval;
            (t = p.trim(t)) && (1 === t.indexOf("use strict") ? ((e = i.createElement("script")).text = t, i.head.appendChild(e).parentNode.removeChild(e)) : n(t))
        },
        camelCase: function(t) {
            return t.replace(m, "ms-").replace(g, y)
        },
        nodeName: function(t, e) {
            return t.nodeName && t.nodeName.toLowerCase() === e.toLowerCase()
        },
        each: function(t, e) {
            var n, i = 0;
            if (v(t))
                for (n = t.length; n > i && !1 !== e.call(t[i], i, t[i]); i++);
            else
                for (i in t)
                    if (!1 === e.call(t[i], i, t[i])) break;
            return t
        },
        trim: function(t) {
            return null == t ? "" : (t + "").replace(f, "")
        },
        makeArray: function(t, e) {
            var n = e || [];
            return null != t && (v(Object(t)) ? p.merge(n, "string" == typeof t ? [t] : t) : s.call(n, t)), n
        },
        inArray: function(t, e, n) {
            return null == e ? -1 : a.call(e, t, n)
        },
        merge: function(t, e) {
            for (var n = +e.length, i = 0, r = t.length; n > i; i++) t[r++] = e[i];
            return t.length = r, t
        },
        grep: function(t, e, n) {
            for (var i = [], r = 0, o = t.length, s = !n; o > r; r++) !e(t[r], r) !== s && i.push(t[r]);
            return i
        },
        map: function(t, e, n) {
            var i, r, s = 0,
                a = [];
            if (v(t))
                for (i = t.length; i > s; s++) null != (r = e(t[s], s, n)) && a.push(r);
            else
                for (s in t) null != (r = e(t[s], s, n)) && a.push(r);
            return o.apply([], a)
        },
        guid: 1,
        proxy: function(t, e) {
            var n, i, o;
            return "string" == typeof e && (n = t[e], e = t, t = n), p.isFunction(t) ? (i = r.call(arguments, 2), (o = function() {
                return t.apply(e || this, i.concat(r.call(arguments)))
            }).guid = t.guid = t.guid || p.guid++, o) : void 0
        },
        now: Date.now,
        support: d
    }), "function" == typeof Symbol && (p.fn[Symbol.iterator] = n[Symbol.iterator]), p.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(t, e) {
        l["[object " + e + "]"] = e.toLowerCase()
    });
    var _ = function(t) {
        var e, n, i, r, o, s, a, l, u, c, d, h, p, f, m, g, y, v, _, b = "sizzle" + 1 * new Date,
            w = t.document,
            x = 0,
            S = 0,
            T = ot(),
            k = ot(),
            C = ot(),
            E = function(t, e) {
                return t === e && (d = !0), 0
            },
            A = 1 << 31,
            D = {}.hasOwnProperty,
            P = [],
            O = P.pop,
            I = P.push,
            M = P.push,
            L = P.slice,
            j = function(t, e) {
                for (var n = 0, i = t.length; i > n; n++)
                    if (t[n] === e) return n;
                return -1
            },
            N = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
            $ = "[\\x20\\t\\r\\n\\f]",
            z = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
            F = "\\[" + $ + "*(" + z + ")(?:" + $ + "*([*^$|!~]?=)" + $ + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + z + "))|)" + $ + "*\\]",
            R = ":(" + z + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + F + ")*)|.*)\\)|)",
            H = new RegExp($ + "+", "g"),
            q = new RegExp("^" + $ + "+|((?:^|[^\\\\])(?:\\\\.)*)" + $ + "+$", "g"),
            B = new RegExp("^" + $ + "*," + $ + "*"),
            U = new RegExp("^" + $ + "*([>+~]|" + $ + ")" + $ + "*"),
            W = new RegExp("=" + $ + "*([^\\]'\"]*?)" + $ + "*\\]", "g"),
            X = new RegExp(R),
            Y = new RegExp("^" + z + "$"),
            Z = {
                ID: new RegExp("^#(" + z + ")"),
                CLASS: new RegExp("^\\.(" + z + ")"),
                TAG: new RegExp("^(" + z + "|[*])"),
                ATTR: new RegExp("^" + F),
                PSEUDO: new RegExp("^" + R),
                CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + $ + "*(even|odd|(([+-]|)(\\d*)n|)" + $ + "*(?:([+-]|)" + $ + "*(\\d+)|))" + $ + "*\\)|)", "i"),
                bool: new RegExp("^(?:" + N + ")$", "i"),
                needsContext: new RegExp("^" + $ + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + $ + "*((?:-\\d)?\\d*)" + $ + "*\\)|)(?=[^-]|$)", "i")
            },
            V = /^(?:input|select|textarea|button)$/i,
            G = /^h\d$/i,
            Q = /^[^{]+\{\s*\[native \w/,
            K = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
            J = /[+~]/,
            tt = /'|\\/g,
            et = new RegExp("\\\\([\\da-f]{1,6}" + $ + "?|(" + $ + ")|.)", "ig"),
            nt = function(t, e, n) {
                var i = "0x" + e - 65536;
                return i != i || n ? e : 0 > i ? String.fromCharCode(i + 65536) : String.fromCharCode(i >> 10 | 55296, 1023 & i | 56320)
            },
            it = function() {
                h()
            };
        try {
            M.apply(P = L.call(w.childNodes), w.childNodes), P[w.childNodes.length].nodeType
        } catch (t) {
            M = {
                apply: P.length ? function(t, e) {
                    I.apply(t, L.call(e))
                } : function(t, e) {
                    for (var n = t.length, i = 0; t[n++] = e[i++];);
                    t.length = n - 1
                }
            }
        }

        function rt(t, e, i, r) {
            var o, a, u, c, d, f, y, v, x = e && e.ownerDocument,
                S = e ? e.nodeType : 9;
            if (i = i || [], "string" != typeof t || !t || 1 !== S && 9 !== S && 11 !== S) return i;
            if (!r && ((e ? e.ownerDocument || e : w) !== p && h(e), e = e || p, m)) {
                if (11 !== S && (f = K.exec(t)))
                    if (o = f[1]) {
                        if (9 === S) {
                            if (!(u = e.getElementById(o))) return i;
                            if (u.id === o) return i.push(u), i
                        } else if (x && (u = x.getElementById(o)) && _(e, u) && u.id === o) return i.push(u), i
                    } else {
                        if (f[2]) return M.apply(i, e.getElementsByTagName(t)), i;
                        if ((o = f[3]) && n.getElementsByClassName && e.getElementsByClassName) return M.apply(i, e.getElementsByClassName(o)), i
                    } if (n.qsa && !C[t + " "] && (!g || !g.test(t))) {
                    if (1 !== S) x = e, v = t;
                    else if ("object" !== e.nodeName.toLowerCase()) {
                        for ((c = e.getAttribute("id")) ? c = c.replace(tt, "\\$&") : e.setAttribute("id", c = b), a = (y = s(t)).length, d = Y.test(c) ? "#" + c : "[id='" + c + "']"; a--;) y[a] = d + " " + mt(y[a]);
                        v = y.join(","), x = J.test(t) && pt(e.parentNode) || e
                    }
                    if (v) try {
                        return M.apply(i, x.querySelectorAll(v)), i
                    } catch (t) {} finally {
                        c === b && e.removeAttribute("id")
                    }
                }
            }
            return l(t.replace(q, "$1"), e, i, r)
        }

        function ot() {
            var t = [];
            return function e(n, r) {
                return t.push(n + " ") > i.cacheLength && delete e[t.shift()], e[n + " "] = r
            }
        }

        function st(t) {
            return t[b] = !0, t
        }

        function at(t) {
            var e = p.createElement("div");
            try {
                return !!t(e)
            } catch (t) {
                return !1
            } finally {
                e.parentNode && e.parentNode.removeChild(e), e = null
            }
        }

        function lt(t, e) {
            for (var n = t.split("|"), r = n.length; r--;) i.attrHandle[n[r]] = e
        }

        function ut(t, e) {
            var n = e && t,
                i = n && 1 === t.nodeType && 1 === e.nodeType && (~e.sourceIndex || A) - (~t.sourceIndex || A);
            if (i) return i;
            if (n)
                for (; n = n.nextSibling;)
                    if (n === e) return -1;
            return t ? 1 : -1
        }

        function ct(t) {
            return function(e) {
                return "input" === e.nodeName.toLowerCase() && e.type === t
            }
        }

        function dt(t) {
            return function(e) {
                var n = e.nodeName.toLowerCase();
                return ("input" === n || "button" === n) && e.type === t
            }
        }

        function ht(t) {
            return st(function(e) {
                return e = +e, st(function(n, i) {
                    for (var r, o = t([], n.length, e), s = o.length; s--;) n[r = o[s]] && (n[r] = !(i[r] = n[r]))
                })
            })
        }

        function pt(t) {
            return t && void 0 !== t.getElementsByTagName && t
        }
        for (e in n = rt.support = {}, o = rt.isXML = function(t) {
                var e = t && (t.ownerDocument || t).documentElement;
                return !!e && "HTML" !== e.nodeName
            }, h = rt.setDocument = function(t) {
                var e, r, s = t ? t.ownerDocument || t : w;
                return s !== p && 9 === s.nodeType && s.documentElement ? (f = (p = s).documentElement, m = !o(p), (r = p.defaultView) && r.top !== r && (r.addEventListener ? r.addEventListener("unload", it, !1) : r.attachEvent && r.attachEvent("onunload", it)), n.attributes = at(function(t) {
                    return t.className = "i", !t.getAttribute("className")
                }), n.getElementsByTagName = at(function(t) {
                    return t.appendChild(p.createComment("")), !t.getElementsByTagName("*").length
                }), n.getElementsByClassName = Q.test(p.getElementsByClassName), n.getById = at(function(t) {
                    return f.appendChild(t).id = b, !p.getElementsByName || !p.getElementsByName(b).length
                }), n.getById ? (i.find.ID = function(t, e) {
                    if (void 0 !== e.getElementById && m) {
                        var n = e.getElementById(t);
                        return n ? [n] : []
                    }
                }, i.filter.ID = function(t) {
                    var e = t.replace(et, nt);
                    return function(t) {
                        return t.getAttribute("id") === e
                    }
                }) : (delete i.find.ID, i.filter.ID = function(t) {
                    var e = t.replace(et, nt);
                    return function(t) {
                        var n = void 0 !== t.getAttributeNode && t.getAttributeNode("id");
                        return n && n.value === e
                    }
                }), i.find.TAG = n.getElementsByTagName ? function(t, e) {
                    return void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t) : n.qsa ? e.querySelectorAll(t) : void 0
                } : function(t, e) {
                    var n, i = [],
                        r = 0,
                        o = e.getElementsByTagName(t);
                    if ("*" === t) {
                        for (; n = o[r++];) 1 === n.nodeType && i.push(n);
                        return i
                    }
                    return o
                }, i.find.CLASS = n.getElementsByClassName && function(t, e) {
                    return void 0 !== e.getElementsByClassName && m ? e.getElementsByClassName(t) : void 0
                }, y = [], g = [], (n.qsa = Q.test(p.querySelectorAll)) && (at(function(t) {
                    f.appendChild(t).innerHTML = "<a id='" + b + "'></a><select id='" + b + "-\r\\' msallowcapture=''><option selected=''></option></select>", t.querySelectorAll("[msallowcapture^='']").length && g.push("[*^$]=" + $ + "*(?:''|\"\")"), t.querySelectorAll("[selected]").length || g.push("\\[" + $ + "*(?:value|" + N + ")"), t.querySelectorAll("[id~=" + b + "-]").length || g.push("~="), t.querySelectorAll(":checked").length || g.push(":checked"), t.querySelectorAll("a#" + b + "+*").length || g.push(".#.+[+~]")
                }), at(function(t) {
                    var e = p.createElement("input");
                    e.setAttribute("type", "hidden"), t.appendChild(e).setAttribute("name", "D"), t.querySelectorAll("[name=d]").length && g.push("name" + $ + "*[*^$|!~]?="), t.querySelectorAll(":enabled").length || g.push(":enabled", ":disabled"), t.querySelectorAll("*,:x"), g.push(",.*:")
                })), (n.matchesSelector = Q.test(v = f.matches || f.webkitMatchesSelector || f.mozMatchesSelector || f.oMatchesSelector || f.msMatchesSelector)) && at(function(t) {
                    n.disconnectedMatch = v.call(t, "div"), v.call(t, "[s!='']:x"), y.push("!=", R)
                }), g = g.length && new RegExp(g.join("|")), y = y.length && new RegExp(y.join("|")), e = Q.test(f.compareDocumentPosition), _ = e || Q.test(f.contains) ? function(t, e) {
                    var n = 9 === t.nodeType ? t.documentElement : t,
                        i = e && e.parentNode;
                    return t === i || !(!i || 1 !== i.nodeType || !(n.contains ? n.contains(i) : t.compareDocumentPosition && 16 & t.compareDocumentPosition(i)))
                } : function(t, e) {
                    if (e)
                        for (; e = e.parentNode;)
                            if (e === t) return !0;
                    return !1
                }, E = e ? function(t, e) {
                    if (t === e) return d = !0, 0;
                    var i = !t.compareDocumentPosition - !e.compareDocumentPosition;
                    return i || (1 & (i = (t.ownerDocument || t) === (e.ownerDocument || e) ? t.compareDocumentPosition(e) : 1) || !n.sortDetached && e.compareDocumentPosition(t) === i ? t === p || t.ownerDocument === w && _(w, t) ? -1 : e === p || e.ownerDocument === w && _(w, e) ? 1 : c ? j(c, t) - j(c, e) : 0 : 4 & i ? -1 : 1)
                } : function(t, e) {
                    if (t === e) return d = !0, 0;
                    var n, i = 0,
                        r = t.parentNode,
                        o = e.parentNode,
                        s = [t],
                        a = [e];
                    if (!r || !o) return t === p ? -1 : e === p ? 1 : r ? -1 : o ? 1 : c ? j(c, t) - j(c, e) : 0;
                    if (r === o) return ut(t, e);
                    for (n = t; n = n.parentNode;) s.unshift(n);
                    for (n = e; n = n.parentNode;) a.unshift(n);
                    for (; s[i] === a[i];) i++;
                    return i ? ut(s[i], a[i]) : s[i] === w ? -1 : a[i] === w ? 1 : 0
                }, p) : p
            }, rt.matches = function(t, e) {
                return rt(t, null, null, e)
            }, rt.matchesSelector = function(t, e) {
                if ((t.ownerDocument || t) !== p && h(t), e = e.replace(W, "='$1']"), n.matchesSelector && m && !C[e + " "] && (!y || !y.test(e)) && (!g || !g.test(e))) try {
                    var i = v.call(t, e);
                    if (i || n.disconnectedMatch || t.document && 11 !== t.document.nodeType) return i
                } catch (t) {}
                return rt(e, p, null, [t]).length > 0
            }, rt.contains = function(t, e) {
                return (t.ownerDocument || t) !== p && h(t), _(t, e)
            }, rt.attr = function(t, e) {
                (t.ownerDocument || t) !== p && h(t);
                var r = i.attrHandle[e.toLowerCase()],
                    o = r && D.call(i.attrHandle, e.toLowerCase()) ? r(t, e, !m) : void 0;
                return void 0 !== o ? o : n.attributes || !m ? t.getAttribute(e) : (o = t.getAttributeNode(e)) && o.specified ? o.value : null
            }, rt.error = function(t) {
                throw new Error("Syntax error, unrecognized expression: " + t)
            }, rt.uniqueSort = function(t) {
                var e, i = [],
                    r = 0,
                    o = 0;
                if (d = !n.detectDuplicates, c = !n.sortStable && t.slice(0), t.sort(E), d) {
                    for (; e = t[o++];) e === t[o] && (r = i.push(o));
                    for (; r--;) t.splice(i[r], 1)
                }
                return c = null, t
            }, r = rt.getText = function(t) {
                var e, n = "",
                    i = 0,
                    o = t.nodeType;
                if (o) {
                    if (1 === o || 9 === o || 11 === o) {
                        if ("string" == typeof t.textContent) return t.textContent;
                        for (t = t.firstChild; t; t = t.nextSibling) n += r(t)
                    } else if (3 === o || 4 === o) return t.nodeValue
                } else
                    for (; e = t[i++];) n += r(e);
                return n
            }, (i = rt.selectors = {
                cacheLength: 50,
                createPseudo: st,
                match: Z,
                attrHandle: {},
                find: {},
                relative: {
                    ">": {
                        dir: "parentNode",
                        first: !0
                    },
                    " ": {
                        dir: "parentNode"
                    },
                    "+": {
                        dir: "previousSibling",
                        first: !0
                    },
                    "~": {
                        dir: "previousSibling"
                    }
                },
                preFilter: {
                    ATTR: function(t) {
                        return t[1] = t[1].replace(et, nt), t[3] = (t[3] || t[4] || t[5] || "").replace(et, nt), "~=" === t[2] && (t[3] = " " + t[3] + " "), t.slice(0, 4)
                    },
                    CHILD: function(t) {
                        return t[1] = t[1].toLowerCase(), "nth" === t[1].slice(0, 3) ? (t[3] || rt.error(t[0]), t[4] = +(t[4] ? t[5] + (t[6] || 1) : 2 * ("even" === t[3] || "odd" === t[3])), t[5] = +(t[7] + t[8] || "odd" === t[3])) : t[3] && rt.error(t[0]), t
                    },
                    PSEUDO: function(t) {
                        var e, n = !t[6] && t[2];
                        return Z.CHILD.test(t[0]) ? null : (t[3] ? t[2] = t[4] || t[5] || "" : n && X.test(n) && (e = s(n, !0)) && (e = n.indexOf(")", n.length - e) - n.length) && (t[0] = t[0].slice(0, e), t[2] = n.slice(0, e)), t.slice(0, 3))
                    }
                },
                filter: {
                    TAG: function(t) {
                        var e = t.replace(et, nt).toLowerCase();
                        return "*" === t ? function() {
                            return !0
                        } : function(t) {
                            return t.nodeName && t.nodeName.toLowerCase() === e
                        }
                    },
                    CLASS: function(t) {
                        var e = T[t + " "];
                        return e || (e = new RegExp("(^|" + $ + ")" + t + "(" + $ + "|$)")) && T(t, function(t) {
                            return e.test("string" == typeof t.className && t.className || void 0 !== t.getAttribute && t.getAttribute("class") || "")
                        })
                    },
                    ATTR: function(t, e, n) {
                        return function(i) {
                            var r = rt.attr(i, t);
                            return null == r ? "!=" === e : !e || (r += "", "=" === e ? r === n : "!=" === e ? r !== n : "^=" === e ? n && 0 === r.indexOf(n) : "*=" === e ? n && r.indexOf(n) > -1 : "$=" === e ? n && r.slice(-n.length) === n : "~=" === e ? (" " + r.replace(H, " ") + " ").indexOf(n) > -1 : "|=" === e && (r === n || r.slice(0, n.length + 1) === n + "-"))
                        }
                    },
                    CHILD: function(t, e, n, i, r) {
                        var o = "nth" !== t.slice(0, 3),
                            s = "last" !== t.slice(-4),
                            a = "of-type" === e;
                        return 1 === i && 0 === r ? function(t) {
                            return !!t.parentNode
                        } : function(e, n, l) {
                            var u, c, d, h, p, f, m = o !== s ? "nextSibling" : "previousSibling",
                                g = e.parentNode,
                                y = a && e.nodeName.toLowerCase(),
                                v = !l && !a,
                                _ = !1;
                            if (g) {
                                if (o) {
                                    for (; m;) {
                                        for (h = e; h = h[m];)
                                            if (a ? h.nodeName.toLowerCase() === y : 1 === h.nodeType) return !1;
                                        f = m = "only" === t && !f && "nextSibling"
                                    }
                                    return !0
                                }
                                if (f = [s ? g.firstChild : g.lastChild], s && v) {
                                    for (_ = (p = (u = (c = (d = (h = g)[b] || (h[b] = {}))[h.uniqueID] || (d[h.uniqueID] = {}))[t] || [])[0] === x && u[1]) && u[2], h = p && g.childNodes[p]; h = ++p && h && h[m] || (_ = p = 0) || f.pop();)
                                        if (1 === h.nodeType && ++_ && h === e) {
                                            c[t] = [x, p, _];
                                            break
                                        }
                                } else if (v && (_ = p = (u = (c = (d = (h = e)[b] || (h[b] = {}))[h.uniqueID] || (d[h.uniqueID] = {}))[t] || [])[0] === x && u[1]), !1 === _)
                                    for (;
                                        (h = ++p && h && h[m] || (_ = p = 0) || f.pop()) && ((a ? h.nodeName.toLowerCase() !== y : 1 !== h.nodeType) || !++_ || (v && ((c = (d = h[b] || (h[b] = {}))[h.uniqueID] || (d[h.uniqueID] = {}))[t] = [x, _]), h !== e)););
                                return (_ -= r) === i || _ % i == 0 && _ / i >= 0
                            }
                        }
                    },
                    PSEUDO: function(t, e) {
                        var n, r = i.pseudos[t] || i.setFilters[t.toLowerCase()] || rt.error("unsupported pseudo: " + t);
                        return r[b] ? r(e) : r.length > 1 ? (n = [t, t, "", e], i.setFilters.hasOwnProperty(t.toLowerCase()) ? st(function(t, n) {
                            for (var i, o = r(t, e), s = o.length; s--;) t[i = j(t, o[s])] = !(n[i] = o[s])
                        }) : function(t) {
                            return r(t, 0, n)
                        }) : r
                    }
                },
                pseudos: {
                    not: st(function(t) {
                        var e = [],
                            n = [],
                            i = a(t.replace(q, "$1"));
                        return i[b] ? st(function(t, e, n, r) {
                            for (var o, s = i(t, null, r, []), a = t.length; a--;)(o = s[a]) && (t[a] = !(e[a] = o))
                        }) : function(t, r, o) {
                            return e[0] = t, i(e, null, o, n), e[0] = null, !n.pop()
                        }
                    }),
                    has: st(function(t) {
                        return function(e) {
                            return rt(t, e).length > 0
                        }
                    }),
                    contains: st(function(t) {
                        return t = t.replace(et, nt),
                            function(e) {
                                return (e.textContent || e.innerText || r(e)).indexOf(t) > -1
                            }
                    }),
                    lang: st(function(t) {
                        return Y.test(t || "") || rt.error("unsupported lang: " + t), t = t.replace(et, nt).toLowerCase(),
                            function(e) {
                                var n;
                                do {
                                    if (n = m ? e.lang : e.getAttribute("xml:lang") || e.getAttribute("lang")) return (n = n.toLowerCase()) === t || 0 === n.indexOf(t + "-")
                                } while ((e = e.parentNode) && 1 === e.nodeType);
                                return !1
                            }
                    }),
                    target: function(e) {
                        var n = t.location && t.location.hash;
                        return n && n.slice(1) === e.id
                    },
                    root: function(t) {
                        return t === f
                    },
                    focus: function(t) {
                        return t === p.activeElement && (!p.hasFocus || p.hasFocus()) && !!(t.type || t.href || ~t.tabIndex)
                    },
                    enabled: function(t) {
                        return !1 === t.disabled
                    },
                    disabled: function(t) {
                        return !0 === t.disabled
                    },
                    checked: function(t) {
                        var e = t.nodeName.toLowerCase();
                        return "input" === e && !!t.checked || "option" === e && !!t.selected
                    },
                    selected: function(t) {
                        return t.parentNode && t.parentNode.selectedIndex, !0 === t.selected
                    },
                    empty: function(t) {
                        for (t = t.firstChild; t; t = t.nextSibling)
                            if (t.nodeType < 6) return !1;
                        return !0
                    },
                    parent: function(t) {
                        return !i.pseudos.empty(t)
                    },
                    header: function(t) {
                        return G.test(t.nodeName)
                    },
                    input: function(t) {
                        return V.test(t.nodeName)
                    },
                    button: function(t) {
                        var e = t.nodeName.toLowerCase();
                        return "input" === e && "button" === t.type || "button" === e
                    },
                    text: function(t) {
                        var e;
                        return "input" === t.nodeName.toLowerCase() && "text" === t.type && (null == (e = t.getAttribute("type")) || "text" === e.toLowerCase())
                    },
                    first: ht(function() {
                        return [0]
                    }),
                    last: ht(function(t, e) {
                        return [e - 1]
                    }),
                    eq: ht(function(t, e, n) {
                        return [0 > n ? n + e : n]
                    }),
                    even: ht(function(t, e) {
                        for (var n = 0; e > n; n += 2) t.push(n);
                        return t
                    }),
                    odd: ht(function(t, e) {
                        for (var n = 1; e > n; n += 2) t.push(n);
                        return t
                    }),
                    lt: ht(function(t, e, n) {
                        for (var i = 0 > n ? n + e : n; --i >= 0;) t.push(i);
                        return t
                    }),
                    gt: ht(function(t, e, n) {
                        for (var i = 0 > n ? n + e : n; ++i < e;) t.push(i);
                        return t
                    })
                }
            }).pseudos.nth = i.pseudos.eq, {
                radio: !0,
                checkbox: !0,
                file: !0,
                password: !0,
                image: !0
            }) i.pseudos[e] = ct(e);
        for (e in {
                submit: !0,
                reset: !0
            }) i.pseudos[e] = dt(e);

        function ft() {}

        function mt(t) {
            for (var e = 0, n = t.length, i = ""; n > e; e++) i += t[e].value;
            return i
        }

        function gt(t, e, n) {
            var i = e.dir,
                r = n && "parentNode" === i,
                o = S++;
            return e.first ? function(e, n, o) {
                for (; e = e[i];)
                    if (1 === e.nodeType || r) return t(e, n, o)
            } : function(e, n, s) {
                var a, l, u, c = [x, o];
                if (s) {
                    for (; e = e[i];)
                        if ((1 === e.nodeType || r) && t(e, n, s)) return !0
                } else
                    for (; e = e[i];)
                        if (1 === e.nodeType || r) {
                            if ((a = (l = (u = e[b] || (e[b] = {}))[e.uniqueID] || (u[e.uniqueID] = {}))[i]) && a[0] === x && a[1] === o) return c[2] = a[2];
                            if (l[i] = c, c[2] = t(e, n, s)) return !0
                        }
            }
        }

        function yt(t) {
            return t.length > 1 ? function(e, n, i) {
                for (var r = t.length; r--;)
                    if (!t[r](e, n, i)) return !1;
                return !0
            } : t[0]
        }

        function vt(t, e, n, i, r) {
            for (var o, s = [], a = 0, l = t.length, u = null != e; l > a; a++)(o = t[a]) && (n && !n(o, i, r) || (s.push(o), u && e.push(a)));
            return s
        }

        function _t(t, e, n, i, r, o) {
            return i && !i[b] && (i = _t(i)), r && !r[b] && (r = _t(r, o)), st(function(o, s, a, l) {
                var u, c, d, h = [],
                    p = [],
                    f = s.length,
                    m = o || function(t, e, n) {
                        for (var i = 0, r = e.length; r > i; i++) rt(t, e[i], n);
                        return n
                    }(e || "*", a.nodeType ? [a] : a, []),
                    g = !t || !o && e ? m : vt(m, h, t, a, l),
                    y = n ? r || (o ? t : f || i) ? [] : s : g;
                if (n && n(g, y, a, l), i)
                    for (u = vt(y, p), i(u, [], a, l), c = u.length; c--;)(d = u[c]) && (y[p[c]] = !(g[p[c]] = d));
                if (o) {
                    if (r || t) {
                        if (r) {
                            for (u = [], c = y.length; c--;)(d = y[c]) && u.push(g[c] = d);
                            r(null, y = [], u, l)
                        }
                        for (c = y.length; c--;)(d = y[c]) && (u = r ? j(o, d) : h[c]) > -1 && (o[u] = !(s[u] = d))
                    }
                } else y = vt(y === s ? y.splice(f, y.length) : y), r ? r(null, s, y, l) : M.apply(s, y)
            })
        }

        function bt(t) {
            for (var e, n, r, o = t.length, s = i.relative[t[0].type], a = s || i.relative[" "], l = s ? 1 : 0, c = gt(function(t) {
                    return t === e
                }, a, !0), d = gt(function(t) {
                    return j(e, t) > -1
                }, a, !0), h = [function(t, n, i) {
                    var r = !s && (i || n !== u) || ((e = n).nodeType ? c(t, n, i) : d(t, n, i));
                    return e = null, r
                }]; o > l; l++)
                if (n = i.relative[t[l].type]) h = [gt(yt(h), n)];
                else {
                    if ((n = i.filter[t[l].type].apply(null, t[l].matches))[b]) {
                        for (r = ++l; o > r && !i.relative[t[r].type]; r++);
                        return _t(l > 1 && yt(h), l > 1 && mt(t.slice(0, l - 1).concat({
                            value: " " === t[l - 2].type ? "*" : ""
                        })).replace(q, "$1"), n, r > l && bt(t.slice(l, r)), o > r && bt(t = t.slice(r)), o > r && mt(t))
                    }
                    h.push(n)
                } return yt(h)
        }
        return ft.prototype = i.filters = i.pseudos, i.setFilters = new ft, s = rt.tokenize = function(t, e) {
            var n, r, o, s, a, l, u, c = k[t + " "];
            if (c) return e ? 0 : c.slice(0);
            for (a = t, l = [], u = i.preFilter; a;) {
                for (s in n && !(r = B.exec(a)) || (r && (a = a.slice(r[0].length) || a), l.push(o = [])), n = !1, (r = U.exec(a)) && (n = r.shift(), o.push({
                        value: n,
                        type: r[0].replace(q, " ")
                    }), a = a.slice(n.length)), i.filter) !(r = Z[s].exec(a)) || u[s] && !(r = u[s](r)) || (n = r.shift(), o.push({
                    value: n,
                    type: s,
                    matches: r
                }), a = a.slice(n.length));
                if (!n) break
            }
            return e ? a.length : a ? rt.error(t) : k(t, l).slice(0)
        }, a = rt.compile = function(t, e) {
            var n, r, o, a, l, c, d = [],
                f = [],
                g = C[t + " "];
            if (!g) {
                for (e || (e = s(t)), n = e.length; n--;)(g = bt(e[n]))[b] ? d.push(g) : f.push(g);
                (g = C(t, (r = f, a = (o = d).length > 0, l = r.length > 0, c = function(t, e, n, s, c) {
                    var d, f, g, y = 0,
                        v = "0",
                        _ = t && [],
                        b = [],
                        w = u,
                        S = t || l && i.find.TAG("*", c),
                        T = x += null == w ? 1 : Math.random() || .1,
                        k = S.length;
                    for (c && (u = e === p || e || c); v !== k && null != (d = S[v]); v++) {
                        if (l && d) {
                            for (f = 0, e || d.ownerDocument === p || (h(d), n = !m); g = r[f++];)
                                if (g(d, e || p, n)) {
                                    s.push(d);
                                    break
                                } c && (x = T)
                        }
                        a && ((d = !g && d) && y--, t && _.push(d))
                    }
                    if (y += v, a && v !== y) {
                        for (f = 0; g = o[f++];) g(_, b, e, n);
                        if (t) {
                            if (y > 0)
                                for (; v--;) _[v] || b[v] || (b[v] = O.call(s));
                            b = vt(b)
                        }
                        M.apply(s, b), c && !t && b.length > 0 && y + o.length > 1 && rt.uniqueSort(s)
                    }
                    return c && (x = T, u = w), _
                }, a ? st(c) : c))).selector = t
            }
            return g
        }, l = rt.select = function(t, e, r, o) {
            var l, u, c, d, h, p = "function" == typeof t && t,
                f = !o && s(t = p.selector || t);
            if (r = r || [], 1 === f.length) {
                if ((u = f[0] = f[0].slice(0)).length > 2 && "ID" === (c = u[0]).type && n.getById && 9 === e.nodeType && m && i.relative[u[1].type]) {
                    if (!(e = (i.find.ID(c.matches[0].replace(et, nt), e) || [])[0])) return r;
                    p && (e = e.parentNode), t = t.slice(u.shift().value.length)
                }
                for (l = Z.needsContext.test(t) ? 0 : u.length; l-- && (c = u[l], !i.relative[d = c.type]);)
                    if ((h = i.find[d]) && (o = h(c.matches[0].replace(et, nt), J.test(u[0].type) && pt(e.parentNode) || e))) {
                        if (u.splice(l, 1), !(t = o.length && mt(u))) return M.apply(r, o), r;
                        break
                    }
            }
            return (p || a(t, f))(o, e, !m, r, !e || J.test(t) && pt(e.parentNode) || e), r
        }, n.sortStable = b.split("").sort(E).join("") === b, n.detectDuplicates = !!d, h(), n.sortDetached = at(function(t) {
            return 1 & t.compareDocumentPosition(p.createElement("div"))
        }), at(function(t) {
            return t.innerHTML = "<a href='#'></a>", "#" === t.firstChild.getAttribute("href")
        }) || lt("type|href|height|width", function(t, e, n) {
            return n ? void 0 : t.getAttribute(e, "type" === e.toLowerCase() ? 1 : 2)
        }), n.attributes && at(function(t) {
            return t.innerHTML = "<input/>", t.firstChild.setAttribute("value", ""), "" === t.firstChild.getAttribute("value")
        }) || lt("value", function(t, e, n) {
            return n || "input" !== t.nodeName.toLowerCase() ? void 0 : t.defaultValue
        }), at(function(t) {
            return null == t.getAttribute("disabled")
        }) || lt(N, function(t, e, n) {
            var i;
            return n ? void 0 : !0 === t[e] ? e.toLowerCase() : (i = t.getAttributeNode(e)) && i.specified ? i.value : null
        }), rt
    }(t);
    p.find = _, p.expr = _.selectors, p.expr[":"] = p.expr.pseudos, p.uniqueSort = p.unique = _.uniqueSort, p.text = _.getText, p.isXMLDoc = _.isXML, p.contains = _.contains;
    var b = function(t, e, n) {
            for (var i = [], r = void 0 !== n;
                (t = t[e]) && 9 !== t.nodeType;)
                if (1 === t.nodeType) {
                    if (r && p(t).is(n)) break;
                    i.push(t)
                } return i
        },
        w = function(t, e) {
            for (var n = []; t; t = t.nextSibling) 1 === t.nodeType && t !== e && n.push(t);
            return n
        },
        x = p.expr.match.needsContext,
        S = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/,
        T = /^.[^:#\[\.,]*$/;

    function k(t, e, n) {
        if (p.isFunction(e)) return p.grep(t, function(t, i) {
            return !!e.call(t, i, t) !== n
        });
        if (e.nodeType) return p.grep(t, function(t) {
            return t === e !== n
        });
        if ("string" == typeof e) {
            if (T.test(e)) return p.filter(e, t, n);
            e = p.filter(e, t)
        }
        return p.grep(t, function(t) {
            return a.call(e, t) > -1 !== n
        })
    }
    p.filter = function(t, e, n) {
        var i = e[0];
        return n && (t = ":not(" + t + ")"), 1 === e.length && 1 === i.nodeType ? p.find.matchesSelector(i, t) ? [i] : [] : p.find.matches(t, p.grep(e, function(t) {
            return 1 === t.nodeType
        }))
    }, p.fn.extend({
        find: function(t) {
            var e, n = this.length,
                i = [],
                r = this;
            if ("string" != typeof t) return this.pushStack(p(t).filter(function() {
                for (e = 0; n > e; e++)
                    if (p.contains(r[e], this)) return !0
            }));
            for (e = 0; n > e; e++) p.find(t, r[e], i);
            return (i = this.pushStack(n > 1 ? p.unique(i) : i)).selector = this.selector ? this.selector + " " + t : t, i
        },
        filter: function(t) {
            return this.pushStack(k(this, t || [], !1))
        },
        not: function(t) {
            return this.pushStack(k(this, t || [], !0))
        },
        is: function(t) {
            return !!k(this, "string" == typeof t && x.test(t) ? p(t) : t || [], !1).length
        }
    });
    var C, E = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/;
    (p.fn.init = function(t, e, n) {
        var r, o;
        if (!t) return this;
        if (n = n || C, "string" == typeof t) {
            if (!(r = "<" === t[0] && ">" === t[t.length - 1] && t.length >= 3 ? [null, t, null] : E.exec(t)) || !r[1] && e) return !e || e.jquery ? (e || n).find(t) : this.constructor(e).find(t);
            if (r[1]) {
                if (e = e instanceof p ? e[0] : e, p.merge(this, p.parseHTML(r[1], e && e.nodeType ? e.ownerDocument || e : i, !0)), S.test(r[1]) && p.isPlainObject(e))
                    for (r in e) p.isFunction(this[r]) ? this[r](e[r]) : this.attr(r, e[r]);
                return this
            }
            return (o = i.getElementById(r[2])) && o.parentNode && (this.length = 1, this[0] = o), this.context = i, this.selector = t, this
        }
        return t.nodeType ? (this.context = this[0] = t, this.length = 1, this) : p.isFunction(t) ? void 0 !== n.ready ? n.ready(t) : t(p) : (void 0 !== t.selector && (this.selector = t.selector, this.context = t.context), p.makeArray(t, this))
    }).prototype = p.fn, C = p(i);
    var A = /^(?:parents|prev(?:Until|All))/,
        D = {
            children: !0,
            contents: !0,
            next: !0,
            prev: !0
        };

    function P(t, e) {
        for (;
            (t = t[e]) && 1 !== t.nodeType;);
        return t
    }
    p.fn.extend({
        has: function(t) {
            var e = p(t, this),
                n = e.length;
            return this.filter(function() {
                for (var t = 0; n > t; t++)
                    if (p.contains(this, e[t])) return !0
            })
        },
        closest: function(t, e) {
            for (var n, i = 0, r = this.length, o = [], s = x.test(t) || "string" != typeof t ? p(t, e || this.context) : 0; r > i; i++)
                for (n = this[i]; n && n !== e; n = n.parentNode)
                    if (n.nodeType < 11 && (s ? s.index(n) > -1 : 1 === n.nodeType && p.find.matchesSelector(n, t))) {
                        o.push(n);
                        break
                    } return this.pushStack(o.length > 1 ? p.uniqueSort(o) : o)
        },
        index: function(t) {
            return t ? "string" == typeof t ? a.call(p(t), this[0]) : a.call(this, t.jquery ? t[0] : t) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
        },
        add: function(t, e) {
            return this.pushStack(p.uniqueSort(p.merge(this.get(), p(t, e))))
        },
        addBack: function(t) {
            return this.add(null == t ? this.prevObject : this.prevObject.filter(t))
        }
    }), p.each({
        parent: function(t) {
            var e = t.parentNode;
            return e && 11 !== e.nodeType ? e : null
        },
        parents: function(t) {
            return b(t, "parentNode")
        },
        parentsUntil: function(t, e, n) {
            return b(t, "parentNode", n)
        },
        next: function(t) {
            return P(t, "nextSibling")
        },
        prev: function(t) {
            return P(t, "previousSibling")
        },
        nextAll: function(t) {
            return b(t, "nextSibling")
        },
        prevAll: function(t) {
            return b(t, "previousSibling")
        },
        nextUntil: function(t, e, n) {
            return b(t, "nextSibling", n)
        },
        prevUntil: function(t, e, n) {
            return b(t, "previousSibling", n)
        },
        siblings: function(t) {
            return w((t.parentNode || {}).firstChild, t)
        },
        children: function(t) {
            return w(t.firstChild)
        },
        contents: function(t) {
            return t.contentDocument || p.merge([], t.childNodes)
        }
    }, function(t, e) {
        p.fn[t] = function(n, i) {
            var r = p.map(this, e, n);
            return "Until" !== t.slice(-5) && (i = n), i && "string" == typeof i && (r = p.filter(i, r)), this.length > 1 && (D[t] || p.uniqueSort(r), A.test(t) && r.reverse()), this.pushStack(r)
        }
    });
    var O, I = /\S+/g;

    function M() {
        i.removeEventListener("DOMContentLoaded", M), t.removeEventListener("load", M), p.ready()
    }
    p.Callbacks = function(t) {
        var e, n;
        t = "string" == typeof t ? (e = t, n = {}, p.each(e.match(I) || [], function(t, e) {
            n[e] = !0
        }), n) : p.extend({}, t);
        var i, r, o, s, a = [],
            l = [],
            u = -1,
            c = function() {
                for (s = t.once, o = i = !0; l.length; u = -1)
                    for (r = l.shift(); ++u < a.length;) !1 === a[u].apply(r[0], r[1]) && t.stopOnFalse && (u = a.length, r = !1);
                t.memory || (r = !1), i = !1, s && (a = r ? [] : "")
            },
            d = {
                add: function() {
                    return a && (r && !i && (u = a.length - 1, l.push(r)), function e(n) {
                        p.each(n, function(n, i) {
                            p.isFunction(i) ? t.unique && d.has(i) || a.push(i) : i && i.length && "string" !== p.type(i) && e(i)
                        })
                    }(arguments), r && !i && c()), this
                },
                remove: function() {
                    return p.each(arguments, function(t, e) {
                        for (var n;
                            (n = p.inArray(e, a, n)) > -1;) a.splice(n, 1), u >= n && u--
                    }), this
                },
                has: function(t) {
                    return t ? p.inArray(t, a) > -1 : a.length > 0
                },
                empty: function() {
                    return a && (a = []), this
                },
                disable: function() {
                    return s = l = [], a = r = "", this
                },
                disabled: function() {
                    return !a
                },
                lock: function() {
                    return s = l = [], r || (a = r = ""), this
                },
                locked: function() {
                    return !!s
                },
                fireWith: function(t, e) {
                    return s || (e = [t, (e = e || []).slice ? e.slice() : e], l.push(e), i || c()), this
                },
                fire: function() {
                    return d.fireWith(this, arguments), this
                },
                fired: function() {
                    return !!o
                }
            };
        return d
    }, p.extend({
        Deferred: function(t) {
            var e = [
                    ["resolve", "done", p.Callbacks("once memory"), "resolved"],
                    ["reject", "fail", p.Callbacks("once memory"), "rejected"],
                    ["notify", "progress", p.Callbacks("memory")]
                ],
                n = "pending",
                i = {
                    state: function() {
                        return n
                    },
                    always: function() {
                        return r.done(arguments).fail(arguments), this
                    },
                    then: function() {
                        var t = arguments;
                        return p.Deferred(function(n) {
                            p.each(e, function(e, o) {
                                var s = p.isFunction(t[e]) && t[e];
                                r[o[1]](function() {
                                    var t = s && s.apply(this, arguments);
                                    t && p.isFunction(t.promise) ? t.promise().progress(n.notify).done(n.resolve).fail(n.reject) : n[o[0] + "With"](this === i ? n.promise() : this, s ? [t] : arguments)
                                })
                            }), t = null
                        }).promise()
                    },
                    promise: function(t) {
                        return null != t ? p.extend(t, i) : i
                    }
                },
                r = {};
            return i.pipe = i.then, p.each(e, function(t, o) {
                var s = o[2],
                    a = o[3];
                i[o[1]] = s.add, a && s.add(function() {
                    n = a
                }, e[1 ^ t][2].disable, e[2][2].lock), r[o[0]] = function() {
                    return r[o[0] + "With"](this === r ? i : this, arguments), this
                }, r[o[0] + "With"] = s.fireWith
            }), i.promise(r), t && t.call(r, r), r
        },
        when: function(t) {
            var e, n, i, o = 0,
                s = r.call(arguments),
                a = s.length,
                l = 1 !== a || t && p.isFunction(t.promise) ? a : 0,
                u = 1 === l ? t : p.Deferred(),
                c = function(t, n, i) {
                    return function(o) {
                        n[t] = this, i[t] = arguments.length > 1 ? r.call(arguments) : o, i === e ? u.notifyWith(n, i) : --l || u.resolveWith(n, i)
                    }
                };
            if (a > 1)
                for (e = new Array(a), n = new Array(a), i = new Array(a); a > o; o++) s[o] && p.isFunction(s[o].promise) ? s[o].promise().progress(c(o, n, e)).done(c(o, i, s)).fail(u.reject) : --l;
            return l || u.resolveWith(i, s), u.promise()
        }
    }), p.fn.ready = function(t) {
        return p.ready.promise().done(t), this
    }, p.extend({
        isReady: !1,
        readyWait: 1,
        holdReady: function(t) {
            t ? p.readyWait++ : p.ready(!0)
        },
        ready: function(t) {
            (!0 === t ? --p.readyWait : p.isReady) || (p.isReady = !0, !0 !== t && --p.readyWait > 0 || (O.resolveWith(i, [p]), p.fn.triggerHandler && (p(i).triggerHandler("ready"), p(i).off("ready"))))
        }
    }), p.ready.promise = function(e) {
        return O || (O = p.Deferred(), "complete" === i.readyState || "loading" !== i.readyState && !i.documentElement.doScroll ? t.setTimeout(p.ready) : (i.addEventListener("DOMContentLoaded", M), t.addEventListener("load", M))), O.promise(e)
    }, p.ready.promise();
    var L = function(t, e, n, i, r, o, s) {
            var a = 0,
                l = t.length,
                u = null == n;
            if ("object" === p.type(n))
                for (a in r = !0, n) L(t, e, a, n[a], !0, o, s);
            else if (void 0 !== i && (r = !0, p.isFunction(i) || (s = !0), u && (s ? (e.call(t, i), e = null) : (u = e, e = function(t, e, n) {
                    return u.call(p(t), n)
                })), e))
                for (; l > a; a++) e(t[a], n, s ? i : i.call(t[a], a, e(t[a], n)));
            return r ? t : u ? e.call(t) : l ? e(t[0], n) : o
        },
        j = function(t) {
            return 1 === t.nodeType || 9 === t.nodeType || !+t.nodeType
        };

    function N() {
        this.expando = p.expando + N.uid++
    }
    N.uid = 1, N.prototype = {
        register: function(t, e) {
            var n = e || {};
            return t.nodeType ? t[this.expando] = n : Object.defineProperty(t, this.expando, {
                value: n,
                writable: !0,
                configurable: !0
            }), t[this.expando]
        },
        cache: function(t) {
            if (!j(t)) return {};
            var e = t[this.expando];
            return e || (e = {}, j(t) && (t.nodeType ? t[this.expando] = e : Object.defineProperty(t, this.expando, {
                value: e,
                configurable: !0
            }))), e
        },
        set: function(t, e, n) {
            var i, r = this.cache(t);
            if ("string" == typeof e) r[e] = n;
            else
                for (i in e) r[i] = e[i];
            return r
        },
        get: function(t, e) {
            return void 0 === e ? this.cache(t) : t[this.expando] && t[this.expando][e]
        },
        access: function(t, e, n) {
            var i;
            return void 0 === e || e && "string" == typeof e && void 0 === n ? void 0 !== (i = this.get(t, e)) ? i : this.get(t, p.camelCase(e)) : (this.set(t, e, n), void 0 !== n ? n : e)
        },
        remove: function(t, e) {
            var n, i, r, o = t[this.expando];
            if (void 0 !== o) {
                if (void 0 === e) this.register(t);
                else {
                    p.isArray(e) ? i = e.concat(e.map(p.camelCase)) : (r = p.camelCase(e), i = e in o ? [e, r] : (i = r) in o ? [i] : i.match(I) || []), n = i.length;
                    for (; n--;) delete o[i[n]]
                }(void 0 === e || p.isEmptyObject(o)) && (t.nodeType ? t[this.expando] = void 0 : delete t[this.expando])
            }
        },
        hasData: function(t) {
            var e = t[this.expando];
            return void 0 !== e && !p.isEmptyObject(e)
        }
    };
    var $ = new N,
        z = new N,
        F = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
        R = /[A-Z]/g;

    function H(t, e, n) {
        var i;
        if (void 0 === n && 1 === t.nodeType)
            if (i = "data-" + e.replace(R, "-$&").toLowerCase(), "string" == typeof(n = t.getAttribute(i))) {
                try {
                    n = "true" === n || "false" !== n && ("null" === n ? null : +n + "" === n ? +n : F.test(n) ? p.parseJSON(n) : n)
                } catch (t) {}
                z.set(t, e, n)
            } else n = void 0;
        return n
    }
    p.extend({
        hasData: function(t) {
            return z.hasData(t) || $.hasData(t)
        },
        data: function(t, e, n) {
            return z.access(t, e, n)
        },
        removeData: function(t, e) {
            z.remove(t, e)
        },
        _data: function(t, e, n) {
            return $.access(t, e, n)
        },
        _removeData: function(t, e) {
            $.remove(t, e)
        }
    }), p.fn.extend({
        data: function(t, e) {
            var n, i, r, o = this[0],
                s = o && o.attributes;
            if (void 0 === t) {
                if (this.length && (r = z.get(o), 1 === o.nodeType && !$.get(o, "hasDataAttrs"))) {
                    for (n = s.length; n--;) s[n] && 0 === (i = s[n].name).indexOf("data-") && (i = p.camelCase(i.slice(5)), H(o, i, r[i]));
                    $.set(o, "hasDataAttrs", !0)
                }
                return r
            }
            return "object" == typeof t ? this.each(function() {
                z.set(this, t)
            }) : L(this, function(e) {
                var n, i;
                if (o && void 0 === e) {
                    if (void 0 !== (n = z.get(o, t) || z.get(o, t.replace(R, "-$&").toLowerCase()))) return n;
                    if (i = p.camelCase(t), void 0 !== (n = z.get(o, i))) return n;
                    if (void 0 !== (n = H(o, i, void 0))) return n
                } else i = p.camelCase(t), this.each(function() {
                    var n = z.get(this, i);
                    z.set(this, i, e), t.indexOf("-") > -1 && void 0 !== n && z.set(this, t, e)
                })
            }, null, e, arguments.length > 1, null, !0)
        },
        removeData: function(t) {
            return this.each(function() {
                z.remove(this, t)
            })
        }
    }), p.extend({
        queue: function(t, e, n) {
            var i;
            return t ? (e = (e || "fx") + "queue", i = $.get(t, e), n && (!i || p.isArray(n) ? i = $.access(t, e, p.makeArray(n)) : i.push(n)), i || []) : void 0
        },
        dequeue: function(t, e) {
            e = e || "fx";
            var n = p.queue(t, e),
                i = n.length,
                r = n.shift(),
                o = p._queueHooks(t, e);
            "inprogress" === r && (r = n.shift(), i--), r && ("fx" === e && n.unshift("inprogress"), delete o.stop, r.call(t, function() {
                p.dequeue(t, e)
            }, o)), !i && o && o.empty.fire()
        },
        _queueHooks: function(t, e) {
            var n = e + "queueHooks";
            return $.get(t, n) || $.access(t, n, {
                empty: p.Callbacks("once memory").add(function() {
                    $.remove(t, [e + "queue", n])
                })
            })
        }
    }), p.fn.extend({
        queue: function(t, e) {
            var n = 2;
            return "string" != typeof t && (e = t, t = "fx", n--), arguments.length < n ? p.queue(this[0], t) : void 0 === e ? this : this.each(function() {
                var n = p.queue(this, t, e);
                p._queueHooks(this, t), "fx" === t && "inprogress" !== n[0] && p.dequeue(this, t)
            })
        },
        dequeue: function(t) {
            return this.each(function() {
                p.dequeue(this, t)
            })
        },
        clearQueue: function(t) {
            return this.queue(t || "fx", [])
        },
        promise: function(t, e) {
            var n, i = 1,
                r = p.Deferred(),
                o = this,
                s = this.length,
                a = function() {
                    --i || r.resolveWith(o, [o])
                };
            for ("string" != typeof t && (e = t, t = void 0), t = t || "fx"; s--;)(n = $.get(o[s], t + "queueHooks")) && n.empty && (i++, n.empty.add(a));
            return a(), r.promise(e)
        }
    });
    var q = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
        B = new RegExp("^(?:([+-])=|)(" + q + ")([a-z%]*)$", "i"),
        U = ["Top", "Right", "Bottom", "Left"],
        W = function(t, e) {
            return t = e || t, "none" === p.css(t, "display") || !p.contains(t.ownerDocument, t)
        };

    function X(t, e, n, i) {
        var r, o = 1,
            s = 20,
            a = i ? function() {
                return i.cur()
            } : function() {
                return p.css(t, e, "")
            },
            l = a(),
            u = n && n[3] || (p.cssNumber[e] ? "" : "px"),
            c = (p.cssNumber[e] || "px" !== u && +l) && B.exec(p.css(t, e));
        if (c && c[3] !== u) {
            u = u || c[3], n = n || [], c = +l || 1;
            do {
                c /= o = o || ".5", p.style(t, e, c + u)
            } while (o !== (o = a() / l) && 1 !== o && --s)
        }
        return n && (c = +c || +l || 0, r = n[1] ? c + (n[1] + 1) * n[2] : +n[2], i && (i.unit = u, i.start = c, i.end = r)), r
    }
    var Y = /^(?:checkbox|radio)$/i,
        Z = /<([\w:-]+)/,
        V = /^$|\/(?:java|ecma)script/i,
        G = {
            option: [1, "<select multiple='multiple'>", "</select>"],
            thead: [1, "<table>", "</table>"],
            col: [2, "<table><colgroup>", "</colgroup></table>"],
            tr: [2, "<table><tbody>", "</tbody></table>"],
            td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
            _default: [0, "", ""]
        };

    function Q(t, e) {
        var n = void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e || "*") : void 0 !== t.querySelectorAll ? t.querySelectorAll(e || "*") : [];
        return void 0 === e || e && p.nodeName(t, e) ? p.merge([t], n) : n
    }

    function K(t, e) {
        for (var n = 0, i = t.length; i > n; n++) $.set(t[n], "globalEval", !e || $.get(e[n], "globalEval"))
    }
    G.optgroup = G.option, G.tbody = G.tfoot = G.colgroup = G.caption = G.thead, G.th = G.td;
    var J, tt, et = /<|&#?\w+;/;

    function nt(t, e, n, i, r) {
        for (var o, s, a, l, u, c, d = e.createDocumentFragment(), h = [], f = 0, m = t.length; m > f; f++)
            if ((o = t[f]) || 0 === o)
                if ("object" === p.type(o)) p.merge(h, o.nodeType ? [o] : o);
                else if (et.test(o)) {
            for (s = s || d.appendChild(e.createElement("div")), a = (Z.exec(o) || ["", ""])[1].toLowerCase(), l = G[a] || G._default, s.innerHTML = l[1] + p.htmlPrefilter(o) + l[2], c = l[0]; c--;) s = s.lastChild;
            p.merge(h, s.childNodes), (s = d.firstChild).textContent = ""
        } else h.push(e.createTextNode(o));
        for (d.textContent = "", f = 0; o = h[f++];)
            if (i && p.inArray(o, i) > -1) r && r.push(o);
            else if (u = p.contains(o.ownerDocument, o), s = Q(d.appendChild(o), "script"), u && K(s), n)
            for (c = 0; o = s[c++];) V.test(o.type || "") && n.push(o);
        return d
    }
    J = i.createDocumentFragment().appendChild(i.createElement("div")), (tt = i.createElement("input")).setAttribute("type", "radio"), tt.setAttribute("checked", "checked"), tt.setAttribute("name", "t"), J.appendChild(tt), d.checkClone = J.cloneNode(!0).cloneNode(!0).lastChild.checked, J.innerHTML = "<textarea>x</textarea>", d.noCloneChecked = !!J.cloneNode(!0).lastChild.defaultValue;
    var it = /^key/,
        rt = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
        ot = /^([^.]*)(?:\.(.+)|)/;

    function st() {
        return !0
    }

    function at() {
        return !1
    }

    function lt() {
        try {
            return i.activeElement
        } catch (t) {}
    }

    function ut(t, e, n, i, r, o) {
        var s, a;
        if ("object" == typeof e) {
            for (a in "string" != typeof n && (i = i || n, n = void 0), e) ut(t, a, n, i, e[a], o);
            return t
        }
        if (null == i && null == r ? (r = n, i = n = void 0) : null == r && ("string" == typeof n ? (r = i, i = void 0) : (r = i, i = n, n = void 0)), !1 === r) r = at;
        else if (!r) return t;
        return 1 === o && (s = r, (r = function(t) {
            return p().off(t), s.apply(this, arguments)
        }).guid = s.guid || (s.guid = p.guid++)), t.each(function() {
            p.event.add(this, e, r, i, n)
        })
    }
    p.event = {
        global: {},
        add: function(t, e, n, i, r) {
            var o, s, a, l, u, c, d, h, f, m, g, y = $.get(t);
            if (y)
                for (n.handler && (n = (o = n).handler, r = o.selector), n.guid || (n.guid = p.guid++), (l = y.events) || (l = y.events = {}), (s = y.handle) || (s = y.handle = function(e) {
                        return void 0 !== p && p.event.triggered !== e.type ? p.event.dispatch.apply(t, arguments) : void 0
                    }), u = (e = (e || "").match(I) || [""]).length; u--;) f = g = (a = ot.exec(e[u]) || [])[1], m = (a[2] || "").split(".").sort(), f && (d = p.event.special[f] || {}, f = (r ? d.delegateType : d.bindType) || f, d = p.event.special[f] || {}, c = p.extend({
                    type: f,
                    origType: g,
                    data: i,
                    handler: n,
                    guid: n.guid,
                    selector: r,
                    needsContext: r && p.expr.match.needsContext.test(r),
                    namespace: m.join(".")
                }, o), (h = l[f]) || ((h = l[f] = []).delegateCount = 0, d.setup && !1 !== d.setup.call(t, i, m, s) || t.addEventListener && t.addEventListener(f, s)), d.add && (d.add.call(t, c), c.handler.guid || (c.handler.guid = n.guid)), r ? h.splice(h.delegateCount++, 0, c) : h.push(c), p.event.global[f] = !0)
        },
        remove: function(t, e, n, i, r) {
            var o, s, a, l, u, c, d, h, f, m, g, y = $.hasData(t) && $.get(t);
            if (y && (l = y.events)) {
                for (u = (e = (e || "").match(I) || [""]).length; u--;)
                    if (f = g = (a = ot.exec(e[u]) || [])[1], m = (a[2] || "").split(".").sort(), f) {
                        for (d = p.event.special[f] || {}, h = l[f = (i ? d.delegateType : d.bindType) || f] || [], a = a[2] && new RegExp("(^|\\.)" + m.join("\\.(?:.*\\.|)") + "(\\.|$)"), s = o = h.length; o--;) c = h[o], !r && g !== c.origType || n && n.guid !== c.guid || a && !a.test(c.namespace) || i && i !== c.selector && ("**" !== i || !c.selector) || (h.splice(o, 1), c.selector && h.delegateCount--, d.remove && d.remove.call(t, c));
                        s && !h.length && (d.teardown && !1 !== d.teardown.call(t, m, y.handle) || p.removeEvent(t, f, y.handle), delete l[f])
                    } else
                        for (f in l) p.event.remove(t, f + e[u], n, i, !0);
                p.isEmptyObject(l) && $.remove(t, "handle events")
            }
        },
        dispatch: function(t) {
            t = p.event.fix(t);
            var e, n, i, o, s, a = [],
                l = r.call(arguments),
                u = ($.get(this, "events") || {})[t.type] || [],
                c = p.event.special[t.type] || {};
            if (l[0] = t, t.delegateTarget = this, !c.preDispatch || !1 !== c.preDispatch.call(this, t)) {
                for (a = p.event.handlers.call(this, t, u), e = 0;
                    (o = a[e++]) && !t.isPropagationStopped();)
                    for (t.currentTarget = o.elem, n = 0;
                        (s = o.handlers[n++]) && !t.isImmediatePropagationStopped();) t.rnamespace && !t.rnamespace.test(s.namespace) || (t.handleObj = s, t.data = s.data, void 0 !== (i = ((p.event.special[s.origType] || {}).handle || s.handler).apply(o.elem, l)) && !1 === (t.result = i) && (t.preventDefault(), t.stopPropagation()));
                return c.postDispatch && c.postDispatch.call(this, t), t.result
            }
        },
        handlers: function(t, e) {
            var n, i, r, o, s = [],
                a = e.delegateCount,
                l = t.target;
            if (a && l.nodeType && ("click" !== t.type || isNaN(t.button) || t.button < 1))
                for (; l !== this; l = l.parentNode || this)
                    if (1 === l.nodeType && (!0 !== l.disabled || "click" !== t.type)) {
                        for (i = [], n = 0; a > n; n++) void 0 === i[r = (o = e[n]).selector + " "] && (i[r] = o.needsContext ? p(r, this).index(l) > -1 : p.find(r, this, null, [l]).length), i[r] && i.push(o);
                        i.length && s.push({
                            elem: l,
                            handlers: i
                        })
                    } return a < e.length && s.push({
                elem: this,
                handlers: e.slice(a)
            }), s
        },
        props: "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),
        fixHooks: {},
        keyHooks: {
            props: "char charCode key keyCode".split(" "),
            filter: function(t, e) {
                return null == t.which && (t.which = null != e.charCode ? e.charCode : e.keyCode), t
            }
        },
        mouseHooks: {
            props: "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
            filter: function(t, e) {
                var n, r, o, s = e.button;
                return null == t.pageX && null != e.clientX && (r = (n = t.target.ownerDocument || i).documentElement, o = n.body, t.pageX = e.clientX + (r && r.scrollLeft || o && o.scrollLeft || 0) - (r && r.clientLeft || o && o.clientLeft || 0), t.pageY = e.clientY + (r && r.scrollTop || o && o.scrollTop || 0) - (r && r.clientTop || o && o.clientTop || 0)), t.which || void 0 === s || (t.which = 1 & s ? 1 : 2 & s ? 3 : 4 & s ? 2 : 0), t
            }
        },
        fix: function(t) {
            if (t[p.expando]) return t;
            var e, n, r, o = t.type,
                s = t,
                a = this.fixHooks[o];
            for (a || (this.fixHooks[o] = a = rt.test(o) ? this.mouseHooks : it.test(o) ? this.keyHooks : {}), r = a.props ? this.props.concat(a.props) : this.props, t = new p.Event(s), e = r.length; e--;) t[n = r[e]] = s[n];
            return t.target || (t.target = i), 3 === t.target.nodeType && (t.target = t.target.parentNode), a.filter ? a.filter(t, s) : t
        },
        special: {
            load: {
                noBubble: !0
            },
            focus: {
                trigger: function() {
                    return this !== lt() && this.focus ? (this.focus(), !1) : void 0
                },
                delegateType: "focusin"
            },
            blur: {
                trigger: function() {
                    return this === lt() && this.blur ? (this.blur(), !1) : void 0
                },
                delegateType: "focusout"
            },
            click: {
                trigger: function() {
                    return "checkbox" === this.type && this.click && p.nodeName(this, "input") ? (this.click(), !1) : void 0
                },
                _default: function(t) {
                    return p.nodeName(t.target, "a")
                }
            },
            beforeunload: {
                postDispatch: function(t) {
                    void 0 !== t.result && t.originalEvent && (t.originalEvent.returnValue = t.result)
                }
            }
        }
    }, p.removeEvent = function(t, e, n) {
        t.removeEventListener && t.removeEventListener(e, n)
    }, p.Event = function(t, e) {
        return this instanceof p.Event ? (t && t.type ? (this.originalEvent = t, this.type = t.type, this.isDefaultPrevented = t.defaultPrevented || void 0 === t.defaultPrevented && !1 === t.returnValue ? st : at) : this.type = t, e && p.extend(this, e), this.timeStamp = t && t.timeStamp || p.now(), void(this[p.expando] = !0)) : new p.Event(t, e)
    }, p.Event.prototype = {
        constructor: p.Event,
        isDefaultPrevented: at,
        isPropagationStopped: at,
        isImmediatePropagationStopped: at,
        preventDefault: function() {
            var t = this.originalEvent;
            this.isDefaultPrevented = st, t && t.preventDefault()
        },
        stopPropagation: function() {
            var t = this.originalEvent;
            this.isPropagationStopped = st, t && t.stopPropagation()
        },
        stopImmediatePropagation: function() {
            var t = this.originalEvent;
            this.isImmediatePropagationStopped = st, t && t.stopImmediatePropagation(), this.stopPropagation()
        }
    }, p.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(t, e) {
        p.event.special[t] = {
            delegateType: e,
            bindType: e,
            handle: function(t) {
                var n, i = t.relatedTarget,
                    r = t.handleObj;
                return i && (i === this || p.contains(this, i)) || (t.type = r.origType, n = r.handler.apply(this, arguments), t.type = e), n
            }
        }
    }), p.fn.extend({
        on: function(t, e, n, i) {
            return ut(this, t, e, n, i)
        },
        one: function(t, e, n, i) {
            return ut(this, t, e, n, i, 1)
        },
        off: function(t, e, n) {
            var i, r;
            if (t && t.preventDefault && t.handleObj) return i = t.handleObj, p(t.delegateTarget).off(i.namespace ? i.origType + "." + i.namespace : i.origType, i.selector, i.handler), this;
            if ("object" == typeof t) {
                for (r in t) this.off(r, e, t[r]);
                return this
            }
            return !1 !== e && "function" != typeof e || (n = e, e = void 0), !1 === n && (n = at), this.each(function() {
                p.event.remove(this, t, n, e)
            })
        }
    });
    var ct = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
        dt = /<script|<style|<link/i,
        ht = /checked\s*(?:[^=]|=\s*.checked.)/i,
        pt = /^true\/(.*)/,
        ft = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

    function mt(t, e) {
        return p.nodeName(t, "table") && p.nodeName(11 !== e.nodeType ? e : e.firstChild, "tr") ? t.getElementsByTagName("tbody")[0] || t.appendChild(t.ownerDocument.createElement("tbody")) : t
    }

    function gt(t) {
        return t.type = (null !== t.getAttribute("type")) + "/" + t.type, t
    }

    function yt(t) {
        var e = pt.exec(t.type);
        return e ? t.type = e[1] : t.removeAttribute("type"), t
    }

    function vt(t, e) {
        var n, i, r, o, s, a, l, u;
        if (1 === e.nodeType) {
            if ($.hasData(t) && (o = $.access(t), s = $.set(e, o), u = o.events))
                for (r in delete s.handle, s.events = {}, u)
                    for (n = 0, i = u[r].length; i > n; n++) p.event.add(e, r, u[r][n]);
            z.hasData(t) && (a = z.access(t), l = p.extend({}, a), z.set(e, l))
        }
    }

    function _t(t, e, n, i) {
        e = o.apply([], e);
        var r, s, a, l, u, c, h = 0,
            f = t.length,
            m = f - 1,
            g = e[0],
            y = p.isFunction(g);
        if (y || f > 1 && "string" == typeof g && !d.checkClone && ht.test(g)) return t.each(function(r) {
            var o = t.eq(r);
            y && (e[0] = g.call(this, r, o.html())), _t(o, e, n, i)
        });
        if (f && (s = (r = nt(e, t[0].ownerDocument, !1, t, i)).firstChild, 1 === r.childNodes.length && (r = s), s || i)) {
            for (l = (a = p.map(Q(r, "script"), gt)).length; f > h; h++) u = r, h !== m && (u = p.clone(u, !0, !0), l && p.merge(a, Q(u, "script"))), n.call(t[h], u, h);
            if (l)
                for (c = a[a.length - 1].ownerDocument, p.map(a, yt), h = 0; l > h; h++) u = a[h], V.test(u.type || "") && !$.access(u, "globalEval") && p.contains(c, u) && (u.src ? p._evalUrl && p._evalUrl(u.src) : p.globalEval(u.textContent.replace(ft, "")))
        }
        return t
    }

    function bt(t, e, n) {
        for (var i, r = e ? p.filter(e, t) : t, o = 0; null != (i = r[o]); o++) n || 1 !== i.nodeType || p.cleanData(Q(i)), i.parentNode && (n && p.contains(i.ownerDocument, i) && K(Q(i, "script")), i.parentNode.removeChild(i));
        return t
    }
    p.extend({
        htmlPrefilter: function(t) {
            return t.replace(ct, "<$1></$2>")
        },
        clone: function(t, e, n) {
            var i, r, o, s, a, l, u, c = t.cloneNode(!0),
                h = p.contains(t.ownerDocument, t);
            if (!(d.noCloneChecked || 1 !== t.nodeType && 11 !== t.nodeType || p.isXMLDoc(t)))
                for (s = Q(c), i = 0, r = (o = Q(t)).length; r > i; i++) a = o[i], "input" === (u = (l = s[i]).nodeName.toLowerCase()) && Y.test(a.type) ? l.checked = a.checked : "input" !== u && "textarea" !== u || (l.defaultValue = a.defaultValue);
            if (e)
                if (n)
                    for (o = o || Q(t), s = s || Q(c), i = 0, r = o.length; r > i; i++) vt(o[i], s[i]);
                else vt(t, c);
            return (s = Q(c, "script")).length > 0 && K(s, !h && Q(t, "script")), c
        },
        cleanData: function(t) {
            for (var e, n, i, r = p.event.special, o = 0; void 0 !== (n = t[o]); o++)
                if (j(n)) {
                    if (e = n[$.expando]) {
                        if (e.events)
                            for (i in e.events) r[i] ? p.event.remove(n, i) : p.removeEvent(n, i, e.handle);
                        n[$.expando] = void 0
                    }
                    n[z.expando] && (n[z.expando] = void 0)
                }
        }
    }), p.fn.extend({
        domManip: _t,
        detach: function(t) {
            return bt(this, t, !0)
        },
        remove: function(t) {
            return bt(this, t)
        },
        text: function(t) {
            return L(this, function(t) {
                return void 0 === t ? p.text(this) : this.empty().each(function() {
                    1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = t)
                })
            }, null, t, arguments.length)
        },
        append: function() {
            return _t(this, arguments, function(t) {
                1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || mt(this, t).appendChild(t)
            })
        },
        prepend: function() {
            return _t(this, arguments, function(t) {
                if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                    var e = mt(this, t);
                    e.insertBefore(t, e.firstChild)
                }
            })
        },
        before: function() {
            return _t(this, arguments, function(t) {
                this.parentNode && this.parentNode.insertBefore(t, this)
            })
        },
        after: function() {
            return _t(this, arguments, function(t) {
                this.parentNode && this.parentNode.insertBefore(t, this.nextSibling)
            })
        },
        empty: function() {
            for (var t, e = 0; null != (t = this[e]); e++) 1 === t.nodeType && (p.cleanData(Q(t, !1)), t.textContent = "");
            return this
        },
        clone: function(t, e) {
            return t = null != t && t, e = null == e ? t : e, this.map(function() {
                return p.clone(this, t, e)
            })
        },
        html: function(t) {
            return L(this, function(t) {
                var e = this[0] || {},
                    n = 0,
                    i = this.length;
                if (void 0 === t && 1 === e.nodeType) return e.innerHTML;
                if ("string" == typeof t && !dt.test(t) && !G[(Z.exec(t) || ["", ""])[1].toLowerCase()]) {
                    t = p.htmlPrefilter(t);
                    try {
                        for (; i > n; n++) 1 === (e = this[n] || {}).nodeType && (p.cleanData(Q(e, !1)), e.innerHTML = t);
                        e = 0
                    } catch (t) {}
                }
                e && this.empty().append(t)
            }, null, t, arguments.length)
        },
        replaceWith: function() {
            var t = [];
            return _t(this, arguments, function(e) {
                var n = this.parentNode;
                p.inArray(this, t) < 0 && (p.cleanData(Q(this)), n && n.replaceChild(e, this))
            }, t)
        }
    }), p.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(t, e) {
        p.fn[t] = function(t) {
            for (var n, i = [], r = p(t), o = r.length - 1, a = 0; o >= a; a++) n = a === o ? this : this.clone(!0), p(r[a])[e](n), s.apply(i, n.get());
            return this.pushStack(i)
        }
    });
    var wt, xt = {
        HTML: "block",
        BODY: "block"
    };

    function St(t, e) {
        var n = p(e.createElement(t)).appendTo(e.body),
            i = p.css(n[0], "display");
        return n.detach(), i
    }

    function Tt(t) {
        var e = i,
            n = xt[t];
        return n || ("none" !== (n = St(t, e)) && n || ((e = (wt = (wt || p("<iframe frameborder='0' width='0' height='0'/>")).appendTo(e.documentElement))[0].contentDocument).write(), e.close(), n = St(t, e), wt.detach()), xt[t] = n), n
    }
    var kt = /^margin/,
        Ct = new RegExp("^(" + q + ")(?!px)[a-z%]+$", "i"),
        Et = function(e) {
            var n = e.ownerDocument.defaultView;
            return n && n.opener || (n = t), n.getComputedStyle(e)
        },
        At = function(t, e, n, i) {
            var r, o, s = {};
            for (o in e) s[o] = t.style[o], t.style[o] = e[o];
            for (o in r = n.apply(t, i || []), e) t.style[o] = s[o];
            return r
        },
        Dt = i.documentElement;

    function Pt(t, e, n) {
        var i, r, o, s, a = t.style;
        return "" !== (s = (n = n || Et(t)) ? n.getPropertyValue(e) || n[e] : void 0) && void 0 !== s || p.contains(t.ownerDocument, t) || (s = p.style(t, e)), n && !d.pixelMarginRight() && Ct.test(s) && kt.test(e) && (i = a.width, r = a.minWidth, o = a.maxWidth, a.minWidth = a.maxWidth = a.width = s, s = n.width, a.width = i, a.minWidth = r, a.maxWidth = o), void 0 !== s ? s + "" : s
    }

    function Ot(t, e) {
        return {
            get: function() {
                return t() ? void delete this.get : (this.get = e).apply(this, arguments)
            }
        }
    }! function() {
        var e, n, r, o, s = i.createElement("div"),
            a = i.createElement("div");
        if (a.style) {
            function l() {
                a.style.cssText = "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%", a.innerHTML = "", Dt.appendChild(s);
                var i = t.getComputedStyle(a);
                e = "1%" !== i.top, o = "2px" === i.marginLeft, n = "4px" === i.width, a.style.marginRight = "50%", r = "4px" === i.marginRight, Dt.removeChild(s)
            }
            a.style.backgroundClip = "content-box", a.cloneNode(!0).style.backgroundClip = "", d.clearCloneStyle = "content-box" === a.style.backgroundClip, s.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute", s.appendChild(a), p.extend(d, {
                pixelPosition: function() {
                    return l(), e
                },
                boxSizingReliable: function() {
                    return null == n && l(), n
                },
                pixelMarginRight: function() {
                    return null == n && l(), r
                },
                reliableMarginLeft: function() {
                    return null == n && l(), o
                },
                reliableMarginRight: function() {
                    var e, n = a.appendChild(i.createElement("div"));
                    return n.style.cssText = a.style.cssText = "-webkit-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0", n.style.marginRight = n.style.width = "0", a.style.width = "1px", Dt.appendChild(s), e = !parseFloat(t.getComputedStyle(n).marginRight), Dt.removeChild(s), a.removeChild(n), e
                }
            })
        }
    }();
    var It = /^(none|table(?!-c[ea]).+)/,
        Mt = {
            position: "absolute",
            visibility: "hidden",
            display: "block"
        },
        Lt = {
            letterSpacing: "0",
            fontWeight: "400"
        },
        jt = ["Webkit", "O", "Moz", "ms"],
        Nt = i.createElement("div").style;

    function $t(t) {
        if (t in Nt) return t;
        for (var e = t[0].toUpperCase() + t.slice(1), n = jt.length; n--;)
            if ((t = jt[n] + e) in Nt) return t
    }

    function zt(t, e, n) {
        var i = B.exec(e);
        return i ? Math.max(0, i[2] - (n || 0)) + (i[3] || "px") : e
    }

    function Ft(t, e, n, i, r) {
        for (var o = n === (i ? "border" : "content") ? 4 : "width" === e ? 1 : 0, s = 0; 4 > o; o += 2) "margin" === n && (s += p.css(t, n + U[o], !0, r)), i ? ("content" === n && (s -= p.css(t, "padding" + U[o], !0, r)), "margin" !== n && (s -= p.css(t, "border" + U[o] + "Width", !0, r))) : (s += p.css(t, "padding" + U[o], !0, r), "padding" !== n && (s += p.css(t, "border" + U[o] + "Width", !0, r)));
        return s
    }

    function Rt(e, n, r) {
        var o = !0,
            s = "width" === n ? e.offsetWidth : e.offsetHeight,
            a = Et(e),
            l = "border-box" === p.css(e, "boxSizing", !1, a);
        if (i.msFullscreenElement && t.top !== t && e.getClientRects().length && (s = Math.round(100 * e.getBoundingClientRect()[n])), 0 >= s || null == s) {
            if ((0 > (s = Pt(e, n, a)) || null == s) && (s = e.style[n]), Ct.test(s)) return s;
            o = l && (d.boxSizingReliable() || s === e.style[n]), s = parseFloat(s) || 0
        }
        return s + Ft(e, n, r || (l ? "border" : "content"), o, a) + "px"
    }

    function Ht(t, e) {
        for (var n, i, r, o = [], s = 0, a = t.length; a > s; s++)(i = t[s]).style && (o[s] = $.get(i, "olddisplay"), n = i.style.display, e ? (o[s] || "none" !== n || (i.style.display = ""), "" === i.style.display && W(i) && (o[s] = $.access(i, "olddisplay", Tt(i.nodeName)))) : (r = W(i), "none" === n && r || $.set(i, "olddisplay", r ? n : p.css(i, "display"))));
        for (s = 0; a > s; s++)(i = t[s]).style && (e && "none" !== i.style.display && "" !== i.style.display || (i.style.display = e ? o[s] || "" : "none"));
        return t
    }

    function qt(t, e, n, i, r) {
        return new qt.prototype.init(t, e, n, i, r)
    }
    p.extend({
        cssHooks: {
            opacity: {
                get: function(t, e) {
                    if (e) {
                        var n = Pt(t, "opacity");
                        return "" === n ? "1" : n
                    }
                }
            }
        },
        cssNumber: {
            animationIterationCount: !0,
            columnCount: !0,
            fillOpacity: !0,
            flexGrow: !0,
            flexShrink: !0,
            fontWeight: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0
        },
        cssProps: {
            float: "cssFloat"
        },
        style: function(t, e, n, i) {
            if (t && 3 !== t.nodeType && 8 !== t.nodeType && t.style) {
                var r, o, s, a = p.camelCase(e),
                    l = t.style;
                return e = p.cssProps[a] || (p.cssProps[a] = $t(a) || a), s = p.cssHooks[e] || p.cssHooks[a], void 0 === n ? s && "get" in s && void 0 !== (r = s.get(t, !1, i)) ? r : l[e] : ("string" == (o = typeof n) && (r = B.exec(n)) && r[1] && (n = X(t, e, r), o = "number"), void(null != n && n == n && ("number" === o && (n += r && r[3] || (p.cssNumber[a] ? "" : "px")), d.clearCloneStyle || "" !== n || 0 !== e.indexOf("background") || (l[e] = "inherit"), s && "set" in s && void 0 === (n = s.set(t, n, i)) || (l[e] = n))))
            }
        },
        css: function(t, e, n, i) {
            var r, o, s, a = p.camelCase(e);
            return e = p.cssProps[a] || (p.cssProps[a] = $t(a) || a), (s = p.cssHooks[e] || p.cssHooks[a]) && "get" in s && (r = s.get(t, !0, n)), void 0 === r && (r = Pt(t, e, i)), "normal" === r && e in Lt && (r = Lt[e]), "" === n || n ? (o = parseFloat(r), !0 === n || isFinite(o) ? o || 0 : r) : r
        }
    }), p.each(["height", "width"], function(t, e) {
        p.cssHooks[e] = {
            get: function(t, n, i) {
                return n ? It.test(p.css(t, "display")) && 0 === t.offsetWidth ? At(t, Mt, function() {
                    return Rt(t, e, i)
                }) : Rt(t, e, i) : void 0
            },
            set: function(t, n, i) {
                var r, o = i && Et(t),
                    s = i && Ft(t, e, i, "border-box" === p.css(t, "boxSizing", !1, o), o);
                return s && (r = B.exec(n)) && "px" !== (r[3] || "px") && (t.style[e] = n, n = p.css(t, e)), zt(0, n, s)
            }
        }
    }), p.cssHooks.marginLeft = Ot(d.reliableMarginLeft, function(t, e) {
        return e ? (parseFloat(Pt(t, "marginLeft")) || t.getBoundingClientRect().left - At(t, {
            marginLeft: 0
        }, function() {
            return t.getBoundingClientRect().left
        })) + "px" : void 0
    }), p.cssHooks.marginRight = Ot(d.reliableMarginRight, function(t, e) {
        return e ? At(t, {
            display: "inline-block"
        }, Pt, [t, "marginRight"]) : void 0
    }), p.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(t, e) {
        p.cssHooks[t + e] = {
            expand: function(n) {
                for (var i = 0, r = {}, o = "string" == typeof n ? n.split(" ") : [n]; 4 > i; i++) r[t + U[i] + e] = o[i] || o[i - 2] || o[0];
                return r
            }
        }, kt.test(t) || (p.cssHooks[t + e].set = zt)
    }), p.fn.extend({
        css: function(t, e) {
            return L(this, function(t, e, n) {
                var i, r, o = {},
                    s = 0;
                if (p.isArray(e)) {
                    for (i = Et(t), r = e.length; r > s; s++) o[e[s]] = p.css(t, e[s], !1, i);
                    return o
                }
                return void 0 !== n ? p.style(t, e, n) : p.css(t, e)
            }, t, e, arguments.length > 1)
        },
        show: function() {
            return Ht(this, !0)
        },
        hide: function() {
            return Ht(this)
        },
        toggle: function(t) {
            return "boolean" == typeof t ? t ? this.show() : this.hide() : this.each(function() {
                W(this) ? p(this).show() : p(this).hide()
            })
        }
    }), p.Tween = qt, qt.prototype = {
        constructor: qt,
        init: function(t, e, n, i, r, o) {
            this.elem = t, this.prop = n, this.easing = r || p.easing._default, this.options = e, this.start = this.now = this.cur(), this.end = i, this.unit = o || (p.cssNumber[n] ? "" : "px")
        },
        cur: function() {
            var t = qt.propHooks[this.prop];
            return t && t.get ? t.get(this) : qt.propHooks._default.get(this)
        },
        run: function(t) {
            var e, n = qt.propHooks[this.prop];
            return this.options.duration ? this.pos = e = p.easing[this.easing](t, this.options.duration * t, 0, 1, this.options.duration) : this.pos = e = t, this.now = (this.end - this.start) * e + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), n && n.set ? n.set(this) : qt.propHooks._default.set(this), this
        }
    }, qt.prototype.init.prototype = qt.prototype, qt.propHooks = {
        _default: {
            get: function(t) {
                var e;
                return 1 !== t.elem.nodeType || null != t.elem[t.prop] && null == t.elem.style[t.prop] ? t.elem[t.prop] : (e = p.css(t.elem, t.prop, "")) && "auto" !== e ? e : 0
            },
            set: function(t) {
                p.fx.step[t.prop] ? p.fx.step[t.prop](t) : 1 !== t.elem.nodeType || null == t.elem.style[p.cssProps[t.prop]] && !p.cssHooks[t.prop] ? t.elem[t.prop] = t.now : p.style(t.elem, t.prop, t.now + t.unit)
            }
        }
    }, qt.propHooks.scrollTop = qt.propHooks.scrollLeft = {
        set: function(t) {
            t.elem.nodeType && t.elem.parentNode && (t.elem[t.prop] = t.now)
        }
    }, p.easing = {
        linear: function(t) {
            return t
        },
        swing: function(t) {
            return .5 - Math.cos(t * Math.PI) / 2
        },
        _default: "swing"
    }, p.fx = qt.prototype.init, p.fx.step = {};
    var Bt, Ut, Wt, Xt, Yt, Zt = /^(?:toggle|show|hide)$/,
        Vt = /queueHooks$/;

    function Gt() {
        return t.setTimeout(function() {
            Bt = void 0
        }), Bt = p.now()
    }

    function Qt(t, e) {
        var n, i = 0,
            r = {
                height: t
            };
        for (e = e ? 1 : 0; 4 > i; i += 2 - e) r["margin" + (n = U[i])] = r["padding" + n] = t;
        return e && (r.opacity = r.width = t), r
    }

    function Kt(t, e, n) {
        for (var i, r = (Jt.tweeners[e] || []).concat(Jt.tweeners["*"]), o = 0, s = r.length; s > o; o++)
            if (i = r[o].call(n, e, t)) return i
    }

    function Jt(t, e, n) {
        var i, r, o = 0,
            s = Jt.prefilters.length,
            a = p.Deferred().always(function() {
                delete l.elem
            }),
            l = function() {
                if (r) return !1;
                for (var e = Bt || Gt(), n = Math.max(0, u.startTime + u.duration - e), i = 1 - (n / u.duration || 0), o = 0, s = u.tweens.length; s > o; o++) u.tweens[o].run(i);
                return a.notifyWith(t, [u, i, n]), 1 > i && s ? n : (a.resolveWith(t, [u]), !1)
            },
            u = a.promise({
                elem: t,
                props: p.extend({}, e),
                opts: p.extend(!0, {
                    specialEasing: {},
                    easing: p.easing._default
                }, n),
                originalProperties: e,
                originalOptions: n,
                startTime: Bt || Gt(),
                duration: n.duration,
                tweens: [],
                createTween: function(e, n) {
                    var i = p.Tween(t, u.opts, e, n, u.opts.specialEasing[e] || u.opts.easing);
                    return u.tweens.push(i), i
                },
                stop: function(e) {
                    var n = 0,
                        i = e ? u.tweens.length : 0;
                    if (r) return this;
                    for (r = !0; i > n; n++) u.tweens[n].run(1);
                    return e ? (a.notifyWith(t, [u, 1, 0]), a.resolveWith(t, [u, e])) : a.rejectWith(t, [u, e]), this
                }
            }),
            c = u.props;
        for (function(t, e) {
                var n, i, r, o, s;
                for (n in t)
                    if (r = e[i = p.camelCase(n)], o = t[n], p.isArray(o) && (r = o[1], o = t[n] = o[0]), n !== i && (t[i] = o, delete t[n]), (s = p.cssHooks[i]) && "expand" in s)
                        for (n in o = s.expand(o), delete t[i], o) n in t || (t[n] = o[n], e[n] = r);
                    else e[i] = r
            }(c, u.opts.specialEasing); s > o; o++)
            if (i = Jt.prefilters[o].call(u, t, c, u.opts)) return p.isFunction(i.stop) && (p._queueHooks(u.elem, u.opts.queue).stop = p.proxy(i.stop, i)), i;
        return p.map(c, Kt, u), p.isFunction(u.opts.start) && u.opts.start.call(t, u), p.fx.timer(p.extend(l, {
            elem: t,
            anim: u,
            queue: u.opts.queue
        })), u.progress(u.opts.progress).done(u.opts.done, u.opts.complete).fail(u.opts.fail).always(u.opts.always)
    }
    p.Animation = p.extend(Jt, {
        tweeners: {
            "*": [function(t, e) {
                var n = this.createTween(t, e);
                return X(n.elem, t, B.exec(e), n), n
            }]
        },
        tweener: function(t, e) {
            p.isFunction(t) ? (e = t, t = ["*"]) : t = t.match(I);
            for (var n, i = 0, r = t.length; r > i; i++) n = t[i], Jt.tweeners[n] = Jt.tweeners[n] || [], Jt.tweeners[n].unshift(e)
        },
        prefilters: [function(t, e, n) {
            var i, r, o, s, a, l, u, c = this,
                d = {},
                h = t.style,
                f = t.nodeType && W(t),
                m = $.get(t, "fxshow");
            for (i in n.queue || (null == (a = p._queueHooks(t, "fx")).unqueued && (a.unqueued = 0, l = a.empty.fire, a.empty.fire = function() {
                    a.unqueued || l()
                }), a.unqueued++, c.always(function() {
                    c.always(function() {
                        a.unqueued--, p.queue(t, "fx").length || a.empty.fire()
                    })
                })), 1 === t.nodeType && ("height" in e || "width" in e) && (n.overflow = [h.overflow, h.overflowX, h.overflowY], "inline" === ("none" === (u = p.css(t, "display")) ? $.get(t, "olddisplay") || Tt(t.nodeName) : u) && "none" === p.css(t, "float") && (h.display = "inline-block")), n.overflow && (h.overflow = "hidden", c.always(function() {
                    h.overflow = n.overflow[0], h.overflowX = n.overflow[1], h.overflowY = n.overflow[2]
                })), e)
                if (r = e[i], Zt.exec(r)) {
                    if (delete e[i], o = o || "toggle" === r, r === (f ? "hide" : "show")) {
                        if ("show" !== r || !m || void 0 === m[i]) continue;
                        f = !0
                    }
                    d[i] = m && m[i] || p.style(t, i)
                } else u = void 0;
            if (p.isEmptyObject(d)) "inline" === ("none" === u ? Tt(t.nodeName) : u) && (h.display = u);
            else
                for (i in m ? "hidden" in m && (f = m.hidden) : m = $.access(t, "fxshow", {}), o && (m.hidden = !f), f ? p(t).show() : c.done(function() {
                        p(t).hide()
                    }), c.done(function() {
                        var e;
                        for (e in $.remove(t, "fxshow"), d) p.style(t, e, d[e])
                    }), d) s = Kt(f ? m[i] : 0, i, c), i in m || (m[i] = s.start, f && (s.end = s.start, s.start = "width" === i || "height" === i ? 1 : 0))
        }],
        prefilter: function(t, e) {
            e ? Jt.prefilters.unshift(t) : Jt.prefilters.push(t)
        }
    }), p.speed = function(t, e, n) {
        var i = t && "object" == typeof t ? p.extend({}, t) : {
            complete: n || !n && e || p.isFunction(t) && t,
            duration: t,
            easing: n && e || e && !p.isFunction(e) && e
        };
        return i.duration = p.fx.off ? 0 : "number" == typeof i.duration ? i.duration : i.duration in p.fx.speeds ? p.fx.speeds[i.duration] : p.fx.speeds._default, null != i.queue && !0 !== i.queue || (i.queue = "fx"), i.old = i.complete, i.complete = function() {
            p.isFunction(i.old) && i.old.call(this), i.queue && p.dequeue(this, i.queue)
        }, i
    }, p.fn.extend({
        fadeTo: function(t, e, n, i) {
            return this.filter(W).css("opacity", 0).show().end().animate({
                opacity: e
            }, t, n, i)
        },
        animate: function(t, e, n, i) {
            var r = p.isEmptyObject(t),
                o = p.speed(e, n, i),
                s = function() {
                    var e = Jt(this, p.extend({}, t), o);
                    (r || $.get(this, "finish")) && e.stop(!0)
                };
            return s.finish = s, r || !1 === o.queue ? this.each(s) : this.queue(o.queue, s)
        },
        stop: function(t, e, n) {
            var i = function(t) {
                var e = t.stop;
                delete t.stop, e(n)
            };
            return "string" != typeof t && (n = e, e = t, t = void 0), e && !1 !== t && this.queue(t || "fx", []), this.each(function() {
                var e = !0,
                    r = null != t && t + "queueHooks",
                    o = p.timers,
                    s = $.get(this);
                if (r) s[r] && s[r].stop && i(s[r]);
                else
                    for (r in s) s[r] && s[r].stop && Vt.test(r) && i(s[r]);
                for (r = o.length; r--;) o[r].elem !== this || null != t && o[r].queue !== t || (o[r].anim.stop(n), e = !1, o.splice(r, 1));
                !e && n || p.dequeue(this, t)
            })
        },
        finish: function(t) {
            return !1 !== t && (t = t || "fx"), this.each(function() {
                var e, n = $.get(this),
                    i = n[t + "queue"],
                    r = n[t + "queueHooks"],
                    o = p.timers,
                    s = i ? i.length : 0;
                for (n.finish = !0, p.queue(this, t, []), r && r.stop && r.stop.call(this, !0), e = o.length; e--;) o[e].elem === this && o[e].queue === t && (o[e].anim.stop(!0), o.splice(e, 1));
                for (e = 0; s > e; e++) i[e] && i[e].finish && i[e].finish.call(this);
                delete n.finish
            })
        }
    }), p.each(["toggle", "show", "hide"], function(t, e) {
        var n = p.fn[e];
        p.fn[e] = function(t, i, r) {
            return null == t || "boolean" == typeof t ? n.apply(this, arguments) : this.animate(Qt(e, !0), t, i, r)
        }
    }), p.each({
        slideDown: Qt("show"),
        slideUp: Qt("hide"),
        slideToggle: Qt("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(t, e) {
        p.fn[t] = function(t, n, i) {
            return this.animate(e, t, n, i)
        }
    }), p.timers = [], p.fx.tick = function() {
        var t, e = 0,
            n = p.timers;
        for (Bt = p.now(); e < n.length; e++)(t = n[e])() || n[e] !== t || n.splice(e--, 1);
        n.length || p.fx.stop(), Bt = void 0
    }, p.fx.timer = function(t) {
        p.timers.push(t), t() ? p.fx.start() : p.timers.pop()
    }, p.fx.interval = 13, p.fx.start = function() {
        Ut || (Ut = t.setInterval(p.fx.tick, p.fx.interval))
    }, p.fx.stop = function() {
        t.clearInterval(Ut), Ut = null
    }, p.fx.speeds = {
        slow: 600,
        fast: 200,
        _default: 400
    }, p.fn.delay = function(e, n) {
        return e = p.fx && p.fx.speeds[e] || e, n = n || "fx", this.queue(n, function(n, i) {
            var r = t.setTimeout(n, e);
            i.stop = function() {
                t.clearTimeout(r)
            }
        })
    }, Wt = i.createElement("input"), Yt = (Xt = i.createElement("select")).appendChild(i.createElement("option")), Wt.type = "checkbox", d.checkOn = "" !== Wt.value, d.optSelected = Yt.selected, Xt.disabled = !0, d.optDisabled = !Yt.disabled, (Wt = i.createElement("input")).value = "t", Wt.type = "radio", d.radioValue = "t" === Wt.value;
    var te, ee = p.expr.attrHandle;
    p.fn.extend({
        attr: function(t, e) {
            return L(this, p.attr, t, e, arguments.length > 1)
        },
        removeAttr: function(t) {
            return this.each(function() {
                p.removeAttr(this, t)
            })
        }
    }), p.extend({
        attr: function(t, e, n) {
            var i, r, o = t.nodeType;
            if (3 !== o && 8 !== o && 2 !== o) return void 0 === t.getAttribute ? p.prop(t, e, n) : (1 === o && p.isXMLDoc(t) || (e = e.toLowerCase(), r = p.attrHooks[e] || (p.expr.match.bool.test(e) ? te : void 0)), void 0 !== n ? null === n ? void p.removeAttr(t, e) : r && "set" in r && void 0 !== (i = r.set(t, n, e)) ? i : (t.setAttribute(e, n + ""), n) : r && "get" in r && null !== (i = r.get(t, e)) ? i : null == (i = p.find.attr(t, e)) ? void 0 : i)
        },
        attrHooks: {
            type: {
                set: function(t, e) {
                    if (!d.radioValue && "radio" === e && p.nodeName(t, "input")) {
                        var n = t.value;
                        return t.setAttribute("type", e), n && (t.value = n), e
                    }
                }
            }
        },
        removeAttr: function(t, e) {
            var n, i, r = 0,
                o = e && e.match(I);
            if (o && 1 === t.nodeType)
                for (; n = o[r++];) i = p.propFix[n] || n, p.expr.match.bool.test(n) && (t[i] = !1), t.removeAttribute(n)
        }
    }), te = {
        set: function(t, e, n) {
            return !1 === e ? p.removeAttr(t, n) : t.setAttribute(n, n), n
        }
    }, p.each(p.expr.match.bool.source.match(/\w+/g), function(t, e) {
        var n = ee[e] || p.find.attr;
        ee[e] = function(t, e, i) {
            var r, o;
            return i || (o = ee[e], ee[e] = r, r = null != n(t, e, i) ? e.toLowerCase() : null, ee[e] = o), r
        }
    });
    var ne = /^(?:input|select|textarea|button)$/i,
        ie = /^(?:a|area)$/i;
    p.fn.extend({
        prop: function(t, e) {
            return L(this, p.prop, t, e, arguments.length > 1)
        },
        removeProp: function(t) {
            return this.each(function() {
                delete this[p.propFix[t] || t]
            })
        }
    }), p.extend({
        prop: function(t, e, n) {
            var i, r, o = t.nodeType;
            if (3 !== o && 8 !== o && 2 !== o) return 1 === o && p.isXMLDoc(t) || (e = p.propFix[e] || e, r = p.propHooks[e]), void 0 !== n ? r && "set" in r && void 0 !== (i = r.set(t, n, e)) ? i : t[e] = n : r && "get" in r && null !== (i = r.get(t, e)) ? i : t[e]
        },
        propHooks: {
            tabIndex: {
                get: function(t) {
                    var e = p.find.attr(t, "tabindex");
                    return e ? parseInt(e, 10) : ne.test(t.nodeName) || ie.test(t.nodeName) && t.href ? 0 : -1
                }
            }
        },
        propFix: {
            for: "htmlFor",
            class: "className"
        }
    }), d.optSelected || (p.propHooks.selected = {
        get: function(t) {
            var e = t.parentNode;
            return e && e.parentNode && e.parentNode.selectedIndex, null
        },
        set: function(t) {
            var e = t.parentNode;
            e && (e.selectedIndex, e.parentNode && e.parentNode.selectedIndex)
        }
    }), p.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() {
        p.propFix[this.toLowerCase()] = this
    });
    var re = /[\t\r\n\f]/g;

    function oe(t) {
        return t.getAttribute && t.getAttribute("class") || ""
    }
    p.fn.extend({
        addClass: function(t) {
            var e, n, i, r, o, s, a, l = 0;
            if (p.isFunction(t)) return this.each(function(e) {
                p(this).addClass(t.call(this, e, oe(this)))
            });
            if ("string" == typeof t && t)
                for (e = t.match(I) || []; n = this[l++];)
                    if (r = oe(n), i = 1 === n.nodeType && (" " + r + " ").replace(re, " ")) {
                        for (s = 0; o = e[s++];) i.indexOf(" " + o + " ") < 0 && (i += o + " ");
                        r !== (a = p.trim(i)) && n.setAttribute("class", a)
                    } return this
        },
        removeClass: function(t) {
            var e, n, i, r, o, s, a, l = 0;
            if (p.isFunction(t)) return this.each(function(e) {
                p(this).removeClass(t.call(this, e, oe(this)))
            });
            if (!arguments.length) return this.attr("class", "");
            if ("string" == typeof t && t)
                for (e = t.match(I) || []; n = this[l++];)
                    if (r = oe(n), i = 1 === n.nodeType && (" " + r + " ").replace(re, " ")) {
                        for (s = 0; o = e[s++];)
                            for (; i.indexOf(" " + o + " ") > -1;) i = i.replace(" " + o + " ", " ");
                        r !== (a = p.trim(i)) && n.setAttribute("class", a)
                    } return this
        },
        toggleClass: function(t, e) {
            var n = typeof t;
            return "boolean" == typeof e && "string" === n ? e ? this.addClass(t) : this.removeClass(t) : p.isFunction(t) ? this.each(function(n) {
                p(this).toggleClass(t.call(this, n, oe(this), e), e)
            }) : this.each(function() {
                var e, i, r, o;
                if ("string" === n)
                    for (i = 0, r = p(this), o = t.match(I) || []; e = o[i++];) r.hasClass(e) ? r.removeClass(e) : r.addClass(e);
                else void 0 !== t && "boolean" !== n || ((e = oe(this)) && $.set(this, "__className__", e), this.setAttribute && this.setAttribute("class", e || !1 === t ? "" : $.get(this, "__className__") || ""))
            })
        },
        hasClass: function(t) {
            var e, n, i = 0;
            for (e = " " + t + " "; n = this[i++];)
                if (1 === n.nodeType && (" " + oe(n) + " ").replace(re, " ").indexOf(e) > -1) return !0;
            return !1
        }
    });
    var se = /\r/g,
        ae = /[\x20\t\r\n\f]+/g;
    p.fn.extend({
        val: function(t) {
            var e, n, i, r = this[0];
            return arguments.length ? (i = p.isFunction(t), this.each(function(n) {
                var r;
                1 === this.nodeType && (null == (r = i ? t.call(this, n, p(this).val()) : t) ? r = "" : "number" == typeof r ? r += "" : p.isArray(r) && (r = p.map(r, function(t) {
                    return null == t ? "" : t + ""
                })), (e = p.valHooks[this.type] || p.valHooks[this.nodeName.toLowerCase()]) && "set" in e && void 0 !== e.set(this, r, "value") || (this.value = r))
            })) : r ? (e = p.valHooks[r.type] || p.valHooks[r.nodeName.toLowerCase()]) && "get" in e && void 0 !== (n = e.get(r, "value")) ? n : "string" == typeof(n = r.value) ? n.replace(se, "") : null == n ? "" : n : void 0
        }
    }), p.extend({
        valHooks: {
            option: {
                get: function(t) {
                    var e = p.find.attr(t, "value");
                    return null != e ? e : p.trim(p.text(t)).replace(ae, " ")
                }
            },
            select: {
                get: function(t) {
                    for (var e, n, i = t.options, r = t.selectedIndex, o = "select-one" === t.type || 0 > r, s = o ? null : [], a = o ? r + 1 : i.length, l = 0 > r ? a : o ? r : 0; a > l; l++)
                        if (((n = i[l]).selected || l === r) && (d.optDisabled ? !n.disabled : null === n.getAttribute("disabled")) && (!n.parentNode.disabled || !p.nodeName(n.parentNode, "optgroup"))) {
                            if (e = p(n).val(), o) return e;
                            s.push(e)
                        } return s
                },
                set: function(t, e) {
                    for (var n, i, r = t.options, o = p.makeArray(e), s = r.length; s--;)((i = r[s]).selected = p.inArray(p.valHooks.option.get(i), o) > -1) && (n = !0);
                    return n || (t.selectedIndex = -1), o
                }
            }
        }
    }), p.each(["radio", "checkbox"], function() {
        p.valHooks[this] = {
            set: function(t, e) {
                return p.isArray(e) ? t.checked = p.inArray(p(t).val(), e) > -1 : void 0
            }
        }, d.checkOn || (p.valHooks[this].get = function(t) {
            return null === t.getAttribute("value") ? "on" : t.value
        })
    });
    var le = /^(?:focusinfocus|focusoutblur)$/;
    p.extend(p.event, {
        trigger: function(e, n, r, o) {
            var s, a, l, u, d, h, f, m = [r || i],
                g = c.call(e, "type") ? e.type : e,
                y = c.call(e, "namespace") ? e.namespace.split(".") : [];
            if (a = l = r = r || i, 3 !== r.nodeType && 8 !== r.nodeType && !le.test(g + p.event.triggered) && (g.indexOf(".") > -1 && (g = (y = g.split(".")).shift(), y.sort()), d = g.indexOf(":") < 0 && "on" + g, (e = e[p.expando] ? e : new p.Event(g, "object" == typeof e && e)).isTrigger = o ? 2 : 3, e.namespace = y.join("."), e.rnamespace = e.namespace ? new RegExp("(^|\\.)" + y.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, e.result = void 0, e.target || (e.target = r), n = null == n ? [e] : p.makeArray(n, [e]), f = p.event.special[g] || {}, o || !f.trigger || !1 !== f.trigger.apply(r, n))) {
                if (!o && !f.noBubble && !p.isWindow(r)) {
                    for (u = f.delegateType || g, le.test(u + g) || (a = a.parentNode); a; a = a.parentNode) m.push(a), l = a;
                    l === (r.ownerDocument || i) && m.push(l.defaultView || l.parentWindow || t)
                }
                for (s = 0;
                    (a = m[s++]) && !e.isPropagationStopped();) e.type = s > 1 ? u : f.bindType || g, (h = ($.get(a, "events") || {})[e.type] && $.get(a, "handle")) && h.apply(a, n), (h = d && a[d]) && h.apply && j(a) && (e.result = h.apply(a, n), !1 === e.result && e.preventDefault());
                return e.type = g, o || e.isDefaultPrevented() || f._default && !1 !== f._default.apply(m.pop(), n) || !j(r) || d && p.isFunction(r[g]) && !p.isWindow(r) && ((l = r[d]) && (r[d] = null), p.event.triggered = g, r[g](), p.event.triggered = void 0, l && (r[d] = l)), e.result
            }
        },
        simulate: function(t, e, n) {
            var i = p.extend(new p.Event, n, {
                type: t,
                isSimulated: !0
            });
            p.event.trigger(i, null, e), i.isDefaultPrevented() && n.preventDefault()
        }
    }), p.fn.extend({
        trigger: function(t, e) {
            return this.each(function() {
                p.event.trigger(t, e, this)
            })
        },
        triggerHandler: function(t, e) {
            var n = this[0];
            return n ? p.event.trigger(t, e, n, !0) : void 0
        }
    }), p.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "), function(t, e) {
        p.fn[e] = function(t, n) {
            return arguments.length > 0 ? this.on(e, null, t, n) : this.trigger(e)
        }
    }), p.fn.extend({
        hover: function(t, e) {
            return this.mouseenter(t).mouseleave(e || t)
        }
    }), d.focusin = "onfocusin" in t, d.focusin || p.each({
        focus: "focusin",
        blur: "focusout"
    }, function(t, e) {
        var n = function(t) {
            p.event.simulate(e, t.target, p.event.fix(t))
        };
        p.event.special[e] = {
            setup: function() {
                var i = this.ownerDocument || this,
                    r = $.access(i, e);
                r || i.addEventListener(t, n, !0), $.access(i, e, (r || 0) + 1)
            },
            teardown: function() {
                var i = this.ownerDocument || this,
                    r = $.access(i, e) - 1;
                r ? $.access(i, e, r) : (i.removeEventListener(t, n, !0), $.remove(i, e))
            }
        }
    });
    var ue = t.location,
        ce = p.now(),
        de = /\?/;
    p.parseJSON = function(t) {
        return JSON.parse(t + "")
    }, p.parseXML = function(e) {
        var n;
        if (!e || "string" != typeof e) return null;
        try {
            n = (new t.DOMParser).parseFromString(e, "text/xml")
        } catch (t) {
            n = void 0
        }
        return n && !n.getElementsByTagName("parsererror").length || p.error("Invalid XML: " + e), n
    };
    var he = /#.*$/,
        pe = /([?&])_=[^&]*/,
        fe = /^(.*?):[ \t]*([^\r\n]*)$/gm,
        me = /^(?:GET|HEAD)$/,
        ge = /^\/\//,
        ye = {},
        ve = {},
        _e = "*/".concat("*"),
        be = i.createElement("a");

    function we(t) {
        return function(e, n) {
            "string" != typeof e && (n = e, e = "*");
            var i, r = 0,
                o = e.toLowerCase().match(I) || [];
            if (p.isFunction(n))
                for (; i = o[r++];) "+" === i[0] ? (i = i.slice(1) || "*", (t[i] = t[i] || []).unshift(n)) : (t[i] = t[i] || []).push(n)
        }
    }

    function xe(t, e, n, i) {
        var r = {},
            o = t === ve;

        function s(a) {
            var l;
            return r[a] = !0, p.each(t[a] || [], function(t, a) {
                var u = a(e, n, i);
                return "string" != typeof u || o || r[u] ? o ? !(l = u) : void 0 : (e.dataTypes.unshift(u), s(u), !1)
            }), l
        }
        return s(e.dataTypes[0]) || !r["*"] && s("*")
    }

    function Se(t, e) {
        var n, i, r = p.ajaxSettings.flatOptions || {};
        for (n in e) void 0 !== e[n] && ((r[n] ? t : i || (i = {}))[n] = e[n]);
        return i && p.extend(!0, t, i), t
    }
    be.href = ue.href, p.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: ue.href,
            type: "GET",
            isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(ue.protocol),
            global: !0,
            processData: !0,
            async: !0,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            accepts: {
                "*": _e,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            converters: {
                "* text": String,
                "text html": !0,
                "text json": p.parseJSON,
                "text xml": p.parseXML
            },
            flatOptions: {
                url: !0,
                context: !0
            }
        },
        ajaxSetup: function(t, e) {
            return e ? Se(Se(t, p.ajaxSettings), e) : Se(p.ajaxSettings, t)
        },
        ajaxPrefilter: we(ye),
        ajaxTransport: we(ve),
        ajax: function(e, n) {
            "object" == typeof e && (n = e, e = void 0), n = n || {};
            var r, o, s, a, l, u, c, d, h = p.ajaxSetup({}, n),
                f = h.context || h,
                m = h.context && (f.nodeType || f.jquery) ? p(f) : p.event,
                g = p.Deferred(),
                y = p.Callbacks("once memory"),
                v = h.statusCode || {},
                _ = {},
                b = {},
                w = 0,
                x = "canceled",
                S = {
                    readyState: 0,
                    getResponseHeader: function(t) {
                        var e;
                        if (2 === w) {
                            if (!a)
                                for (a = {}; e = fe.exec(s);) a[e[1].toLowerCase()] = e[2];
                            e = a[t.toLowerCase()]
                        }
                        return null == e ? null : e
                    },
                    getAllResponseHeaders: function() {
                        return 2 === w ? s : null
                    },
                    setRequestHeader: function(t, e) {
                        var n = t.toLowerCase();
                        return w || (t = b[n] = b[n] || t, _[t] = e), this
                    },
                    overrideMimeType: function(t) {
                        return w || (h.mimeType = t), this
                    },
                    statusCode: function(t) {
                        var e;
                        if (t)
                            if (2 > w)
                                for (e in t) v[e] = [v[e], t[e]];
                            else S.always(t[S.status]);
                        return this
                    },
                    abort: function(t) {
                        var e = t || x;
                        return r && r.abort(e), T(0, e), this
                    }
                };
            if (g.promise(S).complete = y.add, S.success = S.done, S.error = S.fail, h.url = ((e || h.url || ue.href) + "").replace(he, "").replace(ge, ue.protocol + "//"), h.type = n.method || n.type || h.method || h.type, h.dataTypes = p.trim(h.dataType || "*").toLowerCase().match(I) || [""], null == h.crossDomain) {
                u = i.createElement("a");
                try {
                    u.href = h.url, u.href = u.href, h.crossDomain = be.protocol + "//" + be.host != u.protocol + "//" + u.host
                } catch (t) {
                    h.crossDomain = !0
                }
            }
            if (h.data && h.processData && "string" != typeof h.data && (h.data = p.param(h.data, h.traditional)), xe(ye, h, n, S), 2 === w) return S;
            for (d in (c = p.event && h.global) && 0 == p.active++ && p.event.trigger("ajaxStart"), h.type = h.type.toUpperCase(), h.hasContent = !me.test(h.type), o = h.url, h.hasContent || (h.data && (o = h.url += (de.test(o) ? "&" : "?") + h.data, delete h.data), !1 === h.cache && (h.url = pe.test(o) ? o.replace(pe, "$1_=" + ce++) : o + (de.test(o) ? "&" : "?") + "_=" + ce++)), h.ifModified && (p.lastModified[o] && S.setRequestHeader("If-Modified-Since", p.lastModified[o]), p.etag[o] && S.setRequestHeader("If-None-Match", p.etag[o])), (h.data && h.hasContent && !1 !== h.contentType || n.contentType) && S.setRequestHeader("Content-Type", h.contentType), S.setRequestHeader("Accept", h.dataTypes[0] && h.accepts[h.dataTypes[0]] ? h.accepts[h.dataTypes[0]] + ("*" !== h.dataTypes[0] ? ", " + _e + "; q=0.01" : "") : h.accepts["*"]), h.headers) S.setRequestHeader(d, h.headers[d]);
            if (h.beforeSend && (!1 === h.beforeSend.call(f, S, h) || 2 === w)) return S.abort();
            for (d in x = "abort", {
                    success: 1,
                    error: 1,
                    complete: 1
                }) S[d](h[d]);
            if (r = xe(ve, h, n, S)) {
                if (S.readyState = 1, c && m.trigger("ajaxSend", [S, h]), 2 === w) return S;
                h.async && h.timeout > 0 && (l = t.setTimeout(function() {
                    S.abort("timeout")
                }, h.timeout));
                try {
                    w = 1, r.send(_, T)
                } catch (t) {
                    if (!(2 > w)) throw t;
                    T(-1, t)
                }
            } else T(-1, "No Transport");

            function T(e, n, i, a) {
                var u, d, _, b, x, T = n;
                2 !== w && (w = 2, l && t.clearTimeout(l), r = void 0, s = a || "", S.readyState = e > 0 ? 4 : 0, u = e >= 200 && 300 > e || 304 === e, i && (b = function(t, e, n) {
                    for (var i, r, o, s, a = t.contents, l = t.dataTypes;
                        "*" === l[0];) l.shift(), void 0 === i && (i = t.mimeType || e.getResponseHeader("Content-Type"));
                    if (i)
                        for (r in a)
                            if (a[r] && a[r].test(i)) {
                                l.unshift(r);
                                break
                            } if (l[0] in n) o = l[0];
                    else {
                        for (r in n) {
                            if (!l[0] || t.converters[r + " " + l[0]]) {
                                o = r;
                                break
                            }
                            s || (s = r)
                        }
                        o = o || s
                    }
                    return o ? (o !== l[0] && l.unshift(o), n[o]) : void 0
                }(h, S, i)), b = function(t, e, n, i) {
                    var r, o, s, a, l, u = {},
                        c = t.dataTypes.slice();
                    if (c[1])
                        for (s in t.converters) u[s.toLowerCase()] = t.converters[s];
                    for (o = c.shift(); o;)
                        if (t.responseFields[o] && (n[t.responseFields[o]] = e), !l && i && t.dataFilter && (e = t.dataFilter(e, t.dataType)), l = o, o = c.shift())
                            if ("*" === o) o = l;
                            else if ("*" !== l && l !== o) {
                        if (!(s = u[l + " " + o] || u["* " + o]))
                            for (r in u)
                                if ((a = r.split(" "))[1] === o && (s = u[l + " " + a[0]] || u["* " + a[0]])) {
                                    !0 === s ? s = u[r] : !0 !== u[r] && (o = a[0], c.unshift(a[1]));
                                    break
                                } if (!0 !== s)
                            if (s && t.throws) e = s(e);
                            else try {
                                e = s(e)
                            } catch (t) {
                                return {
                                    state: "parsererror",
                                    error: s ? t : "No conversion from " + l + " to " + o
                                }
                            }
                    }
                    return {
                        state: "success",
                        data: e
                    }
                }(h, b, S, u), u ? (h.ifModified && ((x = S.getResponseHeader("Last-Modified")) && (p.lastModified[o] = x), (x = S.getResponseHeader("etag")) && (p.etag[o] = x)), 204 === e || "HEAD" === h.type ? T = "nocontent" : 304 === e ? T = "notmodified" : (T = b.state, d = b.data, u = !(_ = b.error))) : (_ = T, !e && T || (T = "error", 0 > e && (e = 0))), S.status = e, S.statusText = (n || T) + "", u ? g.resolveWith(f, [d, T, S]) : g.rejectWith(f, [S, T, _]), S.statusCode(v), v = void 0, c && m.trigger(u ? "ajaxSuccess" : "ajaxError", [S, h, u ? d : _]), y.fireWith(f, [S, T]), c && (m.trigger("ajaxComplete", [S, h]), --p.active || p.event.trigger("ajaxStop")))
            }
            return S
        },
        getJSON: function(t, e, n) {
            return p.get(t, e, n, "json")
        },
        getScript: function(t, e) {
            return p.get(t, void 0, e, "script")
        }
    }), p.each(["get", "post"], function(t, e) {
        p[e] = function(t, n, i, r) {
            return p.isFunction(n) && (r = r || i, i = n, n = void 0), p.ajax(p.extend({
                url: t,
                type: e,
                dataType: r,
                data: n,
                success: i
            }, p.isPlainObject(t) && t))
        }
    }), p._evalUrl = function(t) {
        return p.ajax({
            url: t,
            type: "GET",
            dataType: "script",
            async: !1,
            global: !1,
            throws: !0
        })
    }, p.fn.extend({
        wrapAll: function(t) {
            var e;
            return p.isFunction(t) ? this.each(function(e) {
                p(this).wrapAll(t.call(this, e))
            }) : (this[0] && (e = p(t, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && e.insertBefore(this[0]), e.map(function() {
                for (var t = this; t.firstElementChild;) t = t.firstElementChild;
                return t
            }).append(this)), this)
        },
        wrapInner: function(t) {
            return p.isFunction(t) ? this.each(function(e) {
                p(this).wrapInner(t.call(this, e))
            }) : this.each(function() {
                var e = p(this),
                    n = e.contents();
                n.length ? n.wrapAll(t) : e.append(t)
            })
        },
        wrap: function(t) {
            var e = p.isFunction(t);
            return this.each(function(n) {
                p(this).wrapAll(e ? t.call(this, n) : t)
            })
        },
        unwrap: function() {
            return this.parent().each(function() {
                p.nodeName(this, "body") || p(this).replaceWith(this.childNodes)
            }).end()
        }
    }), p.expr.filters.hidden = function(t) {
        return !p.expr.filters.visible(t)
    }, p.expr.filters.visible = function(t) {
        return t.offsetWidth > 0 || t.offsetHeight > 0 || t.getClientRects().length > 0
    };
    var Te = /%20/g,
        ke = /\[\]$/,
        Ce = /\r?\n/g,
        Ee = /^(?:submit|button|image|reset|file)$/i,
        Ae = /^(?:input|select|textarea|keygen)/i;

    function De(t, e, n, i) {
        var r;
        if (p.isArray(e)) p.each(e, function(e, r) {
            n || ke.test(t) ? i(t, r) : De(t + "[" + ("object" == typeof r && null != r ? e : "") + "]", r, n, i)
        });
        else if (n || "object" !== p.type(e)) i(t, e);
        else
            for (r in e) De(t + "[" + r + "]", e[r], n, i)
    }
    p.param = function(t, e) {
        var n, i = [],
            r = function(t, e) {
                e = p.isFunction(e) ? e() : null == e ? "" : e, i[i.length] = encodeURIComponent(t) + "=" + encodeURIComponent(e)
            };
        if (void 0 === e && (e = p.ajaxSettings && p.ajaxSettings.traditional), p.isArray(t) || t.jquery && !p.isPlainObject(t)) p.each(t, function() {
            r(this.name, this.value)
        });
        else
            for (n in t) De(n, t[n], e, r);
        return i.join("&").replace(Te, "+")
    }, p.fn.extend({
        serialize: function() {
            return p.param(this.serializeArray())
        },
        serializeArray: function() {
            return this.map(function() {
                var t = p.prop(this, "elements");
                return t ? p.makeArray(t) : this
            }).filter(function() {
                var t = this.type;
                return this.name && !p(this).is(":disabled") && Ae.test(this.nodeName) && !Ee.test(t) && (this.checked || !Y.test(t))
            }).map(function(t, e) {
                var n = p(this).val();
                return null == n ? null : p.isArray(n) ? p.map(n, function(t) {
                    return {
                        name: e.name,
                        value: t.replace(Ce, "\r\n")
                    }
                }) : {
                    name: e.name,
                    value: n.replace(Ce, "\r\n")
                }
            }).get()
        }
    }), p.ajaxSettings.xhr = function() {
        try {
            return new t.XMLHttpRequest
        } catch (t) {}
    };
    var Pe = {
            0: 200,
            1223: 204
        },
        Oe = p.ajaxSettings.xhr();
    d.cors = !!Oe && "withCredentials" in Oe, d.ajax = Oe = !!Oe, p.ajaxTransport(function(e) {
        var n, i;
        return d.cors || Oe && !e.crossDomain ? {
            send: function(r, o) {
                var s, a = e.xhr();
                if (a.open(e.type, e.url, e.async, e.username, e.password), e.xhrFields)
                    for (s in e.xhrFields) a[s] = e.xhrFields[s];
                for (s in e.mimeType && a.overrideMimeType && a.overrideMimeType(e.mimeType), e.crossDomain || r["X-Requested-With"] || (r["X-Requested-With"] = "XMLHttpRequest"), r) a.setRequestHeader(s, r[s]);
                n = function(t) {
                    return function() {
                        n && (n = i = a.onload = a.onerror = a.onabort = a.onreadystatechange = null, "abort" === t ? a.abort() : "error" === t ? "number" != typeof a.status ? o(0, "error") : o(a.status, a.statusText) : o(Pe[a.status] || a.status, a.statusText, "text" !== (a.responseType || "text") || "string" != typeof a.responseText ? {
                            binary: a.response
                        } : {
                            text: a.responseText
                        }, a.getAllResponseHeaders()))
                    }
                }, a.onload = n(), i = a.onerror = n("error"), void 0 !== a.onabort ? a.onabort = i : a.onreadystatechange = function() {
                    4 === a.readyState && t.setTimeout(function() {
                        n && i()
                    })
                }, n = n("abort");
                try {
                    a.send(e.hasContent && e.data || null)
                } catch (t) {
                    if (n) throw t
                }
            },
            abort: function() {
                n && n()
            }
        } : void 0
    }), p.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(t) {
                return p.globalEval(t), t
            }
        }
    }), p.ajaxPrefilter("script", function(t) {
        void 0 === t.cache && (t.cache = !1), t.crossDomain && (t.type = "GET")
    }), p.ajaxTransport("script", function(t) {
        var e, n;
        if (t.crossDomain) return {
            send: function(r, o) {
                e = p("<script>").prop({
                    charset: t.scriptCharset,
                    src: t.url
                }).on("load error", n = function(t) {
                    e.remove(), n = null, t && o("error" === t.type ? 404 : 200, t.type)
                }), i.head.appendChild(e[0])
            },
            abort: function() {
                n && n()
            }
        }
    });
    var Ie = [],
        Me = /(=)\?(?=&|$)|\?\?/;
    p.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var t = Ie.pop() || p.expando + "_" + ce++;
            return this[t] = !0, t
        }
    }), p.ajaxPrefilter("json jsonp", function(e, n, i) {
        var r, o, s, a = !1 !== e.jsonp && (Me.test(e.url) ? "url" : "string" == typeof e.data && 0 === (e.contentType || "").indexOf("application/x-www-form-urlencoded") && Me.test(e.data) && "data");
        return a || "jsonp" === e.dataTypes[0] ? (r = e.jsonpCallback = p.isFunction(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback, a ? e[a] = e[a].replace(Me, "$1" + r) : !1 !== e.jsonp && (e.url += (de.test(e.url) ? "&" : "?") + e.jsonp + "=" + r), e.converters["script json"] = function() {
            return s || p.error(r + " was not called"), s[0]
        }, e.dataTypes[0] = "json", o = t[r], t[r] = function() {
            s = arguments
        }, i.always(function() {
            void 0 === o ? p(t).removeProp(r) : t[r] = o, e[r] && (e.jsonpCallback = n.jsonpCallback, Ie.push(r)), s && p.isFunction(o) && o(s[0]), s = o = void 0
        }), "script") : void 0
    }), p.parseHTML = function(t, e, n) {
        if (!t || "string" != typeof t) return null;
        "boolean" == typeof e && (n = e, e = !1), e = e || i;
        var r = S.exec(t),
            o = !n && [];
        return r ? [e.createElement(r[1])] : (r = nt([t], e, o), o && o.length && p(o).remove(), p.merge([], r.childNodes))
    };
    var Le = p.fn.load;

    function je(t) {
        return p.isWindow(t) ? t : 9 === t.nodeType && t.defaultView
    }
    p.fn.load = function(t, e, n) {
        if ("string" != typeof t && Le) return Le.apply(this, arguments);
        var i, r, o, s = this,
            a = t.indexOf(" ");
        return a > -1 && (i = p.trim(t.slice(a)), t = t.slice(0, a)), p.isFunction(e) ? (n = e, e = void 0) : e && "object" == typeof e && (r = "POST"), s.length > 0 && p.ajax({
            url: t,
            type: r || "GET",
            dataType: "html",
            data: e
        }).done(function(t) {
            o = arguments, s.html(i ? p("<div>").append(p.parseHTML(t)).find(i) : t)
        }).always(n && function(t, e) {
            s.each(function() {
                n.apply(this, o || [t.responseText, e, t])
            })
        }), this
    }, p.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(t, e) {
        p.fn[e] = function(t) {
            return this.on(e, t)
        }
    }), p.expr.filters.animated = function(t) {
        return p.grep(p.timers, function(e) {
            return t === e.elem
        }).length
    }, p.offset = {
        setOffset: function(t, e, n) {
            var i, r, o, s, a, l, u = p.css(t, "position"),
                c = p(t),
                d = {};
            "static" === u && (t.style.position = "relative"), a = c.offset(), o = p.css(t, "top"), l = p.css(t, "left"), ("absolute" === u || "fixed" === u) && (o + l).indexOf("auto") > -1 ? (s = (i = c.position()).top, r = i.left) : (s = parseFloat(o) || 0, r = parseFloat(l) || 0), p.isFunction(e) && (e = e.call(t, n, p.extend({}, a))), null != e.top && (d.top = e.top - a.top + s), null != e.left && (d.left = e.left - a.left + r), "using" in e ? e.using.call(t, d) : c.css(d)
        }
    }, p.fn.extend({
        offset: function(t) {
            if (arguments.length) return void 0 === t ? this : this.each(function(e) {
                p.offset.setOffset(this, t, e)
            });
            var e, n, i = this[0],
                r = {
                    top: 0,
                    left: 0
                },
                o = i && i.ownerDocument;
            return o ? (e = o.documentElement, p.contains(e, i) ? (r = i.getBoundingClientRect(), n = je(o), {
                top: r.top + n.pageYOffset - e.clientTop,
                left: r.left + n.pageXOffset - e.clientLeft
            }) : r) : void 0
        },
        position: function() {
            if (this[0]) {
                var t, e, n = this[0],
                    i = {
                        top: 0,
                        left: 0
                    };
                return "fixed" === p.css(n, "position") ? e = n.getBoundingClientRect() : (t = this.offsetParent(), e = this.offset(), p.nodeName(t[0], "html") || (i = t.offset()), i.top += p.css(t[0], "borderTopWidth", !0), i.left += p.css(t[0], "borderLeftWidth", !0)), {
                    top: e.top - i.top - p.css(n, "marginTop", !0),
                    left: e.left - i.left - p.css(n, "marginLeft", !0)
                }
            }
        },
        offsetParent: function() {
            return this.map(function() {
                for (var t = this.offsetParent; t && "static" === p.css(t, "position");) t = t.offsetParent;
                return t || Dt
            })
        }
    }), p.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(t, e) {
        var n = "pageYOffset" === e;
        p.fn[t] = function(i) {
            return L(this, function(t, i, r) {
                var o = je(t);
                return void 0 === r ? o ? o[e] : t[i] : void(o ? o.scrollTo(n ? o.pageXOffset : r, n ? r : o.pageYOffset) : t[i] = r)
            }, t, i, arguments.length)
        }
    }), p.each(["top", "left"], function(t, e) {
        p.cssHooks[e] = Ot(d.pixelPosition, function(t, n) {
            return n ? (n = Pt(t, e), Ct.test(n) ? p(t).position()[e] + "px" : n) : void 0
        })
    }), p.each({
        Height: "height",
        Width: "width"
    }, function(t, e) {
        p.each({
            padding: "inner" + t,
            content: e,
            "": "outer" + t
        }, function(n, i) {
            p.fn[i] = function(i, r) {
                var o = arguments.length && (n || "boolean" != typeof i),
                    s = n || (!0 === i || !0 === r ? "margin" : "border");
                return L(this, function(e, n, i) {
                    var r;
                    return p.isWindow(e) ? e.document.documentElement["client" + t] : 9 === e.nodeType ? (r = e.documentElement, Math.max(e.body["scroll" + t], r["scroll" + t], e.body["offset" + t], r["offset" + t], r["client" + t])) : void 0 === i ? p.css(e, n, s) : p.style(e, n, i, s)
                }, e, o ? i : void 0, o, null)
            }
        })
    }), p.fn.extend({
        bind: function(t, e, n) {
            return this.on(t, null, e, n)
        },
        unbind: function(t, e) {
            return this.off(t, null, e)
        },
        delegate: function(t, e, n, i) {
            return this.on(e, t, n, i)
        },
        undelegate: function(t, e, n) {
            return 1 === arguments.length ? this.off(t, "**") : this.off(e, t || "**", n)
        },
        size: function() {
            return this.length
        }
    }), p.fn.andSelf = p.fn.addBack, "function" == typeof define && define.amd && define("jquery", [], function() {
        return p
    });
    var Ne = t.jQuery,
        $e = t.$;
    return p.noConflict = function(e) {
        return t.$ === p && (t.$ = $e), e && t.jQuery === p && (t.jQuery = Ne), p
    }, e || (t.jQuery = t.$ = p), p
}), function(t) {
    var e = {
        url: !1,
        callback: !1,
        target: !1,
        duration: 120,
        on: "mouseover",
        touch: !0,
        onZoomIn: !1,
        onZoomOut: !1,
        magnify: 1
    };
    t.zoom = function(e, n, i, r) {
        var o, s, a, l, u, c, d, h = t(e),
            p = h.css("position"),
            f = t(n);
        return e.style.position = /(absolute|fixed)/.test(p) ? p : "relative", e.style.overflow = "hidden", i.style.width = i.style.height = "", t(i).addClass("zoomImg").css({
            position: "absolute",
            top: 0,
            left: 0,
            opacity: 0,
            width: i.width * r,
            height: i.height * r,
            border: "none",
            maxWidth: "none",
            maxHeight: "none"
        }).appendTo(e), {
            init: function() {
                s = h.outerWidth(), o = h.outerHeight(), n === e ? (l = s, a = o) : (l = f.outerWidth(), a = f.outerHeight()), u = (i.width - s) / l, c = (i.height - o) / a, d = f.offset()
            },
            move: function(t) {
                var e = t.pageX - d.left,
                    n = t.pageY - d.top;
                n = Math.max(Math.min(n, a), 0), e = Math.max(Math.min(e, l), 0), i.style.left = e * -u + "px", i.style.top = n * -c + "px"
            }
        }
    }, t.fn.zoom = function(n) {
        return this.each(function() {
            var i = t.extend({}, e, n || {}),
                r = i.target && t(i.target)[0] || this,
                o = this,
                s = t(o),
                a = document.createElement("img"),
                l = t(a),
                u = "mousemove.zoom",
                c = !1,
                d = !1;
            if (!i.url) {
                var h = o.querySelector("img");
                if (h && (i.url = h.getAttribute("data-src") || h.currentSrc || h.src), !i.url) return
            }
            s.one("zoom.destroy", function(t, e) {
                s.off(".zoom"), r.style.position = t, r.style.overflow = e, a.onload = null, l.remove()
            }.bind(this, r.style.position, r.style.overflow)), a.onload = function() {
                function e(e) {
                    h.init(), h.move(e), l.stop().fadeTo(t.support.opacity ? i.duration : 0, 1, !!t.isFunction(i.onZoomIn) && i.onZoomIn.call(a))
                }

                function n() {
                    l.stop().fadeTo(i.duration, 0, !!t.isFunction(i.onZoomOut) && i.onZoomOut.call(a))
                }
                var h = t.zoom(r, o, a, i.magnify);
                "grab" === i.on ? s.on("mousedown.zoom", function(i) {
                    1 === i.which && (t(document).one("mouseup.zoom", function() {
                        n(), t(document).off(u, h.move)
                    }), e(i), t(document).on(u, h.move), i.preventDefault())
                }) : "click" === i.on ? s.on("click.zoom", function(i) {
                    return c ? void 0 : (c = !0, e(i), t(document).on(u, h.move), t(document).one("click.zoom", function() {
                        n(), c = !1, t(document).off(u, h.move)
                    }), !1)
                }) : "toggle" === i.on ? s.on("click.zoom", function(t) {
                    c ? n() : e(t), c = !c
                }) : "mouseover" === i.on && (h.init(), s.on("mouseenter.zoom", e).on("mouseleave.zoom", n).on(u, h.move)), i.touch && s.on("touchstart.zoom", function(t) {
                    t.preventDefault(), d ? (d = !1, n()) : (d = !0, e(t.originalEvent.touches[0] || t.originalEvent.changedTouches[0]))
                }).on("touchmove.zoom", function(t) {
                    t.preventDefault(), h.move(t.originalEvent.touches[0] || t.originalEvent.changedTouches[0])
                }).on("touchend.zoom", function(t) {
                    t.preventDefault(), d && (d = !1, n())
                }), t.isFunction(i.callback) && i.callback.call(a)
            }, a.setAttribute("role", "presentation"), a.alt = "", a.src = i.url
        })
    }, t.fn.zoom.defaults = e
}(window.jQuery), window.mobileCheck = function() {
    var t, e = !1;
    return t = navigator.userAgent || navigator.vendor || window.opera, (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(t) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(t.substr(0, 4))) && (e = !0), e
}, function(t, e, n) {
    function i(t, e) {
        return typeof t === e
    }

    function r() {
        return "function" != typeof e.createElement ? e.createElement(arguments[0]) : g ? e.createElementNS.call(e, "http://www.w3.org/2000/svg", arguments[0]) : e.createElement.apply(e, arguments)
    }

    function o(t, e) {
        return function() {
            return t.apply(e, arguments)
        }
    }

    function s(t) {
        return t.replace(/([A-Z])/g, function(t, e) {
            return "-" + e.toLowerCase()
        }).replace(/^ms-/, "-ms-")
    }

    function a(t, n, i, o) {
        var s, a, l, u, c, d = "modernizr",
            h = r("div"),
            p = ((c = e.body) || ((c = r(g ? "svg" : "body")).fake = !0), c);
        if (parseInt(i, 10))
            for (; i--;)(l = r("div")).id = o ? o[i] : d + (i + 1), h.appendChild(l);
        return (s = r("style")).type = "text/css", s.id = "s" + d, (p.fake ? p : h).appendChild(s), p.appendChild(h), s.styleSheet ? s.styleSheet.cssText = t : s.appendChild(e.createTextNode(t)), h.id = d, p.fake && (p.style.background = "", p.style.overflow = "hidden", u = m.style.overflow, m.style.overflow = "hidden", m.appendChild(p)), a = n(h, t), p.fake ? (p.parentNode.removeChild(p), m.style.overflow = u, m.offsetHeight) : h.parentNode.removeChild(h), !!a
    }

    function l(e, o, l, u) {
        function c() {
            h && (delete w.style, delete w.modElem)
        }
        if (u = !i(u, "undefined") && u, !i(l, "undefined")) {
            var d = function(e, i) {
                var r = e.length;
                if ("CSS" in t && "supports" in t.CSS) {
                    for (; r--;)
                        if (t.CSS.supports(s(e[r]), i)) return !0;
                    return !1
                }
                if ("CSSSupportsRule" in t) {
                    for (var o = []; r--;) o.push("(" + s(e[r]) + ":" + i + ")");
                    return a("@supports (" + (o = o.join(" or ")) + ") { #modernizr { position: absolute; } }", function(t) {
                        return "absolute" == getComputedStyle(t, null).position
                    })
                }
                return n
            }(e, l);
            if (!i(d, "undefined")) return d
        }
        for (var h, p, f, m, g, y = ["modernizr", "tspan", "samp"]; !w.style && y.length;) h = !0, w.modElem = r(y.shift()), w.style = w.modElem.style;
        for (f = e.length, p = 0; f > p; p++)
            if (m = e[p], g = w.style[m], !!~("" + m).indexOf("-") && (m = m.replace(/([a-z])-([a-z])/g, function(t, e, n) {
                    return e + n.toUpperCase()
                }).replace(/^-/, "")), w.style[m] !== n) {
                if (u || i(l, "undefined")) return c(), "pfx" != o || m;
                try {
                    w.style[m] = l
                } catch (e) {}
                if (w.style[m] != g) return c(), "pfx" != o || m
            } return c(), !1
    }

    function u(t, e, n, r, s) {
        var a = t.charAt(0).toUpperCase() + t.slice(1),
            u = (t + " " + v.join(a + " ") + a).split(" ");
        return i(e, "string") || i(e, "undefined") ? l(u, e, r, s) : function(t, e, n) {
            var r;
            for (var s in t)
                if (t[s] in e) return !1 === n ? t[s] : i(r = e[t[s]], "function") ? o(r, n || e) : r;
            return !1
        }(u = (t + " " + _.join(a + " ") + a).split(" "), e, n)
    }

    function c(t, e, i) {
        return u(t, n, n, e, i)
    }
    var d = [],
        h = [],
        p = {
            _version: "3.3.1",
            _config: {
                classPrefix: "",
                enableClasses: !0,
                enableJSClass: !0,
                usePrefixes: !0
            },
            _q: [],
            on: function(t, e) {
                var n = this;
                setTimeout(function() {
                    e(n[t])
                }, 0)
            },
            addTest: function(t, e, n) {
                h.push({
                    name: t,
                    fn: e,
                    options: n
                })
            },
            addAsyncTest: function(t) {
                h.push({
                    name: null,
                    fn: t
                })
            }
        },
        f = function() {};
    f.prototype = p, (f = new f).addTest("svg", !!e.createElementNS && !!e.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect);
    var m = e.documentElement,
        g = "svg" === m.nodeName.toLowerCase(),
        y = "Moz O ms Webkit",
        v = p._config.usePrefixes ? y.split(" ") : [];
    p._cssomPrefixes = v;
    var _ = p._config.usePrefixes ? y.toLowerCase().split(" ") : [];
    p._domPrefixes = _;
    var b = {
        elem: r("modernizr")
    };
    f._q.push(function() {
        delete b.elem
    });
    var w = {
        style: b.elem.style
    };
    f._q.unshift(function() {
            delete w.style
        }), p.testAllProps = u, p.testAllProps = c, f.addTest("flexbox", c("flexBasis", "1px", !0)), f.addTest("csstransforms", function() {
            return -1 === navigator.userAgent.indexOf("Android 2.") && c("transform", "scale(1)", !0)
        }),
        function() {
            var t, e, n, r, o, s;
            for (var a in h)
                if (h.hasOwnProperty(a)) {
                    if (t = [], (e = h[a]).name && (t.push(e.name.toLowerCase()), e.options && e.options.aliases && e.options.aliases.length))
                        for (n = 0; n < e.options.aliases.length; n++) t.push(e.options.aliases[n].toLowerCase());
                    for (r = i(e.fn, "function") ? e.fn() : e.fn, o = 0; o < t.length; o++) 1 === (s = t[o].split(".")).length ? f[s[0]] = r : (!f[s[0]] || f[s[0]] instanceof Boolean || (f[s[0]] = new Boolean(f[s[0]])), f[s[0]][s[1]] = r), d.push((r ? "" : "no-") + s.join("-"))
                }
        }(),
        function(t) {
            var e = m.className,
                n = f._config.classPrefix || "";
            if (g && (e = e.baseVal), f._config.enableJSClass) {
                var i = new RegExp("(^|\\s)" + n + "no-js(\\s|$)");
                e = e.replace(i, "$1" + n + "js$2")
            }
            f._config.enableClasses && (e += " " + n + t.join(" " + n), g ? m.className.baseVal = e : m.className = e)
        }(d), delete p.addTest, delete p.addAsyncTest;
    for (var x = 0; x < f._q.length; x++) f._q[x]();
    t.Modernizr = f
}(window, document), function(t) {
    t.fn.prepareTransition = function() {
        return this.each(function() {
            var e = t(this);
            e.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd", function() {
                e.removeClass("is-transitioning")
            });
            var n = 0;
            t.each(["transition-duration", "-moz-transition-duration", "-webkit-transition-duration", "-o-transition-duration"], function(t, i) {
                n || (n = parseFloat(e.css(i)))
            }), 0 != n && (e.addClass("is-transitioning"), e[0].offsetWidth)
        })
    }
}(jQuery), function(t) {
    "use strict";
    "function" == typeof define && define.amd ? define(["jquery"], t) : "undefined" != typeof exports ? module.exports = t(require("jquery")) : t(jQuery)
}(function(t) {
    "use strict";
    var e, n = window.Slick;
    (e = 0, n = function(n, i) {
        var r, o = this;
        o.defaults = {
            accessibility: !0,
            adaptiveHeight: !1,
            appendArrows: t(n),
            appendDots: t(n),
            arrows: !0,
            asNavFor: null,
            prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
            nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
            autoplay: !1,
            autoplaySpeed: 3e3,
            centerMode: !1,
            centerPadding: "50px",
            cssEase: "ease",
            customPaging: function(e, n) {
                return t('<button type="button" />').text(n + 1)
            },
            dots: !1,
            dotsClass: "slick-dots",
            draggable: !0,
            easing: "linear",
            edgeFriction: .35,
            fade: !1,
            focusOnSelect: !1,
            focusOnChange: !1,
            infinite: !0,
            initialSlide: 0,
            lazyLoad: "ondemand",
            mobileFirst: !1,
            pauseOnHover: !0,
            pauseOnFocus: !0,
            pauseOnDotsHover: !1,
            respondTo: "window",
            responsive: null,
            rows: 1,
            rtl: !1,
            slide: "",
            slidesPerRow: 1,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 500,
            delay: !1,
            swipe: !0,
            swipeToSlide: !1,
            touchMove: !0,
            touchThreshold: 5,
            useCSS: !0,
            useTransform: !0,
            variableWidth: !1,
            vertical: !1,
            verticalSwiping: !1,
            waitForAnimate: !0,
            zIndex: 1e3
        }, o.initials = {
            animating: !1,
            dragging: !1,
            autoPlayTimer: null,
            currentDirection: 0,
            currentLeft: null,
            currentSlide: 0,
            direction: 1,
            $dots: null,
            listWidth: null,
            listHeight: null,
            loadIndex: 0,
            $nextArrow: null,
            $prevArrow: null,
            scrolling: !1,
            slideCount: null,
            slideWidth: null,
            $slideTrack: null,
            $slides: null,
            sliding: !1,
            slideOffset: 0,
            swipeLeft: null,
            swiping: !1,
            $list: null,
            touchObject: {},
            transformsEnabled: !1,
            unslicked: !1
        }, t.extend(o, o.initials), o.activeBreakpoint = null, o.animType = null, o.animProp = null, o.breakpoints = [], o.breakpointSettings = [], o.cssTransitions = !1, o.focussed = !1, o.interrupted = !1, o.hidden = "hidden", o.paused = !0, o.positionProp = null, o.respondTo = null, o.rowCount = 1, o.shouldClick = !0, o.$slider = t(n), o.$slidesCache = null, o.transformType = null, o.transitionType = null, o.visibilityChange = "visibilitychange", o.windowWidth = 0, o.windowTimer = null, r = t(n).data("slick") || {}, o.options = t.extend({}, o.defaults, i, r), o.currentSlide = o.options.initialSlide, o.originalSettings = o.options, void 0 !== document.mozHidden ? (o.hidden = "mozHidden", o.visibilityChange = "mozvisibilitychange") : void 0 !== document.webkitHidden && (o.hidden = "webkitHidden", o.visibilityChange = "webkitvisibilitychange"), o.autoPlay = t.proxy(o.autoPlay, o), o.autoPlayClear = t.proxy(o.autoPlayClear, o), o.autoPlayIterator = t.proxy(o.autoPlayIterator, o), o.changeSlide = t.proxy(o.changeSlide, o), o.clickHandler = t.proxy(o.clickHandler, o), o.selectHandler = t.proxy(o.selectHandler, o), o.setPosition = t.proxy(o.setPosition, o), o.swipeHandler = t.proxy(o.swipeHandler, o), o.dragHandler = t.proxy(o.dragHandler, o), o.keyHandler = t.proxy(o.keyHandler, o), o.instanceUid = e++, o.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/, o.registerBreakpoints(), o.init(!0)
    }).prototype.activateADA = function() {
        this.$slideTrack.find(".slick-active").attr({
            "aria-hidden": "false"
        }).find("a, input, button, select").attr({
            tabindex: "0"
        })
    }, n.prototype.addSlide = n.prototype.slickAdd = function(e, n, i) {
        var r = this;
        if ("boolean" == typeof n) i = n, n = null;
        else if (n < 0 || n >= r.slideCount) return !1;
        r.unload(), "number" == typeof n ? 0 === n && 0 === r.$slides.length ? t(e).appendTo(r.$slideTrack) : i ? t(e).insertBefore(r.$slides.eq(n)) : t(e).insertAfter(r.$slides.eq(n)) : !0 === i ? t(e).prependTo(r.$slideTrack) : t(e).appendTo(r.$slideTrack), r.$slides = r.$slideTrack.children(this.options.slide), r.$slideTrack.children(this.options.slide).detach(), r.$slideTrack.append(r.$slides), r.$slides.each(function(e, n) {
            t(n).attr("data-slick-index", e)
        }), r.$slidesCache = r.$slides, r.reinit()
    }, n.prototype.animateHeight = function() {
        var t = this;
        if (1 === t.options.slidesToShow && !0 === t.options.adaptiveHeight && !1 === t.options.vertical) {
            var e = t.$slides.eq(t.currentSlide).outerHeight(!0);
            t.$list.animate({
                height: e
            }, t.options.speed)
        }
    }, n.prototype.animateSlide = function(e, n) {
        var i = {},
            r = this;
        r.animateHeight(), !0 === r.options.rtl && !1 === r.options.vertical && (e = -e), !1 === r.transformsEnabled ? !1 === r.options.vertical ? r.$slideTrack.animate({
            left: e
        }, r.options.speed, r.options.easing, n) : r.$slideTrack.animate({
            top: e
        }, r.options.speed, r.options.easing, n) : !1 === r.cssTransitions ? (!0 === r.options.rtl && (r.currentLeft = -r.currentLeft), t({
            animStart: r.currentLeft
        }).animate({
            animStart: e
        }, {
            duration: r.options.speed,
            easing: r.options.easing,
            step: function(t) {
                t = Math.ceil(t), !1 === r.options.vertical ? i[r.animType] = "translate(" + t + "px, 0px)" : i[r.animType] = "translate(0px," + t + "px)", r.$slideTrack.css(i)
            },
            complete: function() {
                n && n.call()
            }
        })) : (r.applyTransition(), e = Math.ceil(e), !1 === r.options.vertical ? i[r.animType] = "translate3d(" + e + "px, 0px, 0px)" : i[r.animType] = "translate3d(0px," + e + "px, 0px)", r.$slideTrack.css(i), n && setTimeout(function() {
            r.disableTransition(), n.call()
        }, r.options.delay ? r.options.delay : r.options.speed))
    }, n.prototype.getNavTarget = function() {
        var e = this.options.asNavFor;
        return e && null !== e && (e = t(e).not(this.$slider)), e
    }, n.prototype.asNavFor = function(e) {
        var n = this.getNavTarget();
        null !== n && "object" == typeof n && n.each(function() {
            var n = t(this).slick("getSlick");
            n.unslicked || n.slideHandler(e, !0)
        })
    }, n.prototype.applyTransition = function(t) {
        var e = this,
            n = {};
        !1 === e.options.fade ? n[e.transitionType] = e.transformType + " " + e.options.speed + "ms " + e.options.cssEase : n[e.transitionType] = "opacity " + e.options.speed + "ms " + e.options.cssEase, !1 === e.options.fade ? e.$slideTrack.css(n) : e.$slides.eq(t).css(n)
    }, n.prototype.autoPlay = function() {
        var t = this;
        t.autoPlayClear(), t.slideCount > t.options.slidesToShow && (t.autoPlayTimer = setInterval(t.autoPlayIterator, t.options.autoplaySpeed))
    }, n.prototype.autoPlayClear = function() {
        this.autoPlayTimer && clearInterval(this.autoPlayTimer)
    }, n.prototype.autoPlayIterator = function() {
        var t = this,
            e = t.currentSlide + t.options.slidesToScroll;
        t.paused || t.interrupted || t.focussed || (!1 === t.options.infinite && (1 === t.direction && t.currentSlide + 1 === t.slideCount - 1 ? t.direction = 0 : 0 === t.direction && (e = t.currentSlide - t.options.slidesToScroll, t.currentSlide - 1 == 0 && (t.direction = 1))), t.slideHandler(e))
    }, n.prototype.buildArrows = function() {
        var e = this;
        !0 === e.options.arrows && (e.$prevArrow = t(e.options.prevArrow).addClass("slick-arrow"), e.$nextArrow = t(e.options.nextArrow).addClass("slick-arrow"), e.slideCount > e.options.slidesToShow ? (e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.prependTo(e.options.appendArrows), e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.appendTo(e.options.appendArrows), !0 !== e.options.infinite && e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true")) : e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({
            "aria-disabled": "true",
            tabindex: "-1"
        }))
    }, n.prototype.buildDots = function() {
        var e, n, i = this;
        if (!0 === i.options.dots) {
            for (i.$slider.addClass("slick-dotted"), n = t("<ul />").addClass(i.options.dotsClass), e = 0; e <= i.getDotCount(); e += 1) n.append(t("<li />").append(i.options.customPaging.call(this, i, e)));
            i.$dots = n.appendTo(i.options.appendDots), i.$dots.find("li").first().addClass("slick-active")
        }
    }, n.prototype.buildOut = function() {
        var e = this;
        e.$slides = e.$slider.children(e.options.slide + ":not(.slick-cloned)").addClass("slick-slide"), e.slideCount = e.$slides.length, e.$slides.each(function(e, n) {
            t(n).attr("data-slick-index", e).data("originalStyling", t(n).attr("style") || "")
        }), e.$slider.addClass("slick-slider"), e.$slideTrack = 0 === e.slideCount ? t('<div class="slick-track"/>').appendTo(e.$slider) : e.$slides.wrapAll('<div class="slick-track"/>').parent(), e.$list = e.$slideTrack.wrap('<div class="slick-list"/>').parent(), e.$slideTrack.css("opacity", 0), !0 !== e.options.centerMode && !0 !== e.options.swipeToSlide || (e.options.slidesToScroll = 1), t("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"), e.setupInfinite(), e.buildArrows(), e.buildDots(), e.updateDots(), e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0), !0 === e.options.draggable && e.$list.addClass("draggable")
    }, n.prototype.buildRows = function() {
        var t, e, n, i, r, o, s, a = this;
        if (i = document.createDocumentFragment(), o = a.$slider.children(), 1 < a.options.rows) {
            for (s = a.options.slidesPerRow * a.options.rows, r = Math.ceil(o.length / s), t = 0; t < r; t++) {
                var l = document.createElement("div");
                for (e = 0; e < a.options.rows; e++) {
                    var u = document.createElement("div");
                    for (n = 0; n < a.options.slidesPerRow; n++) {
                        var c = t * s + (e * a.options.slidesPerRow + n);
                        o.get(c) && u.appendChild(o.get(c))
                    }
                    l.appendChild(u)
                }
                i.appendChild(l)
            }
            a.$slider.empty().append(i), a.$slider.children().children().children().css({
                width: 100 / a.options.slidesPerRow + "%",
                display: "inline-block"
            })
        }
    }, n.prototype.checkResponsive = function(e, n) {
        var i, r, o, s = this,
            a = !1,
            l = s.$slider.width(),
            u = window.innerWidth || t(window).width();
        if ("window" === s.respondTo ? o = u : "slider" === s.respondTo ? o = l : "min" === s.respondTo && (o = Math.min(u, l)), s.options.responsive && s.options.responsive.length && null !== s.options.responsive) {
            for (i in r = null, s.breakpoints) s.breakpoints.hasOwnProperty(i) && (!1 === s.originalSettings.mobileFirst ? o < s.breakpoints[i] && (r = s.breakpoints[i]) : o > s.breakpoints[i] && (r = s.breakpoints[i]));
            null !== r ? null !== s.activeBreakpoint ? (r !== s.activeBreakpoint || n) && (s.activeBreakpoint = r, "unslick" === s.breakpointSettings[r] ? s.unslick(r) : (s.options = t.extend({}, s.originalSettings, s.breakpointSettings[r]), !0 === e && (s.currentSlide = s.options.initialSlide), s.refresh(e)), a = r) : (s.activeBreakpoint = r, "unslick" === s.breakpointSettings[r] ? s.unslick(r) : (s.options = t.extend({}, s.originalSettings, s.breakpointSettings[r]), !0 === e && (s.currentSlide = s.options.initialSlide), s.refresh(e)), a = r) : null !== s.activeBreakpoint && (s.activeBreakpoint = null, s.options = s.originalSettings, !0 === e && (s.currentSlide = s.options.initialSlide), s.refresh(e), a = r), e || !1 === a || s.$slider.trigger("breakpoint", [s, a])
        }
    }, n.prototype.changeSlide = function(e, n) {
        var i, r, o = this,
            s = t(e.currentTarget);
        switch (s.is("a") && e.preventDefault(), s.is("li") || (s = s.closest("li")), i = o.slideCount % o.options.slidesToScroll != 0 ? 0 : (o.slideCount - o.currentSlide) % o.options.slidesToScroll, e.data.message) {
            case "previous":
                r = 0 === i ? o.options.slidesToScroll : o.options.slidesToShow - i, o.slideCount > o.options.slidesToShow && o.slideHandler(o.currentSlide - r, !1, n);
                break;
            case "next":
                r = 0 === i ? o.options.slidesToScroll : i, o.slideCount > o.options.slidesToShow && o.slideHandler(o.currentSlide + r, !1, n);
                break;
            case "index":
                var a = 0 === e.data.index ? 0 : e.data.index || s.index() * o.options.slidesToScroll;
                o.slideHandler(o.checkNavigable(a), !1, n), s.children().trigger("focus");
                break;
            default:
                return
        }
    }, n.prototype.checkNavigable = function(t) {
        var e, n;
        if (n = 0, t > (e = this.getNavigableIndexes())[e.length - 1]) t = e[e.length - 1];
        else
            for (var i in e) {
                if (t < e[i]) {
                    t = n;
                    break
                }
                n = e[i]
            }
        return t
    }, n.prototype.cleanUpEvents = function() {
        var e = this;
        e.options.dots && null !== e.$dots && (t("li", e.$dots).off("click.slick", e.changeSlide).off("mouseenter.slick", t.proxy(e.interrupt, e, !0)).off("mouseleave.slick", t.proxy(e.interrupt, e, !1)), !0 === e.options.accessibility && e.$dots.off("keydown.slick", e.keyHandler)), e.$slider.off("focus.slick blur.slick"), !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide), e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide), !0 === e.options.accessibility && (e.$prevArrow && e.$prevArrow.off("keydown.slick", e.keyHandler), e.$nextArrow && e.$nextArrow.off("keydown.slick", e.keyHandler))), e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler), e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler), e.$list.off("touchend.slick mouseup.slick", e.swipeHandler), e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler), e.$list.off("click.slick", e.clickHandler), t(document).off(e.visibilityChange, e.visibility), e.cleanUpSlideEvents(), !0 === e.options.accessibility && e.$list.off("keydown.slick", e.keyHandler), !0 === e.options.focusOnSelect && t(e.$slideTrack).children().off("click.slick", e.selectHandler), t(window).off("orientationchange.slick.slick-" + e.instanceUid, e.orientationChange), t(window).off("resize.slick.slick-" + e.instanceUid, e.resize), t("[draggable!=true]", e.$slideTrack).off("dragstart", e.preventDefault), t(window).off("load.slick.slick-" + e.instanceUid, e.setPosition)
    }, n.prototype.cleanUpSlideEvents = function() {
        var e = this;
        e.$list.off("mouseenter.slick", t.proxy(e.interrupt, e, !0)), e.$list.off("mouseleave.slick", t.proxy(e.interrupt, e, !1))
    }, n.prototype.cleanUpRows = function() {
        var t;
        1 < this.options.rows && ((t = this.$slides.children().children()).removeAttr("style"), this.$slider.empty().append(t))
    }, n.prototype.clickHandler = function(t) {
        !1 === this.shouldClick && (t.stopImmediatePropagation(), t.stopPropagation(), t.preventDefault())
    }, n.prototype.destroy = function(e) {
        var n = this;
        n.autoPlayClear(), n.touchObject = {}, n.cleanUpEvents(), t(".slick-cloned", n.$slider).detach(), n.$dots && n.$dots.remove(), n.$prevArrow && n.$prevArrow.length && (n.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), n.htmlExpr.test(n.options.prevArrow) && n.$prevArrow.remove()), n.$nextArrow && n.$nextArrow.length && (n.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), n.htmlExpr.test(n.options.nextArrow) && n.$nextArrow.remove()), n.$slides && (n.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function() {
            t(this).attr("style", t(this).data("originalStyling"))
        }), n.$slideTrack.children(this.options.slide).detach(), n.$slideTrack.detach(), n.$list.detach(), n.$slider.append(n.$slides)), n.cleanUpRows(), n.$slider.removeClass("slick-slider"), n.$slider.removeClass("slick-initialized"), n.$slider.removeClass("slick-dotted"), n.unslicked = !0, e || n.$slider.trigger("destroy", [n])
    }, n.prototype.disableTransition = function(t) {
        var e = {};
        e[this.transitionType] = "", !1 === this.options.fade ? this.$slideTrack.css(e) : this.$slides.eq(t).css(e)
    }, n.prototype.fadeSlide = function(t, e) {
        var n = this;
        !1 === n.cssTransitions ? (n.$slides.eq(t).css({
            zIndex: n.options.zIndex
        }), n.$slides.eq(t).animate({
            opacity: 1
        }, n.options.speed, n.options.easing, e)) : (n.applyTransition(t), n.$slides.eq(t).css({
            opacity: 1,
            zIndex: n.options.zIndex
        }), e && setTimeout(function() {
            n.disableTransition(t), e.call()
        }, n.options.speed))
    }, n.prototype.fadeSlideOut = function(t) {
        var e = this;
        !1 === e.cssTransitions ? e.$slides.eq(t).animate({
            opacity: 0,
            zIndex: e.options.zIndex - 2
        }, e.options.speed, e.options.easing) : (e.applyTransition(t), e.$slides.eq(t).css({
            opacity: 0,
            zIndex: e.options.zIndex - 2
        }))
    }, n.prototype.filterSlides = n.prototype.slickFilter = function(t) {
        var e = this;
        null !== t && (e.$slidesCache = e.$slides, e.unload(), e.$slideTrack.children(this.options.slide).detach(), e.$slidesCache.filter(t).appendTo(e.$slideTrack), e.reinit())
    }, n.prototype.focusHandler = function() {
        var e = this;
        e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*", function(n) {
            n.stopImmediatePropagation();
            var i = t(this);
            setTimeout(function() {
                e.options.pauseOnFocus && (e.focussed = i.is(":focus"), e.autoPlay())
            }, 0)
        })
    }, n.prototype.getCurrent = n.prototype.slickCurrentSlide = function() {
        return this.currentSlide
    }, n.prototype.getDotCount = function() {
        var t = this,
            e = 0,
            n = 0,
            i = 0;
        if (!0 === t.options.infinite)
            if (t.slideCount <= t.options.slidesToShow) ++i;
            else
                for (; e < t.slideCount;) ++i, e = n + t.options.slidesToScroll, n += t.options.slidesToScroll <= t.options.slidesToShow ? t.options.slidesToScroll : t.options.slidesToShow;
        else if (!0 === t.options.centerMode) i = t.slideCount;
        else if (t.options.asNavFor)
            for (; e < t.slideCount;) ++i, e = n + t.options.slidesToScroll, n += t.options.slidesToScroll <= t.options.slidesToShow ? t.options.slidesToScroll : t.options.slidesToShow;
        else i = 1 + Math.ceil((t.slideCount - t.options.slidesToShow) / t.options.slidesToScroll);
        return i - 1
    }, n.prototype.getLeft = function(t) {
        var e, n, i, r, o = this,
            s = 0;
        return o.slideOffset = 0, n = o.$slides.first().outerHeight(!0), !0 === o.options.infinite ? (o.slideCount > o.options.slidesToShow && (o.slideOffset = o.slideWidth * o.options.slidesToShow * -1, r = -1, !0 === o.options.vertical && !0 === o.options.centerMode && (2 === o.options.slidesToShow ? r = -1.5 : 1 === o.options.slidesToShow && (r = -2)), s = n * o.options.slidesToShow * r), o.slideCount % o.options.slidesToScroll != 0 && t + o.options.slidesToScroll > o.slideCount && o.slideCount > o.options.slidesToShow && (s = t > o.slideCount ? (o.slideOffset = (o.options.slidesToShow - (t - o.slideCount)) * o.slideWidth * -1, (o.options.slidesToShow - (t - o.slideCount)) * n * -1) : (o.slideOffset = o.slideCount % o.options.slidesToScroll * o.slideWidth * -1, o.slideCount % o.options.slidesToScroll * n * -1))) : t + o.options.slidesToShow > o.slideCount && (o.slideOffset = (t + o.options.slidesToShow - o.slideCount) * o.slideWidth, s = (t + o.options.slidesToShow - o.slideCount) * n), o.slideCount <= o.options.slidesToShow && (s = o.slideOffset = 0), !0 === o.options.centerMode && o.slideCount <= o.options.slidesToShow ? o.slideOffset = o.slideWidth * Math.floor(o.options.slidesToShow) / 2 - o.slideWidth * o.slideCount / 2 : !0 === o.options.centerMode && !0 === o.options.infinite ? o.slideOffset += o.slideWidth * Math.floor(o.options.slidesToShow / 2) - o.slideWidth : !0 === o.options.centerMode && (o.slideOffset = 0, o.slideOffset += o.slideWidth * Math.floor(o.options.slidesToShow / 2)), e = !1 === o.options.vertical ? t * o.slideWidth * -1 + o.slideOffset : t * n * -1 + s, !0 === o.options.variableWidth && (i = o.slideCount <= o.options.slidesToShow || !1 === o.options.infinite ? o.$slideTrack.children(".slick-slide").eq(t) : o.$slideTrack.children(".slick-slide").eq(t + o.options.slidesToShow), e = !0 === o.options.rtl ? i[0] ? -1 * (o.$slideTrack.width() - i[0].offsetLeft - i.width()) : 0 : i[0] ? -1 * i[0].offsetLeft : 0, !0 === o.options.centerMode && (i = o.slideCount <= o.options.slidesToShow || !1 === o.options.infinite ? o.$slideTrack.children(".slick-slide").eq(t) : o.$slideTrack.children(".slick-slide").eq(t + o.options.slidesToShow + 1), e = !0 === o.options.rtl ? i[0] ? -1 * (o.$slideTrack.width() - i[0].offsetLeft - i.width()) : 0 : i[0] ? -1 * i[0].offsetLeft : 0, e += (o.$list.width() - i.outerWidth()) / 2)), e
    }, n.prototype.getOption = n.prototype.slickGetOption = function(t) {
        return this.options[t]
    }, n.prototype.getNavigableIndexes = function() {
        var t, e = this,
            n = 0,
            i = 0,
            r = [];
        for (t = !1 === e.options.infinite ? e.slideCount : (n = -1 * e.options.slidesToScroll, i = -1 * e.options.slidesToScroll, 2 * e.slideCount); n < t;) r.push(n), n = i + e.options.slidesToScroll, i += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
        return r
    }, n.prototype.getSlick = function() {
        return this
    }, n.prototype.getSlideCount = function() {
        var e, n, i = this;
        return n = !0 === i.options.centerMode ? i.slideWidth * Math.floor(i.options.slidesToShow / 2) : 0, !0 === i.options.swipeToSlide ? (i.$slideTrack.find(".slick-slide").each(function(r, o) {
            if (o.offsetLeft - n + t(o).outerWidth() / 2 > -1 * i.swipeLeft) return e = o, !1
        }), Math.abs(t(e).attr("data-slick-index") - i.currentSlide) || 1) : i.options.slidesToScroll
    }, n.prototype.goTo = n.prototype.slickGoTo = function(t, e) {
        this.changeSlide({
            data: {
                message: "index",
                index: parseInt(t)
            }
        }, e)
    }, n.prototype.init = function(e) {
        var n = this;
        t(n.$slider).hasClass("slick-initialized") || (t(n.$slider).addClass("slick-initialized"), n.buildRows(), n.buildOut(), n.setProps(), n.startLoad(), n.loadSlider(), n.initializeEvents(), n.updateArrows(), n.updateDots(), n.checkResponsive(!0), n.focusHandler()), e && n.$slider.trigger("init", [n]), !0 === n.options.accessibility && n.initADA(), n.options.autoplay && (n.paused = !1, n.autoPlay())
    }, n.prototype.initADA = function() {
        var e = this,
            n = Math.ceil(e.slideCount / e.options.slidesToShow),
            i = e.getNavigableIndexes().filter(function(t) {
                return 0 <= t && t < e.slideCount
            });
        e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({
            "aria-hidden": "true",
            tabindex: "-1"
        }).find("a, input, button, select").attr({
            tabindex: "-1"
        }), null !== e.$dots && (e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(n) {
            var r = i.indexOf(n);
            t(this).attr({
                role: "tabpanel",
                id: "slick-slide" + e.instanceUid + n,
                tabindex: -1
            }), -1 !== r && t(this).attr({
                "aria-describedby": "slick-slide-control" + e.instanceUid + r
            })
        }), e.$dots.attr("role", "tablist").find("li").each(function(r) {
            var o = i[r];
            t(this).attr({
                role: "presentation"
            }), t(this).find("button").first().attr({
                role: "tab",
                id: "slick-slide-control" + e.instanceUid + r,
                "aria-controls": "slick-slide" + e.instanceUid + o,
                "aria-label": r + 1 + " of " + n,
                "aria-selected": null,
                tabindex: "-1"
            })
        }).eq(e.currentSlide).find("button").attr({
            "aria-selected": "true",
            tabindex: "0"
        }).end());
        for (var r = e.currentSlide, o = r + e.options.slidesToShow; r < o; r++) e.$slides.eq(r).attr("tabindex", 0);
        e.activateADA()
    }, n.prototype.initArrowEvents = function() {
        var t = this;
        !0 === t.options.arrows && t.slideCount > t.options.slidesToShow && (t.$prevArrow.off("click.slick").on("click.slick", {
            message: "previous"
        }, t.changeSlide), t.$nextArrow.off("click.slick").on("click.slick", {
            message: "next"
        }, t.changeSlide), !0 === t.options.accessibility && (t.$prevArrow.on("keydown.slick", t.keyHandler), t.$nextArrow.on("keydown.slick", t.keyHandler)))
    }, n.prototype.initDotEvents = function() {
        var e = this;
        !0 === e.options.dots && (t("li", e.$dots).on("click.slick", {
            message: "index"
        }, e.changeSlide), !0 === e.options.accessibility && e.$dots.on("keydown.slick", e.keyHandler)), !0 === e.options.dots && !0 === e.options.pauseOnDotsHover && t("li", e.$dots).on("mouseenter.slick", t.proxy(e.interrupt, e, !0)).on("mouseleave.slick", t.proxy(e.interrupt, e, !1))
    }, n.prototype.initSlideEvents = function() {
        var e = this;
        e.options.pauseOnHover && (e.$list.on("mouseenter.slick", t.proxy(e.interrupt, e, !0)), e.$list.on("mouseleave.slick", t.proxy(e.interrupt, e, !1)))
    }, n.prototype.initializeEvents = function() {
        var e = this;
        e.initArrowEvents(), e.initDotEvents(), e.initSlideEvents(), e.$list.on("touchstart.slick mousedown.slick", {
            action: "start"
        }, e.swipeHandler), e.$list.on("touchmove.slick mousemove.slick", {
            action: "move"
        }, e.swipeHandler), e.$list.on("touchend.slick mouseup.slick", {
            action: "end"
        }, e.swipeHandler), e.$list.on("touchcancel.slick mouseleave.slick", {
            action: "end"
        }, e.swipeHandler), e.$list.on("click.slick", e.clickHandler), t(document).on(e.visibilityChange, t.proxy(e.visibility, e)), !0 === e.options.accessibility && e.$list.on("keydown.slick", e.keyHandler), !0 === e.options.focusOnSelect && t(e.$slideTrack).children().on("click.slick", e.selectHandler), t(window).on("orientationchange.slick.slick-" + e.instanceUid, t.proxy(e.orientationChange, e)), t(window).on("resize.slick.slick-" + e.instanceUid, t.proxy(e.resize, e)), t("[draggable!=true]", e.$slideTrack).on("dragstart", e.preventDefault), t(window).on("load.slick.slick-" + e.instanceUid, e.setPosition), t(e.setPosition)
    }, n.prototype.initUI = function() {
        var t = this;
        !0 === t.options.arrows && t.slideCount > t.options.slidesToShow && (t.$prevArrow.show(), t.$nextArrow.show()), !0 === t.options.dots && t.slideCount > t.options.slidesToShow && t.$dots.show()
    }, n.prototype.keyHandler = function(t) {
        var e = this;
        t.target.tagName.match("TEXTAREA|INPUT|SELECT") || (37 === t.keyCode && !0 === e.options.accessibility ? e.changeSlide({
            data: {
                message: !0 === e.options.rtl ? "next" : "previous"
            }
        }) : 39 === t.keyCode && !0 === e.options.accessibility && e.changeSlide({
            data: {
                message: !0 === e.options.rtl ? "previous" : "next"
            }
        }))
    }, n.prototype.lazyLoad = function() {
        function e(e) {
            t("img[data-lazy]", e).each(function() {
                var e = t(this),
                    n = t(this).attr("data-lazy"),
                    i = t(this).attr("data-srcset"),
                    r = t(this).attr("data-sizes") || o.$slider.attr("data-sizes"),
                    s = document.createElement("img");
                s.onload = function() {
                    e.animate({
                        opacity: 0
                    }, 100, function() {
                        i && (e.attr("srcset", i), r && e.attr("sizes", r)), e.attr("src", n).animate({
                            opacity: 1
                        }, 200, function() {
                            e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")
                        }), o.$slider.trigger("lazyLoaded", [o, e, n])
                    })
                }, s.onerror = function() {
                    e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), o.$slider.trigger("lazyLoadError", [o, e, n])
                }, s.src = n
            })
        }
        var n, i, r, o = this;
        if (!0 === o.options.centerMode ? r = !0 === o.options.infinite ? (i = o.currentSlide + (o.options.slidesToShow / 2 + 1)) + o.options.slidesToShow + 2 : (i = Math.max(0, o.currentSlide - (o.options.slidesToShow / 2 + 1)), o.options.slidesToShow / 2 + 1 + 2 + o.currentSlide) : (i = o.options.infinite ? o.options.slidesToShow + o.currentSlide : o.currentSlide, r = Math.ceil(i + o.options.slidesToShow), !0 === o.options.fade && (0 < i && i--, r <= o.slideCount && r++)), n = o.$slider.find(".slick-slide").slice(i, r), "anticipated" === o.options.lazyLoad)
            for (var s = i - 1, a = r, l = o.$slider.find(".slick-slide"), u = 0; u < o.options.slidesToScroll; u++) s < 0 && (s = o.slideCount - 1), n = (n = n.add(l.eq(s))).add(l.eq(a)), s--, a++;
        e(n), o.slideCount <= o.options.slidesToShow ? e(o.$slider.find(".slick-slide")) : o.currentSlide >= o.slideCount - o.options.slidesToShow ? e(o.$slider.find(".slick-cloned").slice(0, o.options.slidesToShow)) : 0 === o.currentSlide && e(o.$slider.find(".slick-cloned").slice(-1 * o.options.slidesToShow))
    }, n.prototype.loadSlider = function() {
        var t = this;
        t.setPosition(), t.$slideTrack.css({
            opacity: 1
        }), t.$slider.removeClass("slick-loading"), t.initUI(), "progressive" === t.options.lazyLoad && t.progressiveLazyLoad()
    }, n.prototype.next = n.prototype.slickNext = function() {
        this.changeSlide({
            data: {
                message: "next"
            }
        })
    }, n.prototype.orientationChange = function() {
        this.checkResponsive(), this.setPosition()
    }, n.prototype.pause = n.prototype.slickPause = function() {
        this.autoPlayClear(), this.paused = !0
    }, n.prototype.play = n.prototype.slickPlay = function() {
        var t = this;
        t.autoPlay(), t.options.autoplay = !0, t.paused = !1, t.focussed = !1, t.interrupted = !1
    }, n.prototype.postSlide = function(e) {
        var n = this;
        n.unslicked || (n.$slider.trigger("afterChange", [n, e]), n.animating = !1, n.slideCount > n.options.slidesToShow && n.setPosition(), n.swipeLeft = null, n.options.autoplay && n.autoPlay(), !0 === n.options.accessibility && (n.initADA(), n.options.focusOnChange && t(n.$slides.get(n.currentSlide)).attr("tabindex", 0).focus()))
    }, n.prototype.prev = n.prototype.slickPrev = function() {
        this.changeSlide({
            data: {
                message: "previous"
            }
        })
    }, n.prototype.preventDefault = function(t) {
        t.preventDefault()
    }, n.prototype.progressiveLazyLoad = function(e) {
        e = e || 1;
        var n, i, r, o, s, a = this,
            l = t("img[data-lazy]", a.$slider);
        l.length ? (n = l.first(), i = n.attr("data-lazy"), r = n.attr("data-srcset"), o = n.attr("data-sizes") || a.$slider.attr("data-sizes"), (s = document.createElement("img")).onload = function() {
            r && (n.attr("srcset", r), o && n.attr("sizes", o)), n.attr("src", i).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"), !0 === a.options.adaptiveHeight && a.setPosition(), a.$slider.trigger("lazyLoaded", [a, n, i]), a.progressiveLazyLoad()
        }, s.onerror = function() {
            e < 3 ? setTimeout(function() {
                a.progressiveLazyLoad(e + 1)
            }, 500) : (n.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), a.$slider.trigger("lazyLoadError", [a, n, i]), a.progressiveLazyLoad())
        }, s.src = i) : a.$slider.trigger("allImagesLoaded", [a])
    }, n.prototype.refresh = function(e) {
        var n, i, r = this;
        i = r.slideCount - r.options.slidesToShow, !r.options.infinite && r.currentSlide > i && (r.currentSlide = i), r.slideCount <= r.options.slidesToShow && (r.currentSlide = 0), n = r.currentSlide, r.destroy(!0), t.extend(r, r.initials, {
            currentSlide: n
        }), r.init(), e || r.changeSlide({
            data: {
                message: "index",
                index: n
            }
        }, !1)
    }, n.prototype.registerBreakpoints = function() {
        var e, n, i, r = this,
            o = r.options.responsive || null;
        if ("array" === t.type(o) && o.length) {
            for (e in r.respondTo = r.options.respondTo || "window", o)
                if (i = r.breakpoints.length - 1, o.hasOwnProperty(e)) {
                    for (n = o[e].breakpoint; 0 <= i;) r.breakpoints[i] && r.breakpoints[i] === n && r.breakpoints.splice(i, 1), i--;
                    r.breakpoints.push(n), r.breakpointSettings[n] = o[e].settings
                } r.breakpoints.sort(function(t, e) {
                return r.options.mobileFirst ? t - e : e - t
            })
        }
    }, n.prototype.reinit = function() {
        var e = this;
        e.$slides = e.$slideTrack.children(e.options.slide).addClass("slick-slide"), e.slideCount = e.$slides.length, e.currentSlide >= e.slideCount && 0 !== e.currentSlide && (e.currentSlide = e.currentSlide - e.options.slidesToScroll), e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0), e.registerBreakpoints(), e.setProps(), e.setupInfinite(), e.buildArrows(), e.updateArrows(), e.initArrowEvents(), e.buildDots(), e.updateDots(), e.initDotEvents(), e.cleanUpSlideEvents(), e.initSlideEvents(), e.checkResponsive(!1, !0), !0 === e.options.focusOnSelect && t(e.$slideTrack).children().on("click.slick", e.selectHandler), e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0), e.setPosition(), e.focusHandler(), e.paused = !e.options.autoplay, e.autoPlay(), e.$slider.trigger("reInit", [e])
    }, n.prototype.resize = function() {
        var e = this;
        t(window).width() !== e.windowWidth && (clearTimeout(e.windowDelay), e.windowDelay = window.setTimeout(function() {
            e.windowWidth = t(window).width(), e.checkResponsive(), e.unslicked || e.setPosition()
        }, 50))
    }, n.prototype.removeSlide = n.prototype.slickRemove = function(t, e, n) {
        var i = this;
        if (t = "boolean" == typeof t ? !0 === (e = t) ? 0 : i.slideCount - 1 : !0 === e ? --t : t, i.slideCount < 1 || t < 0 || t > i.slideCount - 1) return !1;
        i.unload(), !0 === n ? i.$slideTrack.children().remove() : i.$slideTrack.children(this.options.slide).eq(t).remove(), i.$slides = i.$slideTrack.children(this.options.slide), i.$slideTrack.children(this.options.slide).detach(), i.$slideTrack.append(i.$slides), i.$slidesCache = i.$slides, i.reinit()
    }, n.prototype.setCSS = function(t) {
        var e, n, i = this,
            r = {};
        !0 === i.options.rtl && (t = -t), e = "left" == i.positionProp ? Math.ceil(t) + "px" : "0px", n = "top" == i.positionProp ? Math.ceil(t) + "px" : "0px", r[i.positionProp] = t, !1 === i.transformsEnabled || (!(r = {}) === i.cssTransitions ? r[i.animType] = "translate(" + e + ", " + n + ")" : r[i.animType] = "translate3d(" + e + ", " + n + ", 0px)"), i.$slideTrack.css(r)
    }, n.prototype.setDimensions = function() {
        var t = this;
        !1 === t.options.vertical ? !0 === t.options.centerMode && t.$list.css({
            padding: "0px " + t.options.centerPadding
        }) : (t.$list.height(t.$slides.first().outerHeight(!0) * t.options.slidesToShow), !0 === t.options.centerMode && t.$list.css({
            padding: t.options.centerPadding + " 0px"
        })), t.listWidth = t.$list.width(), t.listHeight = t.$list.height(), !1 === t.options.vertical && !1 === t.options.variableWidth ? (t.slideWidth = Math.ceil(t.listWidth / t.options.slidesToShow), t.$slideTrack.width(Math.ceil(t.slideWidth * t.$slideTrack.children(".slick-slide").length))) : !0 === t.options.variableWidth ? t.$slideTrack.width(5e3 * t.slideCount) : (t.slideWidth = Math.ceil(t.listWidth), t.$slideTrack.height(Math.ceil(t.$slides.first().outerHeight(!0) * t.$slideTrack.children(".slick-slide").length)));
        var e = t.$slides.first().outerWidth(!0) - t.$slides.first().width();
        !1 === t.options.variableWidth && t.$slideTrack.children(".slick-slide").width(t.slideWidth - e)
    }, n.prototype.setFade = function() {
        var e, n = this;
        n.$slides.each(function(i, r) {
            e = n.slideWidth * i * -1, !0 === n.options.rtl ? t(r).css({
                position: "relative",
                right: e,
                top: 0,
                zIndex: n.options.zIndex - 2,
                opacity: 0
            }) : t(r).css({
                position: "relative",
                left: e,
                top: 0,
                zIndex: n.options.zIndex - 2,
                opacity: 0
            })
        }), n.$slides.eq(n.currentSlide).css({
            zIndex: n.options.zIndex - 1,
            opacity: 1
        })
    }, n.prototype.setHeight = function() {
        var t = this;
        if (1 === t.options.slidesToShow && !0 === t.options.adaptiveHeight && !1 === t.options.vertical) {
            var e = t.$slides.eq(t.currentSlide).outerHeight(!0);
            t.$list.css("height", e)
        }
    }, n.prototype.setOption = n.prototype.slickSetOption = function() {
        var e, n, i, r, o, s = this,
            a = !1;
        if ("object" === t.type(arguments[0]) ? (i = arguments[0], a = arguments[1], o = "multiple") : "string" === t.type(arguments[0]) && (i = arguments[0], r = arguments[1], a = arguments[2], "responsive" === arguments[0] && "array" === t.type(arguments[1]) ? o = "responsive" : void 0 !== arguments[1] && (o = "single")), "single" === o) s.options[i] = r;
        else if ("multiple" === o) t.each(i, function(t, e) {
            s.options[t] = e
        });
        else if ("responsive" === o)
            for (n in r)
                if ("array" !== t.type(s.options.responsive)) s.options.responsive = [r[n]];
                else {
                    for (e = s.options.responsive.length - 1; 0 <= e;) s.options.responsive[e].breakpoint === r[n].breakpoint && s.options.responsive.splice(e, 1), e--;
                    s.options.responsive.push(r[n])
                } a && (s.unload(), s.reinit())
    }, n.prototype.setPosition = function() {
        var t = this;
        t.setDimensions(), t.setHeight(), !1 === t.options.fade ? t.setCSS(t.getLeft(t.currentSlide)) : t.setFade(), t.$slider.trigger("setPosition", [t])
    }, n.prototype.setProps = function() {
        var t = this,
            e = document.body.style;
        t.positionProp = !0 === t.options.vertical ? "top" : "left", "top" === t.positionProp ? t.$slider.addClass("slick-vertical") : t.$slider.removeClass("slick-vertical"), void 0 === e.WebkitTransition && void 0 === e.MozTransition && void 0 === e.msTransition || !0 === t.options.useCSS && (t.cssTransitions = !0), t.options.fade && ("number" == typeof t.options.zIndex ? t.options.zIndex < 3 && (t.options.zIndex = 3) : t.options.zIndex = t.defaults.zIndex), void 0 !== e.OTransform && (t.animType = "OTransform", t.transformType = "-o-transform", t.transitionType = "OTransition", void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (t.animType = !1)), void 0 !== e.MozTransform && (t.animType = "MozTransform", t.transformType = "-moz-transform", t.transitionType = "MozTransition", void 0 === e.perspectiveProperty && void 0 === e.MozPerspective && (t.animType = !1)), void 0 !== e.webkitTransform && (t.animType = "webkitTransform", t.transformType = "-webkit-transform", t.transitionType = "webkitTransition", void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (t.animType = !1)), void 0 !== e.msTransform && (t.animType = "msTransform", t.transformType = "-ms-transform", t.transitionType = "msTransition", void 0 === e.msTransform && (t.animType = !1)), void 0 !== e.transform && !1 !== t.animType && (t.animType = "transform", t.transformType = "transform", t.transitionType = "transition"), t.transformsEnabled = t.options.useTransform && null !== t.animType && !1 !== t.animType
    }, n.prototype.setSlideClasses = function(t) {
        var e, n, i, r, o = this;
        if (n = o.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true"), o.$slides.eq(t).addClass("slick-current"), !0 === o.options.centerMode) {
            var s = o.options.slidesToShow % 2 == 0 ? 1 : 0;
            e = Math.floor(o.options.slidesToShow / 2), !0 === o.options.infinite && (e <= t && t <= o.slideCount - 1 - e ? o.$slides.slice(t - e + s, t + e + 1).addClass("slick-active").attr("aria-hidden", "false") : (i = o.options.slidesToShow + t, n.slice(i - e + 1 + s, i + e + 2).addClass("slick-active").attr("aria-hidden", "false")), 0 === t ? n.eq(n.length - 1 - o.options.slidesToShow).addClass("slick-center") : t === o.slideCount - 1 && n.eq(o.options.slidesToShow).addClass("slick-center")), o.$slides.eq(t).addClass("slick-center")
        } else 0 <= t && t <= o.slideCount - o.options.slidesToShow ? o.$slides.slice(t, t + o.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false") : n.length <= o.options.slidesToShow ? n.addClass("slick-active").attr("aria-hidden", "false") : (r = o.slideCount % o.options.slidesToShow, i = !0 === o.options.infinite ? o.options.slidesToShow + t : t, o.options.slidesToShow == o.options.slidesToScroll && o.slideCount - t < o.options.slidesToShow ? n.slice(i - (o.options.slidesToShow - r), i + r).addClass("slick-active").attr("aria-hidden", "false") : n.slice(i, i + o.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false"));
        "ondemand" !== o.options.lazyLoad && "anticipated" !== o.options.lazyLoad || o.lazyLoad()
    }, n.prototype.setupInfinite = function() {
        var e, n, i, r = this;
        if (!0 === r.options.fade && (r.options.centerMode = !1), !0 === r.options.infinite && !1 === r.options.fade && (n = null, r.slideCount > r.options.slidesToShow)) {
            for (i = !0 === r.options.centerMode ? r.options.slidesToShow + 1 : r.options.slidesToShow, e = r.slideCount; e > r.slideCount - i; e -= 1) n = e - 1, t(r.$slides[n]).clone(!0).attr("id", "").attr("data-slick-index", n - r.slideCount).prependTo(r.$slideTrack).addClass("slick-cloned");
            for (e = 0; e < i + r.slideCount; e += 1) n = e, t(r.$slides[n]).clone(!0).attr("id", "").attr("data-slick-index", n + r.slideCount).appendTo(r.$slideTrack).addClass("slick-cloned");
            r.$slideTrack.find(".slick-cloned").find("[id]").each(function() {
                t(this).attr("id", "")
            })
        }
    }, n.prototype.interrupt = function(t) {
        t || this.autoPlay(), this.interrupted = t
    }, n.prototype.selectHandler = function(e) {
        var n = t(e.target).is(".slick-slide") ? t(e.target) : t(e.target).parents(".slick-slide"),
            i = parseInt(n.attr("data-slick-index"));
        i || (i = 0), this.slideCount <= this.options.slidesToShow ? this.slideHandler(i, !1, !0) : this.slideHandler(i)
    }, n.prototype.slideHandler = function(t, e, n) {
        var i, r, o, s, a, l = null,
            u = this;
        if (e = e || !1, !(!0 === u.animating && !0 === u.options.waitForAnimate || !0 === u.options.fade && u.currentSlide === t))
            if (!1 === e && u.asNavFor(t), i = t, l = u.getLeft(i), s = u.getLeft(u.currentSlide), u.currentLeft = null === u.swipeLeft ? s : u.swipeLeft, !1 === u.options.infinite && !1 === u.options.centerMode && (t < 0 || t > u.getDotCount() * u.options.slidesToScroll)) !1 === u.options.fade && (i = u.currentSlide, !0 !== n ? u.animateSlide(s, function() {
                u.postSlide(i)
            }) : u.postSlide(i));
            else if (!1 === u.options.infinite && !0 === u.options.centerMode && (t < 0 || t > u.slideCount - u.options.slidesToScroll)) !1 === u.options.fade && (i = u.currentSlide, !0 !== n ? u.animateSlide(s, function() {
            u.postSlide(i)
        }) : u.postSlide(i));
        else {
            if (u.options.autoplay && clearInterval(u.autoPlayTimer), r = i < 0 ? u.slideCount % u.options.slidesToScroll != 0 ? u.slideCount - u.slideCount % u.options.slidesToScroll : u.slideCount + i : i >= u.slideCount ? u.slideCount % u.options.slidesToScroll != 0 ? 0 : i - u.slideCount : i, u.animating = !0, u.$slider.trigger("beforeChange", [u, u.currentSlide, r, i]), o = u.currentSlide, u.currentSlide = r, u.setSlideClasses(u.currentSlide), u.options.asNavFor && (a = (a = u.getNavTarget()).slick("getSlick")).slideCount <= a.options.slidesToShow && a.setSlideClasses(u.currentSlide), u.updateDots(), u.updateArrows(), !0 === u.options.fade) return !0 !== n ? (u.fadeSlideOut(o), u.fadeSlide(r, function() {
                u.postSlide(r)
            })) : u.postSlide(r), void u.animateHeight();
            !0 !== n ? u.animateSlide(l, function() {
                u.postSlide(r)
            }) : u.postSlide(r)
        }
    }, n.prototype.startLoad = function() {
        var t = this;
        !0 === t.options.arrows && t.slideCount > t.options.slidesToShow && (t.$prevArrow.hide(), t.$nextArrow.hide()), !0 === t.options.dots && t.slideCount > t.options.slidesToShow && t.$dots.hide(), t.$slider.addClass("slick-loading")
    }, n.prototype.swipeDirection = function() {
        var t, e, n, i, r = this;
        return t = r.touchObject.startX - r.touchObject.curX, e = r.touchObject.startY - r.touchObject.curY, n = Math.atan2(e, t), (i = Math.round(180 * n / Math.PI)) < 0 && (i = 360 - Math.abs(i)), i <= 45 && 0 <= i ? !1 === r.options.rtl ? "left" : "right" : i <= 360 && 315 <= i ? !1 === r.options.rtl ? "left" : "right" : 135 <= i && i <= 225 ? !1 === r.options.rtl ? "right" : "left" : !0 === r.options.verticalSwiping ? 35 <= i && i <= 135 ? "down" : "up" : "vertical"
    }, n.prototype.swipeEnd = function(t) {
        var e, n, i = this;
        if (i.dragging = !1, i.swiping = !1, i.scrolling) return i.scrolling = !1;
        if (i.interrupted = !1, i.shouldClick = !(10 < i.touchObject.swipeLength), void 0 === i.touchObject.curX) return !1;
        if (!0 === i.touchObject.edgeHit && i.$slider.trigger("edge", [i, i.swipeDirection()]), i.touchObject.swipeLength >= i.touchObject.minSwipe) {
            switch (n = i.swipeDirection()) {
                case "left":
                case "down":
                    e = i.options.swipeToSlide ? i.checkNavigable(i.currentSlide + i.getSlideCount()) : i.currentSlide + i.getSlideCount(), i.currentDirection = 0;
                    break;
                case "right":
                case "up":
                    e = i.options.swipeToSlide ? i.checkNavigable(i.currentSlide - i.getSlideCount()) : i.currentSlide - i.getSlideCount(), i.currentDirection = 1
            }
            "vertical" != n && (i.slideHandler(e), i.touchObject = {}, i.$slider.trigger("swipe", [i, n]))
        } else i.touchObject.startX !== i.touchObject.curX && (i.slideHandler(i.currentSlide), i.touchObject = {})
    }, n.prototype.swipeHandler = function(t) {
        var e = this;
        if (!(!1 === e.options.swipe || "ontouchend" in document && !1 === e.options.swipe || !1 === e.options.draggable && -1 !== t.type.indexOf("mouse"))) switch (e.touchObject.fingerCount = t.originalEvent && void 0 !== t.originalEvent.touches ? t.originalEvent.touches.length : 1, e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold, !0 === e.options.verticalSwiping && (e.touchObject.minSwipe = e.listHeight / e.options.touchThreshold), t.data.action) {
            case "start":
                e.swipeStart(t);
                break;
            case "move":
                e.swipeMove(t);
                break;
            case "end":
                e.swipeEnd(t)
        }
    }, n.prototype.swipeMove = function(t) {
        var e, n, i, r, o, s, a = this;
        return o = void 0 !== t.originalEvent ? t.originalEvent.touches : null, !(!a.dragging || a.scrolling || o && 1 !== o.length) && (e = a.getLeft(a.currentSlide), a.touchObject.curX = void 0 !== o ? o[0].pageX : t.clientX, a.touchObject.curY = void 0 !== o ? o[0].pageY : t.clientY, a.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(a.touchObject.curX - a.touchObject.startX, 2))), s = Math.round(Math.sqrt(Math.pow(a.touchObject.curY - a.touchObject.startY, 2))), !a.options.verticalSwiping && !a.swiping && 4 < s ? !(a.scrolling = !0) : (!0 === a.options.verticalSwiping && (a.touchObject.swipeLength = s), n = a.swipeDirection(), void 0 !== t.originalEvent && 4 < a.touchObject.swipeLength && (a.swiping = !0, t.preventDefault()), r = (!1 === a.options.rtl ? 1 : -1) * (a.touchObject.curX > a.touchObject.startX ? 1 : -1), !0 === a.options.verticalSwiping && (r = a.touchObject.curY > a.touchObject.startY ? 1 : -1), i = a.touchObject.swipeLength, (a.touchObject.edgeHit = !1) === a.options.infinite && (0 === a.currentSlide && "right" === n || a.currentSlide >= a.getDotCount() && "left" === n) && (i = a.touchObject.swipeLength * a.options.edgeFriction, a.touchObject.edgeHit = !0), !1 === a.options.vertical ? a.swipeLeft = e + i * r : a.swipeLeft = e + i * (a.$list.height() / a.listWidth) * r, !0 === a.options.verticalSwiping && (a.swipeLeft = e + i * r), !0 !== a.options.fade && !1 !== a.options.touchMove && (!0 === a.animating ? (a.swipeLeft = null, !1) : void a.setCSS(a.swipeLeft))))
    }, n.prototype.swipeStart = function(t) {
        var e, n = this;
        if (n.interrupted = !0, 1 !== n.touchObject.fingerCount || n.slideCount <= n.options.slidesToShow) return !(n.touchObject = {});
        void 0 !== t.originalEvent && void 0 !== t.originalEvent.touches && (e = t.originalEvent.touches[0]), n.touchObject.startX = n.touchObject.curX = void 0 !== e ? e.pageX : t.clientX, n.touchObject.startY = n.touchObject.curY = void 0 !== e ? e.pageY : t.clientY, n.dragging = !0
    }, n.prototype.unfilterSlides = n.prototype.slickUnfilter = function() {
        var t = this;
        null !== t.$slidesCache && (t.unload(), t.$slideTrack.children(this.options.slide).detach(), t.$slidesCache.appendTo(t.$slideTrack), t.reinit())
    }, n.prototype.unload = function() {
        var e = this;
        t(".slick-cloned", e.$slider).remove(), e.$dots && e.$dots.remove(), e.$prevArrow && e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.remove(), e.$nextArrow && e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.remove(), e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "")
    }, n.prototype.unslick = function(t) {
        this.$slider.trigger("unslick", [this, t]), this.destroy()
    }, n.prototype.updateArrows = function() {
        var t = this;
        Math.floor(t.options.slidesToShow / 2), !0 === t.options.arrows && t.slideCount > t.options.slidesToShow && !t.options.infinite && (t.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), t.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), 0 === t.currentSlide ? (t.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"), t.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : t.currentSlide >= t.slideCount - t.options.slidesToShow && !1 === t.options.centerMode ? (t.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), t.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : t.currentSlide >= t.slideCount - 1 && !0 === t.options.centerMode && (t.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), t.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")))
    }, n.prototype.updateDots = function() {
        var t = this;
        null !== t.$dots && (t.$dots.find("li").removeClass("slick-active").end(), t.$dots.find("li").eq(Math.floor(t.currentSlide / t.options.slidesToScroll)).addClass("slick-active"))
    }, n.prototype.visibility = function() {
        this.options.autoplay && (document[this.hidden] ? this.interrupted = !0 : this.interrupted = !1)
    }, t.fn.slick = function() {
        var t, e, i = this,
            r = arguments[0],
            o = Array.prototype.slice.call(arguments, 1),
            s = i.length;
        for (t = 0; t < s; t++)
            if ("object" == typeof r || void 0 === r ? i[t].slick = new n(i[t], r) : e = i[t].slick[r].apply(i[t].slick, o), void 0 !== e) return e;
        return i
    }
}), function(t, e) {
    "function" == typeof define && define.amd ? define("jquery-bridget/jquery-bridget", ["jquery"], function(n) {
        return e(t, n)
    }) : "object" == typeof module && module.exports ? module.exports = e(t, require("jquery")) : t.jQueryBridget = e(t, t.jQuery)
}(window, function(t, e) {
    "use strict";
    var n = Array.prototype.slice,
        i = t.console,
        r = void 0 === i ? function() {} : function(t) {
            i.error(t)
        };

    function o(i, o, a) {
        (a = a || e || t.jQuery) && (o.prototype.option || (o.prototype.option = function(t) {
            a.isPlainObject(t) && (this.options = a.extend(!0, this.options, t))
        }), a.fn[i] = function(t) {
            if ("string" != typeof t) return d = t, this.each(function(t, e) {
                var n = a.data(e, i);
                n ? (n.option(d), n._init()) : (n = new o(e, d), a.data(e, i, n))
            }), this;
            var e, s, l, u, c, d, h = n.call(arguments, 1);
            return l = h, c = "$()." + i + '("' + (s = t) + '")', (e = this).each(function(t, e) {
                var n = a.data(e, i);
                if (n) {
                    var o = n[s];
                    if (o && "_" != s.charAt(0)) {
                        var d = o.apply(n, l);
                        u = void 0 === u ? d : u
                    } else r(c + " is not a valid method")
                } else r(i + " not initialized. Cannot call methods, i.e. " + c)
            }), void 0 !== u ? u : e
        }, s(a))
    }

    function s(t) {
        !t || t && t.bridget || (t.bridget = o)
    }
    return s(e || t.jQuery), o
}), function(t, e) {
    "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", e) : "object" == typeof module && module.exports ? module.exports = e() : t.EvEmitter = e()
}("undefined" != typeof window ? window : this, function() {
    function t() {}
    var e = t.prototype;
    return e.on = function(t, e) {
        if (t && e) {
            var n = this._events = this._events || {},
                i = n[t] = n[t] || [];
            return -1 == i.indexOf(e) && i.push(e), this
        }
    }, e.once = function(t, e) {
        if (t && e) {
            this.on(t, e);
            var n = this._onceEvents = this._onceEvents || {};
            return (n[t] = n[t] || {})[e] = !0, this
        }
    }, e.off = function(t, e) {
        var n = this._events && this._events[t];
        if (n && n.length) {
            var i = n.indexOf(e);
            return -1 != i && n.splice(i, 1), this
        }
    }, e.emitEvent = function(t, e) {
        var n = this._events && this._events[t];
        if (n && n.length) {
            n = n.slice(0), e = e || [];
            for (var i = this._onceEvents && this._onceEvents[t], r = 0; r < n.length; r++) {
                var o = n[r];
                i && i[o] && (this.off(t, o), delete i[o]), o.apply(this, e)
            }
            return this
        }
    }, e.allOff = function() {
        delete this._events, delete this._onceEvents
    }, t
}), function(t, e) {
    "function" == typeof define && define.amd ? define("get-size/get-size", e) : "object" == typeof module && module.exports ? module.exports = e() : t.getSize = e()
}(window, function() {
    "use strict";

    function t(t) {
        var e = parseFloat(t);
        return -1 == t.indexOf("%") && !isNaN(e) && e
    }
    var e = "undefined" == typeof console ? function() {} : function(t) {
            console.error(t)
        },
        n = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"],
        i = n.length;

    function r(t) {
        var n = getComputedStyle(t);
        return n || e("Style returned " + n + ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"), n
    }
    var o, s = !1;
    return function e(a) {
        if (function() {
                if (!s) {
                    s = !0;
                    var n = document.createElement("div");
                    n.style.width = "200px", n.style.padding = "1px 2px 3px 4px", n.style.borderStyle = "solid", n.style.borderWidth = "1px 2px 3px 4px", n.style.boxSizing = "border-box";
                    var i = document.body || document.documentElement;
                    i.appendChild(n);
                    var a = r(n);
                    o = 200 == Math.round(t(a.width)), e.isBoxSizeOuter = o, i.removeChild(n)
                }
            }(), "string" == typeof a && (a = document.querySelector(a)), a && "object" == typeof a && a.nodeType) {
            var l = r(a);
            if ("none" == l.display) return function() {
                for (var t = {
                        width: 0,
                        height: 0,
                        innerWidth: 0,
                        innerHeight: 0,
                        outerWidth: 0,
                        outerHeight: 0
                    }, e = 0; e < i; e++) t[n[e]] = 0;
                return t
            }();
            var u = {};
            u.width = a.offsetWidth, u.height = a.offsetHeight;
            for (var c = u.isBorderBox = "border-box" == l.boxSizing, d = 0; d < i; d++) {
                var h = n[d],
                    p = l[h],
                    f = parseFloat(p);
                u[h] = isNaN(f) ? 0 : f
            }
            var m = u.paddingLeft + u.paddingRight,
                g = u.paddingTop + u.paddingBottom,
                y = u.marginLeft + u.marginRight,
                v = u.marginTop + u.marginBottom,
                _ = u.borderLeftWidth + u.borderRightWidth,
                b = u.borderTopWidth + u.borderBottomWidth,
                w = c && o,
                x = t(l.width);
            !1 !== x && (u.width = x + (w ? 0 : m + _));
            var S = t(l.height);
            return !1 !== S && (u.height = S + (w ? 0 : g + b)), u.innerWidth = u.width - (m + _), u.innerHeight = u.height - (g + b), u.outerWidth = u.width + y, u.outerHeight = u.height + v, u
        }
    }
}), function(t, e) {
    "use strict";
    "function" == typeof define && define.amd ? define("desandro-matches-selector/matches-selector", e) : "object" == typeof module && module.exports ? module.exports = e() : t.matchesSelector = e()
}(window, function() {
    "use strict";
    var t = function() {
        var t = window.Element.prototype;
        if (t.matches) return "matches";
        if (t.matchesSelector) return "matchesSelector";
        for (var e = ["webkit", "moz", "ms", "o"], n = 0; n < e.length; n++) {
            var i = e[n] + "MatchesSelector";
            if (t[i]) return i
        }
    }();
    return function(e, n) {
        return e[t](n)
    }
}), function(t, e) {
    "function" == typeof define && define.amd ? define("fizzy-ui-utils/utils", ["desandro-matches-selector/matches-selector"], function(n) {
        return e(t, n)
    }) : "object" == typeof module && module.exports ? module.exports = e(t, require("desandro-matches-selector")) : t.fizzyUIUtils = e(t, t.matchesSelector)
}(window, function(t, e) {
    var n = {
            extend: function(t, e) {
                for (var n in e) t[n] = e[n];
                return t
            },
            modulo: function(t, e) {
                return (t % e + e) % e
            }
        },
        i = Array.prototype.slice;
    n.makeArray = function(t) {
        return Array.isArray(t) ? t : null == t ? [] : "object" == typeof t && "number" == typeof t.length ? i.call(t) : [t]
    }, n.removeFrom = function(t, e) {
        var n = t.indexOf(e); - 1 != n && t.splice(n, 1)
    }, n.getParent = function(t, n) {
        for (; t.parentNode && t != document.body;)
            if (t = t.parentNode, e(t, n)) return t
    }, n.getQueryElement = function(t) {
        return "string" == typeof t ? document.querySelector(t) : t
    }, n.handleEvent = function(t) {
        var e = "on" + t.type;
        this[e] && this[e](t)
    }, n.filterFindElements = function(t, i) {
        t = n.makeArray(t);
        var r = [];
        return t.forEach(function(t) {
            if (t instanceof HTMLElement)
                if (i) {
                    e(t, i) && r.push(t);
                    for (var n = t.querySelectorAll(i), o = 0; o < n.length; o++) r.push(n[o])
                } else r.push(t)
        }), r
    }, n.debounceMethod = function(t, e, n) {
        n = n || 100;
        var i = t.prototype[e],
            r = e + "Timeout";
        t.prototype[e] = function() {
            var t = this[r];
            clearTimeout(t);
            var e = arguments,
                o = this;
            this[r] = setTimeout(function() {
                i.apply(o, e), delete o[r]
            }, n)
        }
    }, n.docReady = function(t) {
        var e = document.readyState;
        "complete" == e || "interactive" == e ? setTimeout(t) : document.addEventListener("DOMContentLoaded", t)
    }, n.toDashed = function(t) {
        return t.replace(/(.)([A-Z])/g, function(t, e, n) {
            return e + "-" + n
        }).toLowerCase()
    };
    var r = t.console;
    return n.htmlInit = function(e, i) {
        n.docReady(function() {
            var o = n.toDashed(i),
                s = "data-" + o,
                a = document.querySelectorAll("[" + s + "]"),
                l = document.querySelectorAll(".js-" + o),
                u = n.makeArray(a).concat(n.makeArray(l)),
                c = s + "-options",
                d = t.jQuery;
            u.forEach(function(t) {
                var n, o = t.getAttribute(s) || t.getAttribute(c);
                try {
                    n = o && JSON.parse(o)
                } catch (n) {
                    return void(r && r.error("Error parsing " + s + " on " + t.className + ": " + n))
                }
                var a = new e(t, n);
                d && d.data(t, i, a)
            })
        })
    }, n
}), function(t, e) {
    "function" == typeof define && define.amd ? define("flickity/js/cell", ["get-size/get-size"], function(n) {
        return e(t, n)
    }) : "object" == typeof module && module.exports ? module.exports = e(t, require("get-size")) : (t.Flickity = t.Flickity || {}, t.Flickity.Cell = e(t, t.getSize))
}(window, function(t, e) {
    function n(t, e) {
        this.element = t, this.parent = e, this.create()
    }
    var i = n.prototype;
    return i.create = function() {
        this.element.style.position = "absolute", this.element.setAttribute("aria-hidden", "true"), this.x = 0, this.shift = 0
    }, i.destroy = function() {
        this.unselect(), this.element.style.position = "";
        var t = this.parent.originSide;
        this.element.style[t] = ""
    }, i.getSize = function() {
        this.size = e(this.element)
    }, i.setPosition = function(t) {
        this.x = t, this.updateTarget(), this.renderPosition(t)
    }, i.updateTarget = i.setDefaultTarget = function() {
        var t = "left" == this.parent.originSide ? "marginLeft" : "marginRight";
        this.target = this.x + this.size[t] + this.size.width * this.parent.cellAlign
    }, i.renderPosition = function(t) {
        var e = this.parent.originSide;
        this.element.style[e] = this.parent.getPositionValue(t)
    }, i.select = function() {
        this.element.classList.add("is-selected"), this.element.removeAttribute("aria-hidden")
    }, i.unselect = function() {
        this.element.classList.remove("is-selected"), this.element.setAttribute("aria-hidden", "true")
    }, i.wrapShift = function(t) {
        this.shift = t, this.renderPosition(this.x + this.parent.slideableWidth * t)
    }, i.remove = function() {
        this.element.parentNode.removeChild(this.element)
    }, n
}), function(t, e) {
    "function" == typeof define && define.amd ? define("flickity/js/slide", e) : "object" == typeof module && module.exports ? module.exports = e() : (t.Flickity = t.Flickity || {}, t.Flickity.Slide = e())
}(window, function() {
    "use strict";

    function t(t) {
        this.parent = t, this.isOriginLeft = "left" == t.originSide, this.cells = [], this.outerWidth = 0, this.height = 0
    }
    var e = t.prototype;
    return e.addCell = function(t) {
        if (this.cells.push(t), this.outerWidth += t.size.outerWidth, this.height = Math.max(t.size.outerHeight, this.height), 1 == this.cells.length) {
            this.x = t.x;
            var e = this.isOriginLeft ? "marginLeft" : "marginRight";
            this.firstMargin = t.size[e]
        }
    }, e.updateTarget = function() {
        var t = this.isOriginLeft ? "marginRight" : "marginLeft",
            e = this.getLastCell(),
            n = e ? e.size[t] : 0,
            i = this.outerWidth - (this.firstMargin + n);
        this.target = this.x + this.firstMargin + i * this.parent.cellAlign
    }, e.getLastCell = function() {
        return this.cells[this.cells.length - 1]
    }, e.select = function() {
        this.cells.forEach(function(t) {
            t.select()
        })
    }, e.unselect = function() {
        this.cells.forEach(function(t) {
            t.unselect()
        })
    }, e.getCellElements = function() {
        return this.cells.map(function(t) {
            return t.element
        })
    }, t
}), function(t, e) {
    "function" == typeof define && define.amd ? define("flickity/js/animate", ["fizzy-ui-utils/utils"], function(n) {
        return e(t, n)
    }) : "object" == typeof module && module.exports ? module.exports = e(t, require("fizzy-ui-utils")) : (t.Flickity = t.Flickity || {}, t.Flickity.animatePrototype = e(t, t.fizzyUIUtils))
}(window, function(t, e) {
    return {
        startAnimation: function() {
            this.isAnimating || (this.isAnimating = !0, this.restingFrames = 0, this.animate())
        },
        animate: function() {
            this.applyDragForce(), this.applySelectedAttraction();
            var t = this.x;
            if (this.integratePhysics(), this.positionSlider(), this.settle(t), this.isAnimating) {
                var e = this;
                requestAnimationFrame(function() {
                    e.animate()
                })
            }
        },
        positionSlider: function() {
            var t = this.x;
            this.options.wrapAround && 1 < this.cells.length && (t = e.modulo(t, this.slideableWidth), t -= this.slideableWidth, this.shiftWrapCells(t)), this.setTranslateX(t, this.isAnimating), this.dispatchScrollEvent()
        },
        setTranslateX: function(t, e) {
            t += this.cursorPosition, t = this.options.rightToLeft ? -t : t;
            var n = this.getPositionValue(t);
            this.slider.style.transform = e ? "translate3d(" + n + ",0,0)" : "translateX(" + n + ")"
        },
        dispatchScrollEvent: function() {
            var t = this.slides[0];
            if (t) {
                var e = -this.x - t.target,
                    n = e / this.slidesWidth;
                this.dispatchEvent("scroll", null, [n, e])
            }
        },
        positionSliderAtSelected: function() {
            this.cells.length && (this.x = -this.selectedSlide.target, this.velocity = 0, this.positionSlider())
        },
        getPositionValue: function(t) {
            return this.options.percentPosition ? .01 * Math.round(t / this.size.innerWidth * 1e4) + "%" : Math.round(t) + "px"
        },
        settle: function(t) {
            this.isPointerDown || Math.round(100 * this.x) != Math.round(100 * t) || this.restingFrames++, 2 < this.restingFrames && (this.isAnimating = !1, delete this.isFreeScrolling, this.positionSlider(), this.dispatchEvent("settle", null, [this.selectedIndex]))
        },
        shiftWrapCells: function(t) {
            var e = this.cursorPosition + t;
            this._shiftCells(this.beforeShiftCells, e, -1);
            var n = this.size.innerWidth - (t + this.slideableWidth + this.cursorPosition);
            this._shiftCells(this.afterShiftCells, n, 1)
        },
        _shiftCells: function(t, e, n) {
            for (var i = 0; i < t.length; i++) {
                var r = t[i],
                    o = 0 < e ? n : 0;
                r.wrapShift(o), e -= r.size.outerWidth
            }
        },
        _unshiftCells: function(t) {
            if (t && t.length)
                for (var e = 0; e < t.length; e++) t[e].wrapShift(0)
        },
        integratePhysics: function() {
            this.x += this.velocity, this.velocity *= this.getFrictionFactor()
        },
        applyForce: function(t) {
            this.velocity += t
        },
        getFrictionFactor: function() {
            return 1 - this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"]
        },
        getRestingPosition: function() {
            return this.x + this.velocity / (1 - this.getFrictionFactor())
        },
        applyDragForce: function() {
            if (this.isDraggable && this.isPointerDown) {
                var t = this.dragX - this.x - this.velocity;
                this.applyForce(t)
            }
        },
        applySelectedAttraction: function() {
            if ((!this.isDraggable || !this.isPointerDown) && !this.isFreeScrolling && this.slides.length) {
                var t = (-1 * this.selectedSlide.target - this.x) * this.options.selectedAttraction;
                this.applyForce(t)
            }
        }
    }
}), function(t, e) {
    if ("function" == typeof define && define.amd) define("flickity/js/flickity", ["ev-emitter/ev-emitter", "get-size/get-size", "fizzy-ui-utils/utils", "./cell", "./slide", "./animate"], function(n, i, r, o, s, a) {
        return e(t, n, i, r, o, s, a)
    });
    else if ("object" == typeof module && module.exports) module.exports = e(t, require("ev-emitter"), require("get-size"), require("fizzy-ui-utils"), require("./cell"), require("./slide"), require("./animate"));
    else {
        var n = t.Flickity;
        t.Flickity = e(t, t.EvEmitter, t.getSize, t.fizzyUIUtils, n.Cell, n.Slide, n.animatePrototype)
    }
}(window, function(t, e, n, i, r, o, s) {
    var a = t.jQuery,
        l = t.getComputedStyle,
        u = t.console;

    function c(t, e) {
        for (t = i.makeArray(t); t.length;) e.appendChild(t.shift())
    }
    var d = 0,
        h = {};

    function p(t, e) {
        var n = i.getQueryElement(t);
        if (n) {
            if (this.element = n, this.element.flickityGUID) {
                var r = h[this.element.flickityGUID];
                return r.option(e), r
            }
            a && (this.$element = a(this.element)), this.options = i.extend({}, this.constructor.defaults), this.option(e), this._create()
        } else u && u.error("Bad element for Flickity: " + (n || t))
    }
    p.defaults = {
        accessibility: !0,
        cellAlign: "center",
        freeScrollFriction: .075,
        friction: .28,
        namespaceJQueryEvents: !0,
        percentPosition: !0,
        resize: !0,
        selectedAttraction: .025,
        setGallerySize: !0
    }, p.createMethods = [];
    var f = p.prototype;
    i.extend(f, e.prototype), f._create = function() {
        var e = this.guid = ++d;
        for (var n in this.element.flickityGUID = e, (h[e] = this).selectedIndex = 0, this.restingFrames = 0, this.x = 0, this.velocity = 0, this.originSide = this.options.rightToLeft ? "right" : "left", this.viewport = document.createElement("div"), this.viewport.className = "flickity-viewport", this._createSlider(), (this.options.resize || this.options.watchCSS) && t.addEventListener("resize", this), this.options.on) {
            var i = this.options.on[n];
            this.on(n, i)
        }
        p.createMethods.forEach(function(t) {
            this[t]()
        }, this), this.options.watchCSS ? this.watchCSS() : this.activate()
    }, f.option = function(t) {
        i.extend(this.options, t)
    }, f.activate = function() {
        this.isActive || (this.isActive = !0, this.element.classList.add("flickity-enabled"), this.options.rightToLeft && this.element.classList.add("flickity-rtl"), this.getSize(), c(this._filterFindCellElements(this.element.children), this.slider), this.viewport.appendChild(this.slider), this.element.appendChild(this.viewport), this.reloadCells(), this.options.accessibility && (this.element.tabIndex = 0, this.element.addEventListener("keydown", this)), this.emitEvent("activate"), this.selectInitialIndex(), this.isInitActivated = !0, this.dispatchEvent("ready"))
    }, f._createSlider = function() {
        var t = document.createElement("div");
        t.className = "flickity-slider", t.style[this.originSide] = 0, this.slider = t
    }, f._filterFindCellElements = function(t) {
        return i.filterFindElements(t, this.options.cellSelector)
    }, f.reloadCells = function() {
        this.cells = this._makeCells(this.slider.children), this.positionCells(), this._getWrapShiftCells(), this.setGallerySize()
    }, f._makeCells = function(t) {
        return this._filterFindCellElements(t).map(function(t) {
            return new r(t, this)
        }, this)
    }, f.getLastCell = function() {
        return this.cells[this.cells.length - 1]
    }, f.getLastSlide = function() {
        return this.slides[this.slides.length - 1]
    }, f.positionCells = function() {
        this._sizeCells(this.cells), this._positionCells(0)
    }, f._positionCells = function(t) {
        t = t || 0, this.maxCellHeight = t && this.maxCellHeight || 0;
        var e = 0;
        if (0 < t) {
            var n = this.cells[t - 1];
            e = n.x + n.size.outerWidth
        }
        for (var i = this.cells.length, r = t; r < i; r++) {
            var o = this.cells[r];
            o.setPosition(e), e += o.size.outerWidth, this.maxCellHeight = Math.max(o.size.outerHeight, this.maxCellHeight)
        }
        this.slideableWidth = e, this.updateSlides(), this._containSlides(), this.slidesWidth = i ? this.getLastSlide().target - this.slides[0].target : 0
    }, f._sizeCells = function(t) {
        t.forEach(function(t) {
            t.getSize()
        })
    }, f.updateSlides = function() {
        if (this.slides = [], this.cells.length) {
            var t = new o(this);
            this.slides.push(t);
            var e = "left" == this.originSide ? "marginRight" : "marginLeft",
                n = this._getCanCellFit();
            this.cells.forEach(function(i, r) {
                if (t.cells.length) {
                    var s = t.outerWidth - t.firstMargin + (i.size.outerWidth - i.size[e]);
                    n.call(this, r, s) || (t.updateTarget(), t = new o(this), this.slides.push(t)), t.addCell(i)
                } else t.addCell(i)
            }, this), t.updateTarget(), this.updateSelectedSlide()
        }
    }, f._getCanCellFit = function() {
        var t = this.options.groupCells;
        if (!t) return function() {
            return !1
        };
        if ("number" == typeof t) {
            var e = parseInt(t, 10);
            return function(t) {
                return t % e != 0
            }
        }
        var n = "string" == typeof t && t.match(/^(\d+)%$/),
            i = n ? parseInt(n[1], 10) / 100 : 1;
        return function(t, e) {
            return e <= (this.size.innerWidth + 1) * i
        }
    }, f._init = f.reposition = function() {
        this.positionCells(), this.positionSliderAtSelected()
    }, f.getSize = function() {
        this.size = n(this.element), this.setCellAlign(), this.cursorPosition = this.size.innerWidth * this.cellAlign
    };
    var m = {
        center: {
            left: .5,
            right: .5
        },
        left: {
            left: 0,
            right: 1
        },
        right: {
            right: 0,
            left: 1
        }
    };
    return f.setCellAlign = function() {
        var t = m[this.options.cellAlign];
        this.cellAlign = t ? t[this.originSide] : this.options.cellAlign
    }, f.setGallerySize = function() {
        if (this.options.setGallerySize) {
            var t = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
            this.viewport.style.height = t + "px"
        }
    }, f._getWrapShiftCells = function() {
        if (this.options.wrapAround) {
            this._unshiftCells(this.beforeShiftCells), this._unshiftCells(this.afterShiftCells);
            var t = this.cursorPosition,
                e = this.cells.length - 1;
            this.beforeShiftCells = this._getGapCells(t, e, -1), t = this.size.innerWidth - this.cursorPosition, this.afterShiftCells = this._getGapCells(t, 0, 1)
        }
    }, f._getGapCells = function(t, e, n) {
        for (var i = []; 0 < t;) {
            var r = this.cells[e];
            if (!r) break;
            i.push(r), e += n, t -= r.size.outerWidth
        }
        return i
    }, f._containSlides = function() {
        if (this.options.contain && !this.options.wrapAround && this.cells.length) {
            var t = this.options.rightToLeft,
                e = t ? "marginRight" : "marginLeft",
                n = t ? "marginLeft" : "marginRight",
                i = this.slideableWidth - this.getLastCell().size[n],
                r = i < this.size.innerWidth,
                o = this.cursorPosition + this.cells[0].size[e],
                s = i - this.size.innerWidth * (1 - this.cellAlign);
            this.slides.forEach(function(t) {
                t.target = r ? i * this.cellAlign : (t.target = Math.max(t.target, o), Math.min(t.target, s))
            }, this)
        }
    }, f.dispatchEvent = function(t, e, n) {
        var i = e ? [e].concat(n) : n;
        if (this.emitEvent(t, i), a && this.$element) {
            var r = t += this.options.namespaceJQueryEvents ? ".flickity" : "";
            if (e) {
                var o = a.Event(e);
                o.type = t, r = o
            }
            this.$element.trigger(r, n)
        }
    }, f.select = function(t, e, n) {
        if (this.isActive && (t = parseInt(t, 10), this._wrapSelect(t), (this.options.wrapAround || e) && (t = i.modulo(t, this.slides.length)), this.slides[t])) {
            var r = this.selectedIndex;
            this.selectedIndex = t, this.updateSelectedSlide(), n ? this.positionSliderAtSelected() : this.startAnimation(), this.options.adaptiveHeight && this.setGallerySize(), this.dispatchEvent("select", null, [t]), t != r && this.dispatchEvent("change", null, [t]), this.dispatchEvent("cellSelect")
        }
    }, f._wrapSelect = function(t) {
        var e = this.slides.length;
        if (!(this.options.wrapAround && 1 < e)) return t;
        var n = i.modulo(t, e),
            r = Math.abs(n - this.selectedIndex),
            o = Math.abs(n + e - this.selectedIndex),
            s = Math.abs(n - e - this.selectedIndex);
        !this.isDragSelect && o < r ? t += e : !this.isDragSelect && s < r && (t -= e), t < 0 ? this.x -= this.slideableWidth : e <= t && (this.x += this.slideableWidth)
    }, f.previous = function(t, e) {
        this.select(this.selectedIndex - 1, t, e)
    }, f.next = function(t, e) {
        this.select(this.selectedIndex + 1, t, e)
    }, f.updateSelectedSlide = function() {
        var t = this.slides[this.selectedIndex];
        t && (this.unselectSelectedSlide(), (this.selectedSlide = t).select(), this.selectedCells = t.cells, this.selectedElements = t.getCellElements(), this.selectedCell = t.cells[0], this.selectedElement = this.selectedElements[0])
    }, f.unselectSelectedSlide = function() {
        this.selectedSlide && this.selectedSlide.unselect()
    }, f.selectInitialIndex = function() {
        var t = this.options.initialIndex;
        if (this.isInitActivated) this.select(this.selectedIndex, !1, !0);
        else {
            if (t && "string" == typeof t && this.queryCell(t)) return void this.selectCell(t, !1, !0);
            var e = 0;
            t && this.slides[t] && (e = t), this.select(e, !1, !0)
        }
    }, f.selectCell = function(t, e, n) {
        var i = this.queryCell(t);
        if (i) {
            var r = this.getCellSlideIndex(i);
            this.select(r, e, n)
        }
    }, f.getCellSlideIndex = function(t) {
        for (var e = 0; e < this.slides.length; e++)
            if (-1 != this.slides[e].cells.indexOf(t)) return e
    }, f.getCell = function(t) {
        for (var e = 0; e < this.cells.length; e++) {
            var n = this.cells[e];
            if (n.element == t) return n
        }
    }, f.getCells = function(t) {
        t = i.makeArray(t);
        var e = [];
        return t.forEach(function(t) {
            var n = this.getCell(t);
            n && e.push(n)
        }, this), e
    }, f.getCellElements = function() {
        return this.cells.map(function(t) {
            return t.element
        })
    }, f.getParentCell = function(t) {
        return this.getCell(t) || (t = i.getParent(t, ".flickity-slider > *"), this.getCell(t))
    }, f.getAdjacentCellElements = function(t, e) {
        if (!t) return this.selectedSlide.getCellElements();
        e = void 0 === e ? this.selectedIndex : e;
        var n = this.slides.length;
        if (n <= 1 + 2 * t) return this.getCellElements();
        for (var r = [], o = e - t; o <= e + t; o++) {
            var s = this.options.wrapAround ? i.modulo(o, n) : o,
                a = this.slides[s];
            a && (r = r.concat(a.getCellElements()))
        }
        return r
    }, f.queryCell = function(t) {
        if ("number" == typeof t) return this.cells[t];
        if ("string" == typeof t) {
            if (t.match(/^[#\.]?[\d\/]/)) return;
            t = this.element.querySelector(t)
        }
        return this.getCell(t)
    }, f.uiChange = function() {
        this.emitEvent("uiChange")
    }, f.childUIPointerDown = function(t) {
        "touchstart" != t.type && t.preventDefault(), this.focus()
    }, f.onresize = function() {
        this.watchCSS(), this.resize()
    }, i.debounceMethod(p, "onresize", 150), f.resize = function() {
        if (this.isActive) {
            this.getSize(), this.options.wrapAround && (this.x = i.modulo(this.x, this.slideableWidth)), this.positionCells(), this._getWrapShiftCells(), this.setGallerySize(), this.emitEvent("resize");
            var t = this.selectedElements && this.selectedElements[0];
            this.selectCell(t, !1, !0)
        }
    }, f.watchCSS = function() {
        this.options.watchCSS && (-1 != l(this.element, ":after").content.indexOf("flickity") ? this.activate() : this.deactivate())
    }, f.onkeydown = function(t) {
        var e = document.activeElement && document.activeElement != this.element;
        if (this.options.accessibility && !e) {
            var n = p.keyboardHandlers[t.keyCode];
            n && n.call(this)
        }
    }, p.keyboardHandlers = {
        37: function() {
            var t = this.options.rightToLeft ? "next" : "previous";
            this.uiChange(), this[t]()
        },
        39: function() {
            var t = this.options.rightToLeft ? "previous" : "next";
            this.uiChange(), this[t]()
        }
    }, f.focus = function() {
        var e = t.pageYOffset;
        this.element.focus({
            preventScroll: !0
        }), t.pageYOffset != e && t.scrollTo(t.pageXOffset, e)
    }, f.deactivate = function() {
        this.isActive && (this.element.classList.remove("flickity-enabled"), this.element.classList.remove("flickity-rtl"), this.unselectSelectedSlide(), this.cells.forEach(function(t) {
            t.destroy()
        }), this.element.removeChild(this.viewport), c(this.slider.children, this.element), this.options.accessibility && (this.element.removeAttribute("tabIndex"), this.element.removeEventListener("keydown", this)), this.isActive = !1, this.emitEvent("deactivate"))
    }, f.destroy = function() {
        this.deactivate(), t.removeEventListener("resize", this), this.allOff(), this.emitEvent("destroy"), a && this.$element && a.removeData(this.element, "flickity"), delete this.element.flickityGUID, delete h[this.guid]
    }, i.extend(f, s), p.data = function(t) {
        var e = (t = i.getQueryElement(t)) && t.flickityGUID;
        return e && h[e]
    }, i.htmlInit(p, "flickity"), a && a.bridget && a.bridget("flickity", p), p.setJQuery = function(t) {
        a = t
    }, p.Cell = r, p.Slide = o, p
}), function(t, e) {
    "function" == typeof define && define.amd ? define("unipointer/unipointer", ["ev-emitter/ev-emitter"], function(n) {
        return e(t, n)
    }) : "object" == typeof module && module.exports ? module.exports = e(t, require("ev-emitter")) : t.Unipointer = e(t, t.EvEmitter)
}(window, function(t, e) {
    function n() {}
    var i = n.prototype = Object.create(e.prototype);
    i.bindStartEvent = function(t) {
        this._bindStartEvent(t, !0)
    }, i.unbindStartEvent = function(t) {
        this._bindStartEvent(t, !1)
    }, i._bindStartEvent = function(e, n) {
        var i = (n = void 0 === n || n) ? "addEventListener" : "removeEventListener",
            r = "mousedown";
        t.PointerEvent ? r = "pointerdown" : "ontouchstart" in t && (r = "touchstart"), e[i](r, this)
    }, i.handleEvent = function(t) {
        var e = "on" + t.type;
        this[e] && this[e](t)
    }, i.getTouch = function(t) {
        for (var e = 0; e < t.length; e++) {
            var n = t[e];
            if (n.identifier == this.pointerIdentifier) return n
        }
    }, i.onmousedown = function(t) {
        var e = t.button;
        e && 0 !== e && 1 !== e || this._pointerDown(t, t)
    }, i.ontouchstart = function(t) {
        this._pointerDown(t, t.changedTouches[0])
    }, i.onpointerdown = function(t) {
        this._pointerDown(t, t)
    }, i._pointerDown = function(t, e) {
        t.button || this.isPointerDown || (this.isPointerDown = !0, this.pointerIdentifier = void 0 !== e.pointerId ? e.pointerId : e.identifier, this.pointerDown(t, e))
    }, i.pointerDown = function(t, e) {
        this._bindPostStartEvents(t), this.emitEvent("pointerDown", [t, e])
    };
    var r = {
        mousedown: ["mousemove", "mouseup"],
        touchstart: ["touchmove", "touchend", "touchcancel"],
        pointerdown: ["pointermove", "pointerup", "pointercancel"]
    };
    return i._bindPostStartEvents = function(e) {
        if (e) {
            var n = r[e.type];
            n.forEach(function(e) {
                t.addEventListener(e, this)
            }, this), this._boundPointerEvents = n
        }
    }, i._unbindPostStartEvents = function() {
        this._boundPointerEvents && (this._boundPointerEvents.forEach(function(e) {
            t.removeEventListener(e, this)
        }, this), delete this._boundPointerEvents)
    }, i.onmousemove = function(t) {
        this._pointerMove(t, t)
    }, i.onpointermove = function(t) {
        t.pointerId == this.pointerIdentifier && this._pointerMove(t, t)
    }, i.ontouchmove = function(t) {
        var e = this.getTouch(t.changedTouches);
        e && this._pointerMove(t, e)
    }, i._pointerMove = function(t, e) {
        this.pointerMove(t, e)
    }, i.pointerMove = function(t, e) {
        this.emitEvent("pointerMove", [t, e])
    }, i.onmouseup = function(t) {
        this._pointerUp(t, t)
    }, i.onpointerup = function(t) {
        t.pointerId == this.pointerIdentifier && this._pointerUp(t, t)
    }, i.ontouchend = function(t) {
        var e = this.getTouch(t.changedTouches);
        e && this._pointerUp(t, e)
    }, i._pointerUp = function(t, e) {
        this._pointerDone(), this.pointerUp(t, e)
    }, i.pointerUp = function(t, e) {
        this.emitEvent("pointerUp", [t, e])
    }, i._pointerDone = function() {
        this._pointerReset(), this._unbindPostStartEvents(), this.pointerDone()
    }, i._pointerReset = function() {
        this.isPointerDown = !1, delete this.pointerIdentifier
    }, i.pointerDone = function() {}, i.onpointercancel = function(t) {
        t.pointerId == this.pointerIdentifier && this._pointerCancel(t, t)
    }, i.ontouchcancel = function(t) {
        var e = this.getTouch(t.changedTouches);
        e && this._pointerCancel(t, e)
    }, i._pointerCancel = function(t, e) {
        this._pointerDone(), this.pointerCancel(t, e)
    }, i.pointerCancel = function(t, e) {
        this.emitEvent("pointerCancel", [t, e])
    }, n.getPointerPoint = function(t) {
        return {
            x: t.pageX,
            y: t.pageY
        }
    }, n
}), function(t, e) {
    "function" == typeof define && define.amd ? define("unidragger/unidragger", ["unipointer/unipointer"], function(n) {
        return e(t, n)
    }) : "object" == typeof module && module.exports ? module.exports = e(t, require("unipointer")) : t.Unidragger = e(t, t.Unipointer)
}(window, function(t, e) {
    function n() {}
    var i = n.prototype = Object.create(e.prototype);
    i.bindHandles = function() {
        this._bindHandles(!0)
    }, i.unbindHandles = function() {
        this._bindHandles(!1)
    }, i._bindHandles = function(e) {
        for (var n = (e = void 0 === e || e) ? "addEventListener" : "removeEventListener", i = e ? this._touchActionValue : "", r = 0; r < this.handles.length; r++) {
            var o = this.handles[r];
            this._bindStartEvent(o, e), o[n]("click", this), t.PointerEvent && (o.style.touchAction = i)
        }
    }, i._touchActionValue = "none", i.pointerDown = function(t, e) {
        this.okayPointerDown(t) && (this.pointerDownPointer = e, t.preventDefault(), this.pointerDownBlur(), this._bindPostStartEvents(t), this.emitEvent("pointerDown", [t, e]))
    };
    var r = {
            TEXTAREA: !0,
            INPUT: !0,
            SELECT: !0,
            OPTION: !0
        },
        o = {
            radio: !0,
            checkbox: !0,
            button: !0,
            submit: !0,
            image: !0,
            file: !0
        };
    return i.okayPointerDown = function(t) {
        var e = r[t.target.nodeName],
            n = o[t.target.type],
            i = !e || n;
        return i || this._pointerReset(), i
    }, i.pointerDownBlur = function() {
        var t = document.activeElement;
        t && t.blur && t != document.body && t.blur()
    }, i.pointerMove = function(t, e) {
        var n = this._dragPointerMove(t, e);
        this.emitEvent("pointerMove", [t, e, n]), this._dragMove(t, e, n)
    }, i._dragPointerMove = function(t, e) {
        var n = {
            x: e.pageX - this.pointerDownPointer.pageX,
            y: e.pageY - this.pointerDownPointer.pageY
        };
        return !this.isDragging && this.hasDragStarted(n) && this._dragStart(t, e), n
    }, i.hasDragStarted = function(t) {
        return 3 < Math.abs(t.x) || 3 < Math.abs(t.y)
    }, i.pointerUp = function(t, e) {
        this.emitEvent("pointerUp", [t, e]), this._dragPointerUp(t, e)
    }, i._dragPointerUp = function(t, e) {
        this.isDragging ? this._dragEnd(t, e) : this._staticClick(t, e)
    }, i._dragStart = function(t, e) {
        this.isDragging = !0, this.isPreventingClicks = !0, this.dragStart(t, e)
    }, i.dragStart = function(t, e) {
        this.emitEvent("dragStart", [t, e])
    }, i._dragMove = function(t, e, n) {
        this.isDragging && this.dragMove(t, e, n)
    }, i.dragMove = function(t, e, n) {
        t.preventDefault(), this.emitEvent("dragMove", [t, e, n])
    }, i._dragEnd = function(t, e) {
        this.isDragging = !1, setTimeout(function() {
            delete this.isPreventingClicks
        }.bind(this)), this.dragEnd(t, e)
    }, i.dragEnd = function(t, e) {
        this.emitEvent("dragEnd", [t, e])
    }, i.onclick = function(t) {
        this.isPreventingClicks && t.preventDefault()
    }, i._staticClick = function(t, e) {
        this.isIgnoringMouseUp && "mouseup" == t.type || (this.staticClick(t, e), "mouseup" != t.type && (this.isIgnoringMouseUp = !0, setTimeout(function() {
            delete this.isIgnoringMouseUp
        }.bind(this), 400)))
    }, i.staticClick = function(t, e) {
        this.emitEvent("staticClick", [t, e])
    }, n.getPointerPoint = e.getPointerPoint, n
}), function(t, e) {
    "function" == typeof define && define.amd ? define("flickity/js/drag", ["./flickity", "unidragger/unidragger", "fizzy-ui-utils/utils"], function(n, i, r) {
        return e(t, n, i, r)
    }) : "object" == typeof module && module.exports ? module.exports = e(t, require("./flickity"), require("unidragger"), require("fizzy-ui-utils")) : t.Flickity = e(t, t.Flickity, t.Unidragger, t.fizzyUIUtils)
}(window, function(t, e, n, i) {
    i.extend(e.defaults, {
        draggable: ">1",
        dragThreshold: 3
    }), e.createMethods.push("_createDrag");
    var r = e.prototype;
    i.extend(r, n.prototype), r._touchActionValue = "pan-y";
    var o = "createTouch" in document,
        s = !1;
    r._createDrag = function() {
        this.on("activate", this.onActivateDrag), this.on("uiChange", this._uiChangeDrag), this.on("deactivate", this.onDeactivateDrag), this.on("cellChange", this.updateDraggable), o && !s && (t.addEventListener("touchmove", function() {}), s = !0)
    }, r.onActivateDrag = function() {
        this.handles = [this.viewport], this.bindHandles(), this.updateDraggable()
    }, r.onDeactivateDrag = function() {
        this.unbindHandles(), this.element.classList.remove("is-draggable")
    }, r.updateDraggable = function() {
        ">1" == this.options.draggable ? this.isDraggable = 1 < this.slides.length : this.isDraggable = this.options.draggable, this.isDraggable ? this.element.classList.add("is-draggable") : this.element.classList.remove("is-draggable")
    }, r.bindDrag = function() {
        this.options.draggable = !0, this.updateDraggable()
    }, r.unbindDrag = function() {
        this.options.draggable = !1, this.updateDraggable()
    }, r._uiChangeDrag = function() {
        delete this.isFreeScrolling
    }, r.pointerDown = function(e, n) {
        this.isDraggable ? this.okayPointerDown(e) && (this._pointerDownPreventDefault(e), this.pointerDownFocus(e), document.activeElement != this.element && this.pointerDownBlur(), this.dragX = this.x, this.viewport.classList.add("is-pointer-down"), this.pointerDownScroll = l(), t.addEventListener("scroll", this), this._pointerDownDefault(e, n)) : this._pointerDownDefault(e, n)
    }, r._pointerDownDefault = function(t, e) {
        this.pointerDownPointer = {
            pageX: e.pageX,
            pageY: e.pageY
        }, this._bindPostStartEvents(t), this.dispatchEvent("pointerDown", t, [e])
    };
    var a = {
        INPUT: !0,
        TEXTAREA: !0,
        SELECT: !0
    };

    function l() {
        return {
            x: t.pageXOffset,
            y: t.pageYOffset
        }
    }
    return r.pointerDownFocus = function(t) {
        a[t.target.nodeName] || this.focus()
    }, r._pointerDownPreventDefault = function(t) {
        var e = "touchstart" == t.type,
            n = "touch" == t.pointerType,
            i = a[t.target.nodeName];
        e || n || i || t.preventDefault()
    }, r.hasDragStarted = function(t) {
        return Math.abs(t.x) > this.options.dragThreshold
    }, r.pointerUp = function(t, e) {
        delete this.isTouchScrolling, this.viewport.classList.remove("is-pointer-down"), this.dispatchEvent("pointerUp", t, [e]), this._dragPointerUp(t, e)
    }, r.pointerDone = function() {
        t.removeEventListener("scroll", this), delete this.pointerDownScroll
    }, r.dragStart = function(e, n) {
        this.isDraggable && (this.dragStartPosition = this.x, this.startAnimation(), t.removeEventListener("scroll", this), this.dispatchEvent("dragStart", e, [n]))
    }, r.pointerMove = function(t, e) {
        var n = this._dragPointerMove(t, e);
        this.dispatchEvent("pointerMove", t, [e, n]), this._dragMove(t, e, n)
    }, r.dragMove = function(t, e, n) {
        if (this.isDraggable) {
            t.preventDefault(), this.previousDragX = this.dragX;
            var i = this.options.rightToLeft ? -1 : 1;
            this.options.wrapAround && (n.x = n.x % this.slideableWidth);
            var r = this.dragStartPosition + n.x * i;
            if (!this.options.wrapAround && this.slides.length) {
                var o = Math.max(-this.slides[0].target, this.dragStartPosition);
                r = o < r ? .5 * (r + o) : r;
                var s = Math.min(-this.getLastSlide().target, this.dragStartPosition);
                r = r < s ? .5 * (r + s) : r
            }
            this.dragX = r, this.dragMoveTime = new Date, this.dispatchEvent("dragMove", t, [e, n])
        }
    }, r.dragEnd = function(t, e) {
        if (this.isDraggable) {
            this.options.freeScroll && (this.isFreeScrolling = !0);
            var n = this.dragEndRestingSelect();
            if (this.options.freeScroll && !this.options.wrapAround) {
                var i = this.getRestingPosition();
                this.isFreeScrolling = -i > this.slides[0].target && -i < this.getLastSlide().target
            } else this.options.freeScroll || n != this.selectedIndex || (n += this.dragEndBoostSelect());
            delete this.previousDragX, this.isDragSelect = this.options.wrapAround, this.select(n), delete this.isDragSelect, this.dispatchEvent("dragEnd", t, [e])
        }
    }, r.dragEndRestingSelect = function() {
        var t = this.getRestingPosition(),
            e = Math.abs(this.getSlideDistance(-t, this.selectedIndex)),
            n = this._getClosestResting(t, e, 1),
            i = this._getClosestResting(t, e, -1);
        return n.distance < i.distance ? n.index : i.index
    }, r._getClosestResting = function(t, e, n) {
        for (var i = this.selectedIndex, r = 1 / 0, o = this.options.contain && !this.options.wrapAround ? function(t, e) {
                return t <= e
            } : function(t, e) {
                return t < e
            }; o(e, r) && (i += n, r = e, null !== (e = this.getSlideDistance(-t, i)));) e = Math.abs(e);
        return {
            distance: r,
            index: i - n
        }
    }, r.getSlideDistance = function(t, e) {
        var n = this.slides.length,
            r = this.options.wrapAround && 1 < n,
            o = r ? i.modulo(e, n) : e,
            s = this.slides[o];
        if (!s) return null;
        var a = r ? this.slideableWidth * Math.floor(e / n) : 0;
        return t - (s.target + a)
    }, r.dragEndBoostSelect = function() {
        if (void 0 === this.previousDragX || !this.dragMoveTime || 100 < new Date - this.dragMoveTime) return 0;
        var t = this.getSlideDistance(-this.dragX, this.selectedIndex),
            e = this.previousDragX - this.dragX;
        return 0 < t && 0 < e ? 1 : t < 0 && e < 0 ? -1 : 0
    }, r.staticClick = function(t, e) {
        var n = this.getParentCell(t.target),
            i = n && n.element,
            r = n && this.cells.indexOf(n);
        this.dispatchEvent("staticClick", t, [e, i, r])
    }, r.onscroll = function() {
        var t = l(),
            e = this.pointerDownScroll.x - t.x,
            n = this.pointerDownScroll.y - t.y;
        (3 < Math.abs(e) || 3 < Math.abs(n)) && this._pointerDone()
    }, e
}), function(t, e) {
    "function" == typeof define && define.amd ? define("flickity/js/prev-next-button", ["./flickity", "unipointer/unipointer", "fizzy-ui-utils/utils"], function(n, i, r) {
        return e(t, n, i, r)
    }) : "object" == typeof module && module.exports ? module.exports = e(t, require("./flickity"), require("unipointer"), require("fizzy-ui-utils")) : e(t, t.Flickity, t.Unipointer, t.fizzyUIUtils)
}(window, function(t, e, n, i) {
    "use strict";
    var r = "http://www.w3.org/2000/svg";

    function o(t, e) {
        this.direction = t, this.parent = e, this._create()
    }(o.prototype = Object.create(n.prototype))._create = function() {
        this.isEnabled = !0, this.isPrevious = -1 == this.direction;
        var t = this.parent.options.rightToLeft ? 1 : -1;
        this.isLeft = this.direction == t;
        var e = this.element = document.createElement("button");
        e.className = "flickity-button flickity-prev-next-button", e.className += this.isPrevious ? " previous" : " next", e.setAttribute("type", "button"), this.disable(), e.setAttribute("aria-label", this.isPrevious ? "Previous" : "Next");
        var n = this.createSVG();
        e.appendChild(n), this.parent.on("select", this.update.bind(this)), this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent))
    }, o.prototype.activate = function() {
        this.bindStartEvent(this.element), this.element.addEventListener("click", this), this.parent.element.appendChild(this.element)
    }, o.prototype.deactivate = function() {
        this.parent.element.removeChild(this.element), this.unbindStartEvent(this.element), this.element.removeEventListener("click", this)
    }, o.prototype.createSVG = function() {
        var t = document.createElementNS(r, "svg");
        t.setAttribute("class", "flickity-button-icon"), t.setAttribute("viewBox", "0 0 100 100");
        var e, n = document.createElementNS(r, "path"),
            i = "string" != typeof(e = this.parent.options.arrowShape) ? "M " + e.x0 + ",50 L " + e.x1 + "," + (e.y1 + 50) + " L " + e.x2 + "," + (e.y2 + 50) + " L " + e.x3 + ",50  L " + e.x2 + "," + (50 - e.y2) + " L " + e.x1 + "," + (50 - e.y1) + " Z" : e;
        return n.setAttribute("d", i), n.setAttribute("class", "arrow"), this.isLeft || n.setAttribute("transform", "translate(100, 100) rotate(180) "), t.appendChild(n), t
    }, o.prototype.handleEvent = i.handleEvent, o.prototype.onclick = function() {
        if (this.isEnabled) {
            this.parent.uiChange();
            var t = this.isPrevious ? "previous" : "next";
            this.parent[t]()
        }
    }, o.prototype.enable = function() {
        this.isEnabled || (this.element.disabled = !1, this.isEnabled = !0)
    }, o.prototype.disable = function() {
        this.isEnabled && (this.element.disabled = !0, this.isEnabled = !1)
    }, o.prototype.update = function() {
        var t = this.parent.slides;
        if (this.parent.options.wrapAround && 1 < t.length) this.enable();
        else {
            var e = t.length ? t.length - 1 : 0,
                n = this.isPrevious ? 0 : e;
            this[this.parent.selectedIndex == n ? "disable" : "enable"]()
        }
    }, o.prototype.destroy = function() {
        this.deactivate(), this.allOff()
    }, i.extend(e.defaults, {
        prevNextButtons: !0,
        arrowShape: {
            x0: 10,
            x1: 60,
            y1: 50,
            x2: 70,
            y2: 40,
            x3: 30
        }
    }), e.createMethods.push("_createPrevNextButtons");
    var s = e.prototype;
    return s._createPrevNextButtons = function() {
        this.options.prevNextButtons && (this.prevButton = new o(-1, this), this.nextButton = new o(1, this), this.on("activate", this.activatePrevNextButtons))
    }, s.activatePrevNextButtons = function() {
        this.prevButton.activate(), this.nextButton.activate(), this.on("deactivate", this.deactivatePrevNextButtons)
    }, s.deactivatePrevNextButtons = function() {
        this.prevButton.deactivate(), this.nextButton.deactivate(), this.off("deactivate", this.deactivatePrevNextButtons)
    }, e.PrevNextButton = o, e
}), function(t, e) {
    "function" == typeof define && define.amd ? define("flickity/js/page-dots", ["./flickity", "unipointer/unipointer", "fizzy-ui-utils/utils"], function(n, i, r) {
        return e(t, n, i, r)
    }) : "object" == typeof module && module.exports ? module.exports = e(t, require("./flickity"), require("unipointer"), require("fizzy-ui-utils")) : e(t, t.Flickity, t.Unipointer, t.fizzyUIUtils)
}(window, function(t, e, n, i) {
    function r(t) {
        this.parent = t, this._create()
    }(r.prototype = Object.create(n.prototype))._create = function() {
        this.holder = document.createElement("ol"), this.holder.className = "flickity-page-dots", this.dots = [], this.handleClick = this.onClick.bind(this), this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent))
    }, r.prototype.activate = function() {
        this.setDots(), this.holder.addEventListener("click", this.handleClick), this.bindStartEvent(this.holder), this.parent.element.appendChild(this.holder)
    }, r.prototype.deactivate = function() {
        this.holder.removeEventListener("click", this.handleClick), this.unbindStartEvent(this.holder), this.parent.element.removeChild(this.holder)
    }, r.prototype.setDots = function() {
        var t = this.parent.slides.length - this.dots.length;
        0 < t ? this.addDots(t) : t < 0 && this.removeDots(-t)
    }, r.prototype.addDots = function(t) {
        for (var e = document.createDocumentFragment(), n = [], i = this.dots.length, r = i + t, o = i; o < r; o++) {
            var s = document.createElement("li");
            s.className = "dot", s.setAttribute("aria-label", "Page dot " + (o + 1)), e.appendChild(s), n.push(s)
        }
        this.holder.appendChild(e), this.dots = this.dots.concat(n)
    }, r.prototype.removeDots = function(t) {
        this.dots.splice(this.dots.length - t, t).forEach(function(t) {
            this.holder.removeChild(t)
        }, this)
    }, r.prototype.updateSelected = function() {
        this.selectedDot && (this.selectedDot.className = "dot", this.selectedDot.removeAttribute("aria-current")), this.dots.length && (this.selectedDot = this.dots[this.parent.selectedIndex], this.selectedDot.className = "dot is-selected", this.selectedDot.setAttribute("aria-current", "step"))
    }, r.prototype.onTap = r.prototype.onClick = function(t) {
        var e = t.target;
        if ("LI" == e.nodeName) {
            this.parent.uiChange();
            var n = this.dots.indexOf(e);
            this.parent.select(n)
        }
    }, r.prototype.destroy = function() {
        this.deactivate(), this.allOff()
    }, e.PageDots = r, i.extend(e.defaults, {
        pageDots: !0
    }), e.createMethods.push("_createPageDots");
    var o = e.prototype;
    return o._createPageDots = function() {
        this.options.pageDots && (this.pageDots = new r(this), this.on("activate", this.activatePageDots), this.on("select", this.updateSelectedPageDots), this.on("cellChange", this.updatePageDots), this.on("resize", this.updatePageDots), this.on("deactivate", this.deactivatePageDots))
    }, o.activatePageDots = function() {
        this.pageDots.activate()
    }, o.updateSelectedPageDots = function() {
        this.pageDots.updateSelected()
    }, o.updatePageDots = function() {
        this.pageDots.setDots()
    }, o.deactivatePageDots = function() {
        this.pageDots.deactivate()
    }, e.PageDots = r, e
}), function(t, e) {
    "function" == typeof define && define.amd ? define("flickity/js/player", ["ev-emitter/ev-emitter", "fizzy-ui-utils/utils", "./flickity"], function(t, n, i) {
        return e(t, n, i)
    }) : "object" == typeof module && module.exports ? module.exports = e(require("ev-emitter"), require("fizzy-ui-utils"), require("./flickity")) : e(t.EvEmitter, t.fizzyUIUtils, t.Flickity)
}(window, function(t, e, n) {
    function i(t) {
        this.parent = t, this.state = "stopped", this.onVisibilityChange = this.visibilityChange.bind(this), this.onVisibilityPlay = this.visibilityPlay.bind(this)
    }(i.prototype = Object.create(t.prototype)).play = function() {
        "playing" != this.state && (document.hidden ? document.addEventListener("visibilitychange", this.onVisibilityPlay) : (this.state = "playing", document.addEventListener("visibilitychange", this.onVisibilityChange), this.tick()))
    }, i.prototype.tick = function() {
        if ("playing" == this.state) {
            var t = this.parent.options.autoPlay;
            t = "number" == typeof t ? t : 3e3;
            var e = this;
            this.clear(), this.timeout = setTimeout(function() {
                e.parent.next(!0), e.tick()
            }, t)
        }
    }, i.prototype.stop = function() {
        this.state = "stopped", this.clear(), document.removeEventListener("visibilitychange", this.onVisibilityChange)
    }, i.prototype.clear = function() {
        clearTimeout(this.timeout)
    }, i.prototype.pause = function() {
        "playing" == this.state && (this.state = "paused", this.clear())
    }, i.prototype.unpause = function() {
        "paused" == this.state && this.play()
    }, i.prototype.visibilityChange = function() {
        this[document.hidden ? "pause" : "unpause"]()
    }, i.prototype.visibilityPlay = function() {
        this.play(), document.removeEventListener("visibilitychange", this.onVisibilityPlay)
    }, e.extend(n.defaults, {
        pauseAutoPlayOnHover: !0
    }), n.createMethods.push("_createPlayer");
    var r = n.prototype;
    return r._createPlayer = function() {
        this.player = new i(this), this.on("activate", this.activatePlayer), this.on("uiChange", this.stopPlayer), this.on("pointerDown", this.stopPlayer), this.on("deactivate", this.deactivatePlayer)
    }, r.activatePlayer = function() {
        this.options.autoPlay && (this.player.play(), this.element.addEventListener("mouseenter", this))
    }, r.playPlayer = function() {
        this.player.play()
    }, r.stopPlayer = function() {
        this.player.stop()
    }, r.pausePlayer = function() {
        this.player.pause()
    }, r.unpausePlayer = function() {
        this.player.unpause()
    }, r.deactivatePlayer = function() {
        this.player.stop(), this.element.removeEventListener("mouseenter", this)
    }, r.onmouseenter = function() {
        this.options.pauseAutoPlayOnHover && (this.player.pause(), this.element.addEventListener("mouseleave", this))
    }, r.onmouseleave = function() {
        this.player.unpause(), this.element.removeEventListener("mouseleave", this)
    }, n.Player = i, n
}), function(t, e) {
    "function" == typeof define && define.amd ? define("flickity/js/add-remove-cell", ["./flickity", "fizzy-ui-utils/utils"], function(n, i) {
        return e(t, n, i)
    }) : "object" == typeof module && module.exports ? module.exports = e(t, require("./flickity"), require("fizzy-ui-utils")) : e(t, t.Flickity, t.fizzyUIUtils)
}(window, function(t, e, n) {
    var i = e.prototype;
    return i.insert = function(t, e) {
        var n = this._makeCells(t);
        if (n && n.length) {
            var i = this.cells.length;
            e = void 0 === e ? i : e;
            var r, o, s = (r = n, o = document.createDocumentFragment(), r.forEach(function(t) {
                    o.appendChild(t.element)
                }), o),
                a = e == i;
            if (a) this.slider.appendChild(s);
            else {
                var l = this.cells[e].element;
                this.slider.insertBefore(s, l)
            }
            if (0 === e) this.cells = n.concat(this.cells);
            else if (a) this.cells = this.cells.concat(n);
            else {
                var u = this.cells.splice(e, i - e);
                this.cells = this.cells.concat(n).concat(u)
            }
            this._sizeCells(n), this.cellChange(e, !0)
        }
    }, i.append = function(t) {
        this.insert(t, this.cells.length)
    }, i.prepend = function(t) {
        this.insert(t, 0)
    }, i.remove = function(t) {
        var e = this.getCells(t);
        if (e && e.length) {
            var i = this.cells.length - 1;
            e.forEach(function(t) {
                t.remove();
                var e = this.cells.indexOf(t);
                i = Math.min(e, i), n.removeFrom(this.cells, t)
            }, this), this.cellChange(i, !0)
        }
    }, i.cellSizeChange = function(t) {
        var e = this.getCell(t);
        if (e) {
            e.getSize();
            var n = this.cells.indexOf(e);
            this.cellChange(n)
        }
    }, i.cellChange = function(t, e) {
        var n = this.selectedElement;
        this._positionCells(t), this._getWrapShiftCells(), this.setGallerySize();
        var i = this.getCell(n);
        i && (this.selectedIndex = this.getCellSlideIndex(i)), this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex), this.emitEvent("cellChange", [t]), this.select(this.selectedIndex), e && this.positionSliderAtSelected()
    }, e
}), function(t, e) {
    "function" == typeof define && define.amd ? define("flickity/js/lazyload", ["./flickity", "fizzy-ui-utils/utils"], function(n, i) {
        return e(t, n, i)
    }) : "object" == typeof module && module.exports ? module.exports = e(t, require("./flickity"), require("fizzy-ui-utils")) : e(t, t.Flickity, t.fizzyUIUtils)
}(window, function(t, e, n) {
    "use strict";
    e.createMethods.push("_createLazyload");
    var i = e.prototype;

    function r(t, e) {
        this.img = t, this.flickity = e, this.load()
    }
    return i._createLazyload = function() {
        this.on("select", this.lazyLoad)
    }, i.lazyLoad = function() {
        var t = this.options.lazyLoad;
        if (t) {
            var e = "number" == typeof t ? t : 0,
                i = this.getAdjacentCellElements(e),
                o = [];
            i.forEach(function(t) {
                var e = function(t) {
                    if ("IMG" == t.nodeName) {
                        var e = t.getAttribute("data-flickity-lazyload"),
                            i = t.getAttribute("data-flickity-lazyload-src"),
                            r = t.getAttribute("data-flickity-lazyload-srcset");
                        if (e || i || r) return [t]
                    }
                    var o = t.querySelectorAll("img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]");
                    return n.makeArray(o)
                }(t);
                o = o.concat(e)
            }), o.forEach(function(t) {
                new r(t, this)
            }, this)
        }
    }, r.prototype.handleEvent = n.handleEvent, r.prototype.load = function() {
        this.img.addEventListener("load", this), this.img.addEventListener("error", this);
        var t = this.img.getAttribute("data-flickity-lazyload") || this.img.getAttribute("data-flickity-lazyload-src"),
            e = this.img.getAttribute("data-flickity-lazyload-srcset");
        this.img.src = t, e && this.img.setAttribute("srcset", e), this.img.removeAttribute("data-flickity-lazyload"), this.img.removeAttribute("data-flickity-lazyload-src"), this.img.removeAttribute("data-flickity-lazyload-srcset")
    }, r.prototype.onload = function(t) {
        this.complete(t, "flickity-lazyloaded")
    }, r.prototype.onerror = function(t) {
        this.complete(t, "flickity-lazyerror")
    }, r.prototype.complete = function(t, e) {
        this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
        var n = this.flickity.getParentCell(this.img),
            i = n && n.element;
        this.flickity.cellSizeChange(i), this.img.classList.add(e), this.flickity.dispatchEvent("lazyLoad", t, i)
    }, e.LazyLoader = r, e
}), function(t, e) {
    "function" == typeof define && define.amd ? define("flickity/js/index", ["./flickity", "./drag", "./prev-next-button", "./page-dots", "./player", "./add-remove-cell", "./lazyload"], e) : "object" == typeof module && module.exports && (module.exports = e(require("./flickity"), require("./drag"), require("./prev-next-button"), require("./page-dots"), require("./player"), require("./add-remove-cell"), require("./lazyload")))
}(window, function(t) {
    return t
}), function(t, e) {
    "function" == typeof define && define.amd ? define("flickity-as-nav-for/as-nav-for", ["flickity/js/index", "fizzy-ui-utils/utils"], e) : "object" == typeof module && module.exports ? module.exports = e(require("flickity"), require("fizzy-ui-utils")) : t.Flickity = e(t.Flickity, t.fizzyUIUtils)
}(window, function(t, e) {
    t.createMethods.push("_createAsNavFor");
    var n = t.prototype;
    return n._createAsNavFor = function() {
        this.on("activate", this.activateAsNavFor), this.on("deactivate", this.deactivateAsNavFor), this.on("destroy", this.destroyAsNavFor);
        var t = this.options.asNavFor;
        if (t) {
            var e = this;
            setTimeout(function() {
                e.setNavCompanion(t)
            })
        }
    }, n.setNavCompanion = function(n) {
        n = e.getQueryElement(n);
        var i = t.data(n);
        if (i && i != this) {
            this.navCompanion = i;
            var r = this;
            this.onNavCompanionSelect = function() {
                r.navCompanionSelect()
            }, i.on("select", this.onNavCompanionSelect), this.on("staticClick", this.onNavStaticClick), this.navCompanionSelect(!0)
        }
    }, n.navCompanionSelect = function(t) {
        if (this.navCompanion) {
            var e, n = this.navCompanion.selectedCells[0],
                i = this.navCompanion.cells.indexOf(n),
                r = i + this.navCompanion.selectedCells.length - 1,
                o = Math.floor((r - (e = i)) * this.navCompanion.cellAlign + e);
            if (this.selectCell(o, !1, t), this.removeNavSelectedElements(), !(o >= this.cells.length)) {
                var s = this.cells.slice(i, r + 1);
                this.navSelectedElements = s.map(function(t) {
                    return t.element
                }), this.changeNavSelectedClass("add")
            }
        }
    }, n.changeNavSelectedClass = function(t) {
        this.navSelectedElements.forEach(function(e) {
            e.classList[t]("is-nav-selected")
        })
    }, n.activateAsNavFor = function() {
        this.navCompanionSelect(!0)
    }, n.removeNavSelectedElements = function() {
        this.navSelectedElements && (this.changeNavSelectedClass("remove"), delete this.navSelectedElements)
    }, n.onNavStaticClick = function(t, e, n, i) {
        "number" == typeof i && this.navCompanion.selectCell(i)
    }, n.deactivateAsNavFor = function() {
        this.removeNavSelectedElements()
    }, n.destroyAsNavFor = function() {
        this.navCompanion && (this.navCompanion.off("select", this.onNavCompanionSelect), this.off("staticClick", this.onNavStaticClick), delete this.navCompanion)
    }, t
}), function(t, e) {
    "use strict";
    "function" == typeof define && define.amd ? define("imagesloaded/imagesloaded", ["ev-emitter/ev-emitter"], function(n) {
        return e(t, n)
    }) : "object" == typeof module && module.exports ? module.exports = e(t, require("ev-emitter")) : t.imagesLoaded = e(t, t.EvEmitter)
}("undefined" != typeof window ? window : this, function(t, e) {
    var n = t.jQuery,
        i = t.console;

    function r(t, e) {
        for (var n in e) t[n] = e[n];
        return t
    }
    var o = Array.prototype.slice;

    function s(t, e, a) {
        if (!(this instanceof s)) return new s(t, e, a);
        var l, u = t;
        "string" == typeof t && (u = document.querySelectorAll(t)), u ? (this.elements = (l = u, Array.isArray(l) ? l : "object" == typeof l && "number" == typeof l.length ? o.call(l) : [l]), this.options = r({}, this.options), "function" == typeof e ? a = e : r(this.options, e), a && this.on("always", a), this.getImages(), n && (this.jqDeferred = new n.Deferred), setTimeout(this.check.bind(this))) : i.error("Bad element for imagesLoaded " + (u || t))
    }(s.prototype = Object.create(e.prototype)).options = {}, s.prototype.getImages = function() {
        this.images = [], this.elements.forEach(this.addElementImages, this)
    }, s.prototype.addElementImages = function(t) {
        "IMG" == t.nodeName && this.addImage(t), !0 === this.options.background && this.addElementBackgroundImages(t);
        var e = t.nodeType;
        if (e && a[e]) {
            for (var n = t.querySelectorAll("img"), i = 0; i < n.length; i++) {
                var r = n[i];
                this.addImage(r)
            }
            if ("string" == typeof this.options.background) {
                var o = t.querySelectorAll(this.options.background);
                for (i = 0; i < o.length; i++) {
                    var s = o[i];
                    this.addElementBackgroundImages(s)
                }
            }
        }
    };
    var a = {
        1: !0,
        9: !0,
        11: !0
    };

    function l(t) {
        this.img = t
    }

    function u(t, e) {
        this.url = t, this.element = e, this.img = new Image
    }
    return s.prototype.addElementBackgroundImages = function(t) {
        var e = getComputedStyle(t);
        if (e)
            for (var n = /url\((['"])?(.*?)\1\)/gi, i = n.exec(e.backgroundImage); null !== i;) {
                var r = i && i[2];
                r && this.addBackground(r, t), i = n.exec(e.backgroundImage)
            }
    }, s.prototype.addImage = function(t) {
        var e = new l(t);
        this.images.push(e)
    }, s.prototype.addBackground = function(t, e) {
        var n = new u(t, e);
        this.images.push(n)
    }, s.prototype.check = function() {
        var t = this;

        function e(e, n, i) {
            setTimeout(function() {
                t.progress(e, n, i)
            })
        }
        this.progressedCount = 0, this.hasAnyBroken = !1, this.images.length ? this.images.forEach(function(t) {
            t.once("progress", e), t.check()
        }) : this.complete()
    }, s.prototype.progress = function(t, e, n) {
        this.progressedCount++, this.hasAnyBroken = this.hasAnyBroken || !t.isLoaded, this.emitEvent("progress", [this, t, e]), this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, t), this.progressedCount == this.images.length && this.complete(), this.options.debug && i && i.log("progress: " + n, t, e)
    }, s.prototype.complete = function() {
        var t = this.hasAnyBroken ? "fail" : "done";
        if (this.isComplete = !0, this.emitEvent(t, [this]), this.emitEvent("always", [this]), this.jqDeferred) {
            var e = this.hasAnyBroken ? "reject" : "resolve";
            this.jqDeferred[e](this)
        }
    }, (l.prototype = Object.create(e.prototype)).check = function() {
        this.getIsImageComplete() ? this.confirm(0 !== this.img.naturalWidth, "naturalWidth") : (this.proxyImage = new Image, this.proxyImage.addEventListener("load", this), this.proxyImage.addEventListener("error", this), this.img.addEventListener("load", this), this.img.addEventListener("error", this), this.proxyImage.src = this.img.src)
    }, l.prototype.getIsImageComplete = function() {
        return this.img.complete && this.img.naturalWidth
    }, l.prototype.confirm = function(t, e) {
        this.isLoaded = t, this.emitEvent("progress", [this, this.img, e])
    }, l.prototype.handleEvent = function(t) {
        var e = "on" + t.type;
        this[e] && this[e](t)
    }, l.prototype.onload = function() {
        this.confirm(!0, "onload"), this.unbindEvents()
    }, l.prototype.onerror = function() {
        this.confirm(!1, "onerror"), this.unbindEvents()
    }, l.prototype.unbindEvents = function() {
        this.proxyImage.removeEventListener("load", this), this.proxyImage.removeEventListener("error", this), this.img.removeEventListener("load", this), this.img.removeEventListener("error", this)
    }, (u.prototype = Object.create(l.prototype)).check = function() {
        this.img.addEventListener("load", this), this.img.addEventListener("error", this), this.img.src = this.url, this.getIsImageComplete() && (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"), this.unbindEvents())
    }, u.prototype.unbindEvents = function() {
        this.img.removeEventListener("load", this), this.img.removeEventListener("error", this)
    }, u.prototype.confirm = function(t, e) {
        this.isLoaded = t, this.emitEvent("progress", [this, this.element, e])
    }, s.makeJQueryPlugin = function(e) {
        (e = e || t.jQuery) && ((n = e).fn.imagesLoaded = function(t, e) {
            return new s(this, t, e).jqDeferred.promise(n(this))
        })
    }, s.makeJQueryPlugin(), s
}), function(t, e) {
    "function" == typeof define && define.amd ? define(["flickity/js/index", "imagesloaded/imagesloaded"], function(n, i) {
        return e(t, n, i)
    }) : "object" == typeof module && module.exports ? module.exports = e(t, require("flickity"), require("imagesloaded")) : t.Flickity = e(t, t.Flickity, t.imagesLoaded)
}(window, function(t, e, n) {
    "use strict";
    e.createMethods.push("_createImagesLoaded");
    var i = e.prototype;
    return i._createImagesLoaded = function() {
        this.on("activate", this.imagesLoaded)
    }, i.imagesLoaded = function() {
        if (this.options.imagesLoaded) {
            var t = this;
            n(this.slider).on("progress", function(e, n) {
                var i = t.getParentCell(n.img);
                t.cellSizeChange(i && i.element), t.options.freeScroll || t.positionSliderAtSelected()
            })
        }
    }, e
}), function(t, e) {
    "function" == typeof define && define.amd ? define(["flickity/js/index", "fizzy-ui-utils/utils"], e) : "object" == typeof module && module.exports ? module.exports = e(require("flickity"), require("fizzy-ui-utils")) : t.Flickity = e(t.Flickity, t.fizzyUIUtils)
}(window, function(t, e) {
    "use strict";
    return t.createMethods.push("_createSync"), t.prototype._createSync = function() {
        this.syncers = {};
        var t = this.options.sync;
        if (this.on("destroy", this.unsyncAll), t) {
            var e = this;
            setTimeout(function() {
                e.sync(t)
            })
        }
    }, t.prototype.sync = function(n) {
        n = e.getQueryElement(n);
        var i = t.data(n);
        i && (this._syncCompanion(i), i._syncCompanion(this))
    }, t.prototype._syncCompanion = function(t) {
        var e = this;

        function n() {
            var n = e.selectedIndex;
            t.selectedIndex != n && t.select(n)
        }
        this.on("select", n), this.syncers[t.guid] = {
            flickity: t,
            listener: n
        }
    }, t.prototype.unsync = function(n) {
        n = e.getQueryElement(n);
        var i = t.data(n);
        this._unsync(i)
    }, t.prototype._unsync = function(t) {
        t && (this._unsyncCompanion(t), t._unsyncCompanion(this))
    }, t.prototype._unsyncCompanion = function(t) {
        var e = t.guid,
            n = this.syncers[e];
        this.off("select", n.listener), delete this.syncers[e]
    }, t.prototype.unsyncAll = function() {
        for (var t in this.syncers) {
            var e = this.syncers[t];
            this._unsync(e.flickity)
        }
    }, t
}), function(t, e) {
    var n, i = t.jQuery || t.Cowboy || (t.Cowboy = {});
    i.throttle = n = function(t, n, r, o) {
        var s, a = 0;

        function l() {
            var i = this,
                l = +new Date - a,
                u = arguments;

            function c() {
                a = +new Date, r.apply(i, u)
            }
            o && !s && c(), s && clearTimeout(s), o === e && l > t ? c() : !0 !== n && (s = setTimeout(o ? function() {
                s = e
            } : c, o === e ? t - l : t))
        }
        return "boolean" != typeof n && (o = r, r = n, n = e), i.guid && (l.guid = r.guid = r.guid || i.guid++), l
    }, i.debounce = function(t, i, r) {
        return r === e ? n(t, i, !1) : n(t, r, !1 !== i)
    }
}(this), "object" != typeof JSON && (JSON = {}), function() {
    "use strict";

    function f(t) {
        return t < 10 ? "0" + t : t
    }

    function quote(t) {
        return escapable.lastIndex = 0, escapable.test(t) ? '"' + t.replace(escapable, function(t) {
            var e = meta[t];
            return "string" == typeof e ? e : "\\u" + ("0000" + t.charCodeAt(0).toString(16)).slice(-4)
        }) + '"' : '"' + t + '"'
    }

    function str(t, e) {
        var n, i, r, o, s, a = gap,
            l = e[t];
        switch (l && "object" == typeof l && "function" == typeof l.toJSON && (l = l.toJSON(t)), "function" == typeof rep && (l = rep.call(e, t, l)), typeof l) {
            case "string":
                return quote(l);
            case "number":
                return isFinite(l) ? String(l) : "null";
            case "boolean":
            case "null":
                return String(l);
            case "object":
                if (!l) return "null";
                if (gap += indent, s = [], "[object Array]" === Object.prototype.toString.apply(l)) {
                    for (o = l.length, n = 0; n < o; n += 1) s[n] = str(n, l) || "null";
                    return r = 0 === s.length ? "[]" : gap ? "[\n" + gap + s.join(",\n" + gap) + "\n" + a + "]" : "[" + s.join(",") + "]", gap = a, r
                }
                if (rep && "object" == typeof rep)
                    for (o = rep.length, n = 0; n < o; n += 1) "string" == typeof rep[n] && ((r = str(i = rep[n], l)) && s.push(quote(i) + (gap ? ": " : ":") + r));
                else
                    for (i in l) Object.prototype.hasOwnProperty.call(l, i) && (r = str(i, l)) && s.push(quote(i) + (gap ? ": " : ":") + r);
                return r = 0 === s.length ? "{}" : gap ? "{\n" + gap + s.join(",\n" + gap) + "\n" + a + "}" : "{" + s.join(",") + "}", gap = a, r
        }
    }
    "function" != typeof Date.prototype.toJSON && (Date.prototype.toJSON = function(t) {
        return isFinite(this.valueOf()) ? this.getUTCFullYear() + "-" + f(this.getUTCMonth() + 1) + "-" + f(this.getUTCDate()) + "T" + f(this.getUTCHours()) + ":" + f(this.getUTCMinutes()) + ":" + f(this.getUTCSeconds()) + "Z" : null
    }, String.prototype.toJSON = Number.prototype.toJSON = Boolean.prototype.toJSON = function(t) {
        return this.valueOf()
    });
    var cx = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
        escapable = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
        gap, indent, meta = {
            "\b": "\\b",
            "\t": "\\t",
            "\n": "\\n",
            "\f": "\\f",
            "\r": "\\r",
            '"': '\\"',
            "\\": "\\\\"
        },
        rep;
    "function" != typeof JSON.stringify && (JSON.stringify = function(t, e, n) {
        var i;
        if (gap = "", indent = "", "number" == typeof n)
            for (i = 0; i < n; i += 1) indent += " ";
        else "string" == typeof n && (indent = n);
        if (rep = e, !e || "function" == typeof e || "object" == typeof e && "number" == typeof e.length) return str("", {
            "": t
        });
        throw new Error("JSON.stringify")
    }), "function" != typeof JSON.parse && (JSON.parse = function(text, reviver) {
        function walk(t, e) {
            var n, i, r = t[e];
            if (r && "object" == typeof r)
                for (n in r) Object.prototype.hasOwnProperty.call(r, n) && (void 0 !== (i = walk(r, n)) ? r[n] = i : delete r[n]);
            return reviver.call(t, e, r)
        }
        var j;
        if (text = String(text), cx.lastIndex = 0, cx.test(text) && (text = text.replace(cx, function(t) {
                return "\\u" + ("0000" + t.charCodeAt(0).toString(16)).slice(-4)
            })), /^[\],:{}\s]*$/.test(text.replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g, "@").replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, "]").replace(/(?:^|:|,)(?:\s*\[)+/g, ""))) return j = eval("(" + text + ")"), "function" == typeof reviver ? walk({
            "": j
        }, "") : j;
        throw new SyntaxError("JSON.parse")
    })
}(), function(t, e) {
    "use strict";
    var n = t.History = t.History || {},
        i = t.jQuery;
    if (void 0 !== n.Adapter) throw new Error("History.js Adapter has already been loaded...");
    n.Adapter = {
        bind: function(t, e, n) {
            i(t).bind(e, n)
        },
        trigger: function(t, e, n) {
            i(t).trigger(e, n)
        },
        extractEventData: function(t, e, n) {
            return e && e.originalEvent && e.originalEvent[t] || n && n[t] || void 0
        },
        onDomLoad: function(t) {
            i(t)
        }
    }, void 0 !== n.init && n.init()
}(window), function(t, e) {
    "use strict";
    var n = t.document,
        i = t.setTimeout || i,
        r = t.clearTimeout || r,
        o = t.setInterval || o,
        s = t.History = t.History || {};
    if (void 0 !== s.initHtml4) throw new Error("History.js HTML4 Support has already been loaded...");
    s.initHtml4 = function() {
        if (void 0 !== s.initHtml4.initialized) return !1;
        s.initHtml4.initialized = !0, s.enabled = !0, s.savedHashes = [], s.isLastHash = function(t) {
            return t === s.getHashByIndex()
        }, s.isHashEqual = function(t, e) {
            return (t = encodeURIComponent(t).replace(/%25/g, "%")) === (e = encodeURIComponent(e).replace(/%25/g, "%"))
        }, s.saveHash = function(t) {
            return !s.isLastHash(t) && (s.savedHashes.push(t), !0)
        }, s.getHashByIndex = function(t) {
            return void 0 === t ? s.savedHashes[s.savedHashes.length - 1] : t < 0 ? s.savedHashes[s.savedHashes.length + t] : s.savedHashes[t]
        }, s.discardedHashes = {}, s.discardedStates = {}, s.discardState = function(t, e, n) {
            var i, r = s.getHashByState(t);
            return i = {
                discardedState: t,
                backState: n,
                forwardState: e
            }, s.discardedStates[r] = i, !0
        }, s.discardHash = function(t, e, n) {
            var i = {
                discardedHash: t,
                backState: n,
                forwardState: e
            };
            return s.discardedHashes[t] = i, !0
        }, s.discardedState = function(t) {
            var e = s.getHashByState(t);
            return s.discardedStates[e] || !1
        }, s.discardedHash = function(t) {
            return s.discardedHashes[t] || !1
        }, s.recycleState = function(t) {
            var e = s.getHashByState(t);
            return s.discardedState(t) && delete s.discardedStates[e], !0
        }, s.emulated.hashChange && (s.hashChangeInit = function() {
            s.checkerFunction = null;
            var e, i, r, a = "",
                l = Boolean(s.getHash());
            return s.isInternetExplorer() ? ("historyjs-iframe", (e = n.createElement("iframe")).setAttribute("id", "historyjs-iframe"), e.setAttribute("src", "#"), e.style.display = "none", n.body.appendChild(e), e.contentWindow.document.open(), e.contentWindow.document.close(), i = "", r = !1, s.checkerFunction = function() {
                if (r) return !1;
                r = !0;
                var n = s.getHash(),
                    o = s.getHash(e.contentWindow.document);
                return n !== a ? (a = n, o !== n && (i = o = n, e.contentWindow.document.open(), e.contentWindow.document.close(), e.contentWindow.document.location.hash = s.escapeHash(n)), s.Adapter.trigger(t, "hashchange")) : o !== i && (i = o, l && "" === o ? s.back() : s.setHash(o, !1)), r = !1, !0
            }) : s.checkerFunction = function() {
                var e = s.getHash() || "";
                return e !== a && (a = e, s.Adapter.trigger(t, "hashchange")), !0
            }, s.intervalList.push(o(s.checkerFunction, s.options.hashChangeInterval)), !0
        }, s.Adapter.onDomLoad(s.hashChangeInit)), s.emulated.pushState && (s.onHashChange = function(e) {
            var n, i = e && e.newURL || s.getLocationHref(),
                r = s.getHashByUrl(i),
                o = null;
            return s.isLastHash(r) ? (s.busy(!1), !1) : (s.doubleCheckComplete(), s.saveHash(r), r && s.isTraditionalAnchor(r) ? (s.Adapter.trigger(t, "anchorchange"), s.busy(!1), !1) : (o = s.extractState(s.getFullUrl(r || s.getLocationHref()), !0), s.isLastSavedState(o) ? (s.busy(!1), !1) : (s.getHashByState(o), (n = s.discardedState(o)) ? (s.getHashByIndex(-2) === s.getHashByState(n.forwardState) ? s.back(!1) : s.forward(!1), !1) : (s.pushState(o.data, o.title, encodeURI(o.url), !1), !0))))
        }, s.Adapter.bind(t, "hashchange", s.onHashChange), s.pushState = function(e, n, i, r) {
            if (i = encodeURI(i).replace(/%25/g, "%"), s.getHashByUrl(i)) throw new Error("History.js does not support states with fragment-identifiers (hashes/anchors).");
            if (!1 !== r && s.busy()) return s.pushQueue({
                scope: s,
                callback: s.pushState,
                args: arguments,
                queue: r
            }), !1;
            s.busy(!0);
            var o = s.createStateObject(e, n, i),
                a = s.getHashByState(o),
                l = s.getState(!1),
                u = s.getHashByState(l),
                c = s.getHash(),
                d = s.expectedStateId == o.id;
            return s.storeState(o), s.expectedStateId = o.id, s.recycleState(o), s.setTitle(o), a === u ? (s.busy(!1), !1) : (s.saveState(o), d || s.Adapter.trigger(t, "statechange"), !s.isHashEqual(a, c) && !s.isHashEqual(a, s.getShortUrl(s.getLocationHref())) && s.setHash(a, !1), s.busy(!1), !0)
        }, s.replaceState = function(e, n, i, r) {
            if (i = encodeURI(i).replace(/%25/g, "%"), s.getHashByUrl(i)) throw new Error("History.js does not support states with fragment-identifiers (hashes/anchors).");
            if (!1 !== r && s.busy()) return s.pushQueue({
                scope: s,
                callback: s.replaceState,
                args: arguments,
                queue: r
            }), !1;
            s.busy(!0);
            var o = s.createStateObject(e, n, i),
                a = s.getHashByState(o),
                l = s.getState(!1),
                u = s.getHashByState(l),
                c = s.getStateByIndex(-2);
            return s.discardState(l, o, c), a === u ? (s.storeState(o), s.expectedStateId = o.id, s.recycleState(o), s.setTitle(o), s.saveState(o), s.Adapter.trigger(t, "statechange"), s.busy(!1)) : s.pushState(o.data, o.title, o.url, !1), !0
        }), s.emulated.pushState && s.getHash() && !s.emulated.hashChange && s.Adapter.onDomLoad(function() {
            s.Adapter.trigger(t, "hashchange")
        })
    }, void 0 !== s.init && s.init()
}(window), function(t, e) {
    "use strict";
    var n = t.console || e,
        i = t.document,
        r = t.navigator,
        o = !1,
        s = t.setTimeout,
        a = t.clearTimeout,
        l = t.setInterval,
        u = t.clearInterval,
        c = t.JSON,
        d = t.alert,
        h = t.History = t.History || {},
        p = t.history;
    try {
        (o = t.sessionStorage).setItem("TEST", "1"), o.removeItem("TEST")
    } catch (t) {
        o = !1
    }
    if (c.stringify = c.stringify || c.encode, c.parse = c.parse || c.decode, void 0 !== h.init) throw new Error("History.js Core has already been loaded...");
    h.init = function(t) {
        return void 0 !== h.Adapter && (void 0 !== h.initCore && h.initCore(), void 0 !== h.initHtml4 && h.initHtml4(), !0)
    }, h.initCore = function(f) {
        if (void 0 !== h.initCore.initialized) return !1;
        if (h.initCore.initialized = !0, h.options = h.options || {}, h.options.hashChangeInterval = h.options.hashChangeInterval || 100, h.options.safariPollInterval = h.options.safariPollInterval || 500, h.options.doubleCheckInterval = h.options.doubleCheckInterval || 500, h.options.disableSuid = h.options.disableSuid || !1, h.options.storeInterval = h.options.storeInterval || 1e3, h.options.busyDelay = h.options.busyDelay || 250, h.options.debug = h.options.debug || !1, h.options.initialTitle = h.options.initialTitle || i.title, h.options.html4Mode = h.options.html4Mode || !1, h.options.delayInit = h.options.delayInit || !1, h.intervalList = [], h.clearAllIntervals = function() {
                var t, e = h.intervalList;
                if (null != e) {
                    for (t = 0; t < e.length; t++) u(e[t]);
                    h.intervalList = null
                }
            }, h.debug = function() {
                h.options.debug && h.log.apply(h, arguments)
            }, h.log = function() {
                var t, e, r, o, s, a = void 0 !== n && void 0 !== n.log && void 0 !== n.log.apply,
                    l = i.getElementById("log");
                for (a ? (t = (o = Array.prototype.slice.call(arguments)).shift(), void 0 !== n.debug ? n.debug.apply(n, [t, o]) : n.log.apply(n, [t, o])) : t = "\n" + arguments[0] + "\n", e = 1, r = arguments.length; e < r; ++e) {
                    if ("object" == typeof(s = arguments[e]) && void 0 !== c) try {
                        s = c.stringify(s)
                    } catch (t) {}
                    t += "\n" + s + "\n"
                }
                return l ? (l.value += t + "\n-----\n", l.scrollTop = l.scrollHeight - l.clientHeight) : a || d(t), !0
            }, h.getInternetExplorerMajorVersion = function() {
                return h.getInternetExplorerMajorVersion.cached = void 0 !== h.getInternetExplorerMajorVersion.cached ? h.getInternetExplorerMajorVersion.cached : function() {
                    for (var t = 3, e = i.createElement("div"), n = e.getElementsByTagName("i");
                        (e.innerHTML = "\x3c!--[if gt IE " + ++t + "]><i></i><![endif]--\x3e") && n[0];);
                    return t > 4 && t
                }()
            }, h.isInternetExplorer = function() {
                return h.isInternetExplorer.cached = void 0 !== h.isInternetExplorer.cached ? h.isInternetExplorer.cached : Boolean(h.getInternetExplorerMajorVersion())
            }, h.options.html4Mode ? h.emulated = {
                pushState: !0,
                hashChange: !0
            } : h.emulated = {
                pushState: !Boolean(t.history && t.history.pushState && t.history.replaceState && !/ Mobile\/([1-7][a-z]|(8([abcde]|f(1[0-8]))))/i.test(r.userAgent) && !/AppleWebKit\/5([0-2]|3[0-2])/i.test(r.userAgent)),
                hashChange: Boolean(!("onhashchange" in t || "onhashchange" in i) || h.isInternetExplorer() && h.getInternetExplorerMajorVersion() < 8)
            }, h.enabled = !h.emulated.pushState, h.bugs = {
                setHash: Boolean(!h.emulated.pushState && "Apple Computer, Inc." === r.vendor && /AppleWebKit\/5([0-2]|3[0-3])/.test(r.userAgent)),
                safariPoll: Boolean(!h.emulated.pushState && "Apple Computer, Inc." === r.vendor && /AppleWebKit\/5([0-2]|3[0-3])/.test(r.userAgent)),
                ieDoubleCheck: Boolean(h.isInternetExplorer() && h.getInternetExplorerMajorVersion() < 8),
                hashEscape: Boolean(h.isInternetExplorer() && h.getInternetExplorerMajorVersion() < 7)
            }, h.isEmptyObject = function(t) {
                for (var e in t)
                    if (t.hasOwnProperty(e)) return !1;
                return !0
            }, h.cloneObject = function(t) {
                var e, n;
                return t ? (e = c.stringify(t), n = c.parse(e)) : n = {}, n
            }, h.getRootUrl = function() {
                var t = i.location.protocol + "//" + (i.location.hostname || i.location.host);
                return i.location.port && (t += ":" + i.location.port), t + "/"
            }, h.getBaseHref = function() {
                var t = i.getElementsByTagName("base"),
                    e = "";
                return 1 === t.length && (e = t[0].href.replace(/[^\/]+$/, "")), (e = e.replace(/\/+$/, "")) && (e += "/"), e
            }, h.getBaseUrl = function() {
                return h.getBaseHref() || h.getBasePageUrl() || h.getRootUrl()
            }, h.getPageUrl = function() {
                return ((h.getState(!1, !1) || {}).url || h.getLocationHref()).replace(/\/+$/, "").replace(/[^\/]+$/, function(t, e, n) {
                    return /\./.test(t) ? t : t + "/"
                })
            }, h.getBasePageUrl = function() {
                return h.getLocationHref().replace(/[#\?].*/, "").replace(/[^\/]+$/, function(t, e, n) {
                    return /[^\/]$/.test(t) ? "" : t
                }).replace(/\/+$/, "") + "/"
            }, h.getFullUrl = function(t, e) {
                var n = t,
                    i = t.substring(0, 1);
                return e = void 0 === e || e, /[a-z]+\:\/\//.test(t) || (n = "/" === i ? h.getRootUrl() + t.replace(/^\/+/, "") : "#" === i ? h.getPageUrl().replace(/#.*/, "") + t : "?" === i ? h.getPageUrl().replace(/[\?#].*/, "") + t : e ? h.getBaseUrl() + t.replace(/^(\.\/)+/, "") : h.getBasePageUrl() + t.replace(/^(\.\/)+/, "")), n.replace(/\#$/, "")
            }, h.getShortUrl = function(t) {
                var e = t,
                    n = h.getBaseUrl(),
                    i = h.getRootUrl();
                return h.emulated.pushState && (e = e.replace(n, "")), e = e.replace(i, "/"), h.isTraditionalAnchor(e) && (e = "./" + e), e.replace(/^(\.\/)+/g, "./").replace(/\#$/, "")
            }, h.getLocationHref = function(t) {
                return (t = t || i).URL === t.location.href ? t.location.href : t.location.href === decodeURIComponent(t.URL) ? t.URL : t.location.hash && decodeURIComponent(t.location.href.replace(/^[^#]+/, "")) === t.location.hash ? t.location.href : -1 == t.URL.indexOf("#") && -1 != t.location.href.indexOf("#") ? t.location.href : t.URL || t.location.href
            }, h.store = {}, h.idToState = h.idToState || {}, h.stateToId = h.stateToId || {}, h.urlToId = h.urlToId || {}, h.storedStates = h.storedStates || [], h.savedStates = h.savedStates || [], h.normalizeStore = function() {
                h.store.idToState = h.store.idToState || {}, h.store.urlToId = h.store.urlToId || {}, h.store.stateToId = h.store.stateToId || {}
            }, h.getState = function(t, e) {
                void 0 === t && (t = !0), void 0 === e && (e = !0);
                var n = h.getLastSavedState();
                return !n && e && (n = h.createStateObject()), t && ((n = h.cloneObject(n)).url = n.cleanUrl || n.url), n
            }, h.getIdByState = function(t) {
                var e, n = h.extractId(t.url);
                if (!n)
                    if (e = h.getStateString(t), void 0 !== h.stateToId[e]) n = h.stateToId[e];
                    else if (void 0 !== h.store.stateToId[e]) n = h.store.stateToId[e];
                else {
                    for (; n = (new Date).getTime() + String(Math.random()).replace(/\D/g, ""), void 0 !== h.idToState[n] || void 0 !== h.store.idToState[n];);
                    h.stateToId[e] = n, h.idToState[n] = t
                }
                return n
            }, h.normalizeState = function(t) {
                var e, n;
                return t && "object" == typeof t || (t = {}), void 0 !== t.normalized ? t : (t.data && "object" == typeof t.data || (t.data = {}), (e = {}).normalized = !0, e.title = t.title || "", e.url = h.getFullUrl(t.url ? t.url : h.getLocationHref()), e.hash = h.getShortUrl(e.url), e.data = h.cloneObject(t.data), e.id = h.getIdByState(e), e.cleanUrl = e.url.replace(/\??\&_suid.*/, ""), e.url = e.cleanUrl, n = !h.isEmptyObject(e.data), (e.title || n) && !0 !== h.options.disableSuid && (e.hash = h.getShortUrl(e.url).replace(/\??\&_suid.*/, ""), /\?/.test(e.hash) || (e.hash += "?"), e.hash += "&_suid=" + e.id), e.hashedUrl = h.getFullUrl(e.hash), (h.emulated.pushState || h.bugs.safariPoll) && h.hasUrlDuplicate(e) && (e.url = e.hashedUrl), e)
            }, h.createStateObject = function(t, e, n) {
                var i = {
                    data: t,
                    title: e,
                    url: n
                };
                return h.normalizeState(i)
            }, h.getStateById = function(t) {
                return t = String(t), h.idToState[t] || h.store.idToState[t] || e
            }, h.getStateString = function(t) {
                var e;
                return e = {
                    data: h.normalizeState(t).data,
                    title: t.title,
                    url: t.url
                }, c.stringify(e)
            }, h.getStateId = function(t) {
                return h.normalizeState(t).id
            }, h.getHashByState = function(t) {
                return h.normalizeState(t).hash
            }, h.extractId = function(t) {
                var e, n;
                return n = -1 != t.indexOf("#") ? t.split("#")[0] : t, (e = /(.*)\&_suid=([0-9]+)$/.exec(n)) && e[1], (e ? String(e[2] || "") : "") || !1
            }, h.isTraditionalAnchor = function(t) {
                return !/[\/\?\.]/.test(t)
            }, h.extractState = function(t, e) {
                var n, i, r = null;
                return e = e || !1, (n = h.extractId(t)) && (r = h.getStateById(n)), r || (i = h.getFullUrl(t), (n = h.getIdByUrl(i) || !1) && (r = h.getStateById(n)), !r && e && !h.isTraditionalAnchor(t) && (r = h.createStateObject(null, null, i))), r
            }, h.getIdByUrl = function(t) {
                return h.urlToId[t] || h.store.urlToId[t] || e
            }, h.getLastSavedState = function() {
                return h.savedStates[h.savedStates.length - 1] || e
            }, h.getLastStoredState = function() {
                return h.storedStates[h.storedStates.length - 1] || e
            }, h.hasUrlDuplicate = function(t) {
                var e;
                return (e = h.extractState(t.url)) && e.id !== t.id
            }, h.storeState = function(t) {
                return h.urlToId[t.url] = t.id, h.storedStates.push(h.cloneObject(t)), t
            }, h.isLastSavedState = function(t) {
                var e = !1;
                return h.savedStates.length && (e = t.id === h.getLastSavedState().id), e
            }, h.saveState = function(t) {
                return !h.isLastSavedState(t) && (h.savedStates.push(h.cloneObject(t)), !0)
            }, h.getStateByIndex = function(t) {
                return void 0 === t ? h.savedStates[h.savedStates.length - 1] : t < 0 ? h.savedStates[h.savedStates.length + t] : h.savedStates[t]
            }, h.getCurrentIndex = function() {
                return h.savedStates.length < 1 ? 0 : h.savedStates.length - 1
            }, h.getHash = function(t) {
                var e = h.getLocationHref(t);
                return h.getHashByUrl(e)
            }, h.unescapeHash = function(t) {
                var e = h.normalizeHash(t);
                return decodeURIComponent(e)
            }, h.normalizeHash = function(t) {
                return t.replace(/[^#]*#/, "").replace(/#.*/, "")
            }, h.setHash = function(t, e) {
                var n, r;
                return !1 !== e && h.busy() ? (h.pushQueue({
                    scope: h,
                    callback: h.setHash,
                    args: arguments,
                    queue: e
                }), !1) : (h.busy(!0), (n = h.extractState(t, !0)) && !h.emulated.pushState ? h.pushState(n.data, n.title, n.url, !1) : h.getHash() !== t && (h.bugs.setHash ? (r = h.getPageUrl(), h.pushState(null, null, r + "#" + t, !1)) : i.location.hash = t), h)
            }, h.escapeHash = function(e) {
                var n = h.normalizeHash(e);
                return n = t.encodeURIComponent(n), h.bugs.hashEscape || (n = n.replace(/\%21/g, "!").replace(/\%26/g, "&").replace(/\%3D/g, "=").replace(/\%3F/g, "?")), n
            }, h.getHashByUrl = function(t) {
                var e = String(t).replace(/([^#]*)#?([^#]*)#?(.*)/, "$2");
                return h.unescapeHash(e)
            }, h.setTitle = function(t) {
                var e, n = t.title;
                n || (e = h.getStateByIndex(0)) && e.url === t.url && (n = e.title || h.options.initialTitle);
                try {
                    i.getElementsByTagName("title")[0].innerHTML = n.replace("<", "&lt;").replace(">", "&gt;").replace(" & ", " &amp; ")
                } catch (t) {}
                return i.title = n, h
            }, h.queues = [], h.busy = function(t) {
                if (void 0 !== t ? h.busy.flag = t : void 0 === h.busy.flag && (h.busy.flag = !1), !h.busy.flag) {
                    a(h.busy.timeout);
                    var e = function() {
                        var t, n, i;
                        if (!h.busy.flag)
                            for (t = h.queues.length - 1; t >= 0; --t) 0 !== (n = h.queues[t]).length && (i = n.shift(), h.fireQueueItem(i), h.busy.timeout = s(e, h.options.busyDelay))
                    };
                    h.busy.timeout = s(e, h.options.busyDelay)
                }
                return h.busy.flag
            }, h.busy.flag = !1, h.fireQueueItem = function(t) {
                return t.callback.apply(t.scope || h, t.args || [])
            }, h.pushQueue = function(t) {
                return h.queues[t.queue || 0] = h.queues[t.queue || 0] || [], h.queues[t.queue || 0].push(t), h
            }, h.queue = function(t, e) {
                return "function" == typeof t && (t = {
                    callback: t
                }), void 0 !== e && (t.queue = e), h.busy() ? h.pushQueue(t) : h.fireQueueItem(t), h
            }, h.clearQueue = function() {
                return h.busy.flag = !1, h.queues = [], h
            }, h.stateChanged = !1, h.doubleChecker = !1, h.doubleCheckComplete = function() {
                return h.stateChanged = !0, h.doubleCheckClear(), h
            }, h.doubleCheckClear = function() {
                return h.doubleChecker && (a(h.doubleChecker), h.doubleChecker = !1), h
            }, h.doubleCheck = function(t) {
                return h.stateChanged = !1, h.doubleCheckClear(), h.bugs.ieDoubleCheck && (h.doubleChecker = s(function() {
                    return h.doubleCheckClear(), h.stateChanged || t(), !0
                }, h.options.doubleCheckInterval)), h
            }, h.safariStatePoll = function() {
                var e = h.extractState(h.getLocationHref());
                if (!h.isLastSavedState(e)) return e || h.createStateObject(), h.Adapter.trigger(t, "popstate"), h
            }, h.back = function(t) {
                return !1 !== t && h.busy() ? (h.pushQueue({
                    scope: h,
                    callback: h.back,
                    args: arguments,
                    queue: t
                }), !1) : (h.busy(!0), h.doubleCheck(function() {
                    h.back(!1)
                }), p.go(-1), !0)
            }, h.forward = function(t) {
                return !1 !== t && h.busy() ? (h.pushQueue({
                    scope: h,
                    callback: h.forward,
                    args: arguments,
                    queue: t
                }), !1) : (h.busy(!0), h.doubleCheck(function() {
                    h.forward(!1)
                }), p.go(1), !0)
            }, h.go = function(t, e) {
                var n;
                if (t > 0)
                    for (n = 1; n <= t; ++n) h.forward(e);
                else {
                    if (!(t < 0)) throw new Error("History.go: History.go requires a positive or negative integer passed.");
                    for (n = -1; n >= t; --n) h.back(e)
                }
                return h
            }, h.emulated.pushState) {
            var m = function() {};
            h.pushState = h.pushState || m, h.replaceState = h.replaceState || m
        } else h.onPopState = function(e, n) {
            var i, r, o = !1,
                s = !1;
            return h.doubleCheckComplete(), (i = h.getHash()) ? ((r = h.extractState(i || h.getLocationHref(), !0)) ? h.replaceState(r.data, r.title, r.url, !1) : (h.Adapter.trigger(t, "anchorchange"), h.busy(!1)), h.expectedStateId = !1, !1) : ((s = (o = h.Adapter.extractEventData("state", e, n) || !1) ? h.getStateById(o) : h.expectedStateId ? h.getStateById(h.expectedStateId) : h.extractState(h.getLocationHref())) || (s = h.createStateObject(null, null, h.getLocationHref())), h.expectedStateId = !1, h.isLastSavedState(s) ? (h.busy(!1), !1) : (h.storeState(s), h.saveState(s), h.setTitle(s), h.Adapter.trigger(t, "statechange"), h.busy(!1), !0))
        }, h.Adapter.bind(t, "popstate", h.onPopState), h.pushState = function(e, n, i, r) {
            if (h.getHashByUrl(i) && h.emulated.pushState) throw new Error("History.js does not support states with fragement-identifiers (hashes/anchors).");
            if (!1 !== r && h.busy()) return h.pushQueue({
                scope: h,
                callback: h.pushState,
                args: arguments,
                queue: r
            }), !1;
            h.busy(!0);
            var o = h.createStateObject(e, n, i);
            return h.isLastSavedState(o) ? h.busy(!1) : (h.storeState(o), h.expectedStateId = o.id, p.pushState(o.id, o.title, o.url), h.Adapter.trigger(t, "popstate")), !0
        }, h.replaceState = function(e, n, i, r) {
            if (h.getHashByUrl(i) && h.emulated.pushState) throw new Error("History.js does not support states with fragement-identifiers (hashes/anchors).");
            if (!1 !== r && h.busy()) return h.pushQueue({
                scope: h,
                callback: h.replaceState,
                args: arguments,
                queue: r
            }), !1;
            h.busy(!0);
            var o = h.createStateObject(e, n, i);
            return h.isLastSavedState(o) ? h.busy(!1) : (h.storeState(o), h.expectedStateId = o.id, p.replaceState(o.id, o.title, o.url), h.Adapter.trigger(t, "popstate")), !0
        };
        if (o) {
            try {
                h.store = c.parse(o.getItem("History.store")) || {}
            } catch (t) {
                h.store = {}
            }
            h.normalizeStore()
        } else h.store = {}, h.normalizeStore();
        h.Adapter.bind(t, "unload", h.clearAllIntervals), h.saveState(h.storeState(h.extractState(h.getLocationHref(), !0))), o && (h.onUnload = function() {
            var t, e, n;
            try {
                t = c.parse(o.getItem("History.store")) || {}
            } catch (e) {
                t = {}
            }
            for (e in t.idToState = t.idToState || {}, t.urlToId = t.urlToId || {}, t.stateToId = t.stateToId || {}, h.idToState) h.idToState.hasOwnProperty(e) && (t.idToState[e] = h.idToState[e]);
            for (e in h.urlToId) h.urlToId.hasOwnProperty(e) && (t.urlToId[e] = h.urlToId[e]);
            for (e in h.stateToId) h.stateToId.hasOwnProperty(e) && (t.stateToId[e] = h.stateToId[e]);
            h.store = t, h.normalizeStore(), n = c.stringify(t);
            try {
                o.setItem("History.store", n)
            } catch (t) {
                if (t.code !== DOMException.QUOTA_EXCEEDED_ERR) throw t;
                o.length && (o.removeItem("History.store"), o.setItem("History.store", n))
            }
        }, h.intervalList.push(l(h.onUnload, h.options.storeInterval)), h.Adapter.bind(t, "beforeunload", h.onUnload), h.Adapter.bind(t, "unload", h.onUnload)), h.emulated.pushState || (h.bugs.safariPoll && h.intervalList.push(l(h.safariStatePoll, h.options.safariPollInterval)), "Apple Computer, Inc." !== r.vendor && "Mozilla" !== (r.appCodeName || "") || (h.Adapter.bind(t, "hashchange", function() {
            h.Adapter.trigger(t, "popstate")
        }), h.getHash() && h.Adapter.onDomLoad(function() {
            h.Adapter.trigger(t, "hashchange")
        })))
    }, (!h.options || !h.options.delayInit) && h.init()
}(window), void 0 === Currency) var Currency = {};

function getVendorPrefix() {
if ("result" in arguments.callee) return arguments.callee.result;
var t = /^(Moz|Webkit|Khtml|O|ms|Icab)(?=[A-Z])/,
    e = document.getElementsByTagName("script")[0];
for (var n in e.style)
    if (t.test(n)) return arguments.callee.result = n.match(t)[0];
return arguments.callee.result = "WebkitOpacity" in e.style ? "Webkit" : "KhtmlOpacity" in e.style ? "Khtml" : ""
}
Currency.cookie = {
    name: "roarStorage_currency",
    write: function(t) {
        try {
            localStorage.setItem(this.name, t)
        } catch (t) {}
    },
    read: function() {
        try {
            return localStorage.getItem(this.name)
        } catch (t) {
            return null
        }
    },
    destroy: function() {
        try {
            localStorage.setItem(this.name, null)
        } catch (t) {}
    }
}, Currency.moneyFormats = {
    USD: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} USD"
    },
    EUR: {
        money_format: "&euro;{{amount}}",
        money_with_currency_format: "&euro;{{amount}} EUR"
    },
    GBP: {
        money_format: "&pound;{{amount}}",
        money_with_currency_format: "&pound;{{amount}} GBP"
    },
    CAD: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} CAD"
    },
    ALL: {
        money_format: "Lek {{amount}}",
        money_with_currency_format: "Lek {{amount}} ALL"
    },
    DZD: {
        money_format: "DA {{amount}}",
        money_with_currency_format: "DA {{amount}} DZD"
    },
    AOA: {
        money_format: "Kz{{amount}}",
        money_with_currency_format: "Kz{{amount}} AOA"
    },
    ARS: {
        money_format: "${{amount_with_comma_separator}}",
        money_with_currency_format: "${{amount_with_comma_separator}} ARS"
    },
    AMD: {
        money_format: "{{amount}} AMD",
        money_with_currency_format: "{{amount}} AMD"
    },
    AWG: {
        money_format: "Afl{{amount}}",
        money_with_currency_format: "Afl{{amount}} AWG"
    },
    AUD: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} AUD"
    },
    BBD: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} Bds"
    },
    AZN: {
        money_format: "m.{{amount}}",
        money_with_currency_format: "m.{{amount}} AZN"
    },
    BDT: {
        money_format: "Tk {{amount}}",
        money_with_currency_format: "Tk {{amount}} BDT"
    },
    BSD: {
        money_format: "BS${{amount}}",
        money_with_currency_format: "BS${{amount}} BSD"
    },
    BHD: {
        money_format: "{{amount}}0 BD",
        money_with_currency_format: "{{amount}}0 BHD"
    },
    BYR: {
        money_format: "Br {{amount}}",
        money_with_currency_format: "Br {{amount}} BYR"
    },
    BZD: {
        money_format: "BZ${{amount}}",
        money_with_currency_format: "BZ${{amount}} BZD"
    },
    BTN: {
        money_format: "Nu {{amount}}",
        money_with_currency_format: "Nu {{amount}} BTN"
    },
    BAM: {
        money_format: "KM {{amount_with_comma_separator}}",
        money_with_currency_format: "KM {{amount_with_comma_separator}} BAM"
    },
    BRL: {
        money_format: "R$ {{amount_with_comma_separator}}",
        money_with_currency_format: "R$ {{amount_with_comma_separator}} BRL"
    },
    BOB: {
        money_format: "Bs{{amount_with_comma_separator}}",
        money_with_currency_format: "Bs{{amount_with_comma_separator}} BOB"
    },
    BWP: {
        money_format: "P{{amount}}",
        money_with_currency_format: "P{{amount}} BWP"
    },
    BND: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} BND"
    },
    BGN: {
        money_format: "{{amount}} лв",
        money_with_currency_format: "{{amount}} лв BGN"
    },
    MMK: {
        money_format: "K{{amount}}",
        money_with_currency_format: "K{{amount}} MMK"
    },
    KHR: {
        money_format: "KHR{{amount}}",
        money_with_currency_format: "KHR{{amount}}"
    },
    KYD: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} KYD"
    },
    XAF: {
        money_format: "FCFA{{amount}}",
        money_with_currency_format: "FCFA{{amount}} XAF"
    },
    CLP: {
        money_format: "${{amount_no_decimals}}",
        money_with_currency_format: "${{amount_no_decimals}} CLP"
    },
    CNY: {
        money_format: "&#165;{{amount}}",
        money_with_currency_format: "&#165;{{amount}} CNY"
    },
    COP: {
        money_format: "${{amount_with_comma_separator}}",
        money_with_currency_format: "${{amount_with_comma_separator}} COP"
    },
    CRC: {
        money_format: "&#8353; {{amount_with_comma_separator}}",
        money_with_currency_format: "&#8353; {{amount_with_comma_separator}} CRC"
    },
    HRK: {
        money_format: "{{amount_with_comma_separator}} kn",
        money_with_currency_format: "{{amount_with_comma_separator}} kn HRK"
    },
    CZK: {
        money_format: "{{amount_with_comma_separator}} K&#269;",
        money_with_currency_format: "{{amount_with_comma_separator}} K&#269;"
    },
    DKK: {
        money_format: "{{amount_with_comma_separator}}",
        money_with_currency_format: "kr.{{amount_with_comma_separator}}"
    },
    DOP: {
        money_format: "RD$ {{amount}}",
        money_with_currency_format: "RD$ {{amount}}"
    },
    XCD: {
        money_format: "${{amount}}",
        money_with_currency_format: "EC${{amount}}"
    },
    EGP: {
        money_format: "LE {{amount}}",
        money_with_currency_format: "LE {{amount}} EGP"
    },
    ETB: {
        money_format: "Br{{amount}}",
        money_with_currency_format: "Br{{amount}} ETB"
    },
    XPF: {
        money_format: "{{amount_no_decimals_with_comma_separator}} XPF",
        money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} XPF"
    },
    FJD: {
        money_format: "${{amount}}",
        money_with_currency_format: "FJ${{amount}}"
    },
    GMD: {
        money_format: "D {{amount}}",
        money_with_currency_format: "D {{amount}} GMD"
    },
    GHS: {
        money_format: "GH&#8373;{{amount}}",
        money_with_currency_format: "GH&#8373;{{amount}}"
    },
    GTQ: {
        money_format: "Q{{amount}}",
        money_with_currency_format: "{{amount}} GTQ"
    },
    GYD: {
        money_format: "G${{amount}}",
        money_with_currency_format: "${{amount}} GYD"
    },
    GEL: {
        money_format: "{{amount}} GEL",
        money_with_currency_format: "{{amount}} GEL"
    },
    HNL: {
        money_format: "L {{amount}}",
        money_with_currency_format: "L {{amount}} HNL"
    },
    HKD: {
        money_format: "${{amount}}",
        money_with_currency_format: "HK${{amount}}"
    },
    HUF: {
        money_format: "{{amount_no_decimals_with_comma_separator}}",
        money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} Ft"
    },
    ISK: {
        money_format: "{{amount_no_decimals}} kr",
        money_with_currency_format: "{{amount_no_decimals}} kr ISK"
    },
    INR: {
        money_format: "Rs. {{amount}}",
        money_with_currency_format: "Rs. {{amount}}"
    },
    IDR: {
        money_format: "{{amount_with_comma_separator}}",
        money_with_currency_format: "Rp {{amount_with_comma_separator}}"
    },
    ILS: {
        money_format: "{{amount}} NIS",
        money_with_currency_format: "{{amount}} NIS"
    },
    JMD: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} JMD"
    },
    JPY: {
        money_format: "&#165;{{amount_no_decimals}}",
        money_with_currency_format: "&#165;{{amount_no_decimals}} JPY"
    },
    JEP: {
        money_format: "&pound;{{amount}}",
        money_with_currency_format: "&pound;{{amount}} JEP"
    },
    JOD: {
        money_format: "{{amount}}0 JD",
        money_with_currency_format: "{{amount}}0 JOD"
    },
    KZT: {
        money_format: "{{amount}} KZT",
        money_with_currency_format: "{{amount}} KZT"
    },
    KES: {
        money_format: "KSh{{amount}}",
        money_with_currency_format: "KSh{{amount}}"
    },
    KWD: {
        money_format: "{{amount}}0 KD",
        money_with_currency_format: "{{amount}}0 KWD"
    },
    KGS: {
        money_format: "лв{{amount}}",
        money_with_currency_format: "лв{{amount}}"
    },
    LVL: {
        money_format: "Ls {{amount}}",
        money_with_currency_format: "Ls {{amount}} LVL"
    },
    LBP: {
        money_format: "L&pound;{{amount}}",
        money_with_currency_format: "L&pound;{{amount}} LBP"
    },
    LTL: {
        money_format: "{{amount}} Lt",
        money_with_currency_format: "{{amount}} Lt"
    },
    MGA: {
        money_format: "Ar {{amount}}",
        money_with_currency_format: "Ar {{amount}} MGA"
    },
    MKD: {
        money_format: "ден {{amount}}",
        money_with_currency_format: "ден {{amount}} MKD"
    },
    MOP: {
        money_format: "MOP${{amount}}",
        money_with_currency_format: "MOP${{amount}}"
    },
    MVR: {
        money_format: "Rf{{amount}}",
        money_with_currency_format: "Rf{{amount}} MRf"
    },
    MXN: {
        money_format: "$ {{amount}}",
        money_with_currency_format: "$ {{amount}} MXN"
    },
    MYR: {
        money_format: "RM{{amount}} MYR",
        money_with_currency_format: "RM{{amount}} MYR"
    },
    MUR: {
        money_format: "Rs {{amount}}",
        money_with_currency_format: "Rs {{amount}} MUR"
    },
    MDL: {
        money_format: "{{amount}} MDL",
        money_with_currency_format: "{{amount}} MDL"
    },
    MAD: {
        money_format: "{{amount}} dh",
        money_with_currency_format: "Dh {{amount}} MAD"
    },
    MNT: {
        money_format: "{{amount_no_decimals}} &#8366",
        money_with_currency_format: "{{amount_no_decimals}} MNT"
    },
    MZN: {
        money_format: "{{amount}} Mt",
        money_with_currency_format: "Mt {{amount}} MZN"
    },
    NAD: {
        money_format: "N${{amount}}",
        money_with_currency_format: "N${{amount}} NAD"
    },
    NPR: {
        money_format: "Rs{{amount}}",
        money_with_currency_format: "Rs{{amount}} NPR"
    },
    ANG: {
        money_format: "&fnof;{{amount}}",
        money_with_currency_format: "{{amount}} NA&fnof;"
    },
    NZD: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} NZD"
    },
    NIO: {
        money_format: "C${{amount}}",
        money_with_currency_format: "C${{amount}} NIO"
    },
    NGN: {
        money_format: "&#8358;{{amount}}",
        money_with_currency_format: "&#8358;{{amount}} NGN"
    },
    NOK: {
        money_format: "kr {{amount_with_comma_separator}}",
        money_with_currency_format: "kr {{amount_with_comma_separator}} NOK"
    },
    OMR: {
        money_format: "{{amount_with_comma_separator}} OMR",
        money_with_currency_format: "{{amount_with_comma_separator}} OMR"
    },
    PKR: {
        money_format: "Rs.{{amount}}",
        money_with_currency_format: "Rs.{{amount}} PKR"
    },
    PGK: {
        money_format: "K {{amount}}",
        money_with_currency_format: "K {{amount}} PGK"
    },
    PYG: {
        money_format: "Gs. {{amount_no_decimals_with_comma_separator}}",
        money_with_currency_format: "Gs. {{amount_no_decimals_with_comma_separator}} PYG"
    },
    PEN: {
        money_format: "S/. {{amount}}",
        money_with_currency_format: "S/. {{amount}} PEN"
    },
    PHP: {
        money_format: "&#8369;{{amount}}",
        money_with_currency_format: "&#8369;{{amount}} PHP"
    },
    PLN: {
        money_format: "{{amount_with_comma_separator}} zl",
        money_with_currency_format: "{{amount_with_comma_separator}} zl PLN"
    },
    QAR: {
        money_format: "QAR {{amount_with_comma_separator}}",
        money_with_currency_format: "QAR {{amount_with_comma_separator}}"
    },
    RON: {
        money_format: "{{amount_with_comma_separator}} lei",
        money_with_currency_format: "{{amount_with_comma_separator}} lei RON"
    },
    RUB: {
        money_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}}",
        money_with_currency_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB"
    },
    RWF: {
        money_format: "{{amount_no_decimals}} RF",
        money_with_currency_format: "{{amount_no_decimals}} RWF"
    },
    WST: {
        money_format: "WS$ {{amount}}",
        money_with_currency_format: "WS$ {{amount}} WST"
    },
    SAR: {
        money_format: "{{amount}} SR",
        money_with_currency_format: "{{amount}} SAR"
    },
    STD: {
        money_format: "Db {{amount}}",
        money_with_currency_format: "Db {{amount}} STD"
    },
    RSD: {
        money_format: "{{amount}} RSD",
        money_with_currency_format: "{{amount}} RSD"
    },
    SCR: {
        money_format: "Rs {{amount}}",
        money_with_currency_format: "Rs {{amount}} SCR"
    },
    SGD: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} SGD"
    },
    SYP: {
        money_format: "S&pound;{{amount}}",
        money_with_currency_format: "S&pound;{{amount}} SYP"
    },
    ZAR: {
        money_format: "R {{amount}}",
        money_with_currency_format: "R {{amount}} ZAR"
    },
    KRW: {
        money_format: "&#8361;{{amount_no_decimals}}",
        money_with_currency_format: "&#8361;{{amount_no_decimals}} KRW"
    },
    LKR: {
        money_format: "Rs {{amount}}",
        money_with_currency_format: "Rs {{amount}} LKR"
    },
    SEK: {
        money_format: "{{amount_no_decimals}} kr",
        money_with_currency_format: "{{amount_no_decimals}} kr SEK"
    },
    CHF: {
        money_format: "SFr. {{amount}}",
        money_with_currency_format: "SFr. {{amount}} CHF"
    },
    TWD: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} TWD"
    },
    THB: {
        money_format: "{{amount}} &#xe3f;",
        money_with_currency_format: "{{amount}} &#xe3f; THB"
    },
    TZS: {
        money_format: "{{amount}} TZS",
        money_with_currency_format: "{{amount}} TZS"
    },
    TTD: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} TTD"
    },
    TND: {
        money_format: "{{amount}}",
        money_with_currency_format: "{{amount}} DT"
    },
    TRY: {
        money_format: "{{amount}}TL",
        money_with_currency_format: "{{amount}}TL"
    },
    UGX: {
        money_format: "Ush {{amount_no_decimals}}",
        money_with_currency_format: "Ush {{amount_no_decimals}} UGX"
    },
    UAH: {
        money_format: "₴{{amount}}",
        money_with_currency_format: "₴{{amount}} UAH"
    },
    AED: {
        money_format: "Dhs. {{amount}}",
        money_with_currency_format: "Dhs. {{amount}} AED"
    },
    UYU: {
        money_format: "${{amount_with_comma_separator}}",
        money_with_currency_format: "${{amount_with_comma_separator}} UYU"
    },
    VUV: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}}VT"
    },
    VEF: {
        money_format: "Bs. {{amount_with_comma_separator}}",
        money_with_currency_format: "Bs. {{amount_with_comma_separator}} VEF"
    },
    VND: {
        money_format: "{{amount_no_decimals_with_comma_separator}}&#8363;",
        money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} VND"
    },
    XBT: {
        money_format: "{{amount_no_decimals}} BTC",
        money_with_currency_format: "{{amount_no_decimals}} BTC"
    },
    XOF: {
        money_format: "CFA{{amount}}",
        money_with_currency_format: "CFA{{amount}} XOF"
    },
    ZMW: {
        money_format: "K{{amount_no_decimals_with_comma_separator}}",
        money_with_currency_format: "ZMW{{amount_no_decimals_with_comma_separator}}"
    },
    AFN: {
        money_format: "&#65;&#102; {{amount}}",
        money_with_currency_format: "&#65;&#102; {{amount}} AFN"
    },
    CVE: {
        money_format: "&#36; {{amount}}",
        money_with_currency_format: "&#36; {{amount}} CVE"
    },
    KMF: {
        money_format: "&#67;&#70; {{amount}}",
        money_with_currency_format: "&#67;&#70; {{amount}} KMF"
    },
    CDF: {
        money_format: "&#70;&#67; {{amount}}",
        money_with_currency_format: "&#70;&#67; {{amount}} CDF"
    },
    HTG: {
        money_format: "&#71; {{amount}}",
        money_with_currency_format: "&#71; {{amount}} HTG"
    },
    LAK: {
        money_format: "&#8365; {{amount}}",
        money_with_currency_format: "&#8365; {{amount}} LAK"
    },
    LSL: {
        money_format: "&#76; {{amount}}",
        money_with_currency_format: "&#76; {{amount}} LSL"
    },
    LRD: {
        money_format: "&#36; {{amount}}",
        money_with_currency_format: "&#36; {{amount}} LRD"
    },
    MWK: {
        money_format: "&#77;&#75; {{amount}}",
        money_with_currency_format: "&#77;&#75; {{amount}} MWK"
    },
    SDG: {
        money_format: "&#163; {{amount}}",
        money_with_currency_format: "&#163; {{amount}} SDG"
    },
    SBD: {
        money_format: "&#36; {{amount}}",
        money_with_currency_format: "&#36; {{amount}} SBD"
    },
    SRD: {
        money_format: "&#36; {{amount}}",
        money_with_currency_format: "&#36; {{amount}} SRD"
    },
    SZL: {
        money_format: "&#76; {{amount}}",
        money_with_currency_format: "&#76; {{amount}} SZL"
    },
    TMT: {
        money_format: "&#109; {{amount}}",
        money_with_currency_format: "&#109; {{amount}} TMT"
    },
    UZS: {
        money_format: "&#1083;&#1074; {{amount}}",
        money_with_currency_format: "&#1083;&#1074; {{amount}} UZS"
    },
    YER: {
        money_format: "&#65020; {{amount}}",
        money_with_currency_format: "&#65020; {{amount}} YER"
    }
}, Currency.formatMoney = function(t, e) {
    if ("function" == typeof Shopify.formatMoney) return Shopify.formatMoney(t, e);
    "string" == typeof t && (t = t.replace(".", ""));
    var n = "",
        i = /\{\{\s*(\w+)\s*\}\}/,
        r = e || "${{amount}}";

    function o(t, e) {
        return void 0 === t ? e : t
    }

    function s(t, e, n, i) {
        if (e = o(e, 2), n = o(n, ","), i = o(i, "."), isNaN(t) || null == t) return 0;
        var r = (t = (t / 100).toFixed(e)).split(".");
        return r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + n) + (r[1] ? i + r[1] : "")
    }
    switch (r.match(i)[1]) {
        case "amount":
            n = s(t, 2);
            break;
        case "amount_no_decimals":
            n = s(t, 0);
            break;
        case "amount_with_comma_separator":
            n = s(t, 2, ".", ",");
            break;
        case "amount_no_decimals_with_comma_separator":
            n = s(t, 0, ".", ",")
    }
    return r.replace(i, n)
}, Currency.currentCurrency = "", Currency.format = "money_with_currency_format", Currency.convertAll = function(t, e, n, i) {
    jQuery(n || "span.money").each(function() {
        if (jQuery(this).attr("data-currency") !== e) {
            if (jQuery(this).attr("data-currency-" + e)) jQuery(this).html(jQuery(this).attr("data-currency-" + e));
            else {
                var n, r = Currency.moneyFormats[t][i || Currency.format] || "{{amount}}",
                    o = Currency.moneyFormats[e][i || Currency.format] || "{{amount}}";
                n = -1 !== r.indexOf("amount_no_decimals") ? Currency.convert(100 * parseInt(jQuery(this).html().replace(/[^0-9]/g, ""), 10), t, e) : "JOD" === t || "KWD" == t || "BHD" == t ? Currency.convert(parseInt(jQuery(this).html().replace(/[^0-9]/g, ""), 10) / 10, t, e) : Currency.convert(parseInt(jQuery(this).html().replace(/[^0-9]/g, ""), 10), t, e);
                var s = Currency.formatMoney(n, o);
                jQuery(this).html(s), jQuery(this).attr("data-currency-" + e, s)
            }
            jQuery(this).attr("data-currency", e)
        }
    }), this.currentCurrency = e, this.cookie.write(e)
},
function(t, e) {
    "function" == typeof define && define.amd ? define(e) : "object" == typeof exports ? module.exports = e() : t.NProgress = e()
}(this, function() {
    var t, e, n = {
            version: "0.2.0"
        },
        i = n.settings = {
            minimum: .08,
            easing: "linear",
            positionUsing: "",
            speed: 200,
            trickle: !0,
            trickleSpeed: 200,
            showSpinner: !0,
            barSelector: '[role="bar"]',
            spinnerSelector: '[role="spinner"]',
            parent: "body",
            template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
        };

    function r(t, e, n) {
        return t < e ? e : t > n ? n : t
    }

    function o(t) {
        return 100 * (-1 + t)
    }
    n.configure = function(t) {
        var e, n;
        for (e in t) void 0 !== (n = t[e]) && t.hasOwnProperty(e) && (i[e] = n);
        return this
    }, n.status = null, n.set = function(t) {
        var e = n.isStarted();
        t = r(t, i.minimum, 1), n.status = 1 === t ? null : t;
        var l = n.render(!e),
            u = l.querySelector(i.barSelector),
            c = i.speed,
            d = i.easing;
        return l.offsetWidth, s(function(e) {
            "" === i.positionUsing && (i.positionUsing = n.getPositioningCSS()), a(u, function(t, e, n) {
                var r;
                return (r = "translate3d" === i.positionUsing ? {
                    transform: "translate3d(" + o(t) + "%,0,0)"
                } : "translate" === i.positionUsing ? {
                    transform: "translate(" + o(t) + "%,0)"
                } : {
                    "margin-left": o(t) + "%"
                }).transition = "all " + e + "ms " + n, r
            }(t, c, d)), 1 === t ? (a(l, {
                transition: "none",
                opacity: 1
            }), l.offsetWidth, setTimeout(function() {
                a(l, {
                    transition: "all " + c + "ms linear",
                    opacity: 0
                }), setTimeout(function() {
                    n.remove(), e()
                }, c)
            }, c)) : setTimeout(e, c)
        }), this
    }, n.isStarted = function() {
        return "number" == typeof n.status
    }, n.start = function() {
        n.status || n.set(0);
        var t = function() {
            setTimeout(function() {
                n.status && (n.trickle(), t())
            }, i.trickleSpeed)
        };
        return i.trickle && t(), this
    }, n.done = function(t) {
        return t || n.status ? n.inc(.3 + .5 * Math.random()).set(1) : this
    }, n.inc = function(t) {
        var e = n.status;
        return e ? e > 1 ? void 0 : ("number" != typeof t && (t = e >= 0 && e < .2 ? .1 : e >= .2 && e < .5 ? .04 : e >= .5 && e < .8 ? .02 : e >= .8 && e < .99 ? .005 : 0), e = r(e + t, 0, .994), n.set(e)) : n.start()
    }, n.trickle = function() {
        return n.inc()
    }, t = 0, e = 0, n.promise = function(i) {
        return i && "resolved" !== i.state() ? (0 === e && n.start(), t++, e++, i.always(function() {
            0 == --e ? (t = 0, n.done()) : n.set((t - e) / t)
        }), this) : this
    }, n.render = function(t) {
        if (n.isRendered()) return document.getElementById("nprogress");
        u(document.documentElement, "nprogress-busy");
        var e = document.createElement("div");
        e.id = "nprogress", e.innerHTML = i.template;
        var r, s = e.querySelector(i.barSelector),
            l = t ? "-100" : o(n.status || 0),
            c = document.querySelector(i.parent);
        return a(s, {
            transition: "all 0 linear",
            transform: "translate3d(" + l + "%,0,0)"
        }), i.showSpinner || (r = e.querySelector(i.spinnerSelector)) && h(r), c != document.body && u(c, "nprogress-custom-parent"), c.appendChild(e), e
    }, n.remove = function() {
        c(document.documentElement, "nprogress-busy"), c(document.querySelector(i.parent), "nprogress-custom-parent");
        var t = document.getElementById("nprogress");
        t && h(t)
    }, n.isRendered = function() {
        return !!document.getElementById("nprogress")
    }, n.getPositioningCSS = function() {
        var t = document.body.style,
            e = "WebkitTransform" in t ? "Webkit" : "MozTransform" in t ? "Moz" : "msTransform" in t ? "ms" : "OTransform" in t ? "O" : "";
        return e + "Perspective" in t ? "translate3d" : e + "Transform" in t ? "translate" : "margin"
    };
    var s = function() {
            var t = [];

            function e() {
                var n = t.shift();
                n && n(e)
            }
            return function(n) {
                t.push(n), 1 == t.length && e()
            }
        }(),
        a = function() {
            var t = ["Webkit", "O", "Moz", "ms"],
                e = {};

            function n(n) {
                return n = n.replace(/^-ms-/, "ms-").replace(/-([\da-z])/gi, function(t, e) {
                    return e.toUpperCase()
                }), e[n] || (e[n] = function(e) {
                    var n = document.body.style;
                    if (e in n) return e;
                    for (var i, r = t.length, o = e.charAt(0).toUpperCase() + e.slice(1); r--;)
                        if ((i = t[r] + o) in n) return i;
                    return e
                }(n))
            }

            function i(t, e, i) {
                e = n(e), t.style[e] = i
            }
            return function(t, e) {
                var n, r, o = arguments;
                if (2 == o.length)
                    for (n in e) void 0 !== (r = e[n]) && e.hasOwnProperty(n) && i(t, n, r);
                else i(t, o[1], o[2])
            }
        }();

    function l(t, e) {
        return ("string" == typeof t ? t : d(t)).indexOf(" " + e + " ") >= 0
    }

    function u(t, e) {
        var n = d(t),
            i = n + e;
        l(n, e) || (t.className = i.substring(1))
    }

    function c(t, e) {
        var n, i = d(t);
        l(t, e) && (n = i.replace(" " + e + " ", " "), t.className = n.substring(1, n.length - 1))
    }

    function d(t) {
        return (" " + (t && t.className || "") + " ").replace(/\s+/gi, " ")
    }

    function h(t) {
        t && t.parentNode && t.parentNode.removeChild(t)
    }
    return n
}),
function(t, e) {
    "function" == typeof define && define.amd ? define(e) : "object" == typeof exports ? module.exports = e() : t.PhotoSwipe = e()
}(this, function() {
    "use strict";
    return function(t, e, n, i) {
        var r = {
            features: null,
            bind: function(t, e, n, i) {
                var r = (i ? "remove" : "add") + "EventListener";
                e = e.split(" ");
                for (var o = 0; o < e.length; o++) e[o] && t[r](e[o], n, !1)
            },
            isArray: function(t) {
                return t instanceof Array
            },
            createEl: function(t, e) {
                var n = document.createElement(e || "div");
                return t && (n.className = t), n
            },
            getScrollY: function() {
                var t = window.pageYOffset;
                return void 0 !== t ? t : document.documentElement.scrollTop
            },
            unbind: function(t, e, n) {
                r.bind(t, e, n, !0)
            },
            removeClass: function(t, e) {
                var n = new RegExp("(\\s|^)" + e + "(\\s|$)");
                t.className = t.className.replace(n, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "")
            },
            addClass: function(t, e) {
                r.hasClass(t, e) || (t.className += (t.className ? " " : "") + e)
            },
            hasClass: function(t, e) {
                return t.className && new RegExp("(^|\\s)" + e + "(\\s|$)").test(t.className)
            },
            getChildByClass: function(t, e) {
                for (var n = t.firstChild; n;) {
                    if (r.hasClass(n, e)) return n;
                    n = n.nextSibling
                }
            },
            arraySearch: function(t, e, n) {
                for (var i = t.length; i--;)
                    if (t[i][n] === e) return i;
                return -1
            },
            extend: function(t, e, n) {
                for (var i in e)
                    if (e.hasOwnProperty(i)) {
                        if (n && t.hasOwnProperty(i)) continue;
                        t[i] = e[i]
                    }
            },
            easing: {
                sine: {
                    out: function(t) {
                        return Math.sin(t * (Math.PI / 2))
                    },
                    inOut: function(t) {
                        return -(Math.cos(Math.PI * t) - 1) / 2
                    }
                },
                cubic: {
                    out: function(t) {
                        return --t * t * t + 1
                    }
                }
            },
            detectFeatures: function() {
                if (r.features) return r.features;
                var t = r.createEl().style,
                    e = "",
                    n = {};
                if (n.oldIE = document.all && !document.addEventListener, n.touch = "ontouchstart" in window, window.requestAnimationFrame && (n.raf = window.requestAnimationFrame, n.caf = window.cancelAnimationFrame), n.pointerEvent = !!window.PointerEvent || navigator.msPointerEnabled, !n.pointerEvent) {
                    var i = navigator.userAgent;
                    if (/iP(hone|od)/.test(navigator.platform)) {
                        var o = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
                        o && o.length > 0 && (o = parseInt(o[1], 10)) >= 1 && o < 8 && (n.isOldIOSPhone = !0)
                    }
                    var s = i.match(/Android\s([0-9\.]*)/),
                        a = s ? s[1] : 0;
                    (a = parseFloat(a)) >= 1 && (a < 4.4 && (n.isOldAndroid = !0), n.androidVersion = a), n.isMobileOpera = /opera mini|opera mobi/i.test(i)
                }
                for (var l, u, c = ["transform", "perspective", "animationName"], d = ["", "webkit", "Moz", "ms", "O"], h = 0; h < 4; h++) {
                    e = d[h];
                    for (var p = 0; p < 3; p++) l = c[p], u = e + (e ? l.charAt(0).toUpperCase() + l.slice(1) : l), !n[l] && u in t && (n[l] = u);
                    e && !n.raf && (e = e.toLowerCase(), n.raf = window[e + "RequestAnimationFrame"], n.raf && (n.caf = window[e + "CancelAnimationFrame"] || window[e + "CancelRequestAnimationFrame"]))
                }
                if (!n.raf) {
                    var f = 0;
                    n.raf = function(t) {
                        var e = (new Date).getTime(),
                            n = Math.max(0, 16 - (e - f)),
                            i = window.setTimeout(function() {
                                t(e + n)
                            }, n);
                        return f = e + n, i
                    }, n.caf = function(t) {
                        clearTimeout(t)
                    }
                }
                return n.svg = !!document.createElementNS && !!document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect, r.features = n, n
            }
        };
        r.detectFeatures(), r.features.oldIE && (r.bind = function(t, e, n, i) {
            e = e.split(" ");
            for (var r, o = (i ? "detach" : "attach") + "Event", s = function() {
                    n.handleEvent.call(n)
                }, a = 0; a < e.length; a++)
                if (r = e[a])
                    if ("object" == typeof n && n.handleEvent) {
                        if (i) {
                            if (!n["oldIE" + r]) return !1
                        } else n["oldIE" + r] = s;
                        t[o]("on" + r, n["oldIE" + r])
                    } else t[o]("on" + r, n)
        });
        var o = this,
            s = {
                allowPanToNext: !0,
                spacing: .12,
                bgOpacity: 1,
                mouseUsed: !1,
                loop: !0,
                pinchToClose: !0,
                closeOnScroll: !0,
                closeOnVerticalDrag: !0,
                verticalDragRange: .75,
                hideAnimationDuration: 333,
                showAnimationDuration: 333,
                showHideOpacity: !1,
                focus: !0,
                escKey: !0,
                arrowKeys: !0,
                mainScrollEndFriction: .35,
                panEndFriction: .35,
                isClickableElement: function(t) {
                    return "A" === t.tagName
                },
                getDoubleTapZoom: function(t, e) {
                    return t ? 1 : e.initialZoomLevel < .7 ? 1 : 1.33
                },
                maxSpreadZoom: 1.33,
                modal: !0,
                scaleMode: "fit"
            };
        r.extend(s, i);
        var a, l, u, c, d, h, p, f, m, g, y, v, _, b, w, x, S, T, k, C, E, A, D, P, O, I, M, L, j, N, $, z, F, R, H, q, B, U, W, X, Y, Z, V, G, Q, K, J, tt, et, nt, it, rt, ot, st, at, lt, ut = {
                x: 0,
                y: 0
            },
            ct = {
                x: 0,
                y: 0
            },
            dt = {
                x: 0,
                y: 0
            },
            ht = {},
            pt = 0,
            ft = {},
            mt = {
                x: 0,
                y: 0
            },
            gt = 0,
            yt = !0,
            vt = [],
            _t = {},
            bt = !1,
            wt = function(t, e) {
                r.extend(o, e.publicMethods), vt.push(t)
            },
            xt = function(t) {
                var e = He();
                return t > e - 1 ? t - e : t < 0 ? e + t : t
            },
            St = {},
            Tt = function(t, e) {
                return St[t] || (St[t] = []), St[t].push(e)
            },
            kt = function(t) {
                var e = St[t];
                if (e) {
                    var n = Array.prototype.slice.call(arguments);
                    n.shift();
                    for (var i = 0; i < e.length; i++) e[i].apply(o, n)
                }
            },
            Ct = function() {
                return (new Date).getTime()
            },
            Et = function(t) {
                st = t, o.bg.style.opacity = t * s.bgOpacity
            },
            At = function(t, e, n, i, r) {
                (!bt || r && r !== o.currItem) && (i /= r ? r.fitRatio : o.currItem.fitRatio), t[A] = v + e + "px, " + n + "px" + _ + " scale(" + i + ")"
            },
            Dt = function(t) {
                et && (t && (g > o.currItem.fitRatio ? bt || (Ge(o.currItem, !1, !0), bt = !0) : bt && (Ge(o.currItem), bt = !1)), At(et, dt.x, dt.y, g))
            },
            Pt = function(t) {
                t.container && At(t.container.style, t.initialPosition.x, t.initialPosition.y, t.initialZoomLevel, t)
            },
            Ot = function(t, e) {
                e[A] = v + t + "px, 0px" + _
            },
            It = function(t, e) {
                if (!s.loop && e) {
                    var n = c + (mt.x * pt - t) / mt.x,
                        i = Math.round(t - ce.x);
                    (n < 0 && i > 0 || n >= He() - 1 && i < 0) && (t = ce.x + i * s.mainScrollEndFriction)
                }
                ce.x = t, Ot(t, d)
            },
            Mt = function(t, e) {
                var n = de[t] - ft[t];
                return ct[t] + ut[t] + n - n * (e / y)
            },
            Lt = function(t, e) {
                t.x = e.x, t.y = e.y, e.id && (t.id = e.id)
            },
            jt = function(t) {
                t.x = Math.round(t.x), t.y = Math.round(t.y)
            },
            Nt = null,
            $t = function() {
                Nt && (r.unbind(document, "mousemove", $t), r.addClass(t, "pswp--has_mouse"), s.mouseUsed = !0, kt("mouseUsed")), Nt = setTimeout(function() {
                    Nt = null
                }, 100)
            },
            zt = function(t, e) {
                var n = Xe(o.currItem, ht, t);
                return e && (tt = n), n
            },
            Ft = function(t) {
                return t || (t = o.currItem), t.initialZoomLevel
            },
            Rt = function(t) {
                return t || (t = o.currItem), t.w > 0 ? s.maxSpreadZoom : 1
            },
            Ht = function(t, e, n, i) {
                return i === o.currItem.initialZoomLevel ? (n[t] = o.currItem.initialPosition[t], !0) : (n[t] = Mt(t, i), n[t] > e.min[t] ? (n[t] = e.min[t], !0) : n[t] < e.max[t] && (n[t] = e.max[t], !0))
            },
            qt = function(t) {
                var e = "";
                s.escKey && 27 === t.keyCode ? e = "close" : s.arrowKeys && (37 === t.keyCode ? e = "prev" : 39 === t.keyCode && (e = "next")), e && (t.ctrlKey || t.altKey || t.shiftKey || t.metaKey || (t.preventDefault ? t.preventDefault() : t.returnValue = !1, o[e]()))
            },
            Bt = function(t) {
                t && (Z || Y || nt || B) && (t.preventDefault(), t.stopPropagation())
            },
            Ut = function() {
                o.setScrollOffset(0, r.getScrollY())
            },
            Wt = {},
            Xt = 0,
            Yt = function(t) {
                Wt[t] && (Wt[t].raf && I(Wt[t].raf), Xt--, delete Wt[t])
            },
            Zt = function(t) {
                Wt[t] && Yt(t), Wt[t] || (Xt++, Wt[t] = {})
            },
            Vt = function() {
                for (var t in Wt) Wt.hasOwnProperty(t) && Yt(t)
            },
            Gt = function(t, e, n, i, r, o, s) {
                var a, l = Ct();
                Zt(t);
                var u = function() {
                    if (Wt[t]) {
                        if ((a = Ct() - l) >= i) return Yt(t), o(n), void(s && s());
                        o((n - e) * r(a / i) + e), Wt[t].raf = O(u)
                    }
                };
                u()
            },
            Qt = {
                shout: kt,
                listen: Tt,
                viewportSize: ht,
                options: s,
                isMainScrollAnimating: function() {
                    return nt
                },
                getZoomLevel: function() {
                    return g
                },
                getCurrentIndex: function() {
                    return c
                },
                isDragging: function() {
                    return W
                },
                isZooming: function() {
                    return K
                },
                setScrollOffset: function(t, e) {
                    ft.x = t, N = ft.y = e, kt("updateScrollOffset", ft)
                },
                applyZoomPan: function(t, e, n, i) {
                    dt.x = e, dt.y = n, g = t, Dt(i)
                },
                init: function() {
                    if (!a && !l) {
                        var n;
                        o.framework = r, o.template = t, o.bg = r.getChildByClass(t, "pswp__bg"), M = t.className, a = !0, $ = r.detectFeatures(), O = $.raf, I = $.caf, A = $.transform, j = $.oldIE, o.scrollWrap = r.getChildByClass(t, "pswp__scroll-wrap"), o.container = r.getChildByClass(o.scrollWrap, "pswp__container"), d = o.container.style, o.itemHolders = x = [{
                                el: o.container.children[0],
                                wrap: 0,
                                index: -1
                            }, {
                                el: o.container.children[1],
                                wrap: 0,
                                index: -1
                            }, {
                                el: o.container.children[2],
                                wrap: 0,
                                index: -1
                            }], x[0].el.style.display = x[2].el.style.display = "none",
                            function() {
                                if (A) {
                                    var e = $.perspective && !P;
                                    return v = "translate" + (e ? "3d(" : "("), void(_ = $.perspective ? ", 0px)" : ")")
                                }
                                A = "left", r.addClass(t, "pswp--ie"), Ot = function(t, e) {
                                    e.left = t + "px"
                                }, Pt = function(t) {
                                    var e = t.fitRatio > 1 ? 1 : t.fitRatio,
                                        n = t.container.style,
                                        i = e * t.w,
                                        r = e * t.h;
                                    n.width = i + "px", n.height = r + "px", n.left = t.initialPosition.x + "px", n.top = t.initialPosition.y + "px"
                                }, Dt = function() {
                                    if (et) {
                                        var t = et,
                                            e = o.currItem,
                                            n = e.fitRatio > 1 ? 1 : e.fitRatio,
                                            i = n * e.w,
                                            r = n * e.h;
                                        t.width = i + "px", t.height = r + "px", t.left = dt.x + "px", t.top = dt.y + "px"
                                    }
                                }
                            }(), m = {
                                resize: o.updateSize,
                                orientationchange: function() {
                                    clearTimeout(z), z = setTimeout(function() {
                                        ht.x !== o.scrollWrap.clientWidth && o.updateSize()
                                    }, 500)
                                },
                                scroll: Ut,
                                keydown: qt,
                                click: Bt
                            };
                        var i = $.isOldIOSPhone || $.isOldAndroid || $.isMobileOpera;
                        for ($.animationName && $.transform && !i || (s.showAnimationDuration = s.hideAnimationDuration = 0), n = 0; n < vt.length; n++) o["init" + vt[n]]();
                        e && (o.ui = new e(o, r)).init(), kt("firstUpdate"), c = c || s.index || 0, (isNaN(c) || c < 0 || c >= He()) && (c = 0), o.currItem = Re(c), ($.isOldIOSPhone || $.isOldAndroid) && (yt = !1), t.setAttribute("aria-hidden", "false"), s.modal && (yt ? t.style.position = "fixed" : (t.style.position = "absolute", t.style.top = r.getScrollY() + "px")), void 0 === N && (kt("initialLayout"), N = L = r.getScrollY());
                        var u = "pswp--open ";
                        for (s.mainClass && (u += s.mainClass + " "), s.showHideOpacity && (u += "pswp--animate_opacity "), u += P ? "pswp--touch" : "pswp--notouch", u += $.animationName ? " pswp--css_animation" : "", u += $.svg ? " pswp--svg" : "", r.addClass(t, u), o.updateSize(), h = -1, gt = null, n = 0; n < 3; n++) Ot((n + h) * mt.x, x[n].el.style);
                        j || r.bind(o.scrollWrap, f, o), Tt("initialZoomInEnd", function() {
                            o.setContent(x[0], c - 1), o.setContent(x[2], c + 1), x[0].el.style.display = x[2].el.style.display = "block", s.focus && t.focus(), r.bind(document, "keydown", o), $.transform && r.bind(o.scrollWrap, "click", o), s.mouseUsed || r.bind(document, "mousemove", $t), r.bind(window, "resize scroll orientationchange", o), kt("bindEvents")
                        }), o.setContent(x[1], c), o.updateCurrItem(), kt("afterInit"), yt || (b = setInterval(function() {
                            Xt || W || K || g !== o.currItem.initialZoomLevel || o.updateSize()
                        }, 1e3)), r.addClass(t, "pswp--visible")
                    }
                },
                close: function() {
                    a && (a = !1, l = !0, kt("close"), r.unbind(window, "resize scroll orientationchange", o), r.unbind(window, "scroll", m.scroll), r.unbind(document, "keydown", o), r.unbind(document, "mousemove", $t), $.transform && r.unbind(o.scrollWrap, "click", o), W && r.unbind(window, p, o), clearTimeout(z), kt("unbindEvents"), qe(o.currItem, null, !0, o.destroy))
                },
                destroy: function() {
                    kt("destroy"), Ne && clearTimeout(Ne), t.setAttribute("aria-hidden", "true"), t.className = M, b && clearInterval(b), r.unbind(o.scrollWrap, f, o), r.unbind(window, "scroll", o), fe(), Vt(), St = null
                },
                panTo: function(t, e, n) {
                    n || (t > tt.min.x ? t = tt.min.x : t < tt.max.x && (t = tt.max.x), e > tt.min.y ? e = tt.min.y : e < tt.max.y && (e = tt.max.y)), dt.x = t, dt.y = e, Dt()
                },
                handleEvent: function(t) {
                    t = t || window.event, m[t.type] && m[t.type](t)
                },
                goTo: function(t) {
                    var e = (t = xt(t)) - c;
                    gt = e, c = t, o.currItem = Re(c), pt -= e, It(mt.x * pt), Vt(), nt = !1, o.updateCurrItem()
                },
                next: function() {
                    o.goTo(c + 1)
                },
                prev: function() {
                    o.goTo(c - 1)
                },
                updateCurrZoomItem: function(t) {
                    if (t && kt("beforeChange", 0), x[1].el.children.length) {
                        var e = x[1].el.children[0];
                        et = r.hasClass(e, "pswp__zoom-wrap") ? e.style : null
                    } else et = null;
                    tt = o.currItem.bounds, y = g = o.currItem.initialZoomLevel, dt.x = tt.center.x, dt.y = tt.center.y, t && kt("afterChange")
                },
                invalidateCurrItems: function() {
                    w = !0;
                    for (var t = 0; t < 3; t++) x[t].item && (x[t].item.needsUpdate = !0)
                },
                updateCurrItem: function(t) {
                    if (0 !== gt) {
                        var e, n = Math.abs(gt);
                        if (!(t && n < 2)) {
                            o.currItem = Re(c), bt = !1, kt("beforeChange", gt), n >= 3 && (h += gt + (gt > 0 ? -3 : 3), n = 3);
                            for (var i = 0; i < n; i++) gt > 0 ? (e = x.shift(), x[2] = e, Ot((++h + 2) * mt.x, e.el.style), o.setContent(e, c - n + i + 1 + 1)) : (e = x.pop(), x.unshift(e), Ot(--h * mt.x, e.el.style), o.setContent(e, c + n - i - 1 - 1));
                            if (et && 1 === Math.abs(gt)) {
                                var r = Re(S);
                                r.initialZoomLevel !== g && (Xe(r, ht), Ge(r), Pt(r))
                            }
                            gt = 0, o.updateCurrZoomItem(), S = c, kt("afterChange")
                        }
                    }
                },
                updateSize: function(e) {
                    if (!yt && s.modal) {
                        var n = r.getScrollY();
                        if (N !== n && (t.style.top = n + "px", N = n), !e && _t.x === window.innerWidth && _t.y === window.innerHeight) return;
                        _t.x = window.innerWidth, _t.y = window.innerHeight, t.style.height = _t.y + "px"
                    }
                    if (ht.x = o.scrollWrap.clientWidth, ht.y = o.scrollWrap.clientHeight, Ut(), mt.x = ht.x + Math.round(ht.x * s.spacing), mt.y = ht.y, It(mt.x * pt), kt("beforeResize"), void 0 !== h) {
                        for (var i, a, l, u = 0; u < 3; u++) i = x[u], Ot((u + h) * mt.x, i.el.style), l = c + u - 1, s.loop && He() > 2 && (l = xt(l)), (a = Re(l)) && (w || a.needsUpdate || !a.bounds) ? (o.cleanSlide(a), o.setContent(i, l), 1 === u && (o.currItem = a, o.updateCurrZoomItem(!0)), a.needsUpdate = !1) : -1 === i.index && l >= 0 && o.setContent(i, l), a && a.container && (Xe(a, ht), Ge(a), Pt(a));
                        w = !1
                    }
                    y = g = o.currItem.initialZoomLevel, (tt = o.currItem.bounds) && (dt.x = tt.center.x, dt.y = tt.center.y, Dt(!0)), kt("resize")
                },
                zoomTo: function(t, e, n, i, o) {
                    e && (y = g, de.x = Math.abs(e.x) - dt.x, de.y = Math.abs(e.y) - dt.y, Lt(ct, dt));
                    var s = zt(t, !1),
                        a = {};
                    Ht("x", s, a, t), Ht("y", s, a, t);
                    var l = g,
                        u = dt.x,
                        c = dt.y;
                    jt(a);
                    var d = function(e) {
                        1 === e ? (g = t, dt.x = a.x, dt.y = a.y) : (g = (t - l) * e + l, dt.x = (a.x - u) * e + u, dt.y = (a.y - c) * e + c), o && o(e), Dt(1 === e)
                    };
                    n ? Gt("customZoomTo", 0, 1, n, i || r.easing.sine.inOut, d) : d(1)
                }
            },
            Kt = {},
            Jt = {},
            te = {},
            ee = {},
            ne = {},
            ie = [],
            re = {},
            oe = [],
            se = {},
            ae = 0,
            le = {
                x: 0,
                y: 0
            },
            ue = 0,
            ce = {
                x: 0,
                y: 0
            },
            de = {
                x: 0,
                y: 0
            },
            he = {
                x: 0,
                y: 0
            },
            pe = function(t, e) {
                return se.x = Math.abs(t.x - e.x), se.y = Math.abs(t.y - e.y), Math.sqrt(se.x * se.x + se.y * se.y)
            },
            fe = function() {
                V && (I(V), V = null)
            },
            me = function() {
                W && (V = O(me), De())
            },
            ge = function(t, e) {
                return !(!t || t === document) && !(t.getAttribute("class") && t.getAttribute("class").indexOf("pswp__scroll-wrap") > -1) && (e(t) ? t : ge(t.parentNode, e))
            },
            ye = {},
            ve = function(t, e) {
                return ye.prevent = !ge(t.target, s.isClickableElement), kt("preventDragEvent", t, e, ye), ye.prevent
            },
            _e = function(t, e) {
                return e.x = t.pageX, e.y = t.pageY, e.id = t.identifier, e
            },
            be = function(t, e, n) {
                n.x = .5 * (t.x + e.x), n.y = .5 * (t.y + e.y)
            },
            we = function() {
                var t = dt.y - o.currItem.initialPosition.y;
                return 1 - Math.abs(t / (ht.y / 2))
            },
            xe = {},
            Se = {},
            Te = [],
            ke = function(t) {
                for (; Te.length > 0;) Te.pop();
                return D ? (lt = 0, ie.forEach(function(t) {
                    0 === lt ? Te[0] = t : 1 === lt && (Te[1] = t), lt++
                })) : t.type.indexOf("touch") > -1 ? t.touches && t.touches.length > 0 && (Te[0] = _e(t.touches[0], xe), t.touches.length > 1 && (Te[1] = _e(t.touches[1], Se))) : (xe.x = t.pageX, xe.y = t.pageY, xe.id = "", Te[0] = xe), Te
            },
            Ce = function(t, e) {
                var n, i, r, a, l = dt[t] + e[t],
                    u = e[t] > 0,
                    c = ce.x + e.x,
                    d = ce.x - re.x;
                return n = l > tt.min[t] || l < tt.max[t] ? s.panEndFriction : 1, l = dt[t] + e[t] * n, !s.allowPanToNext && g !== o.currItem.initialZoomLevel || (et ? "h" !== it || "x" !== t || Y || (u ? (l > tt.min[t] && (n = s.panEndFriction, tt.min[t], i = tt.min[t] - ct[t]), (i <= 0 || d < 0) && He() > 1 ? (a = c, d < 0 && c > re.x && (a = re.x)) : tt.min.x !== tt.max.x && (r = l)) : (l < tt.max[t] && (n = s.panEndFriction, tt.max[t], i = ct[t] - tt.max[t]), (i <= 0 || d > 0) && He() > 1 ? (a = c, d > 0 && c < re.x && (a = re.x)) : tt.min.x !== tt.max.x && (r = l))) : a = c, "x" !== t) ? void(nt || G || g > o.currItem.fitRatio && (dt[t] += e[t] * n)) : (void 0 !== a && (It(a, !0), G = a !== re.x), tt.min.x !== tt.max.x && (void 0 !== r ? dt.x = r : G || (dt.x += e.x * n)), void 0 !== a)
            },
            Ee = function(t) {
                if (!("mousedown" === t.type && t.button > 0)) {
                    if (Fe) return void t.preventDefault();
                    if (!U || "mousedown" !== t.type) {
                        if (ve(t, !0) && t.preventDefault(), kt("pointerDown"), D) {
                            var e = r.arraySearch(ie, t.pointerId, "id");
                            e < 0 && (e = ie.length), ie[e] = {
                                x: t.pageX,
                                y: t.pageY,
                                id: t.pointerId
                            }
                        }
                        var n = ke(t),
                            i = n.length;
                        Q = null, Vt(), W && 1 !== i || (W = rt = !0, r.bind(window, p, o), q = at = ot = B = G = Z = X = Y = !1, it = null, kt("firstTouchStart", n), Lt(ct, dt), ut.x = ut.y = 0, Lt(ee, n[0]), Lt(ne, ee), re.x = mt.x * pt, oe = [{
                            x: ee.x,
                            y: ee.y
                        }], R = F = Ct(), zt(g, !0), fe(), me()), !K && i > 1 && !nt && !G && (y = g, Y = !1, K = X = !0, ut.y = ut.x = 0, Lt(ct, dt), Lt(Kt, n[0]), Lt(Jt, n[1]), be(Kt, Jt, he), de.x = Math.abs(he.x) - dt.x, de.y = Math.abs(he.y) - dt.y, J = pe(Kt, Jt))
                    }
                }
            },
            Ae = function(t) {
                if (t.preventDefault(), D) {
                    var e = r.arraySearch(ie, t.pointerId, "id");
                    if (e > -1) {
                        var n = ie[e];
                        n.x = t.pageX, n.y = t.pageY
                    }
                }
                if (W) {
                    var i = ke(t);
                    if (it || Z || K) Q = i;
                    else if (ce.x !== mt.x * pt) it = "h";
                    else {
                        var o = Math.abs(i[0].x - ee.x) - Math.abs(i[0].y - ee.y);
                        Math.abs(o) >= 10 && (it = o > 0 ? "h" : "v", Q = i)
                    }
                }
            },
            De = function() {
                if (Q) {
                    var t = Q.length;
                    if (0 !== t)
                        if (Lt(Kt, Q[0]), te.x = Kt.x - ee.x, te.y = Kt.y - ee.y, K && t > 1) {
                            if (ee.x = Kt.x, ee.y = Kt.y, !te.x && !te.y && function(t, e) {
                                    return t.x === e.x && t.y === e.y
                                }(Q[1], Jt)) return;
                            Lt(Jt, Q[1]), Y || (Y = !0, kt("zoomGestureStarted"));
                            var e = pe(Kt, Jt),
                                n = Le(e);
                            n > o.currItem.initialZoomLevel + o.currItem.initialZoomLevel / 15 && (at = !0);
                            var i = 1,
                                r = Ft(),
                                a = Rt();
                            if (n < r)
                                if (s.pinchToClose && !at && y <= o.currItem.initialZoomLevel) {
                                    var l = 1 - (r - n) / (r / 1.2);
                                    Et(l), kt("onPinchClose", l), ot = !0
                                } else(i = (r - n) / r) > 1 && (i = 1), n = r - i * (r / 3);
                            else n > a && ((i = (n - a) / (6 * r)) > 1 && (i = 1), n = a + i * r);
                            i < 0 && (i = 0), be(Kt, Jt, le), ut.x += le.x - he.x, ut.y += le.y - he.y, Lt(he, le), dt.x = Mt("x", n), dt.y = Mt("y", n), q = n > g, g = n, Dt()
                        } else {
                            if (!it) return;
                            if (rt && (rt = !1, Math.abs(te.x) >= 10 && (te.x -= Q[0].x - ne.x), Math.abs(te.y) >= 10 && (te.y -= Q[0].y - ne.y)), ee.x = Kt.x, ee.y = Kt.y, 0 === te.x && 0 === te.y) return;
                            if ("v" === it && s.closeOnVerticalDrag && "fit" === s.scaleMode && g === o.currItem.initialZoomLevel) {
                                ut.y += te.y, dt.y += te.y;
                                var u = we();
                                return B = !0, kt("onVerticalDrag", u), Et(u), void Dt()
                            }(function(t, e, n) {
                                if (t - R > 50) {
                                    var i = oe.length > 2 ? oe.shift() : {};
                                    i.x = e, i.y = n, oe.push(i), R = t
                                }
                            })(Ct(), Kt.x, Kt.y), Z = !0, tt = o.currItem.bounds, Ce("x", te) || (Ce("y", te), jt(dt), Dt())
                        }
                }
            },
            Pe = function(t) {
                if ($.isOldAndroid) {
                    if (U && "mouseup" === t.type) return;
                    t.type.indexOf("touch") > -1 && (clearTimeout(U), U = setTimeout(function() {
                        U = 0
                    }, 600))
                }
                var e;
                if (kt("pointerUp"), ve(t, !1) && t.preventDefault(), D) {
                    var n = r.arraySearch(ie, t.pointerId, "id");
                    n > -1 && (e = ie.splice(n, 1)[0], navigator.msPointerEnabled ? (e.type = {
                        4: "mouse",
                        2: "touch",
                        3: "pen"
                    } [t.pointerType], e.type || (e.type = t.pointerType || "mouse")) : e.type = t.pointerType || "mouse")
                }
                var i, a = ke(t),
                    l = a.length;
                if ("mouseup" === t.type && (l = 0), 2 === l) return Q = null, !0;
                1 === l && Lt(ne, a[0]), 0 !== l || it || nt || (e || ("mouseup" === t.type ? e = {
                    x: t.pageX,
                    y: t.pageY,
                    type: "mouse"
                } : t.changedTouches && t.changedTouches[0] && (e = {
                    x: t.changedTouches[0].pageX,
                    y: t.changedTouches[0].pageY,
                    type: "touch"
                })), kt("touchRelease", t, e));
                var u = -1;
                if (0 === l && (W = !1, r.unbind(window, p, o), fe(), K ? u = 0 : -1 !== ue && (u = Ct() - ue)), ue = 1 === l ? Ct() : -1, i = -1 !== u && u < 150 ? "zoom" : "swipe", K && l < 2 && (K = !1, 1 === l && (i = "zoomPointerUp"), kt("zoomGestureEnded")), Q = null, Z || Y || nt || B)
                    if (Vt(), H || (H = Oe()), H.calculateSwipeSpeed("x"), B)
                        if (we() < s.verticalDragRange) o.close();
                        else {
                            var c = dt.y,
                                d = st;
                            Gt("verticalDrag", 0, 1, 300, r.easing.cubic.out, function(t) {
                                dt.y = (o.currItem.initialPosition.y - c) * t + c, Et((1 - d) * t + d), Dt()
                            }), kt("onVerticalDrag", 1)
                        }
                else {
                    if ((G || nt) && 0 === l) {
                        if (Me(i, H)) return;
                        i = "zoomPointerUp"
                    }
                    if (!nt) return "swipe" !== i ? void je() : void(!G && g > o.currItem.fitRatio && Ie(H))
                }
            },
            Oe = function() {
                var t, e, n = {
                    lastFlickOffset: {},
                    lastFlickDist: {},
                    lastFlickSpeed: {},
                    slowDownRatio: {},
                    slowDownRatioReverse: {},
                    speedDecelerationRatio: {},
                    speedDecelerationRatioAbs: {},
                    distanceOffset: {},
                    backAnimDestination: {},
                    backAnimStarted: {},
                    calculateSwipeSpeed: function(i) {
                        oe.length > 1 ? (t = Ct() - R + 50, e = oe[oe.length - 2][i]) : (t = Ct() - F, e = ne[i]), n.lastFlickOffset[i] = ee[i] - e, n.lastFlickDist[i] = Math.abs(n.lastFlickOffset[i]), n.lastFlickDist[i] > 20 ? n.lastFlickSpeed[i] = n.lastFlickOffset[i] / t : n.lastFlickSpeed[i] = 0, Math.abs(n.lastFlickSpeed[i]) < .1 && (n.lastFlickSpeed[i] = 0), n.slowDownRatio[i] = .95, n.slowDownRatioReverse[i] = 1 - n.slowDownRatio[i], n.speedDecelerationRatio[i] = 1
                    },
                    calculateOverBoundsAnimOffset: function(t, e) {
                        n.backAnimStarted[t] || (dt[t] > tt.min[t] ? n.backAnimDestination[t] = tt.min[t] : dt[t] < tt.max[t] && (n.backAnimDestination[t] = tt.max[t]), void 0 !== n.backAnimDestination[t] && (n.slowDownRatio[t] = .7, n.slowDownRatioReverse[t] = 1 - n.slowDownRatio[t], n.speedDecelerationRatioAbs[t] < .05 && (n.lastFlickSpeed[t] = 0, n.backAnimStarted[t] = !0, Gt("bounceZoomPan" + t, dt[t], n.backAnimDestination[t], e || 300, r.easing.sine.out, function(e) {
                            dt[t] = e, Dt()
                        }))))
                    },
                    calculateAnimOffset: function(t) {
                        n.backAnimStarted[t] || (n.speedDecelerationRatio[t] = n.speedDecelerationRatio[t] * (n.slowDownRatio[t] + n.slowDownRatioReverse[t] - n.slowDownRatioReverse[t] * n.timeDiff / 10), n.speedDecelerationRatioAbs[t] = Math.abs(n.lastFlickSpeed[t] * n.speedDecelerationRatio[t]), n.distanceOffset[t] = n.lastFlickSpeed[t] * n.speedDecelerationRatio[t] * n.timeDiff, dt[t] += n.distanceOffset[t])
                    },
                    panAnimLoop: function() {
                        if (Wt.zoomPan && (Wt.zoomPan.raf = O(n.panAnimLoop), n.now = Ct(), n.timeDiff = n.now - n.lastNow, n.lastNow = n.now, n.calculateAnimOffset("x"), n.calculateAnimOffset("y"), Dt(), n.calculateOverBoundsAnimOffset("x"), n.calculateOverBoundsAnimOffset("y"), n.speedDecelerationRatioAbs.x < .05 && n.speedDecelerationRatioAbs.y < .05)) return dt.x = Math.round(dt.x), dt.y = Math.round(dt.y), Dt(), void Yt("zoomPan")
                    }
                };
                return n
            },
            Ie = function(t) {
                return t.calculateSwipeSpeed("y"), tt = o.currItem.bounds, t.backAnimDestination = {}, t.backAnimStarted = {}, Math.abs(t.lastFlickSpeed.x) <= .05 && Math.abs(t.lastFlickSpeed.y) <= .05 ? (t.speedDecelerationRatioAbs.x = t.speedDecelerationRatioAbs.y = 0, t.calculateOverBoundsAnimOffset("x"), t.calculateOverBoundsAnimOffset("y"), !0) : (Zt("zoomPan"), t.lastNow = Ct(), void t.panAnimLoop())
            },
            Me = function(t, e) {
                var n, i, a;
                if (nt || (ae = c), "swipe" === t) {
                    var l = ee.x - ne.x,
                        u = e.lastFlickDist.x < 10;
                    l > 30 && (u || e.lastFlickOffset.x > 20) ? i = -1 : l < -30 && (u || e.lastFlickOffset.x < -20) && (i = 1)
                }
                i && ((c += i) < 0 ? (c = s.loop ? He() - 1 : 0, a = !0) : c >= He() && (c = s.loop ? 0 : He() - 1, a = !0), a && !s.loop || (gt += i, pt -= i, n = !0));
                var d, h = mt.x * pt,
                    p = Math.abs(h - ce.x);
                return n || h > ce.x == e.lastFlickSpeed.x > 0 ? (d = Math.abs(e.lastFlickSpeed.x) > 0 ? p / Math.abs(e.lastFlickSpeed.x) : 333, d = Math.min(d, 400), d = Math.max(d, 250)) : d = 333, ae === c && (n = !1), nt = !0, kt("mainScrollAnimStart"), Gt("mainScroll", ce.x, h, d, r.easing.cubic.out, It, function() {
                    Vt(), nt = !1, ae = -1, (n || ae !== c) && o.updateCurrItem(), kt("mainScrollAnimComplete")
                }), n && o.updateCurrItem(!0), n
            },
            Le = function(t) {
                return 1 / J * t * y
            },
            je = function() {
                var t = g,
                    e = Ft(),
                    n = Rt();
                g < e ? t = e : g > n && (t = n);
                var i, s = st;
                return ot && !q && !at && g < e ? (o.close(), !0) : (ot && (i = function(t) {
                    Et((1 - s) * t + s)
                }), o.zoomTo(t, 0, 200, r.easing.cubic.out, i), !0)
            };
        wt("Gestures", {
            publicMethods: {
                initGestures: function() {
                    var t = function(t, e, n, i, r) {
                        T = t + e, k = t + n, C = t + i, E = r ? t + r : ""
                    };
                    (D = $.pointerEvent) && $.touch && ($.touch = !1), D ? navigator.msPointerEnabled ? t("MSPointer", "Down", "Move", "Up", "Cancel") : t("pointer", "down", "move", "up", "cancel") : $.touch ? (t("touch", "start", "move", "end", "cancel"), P = !0) : t("mouse", "down", "move", "up"), p = k + " " + C + " " + E, f = T, D && !P && (P = navigator.maxTouchPoints > 1 || navigator.msMaxTouchPoints > 1), o.likelyTouchDevice = P, m[T] = Ee, m[k] = Ae, m[C] = Pe, E && (m[E] = m[C]), $.touch && (f += " mousedown", p += " mousemove mouseup", m.mousedown = m[T], m.mousemove = m[k], m.mouseup = m[C]), P || (s.allowPanToNext = !1)
                }
            }
        });
        var Ne, $e, ze, Fe, Re, He, qe = function(e, n, i, a) {
                var l;
                Ne && clearTimeout(Ne), Fe = !0, ze = !0, e.initialLayout ? (l = e.initialLayout, e.initialLayout = null) : l = s.getThumbBoundsFn && s.getThumbBoundsFn(c);
                var d = i ? s.hideAnimationDuration : s.showAnimationDuration,
                    h = function() {
                        Yt("initialZoom"), i ? (o.template.removeAttribute("style"), o.bg.removeAttribute("style")) : (Et(1), n && (n.style.display = "block"), r.addClass(t, "pswp--animated-in"), kt("initialZoom" + (i ? "OutEnd" : "InEnd"))), a && a(), Fe = !1
                    };
                if (!d || !l || void 0 === l.x) return kt("initialZoom" + (i ? "Out" : "In")), g = e.initialZoomLevel, Lt(dt, e.initialPosition), Dt(), t.style.opacity = i ? 0 : 1, Et(1), void(d ? setTimeout(function() {
                    h()
                }, d) : h());
                ! function() {
                    var n = u,
                        a = !o.currItem.src || o.currItem.loadError || s.showHideOpacity;
                    e.miniImg && (e.miniImg.style.webkitBackfaceVisibility = "hidden"), i || (g = l.w / e.w, dt.x = l.x, dt.y = l.y - L, o[a ? "template" : "bg"].style.opacity = .001, Dt()), Zt("initialZoom"), i && !n && r.removeClass(t, "pswp--animated-in"), a && (i ? r[(n ? "remove" : "add") + "Class"](t, "pswp--animate_opacity") : setTimeout(function() {
                        r.addClass(t, "pswp--animate_opacity")
                    }, 30)), Ne = setTimeout(function() {
                        if (kt("initialZoom" + (i ? "Out" : "In")), i) {
                            var o = l.w / e.w,
                                s = {
                                    x: dt.x,
                                    y: dt.y
                                },
                                u = g,
                                c = st,
                                p = function(e) {
                                    1 === e ? (g = o, dt.x = l.x, dt.y = l.y - N) : (g = (o - u) * e + u, dt.x = (l.x - s.x) * e + s.x, dt.y = (l.y - N - s.y) * e + s.y), Dt(), a ? t.style.opacity = 1 - e : Et(c - e * c)
                                };
                            n ? Gt("initialZoom", 0, 1, d, r.easing.cubic.out, p, h) : (p(1), Ne = setTimeout(h, d + 20))
                        } else g = e.initialZoomLevel, Lt(dt, e.initialPosition), Dt(), Et(1), a ? t.style.opacity = 1 : Et(1), Ne = setTimeout(h, d + 20)
                    }, i ? 25 : 90)
                }()
            },
            Be = {},
            Ue = [],
            We = {
                index: 0,
                errorMsg: '<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
                forceProgressiveLoading: !1,
                preload: [1, 1],
                getNumItemsFn: function() {
                    return $e.length
                }
            },
            Xe = function(t, e, n) {
                if (t.src && !t.loadError) {
                    var i = !n;
                    if (i && (t.vGap || (t.vGap = {
                            top: 0,
                            bottom: 0
                        }), kt("parseVerticalMargin", t)), Be.x = e.x, Be.y = e.y - t.vGap.top - t.vGap.bottom, i) {
                        var r = Be.x / t.w,
                            o = Be.y / t.h;
                        t.fitRatio = r < o ? r : o;
                        var a = s.scaleMode;
                        "orig" === a ? n = 1 : "fit" === a && (n = t.fitRatio), n > 1 && (n = 1), t.initialZoomLevel = n, t.bounds || (t.bounds = {
                            center: {
                                x: 0,
                                y: 0
                            },
                            max: {
                                x: 0,
                                y: 0
                            },
                            min: {
                                x: 0,
                                y: 0
                            }
                        })
                    }
                    if (!n) return;
                    return function(t, e, n) {
                        var i = t.bounds;
                        i.center.x = Math.round((Be.x - e) / 2), i.center.y = Math.round((Be.y - n) / 2) + t.vGap.top, i.max.x = e > Be.x ? Math.round(Be.x - e) : i.center.x, i.max.y = n > Be.y ? Math.round(Be.y - n) + t.vGap.top : i.center.y, i.min.x = e > Be.x ? 0 : i.center.x, i.min.y = n > Be.y ? t.vGap.top : i.center.y
                    }(t, t.w * n, t.h * n), i && n === t.initialZoomLevel && (t.initialPosition = t.bounds.center), t.bounds
                }
                return t.w = t.h = 0, t.initialZoomLevel = t.fitRatio = 1, t.bounds = {
                    center: {
                        x: 0,
                        y: 0
                    },
                    max: {
                        x: 0,
                        y: 0
                    },
                    min: {
                        x: 0,
                        y: 0
                    }
                }, t.initialPosition = t.bounds.center, t.bounds
            },
            Ye = function(t, e, n, i, r, s) {
                e.loadError || i && (e.imageAppended = !0, Ge(e, i, e === o.currItem && bt), n.appendChild(i), s && setTimeout(function() {
                    e && e.loaded && e.placeholder && (e.placeholder.style.display = "none", e.placeholder = null)
                }, 500))
            },
            Ze = function(t) {
                t.loading = !0, t.loaded = !1;
                var e = t.img = r.createEl("pswp__img", "img"),
                    n = function() {
                        t.loading = !1, t.loaded = !0, t.loadComplete ? t.loadComplete(t) : t.img = null, e.onload = e.onerror = null, e = null
                    };
                return e.onload = n, e.onerror = function() {
                    t.loadError = !0, n()
                }, e.src = t.src, e
            },
            Ve = function(t, e) {
                if (t.src && t.loadError && t.container) return e && (t.container.innerHTML = ""), t.container.innerHTML = s.errorMsg.replace("%url%", t.src), !0
            },
            Ge = function(t, e, n) {
                if (t.src) {
                    e || (e = t.container.lastChild);
                    var i = n ? t.w : Math.round(t.w * t.fitRatio),
                        r = n ? t.h : Math.round(t.h * t.fitRatio);
                    t.placeholder && !t.loaded && (t.placeholder.style.width = i + "px", t.placeholder.style.height = r + "px"), e.style.width = i + "px", e.style.height = r + "px"
                }
            },
            Qe = function() {
                if (Ue.length) {
                    for (var t, e = 0; e < Ue.length; e++)(t = Ue[e]).holder.index === t.index && Ye(t.index, t.item, t.baseDiv, t.img, 0, t.clearPlaceholder);
                    Ue = []
                }
            };
        wt("Controller", {
            publicMethods: {
                lazyLoadItem: function(t) {
                    t = xt(t);
                    var e = Re(t);
                    e && (!e.loaded && !e.loading || w) && (kt("gettingData", t, e), e.src && Ze(e))
                },
                initController: function() {
                    r.extend(s, We, !0), o.items = $e = n, Re = o.getItemAt, He = s.getNumItemsFn, s.loop, He() < 3 && (s.loop = !1), Tt("beforeChange", function(t) {
                        var e, n = s.preload,
                            i = null === t || t >= 0,
                            r = Math.min(n[0], He()),
                            a = Math.min(n[1], He());
                        for (e = 1; e <= (i ? a : r); e++) o.lazyLoadItem(c + e);
                        for (e = 1; e <= (i ? r : a); e++) o.lazyLoadItem(c - e)
                    }), Tt("initialLayout", function() {
                        o.currItem.initialLayout = s.getThumbBoundsFn && s.getThumbBoundsFn(c)
                    }), Tt("mainScrollAnimComplete", Qe), Tt("initialZoomInEnd", Qe), Tt("destroy", function() {
                        for (var t, e = 0; e < $e.length; e++)(t = $e[e]).container && (t.container = null), t.placeholder && (t.placeholder = null), t.img && (t.img = null), t.preloader && (t.preloader = null), t.loadError && (t.loaded = t.loadError = !1);
                        Ue = null
                    })
                },
                getItemAt: function(t) {
                    return t >= 0 && void 0 !== $e[t] && $e[t]
                },
                allowProgressiveImg: function() {
                    return s.forceProgressiveLoading || !P || s.mouseUsed || screen.width > 1200
                },
                setContent: function(t, e) {
                    s.loop && (e = xt(e));
                    var n = o.getItemAt(t.index);
                    n && (n.container = null);
                    var i, l = o.getItemAt(e);
                    if (l) {
                        kt("gettingData", e, l), t.index = e, t.item = l;
                        var u = l.container = r.createEl("pswp__zoom-wrap");
                        if (!l.src && l.html && (l.html.tagName ? u.appendChild(l.html) : u.innerHTML = l.html), Ve(l), Xe(l, ht), !l.src || l.loadError || l.loaded) l.src && !l.loadError && ((i = r.createEl("pswp__img", "img")).style.opacity = 1, i.src = l.src, Ge(l, i), Ye(0, l, u, i));
                        else {
                            if (l.loadComplete = function(n) {
                                    if (a) {
                                        if (t && t.index === e) {
                                            if (Ve(n, !0)) return n.loadComplete = n.img = null, Xe(n, ht), Pt(n), void(t.index === c && o.updateCurrZoomItem());
                                            n.imageAppended ? !Fe && n.placeholder && (n.placeholder.style.display = "none", n.placeholder = null) : $.transform && (nt || Fe) ? Ue.push({
                                                item: n,
                                                baseDiv: u,
                                                img: n.img,
                                                index: e,
                                                holder: t,
                                                clearPlaceholder: !0
                                            }) : Ye(0, n, u, n.img, 0, !0)
                                        }
                                        n.loadComplete = null, n.img = null, kt("imageLoadComplete", e, n)
                                    }
                                }, r.features.transform) {
                                var d = "pswp__img pswp__img--placeholder";
                                d += l.msrc ? "" : " pswp__img--placeholder--blank";
                                var h = r.createEl(d, l.msrc ? "img" : "");
                                l.msrc && (h.src = l.msrc), Ge(l, h), u.appendChild(h), l.placeholder = h
                            }
                            l.loading || Ze(l), o.allowProgressiveImg() && (!ze && $.transform ? Ue.push({
                                item: l,
                                baseDiv: u,
                                img: l.img,
                                index: e,
                                holder: t
                            }) : Ye(0, l, u, l.img, 0, !0))
                        }
                        ze || e !== c ? Pt(l) : (et = u.style, qe(l, i || l.img)), t.el.innerHTML = "", t.el.appendChild(u)
                    } else t.el.innerHTML = ""
                },
                cleanSlide: function(t) {
                    t.img && (t.img.onload = t.img.onerror = null), t.loaded = t.loading = t.img = t.imageAppended = !1
                }
            }
        });
        var Ke, Je, tn = {},
            en = function(t, e, n) {
                var i = document.createEvent("CustomEvent"),
                    r = {
                        origEvent: t,
                        target: t.target,
                        releasePoint: e,
                        pointerType: n || "touch"
                    };
                i.initCustomEvent("pswpTap", !0, !0, r), t.target.dispatchEvent(i)
            };
        wt("Tap", {
            publicMethods: {
                initTap: function() {
                    Tt("firstTouchStart", o.onTapStart), Tt("touchRelease", o.onTapRelease), Tt("destroy", function() {
                        tn = {}, Ke = null
                    })
                },
                onTapStart: function(t) {
                    t.length > 1 && (clearTimeout(Ke), Ke = null)
                },
                onTapRelease: function(t, e) {
                    if (e && !Z && !X && !Xt) {
                        var n = e;
                        if (Ke && (clearTimeout(Ke), Ke = null, function(t, e) {
                                return Math.abs(t.x - e.x) < 25 && Math.abs(t.y - e.y) < 25
                            }(n, tn))) return void kt("doubleTap", n);
                        if ("mouse" === e.type) return void en(t, e, "mouse");
                        if ("BUTTON" === t.target.tagName.toUpperCase() || r.hasClass(t.target, "pswp__single-tap")) return void en(t, e);
                        Lt(tn, n), Ke = setTimeout(function() {
                            en(t, e), Ke = null
                        }, 300)
                    }
                }
            }
        }), wt("DesktopZoom", {
            publicMethods: {
                initDesktopZoom: function() {
                    j || (P ? Tt("mouseUsed", function() {
                        o.setupDesktopZoom()
                    }) : o.setupDesktopZoom(!0))
                },
                setupDesktopZoom: function(e) {
                    Je = {};
                    var n = "wheel mousewheel DOMMouseScroll";
                    Tt("bindEvents", function() {
                        r.bind(t, n, o.handleMouseWheel)
                    }), Tt("unbindEvents", function() {
                        Je && r.unbind(t, n, o.handleMouseWheel)
                    }), o.mouseZoomedIn = !1;
                    var i, s = function() {
                            o.mouseZoomedIn && (r.removeClass(t, "pswp--zoomed-in"), o.mouseZoomedIn = !1), g < 1 ? r.addClass(t, "pswp--zoom-allowed") : r.removeClass(t, "pswp--zoom-allowed"), a()
                        },
                        a = function() {
                            i && (r.removeClass(t, "pswp--dragging"), i = !1)
                        };
                    Tt("resize", s), Tt("afterChange", s), Tt("pointerDown", function() {
                        o.mouseZoomedIn && (i = !0, r.addClass(t, "pswp--dragging"))
                    }), Tt("pointerUp", a), e || s()
                },
                handleMouseWheel: function(t) {
                    if (g <= o.currItem.fitRatio) return s.modal && (!s.closeOnScroll || Xt || W ? t.preventDefault() : A && Math.abs(t.deltaY) > 2 && (u = !0, o.close())), !0;
                    if (t.stopPropagation(), Je.x = 0, "deltaX" in t) 1 === t.deltaMode ? (Je.x = 18 * t.deltaX, Je.y = 18 * t.deltaY) : (Je.x = t.deltaX, Je.y = t.deltaY);
                    else if ("wheelDelta" in t) t.wheelDeltaX && (Je.x = -.16 * t.wheelDeltaX), t.wheelDeltaY ? Je.y = -.16 * t.wheelDeltaY : Je.y = -.16 * t.wheelDelta;
                    else {
                        if (!("detail" in t)) return;
                        Je.y = t.detail
                    }
                    zt(g, !0);
                    var e = dt.x - Je.x,
                        n = dt.y - Je.y;
                    (s.modal || e <= tt.min.x && e >= tt.max.x && n <= tt.min.y && n >= tt.max.y) && t.preventDefault(), o.panTo(e, n)
                },
                toggleDesktopZoom: function(e) {
                    e = e || {
                        x: ht.x / 2 + ft.x,
                        y: ht.y / 2 + ft.y
                    };
                    var n = s.getDoubleTapZoom(!0, o.currItem),
                        i = g === n;
                    o.mouseZoomedIn = !i, o.zoomTo(i ? o.currItem.initialZoomLevel : n, e, 333), r[(i ? "remove" : "add") + "Class"](t, "pswp--zoomed-in")
                }
            }
        });
        var nn, rn, on, sn, an, ln, un, cn, dn, hn, pn, fn, mn = {
                history: !0,
                galleryUID: 1
            },
            gn = function() {
                return pn.hash.substring(1)
            },
            yn = function() {
                nn && clearTimeout(nn), on && clearTimeout(on)
            },
            vn = function() {
                var t = gn(),
                    e = {};
                if (t.length < 5) return e;
                var n, i = t.split("&");
                for (n = 0; n < i.length; n++)
                    if (i[n]) {
                        var r = i[n].split("=");
                        r.length < 2 || (e[r[0]] = r[1])
                    } if (s.galleryPIDs) {
                    var o = e.pid;
                    for (e.pid = 0, n = 0; n < $e.length; n++)
                        if ($e[n].pid === o) {
                            e.pid = n;
                            break
                        }
                } else e.pid = parseInt(e.pid, 10) - 1;
                return e.pid < 0 && (e.pid = 0), e
            },
            _n = function() {
                if (on && clearTimeout(on), Xt || W) on = setTimeout(_n, 500);
                else {
                    sn ? clearTimeout(rn) : sn = !0;
                    var t = c + 1,
                        e = Re(c);
                    e.hasOwnProperty("pid") && (t = e.pid);
                    var n = un + "&gid=" + s.galleryUID + "&pid=" + t;
                    cn || -1 === pn.hash.indexOf(n) && (hn = !0);
                    var i = pn.href.split("#")[0] + "#" + n;
                    fn ? "#" + n !== window.location.hash && history[cn ? "replaceState" : "pushState"]("", document.title, i) : cn ? pn.replace(i) : pn.hash = n, cn = !0, rn = setTimeout(function() {
                        sn = !1
                    }, 60)
                }
            };
        wt("History", {
            publicMethods: {
                initHistory: function() {
                    if (r.extend(s, mn, !0), s.history) {
                        pn = window.location, hn = !1, dn = !1, cn = !1, un = gn(), fn = "pushState" in history, un.indexOf("gid=") > -1 && (un = (un = un.split("&gid=")[0]).split("?gid=")[0]), Tt("afterChange", o.updateURL), Tt("unbindEvents", function() {
                            r.unbind(window, "hashchange", o.onHashChange)
                        });
                        var t = function() {
                            ln = !0, dn || (hn ? history.back() : un ? pn.hash = un : fn ? history.pushState("", document.title, pn.pathname + pn.search) : pn.hash = ""), yn()
                        };
                        Tt("unbindEvents", function() {
                            u && t()
                        }), Tt("destroy", function() {
                            ln || t()
                        }), Tt("firstUpdate", function() {
                            c = vn().pid
                        });
                        var e = un.indexOf("pid=");
                        e > -1 && "&" === (un = un.substring(0, e)).slice(-1) && (un = un.slice(0, -1)), setTimeout(function() {
                            a && r.bind(window, "hashchange", o.onHashChange)
                        }, 40)
                    }
                },
                onHashChange: function() {
                    return gn() === un ? (dn = !0, void o.close()) : void(sn || (an = !0, o.goTo(vn().pid), an = !1))
                },
                updateURL: function() {
                    yn(), an || (cn ? nn = setTimeout(_n, 800) : _n())
                }
            }
        }), r.extend(o, Qt)
    }
}),
function(t, e) {
    "function" == typeof define && define.amd ? define(e) : "object" == typeof exports ? module.exports = e() : t.PhotoSwipeUI_Default = e()
}(this, function() {
    "use strict";
    return function(t, e) {
        var n, i, r, o, s, a, l, u, c, d, h, p, f, m, g, y, v, _, b = this,
            w = !1,
            x = !0,
            S = !0,
            T = {
                barsSize: {
                    top: 44,
                    bottom: "auto"
                },
                closeElClasses: ["item", "caption", "zoom-wrap", "ui", "top-bar"],
                timeToIdle: 4e3,
                timeToIdleOutside: 1e3,
                loadingIndicatorDelay: 1e3,
                addCaptionHTMLFn: function(t, e) {
                    return t.title ? (e.children[0].innerHTML = t.title, !0) : (e.children[0].innerHTML = "", !1)
                },
                closeEl: !0,
                captionEl: !0,
                fullscreenEl: !0,
                zoomEl: !0,
                shareEl: !0,
                counterEl: !0,
                arrowEl: !0,
                preloaderEl: !0,
                tapToClose: !1,
                tapToToggleControls: !0,
                clickToCloseNonZoomable: !0,
                shareButtons: [{
                    id: "facebook",
                    label: "Share on Facebook",
                    url: "https://www.facebook.com/sharer/sharer.php?u={{url}}"
                }, {
                    id: "twitter",
                    label: "Tweet",
                    url: "https://twitter.com/intent/tweet?text={{text}}&url={{url}}"
                }, {
                    id: "pinterest",
                    label: "Pin it",
                    url: "http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}"
                }, {
                    id: "download",
                    label: "Download image",
                    url: "{{raw_image_url}}",
                    download: !0
                }],
                getImageURLForShare: function() {
                    return t.currItem.src || ""
                },
                getPageURLForShare: function() {
                    return window.location.href
                },
                getTextForShare: function() {
                    return t.currItem.title || ""
                },
                indexIndicatorSep: " / ",
                fitControlsWidth: 1200
            },
            k = function(t) {
                if (y) return !0;
                t = t || window.event, g.timeToIdle && g.mouseUsed && !c && j();
                for (var n, i, r = (t.target || t.srcElement).getAttribute("class") || "", o = 0; o < F.length; o++)(n = F[o]).onTap && r.indexOf("pswp__" + n.name) > -1 && (n.onTap(), i = !0);
                if (i) {
                    t.stopPropagation && t.stopPropagation(), y = !0;
                    var s = e.features.isOldAndroid ? 600 : 30;
                    setTimeout(function() {
                        y = !1
                    }, s)
                }
            },
            C = function() {
                return !t.likelyTouchDevice || g.mouseUsed || screen.width > g.fitControlsWidth
            },
            E = function(t, n, i) {
                e[(i ? "add" : "remove") + "Class"](t, "pswp__" + n)
            },
            A = function() {
                var t = 1 === g.getNumItemsFn();
                t !== m && (E(i, "ui--one-slide", t), m = t)
            },
            D = function() {
                E(l, "share-modal--hidden", S)
            },
            P = function() {
                return (S = !S) ? (e.removeClass(l, "pswp__share-modal--fade-in"), setTimeout(function() {
                    S && D()
                }, 300)) : (D(), setTimeout(function() {
                    S || e.addClass(l, "pswp__share-modal--fade-in")
                }, 30)), S || I(), !1
            },
            O = function(e) {
                var n = (e = e || window.event).target || e.srcElement;
                return t.shout("shareLinkClick", e, n), !(!n.href || !n.hasAttribute("download") && (window.open(n.href, "pswp_share", "scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=550,height=420,top=100,left=" + (window.screen ? Math.round(screen.width / 2 - 275) : 100)), S || P(), 1))
            },
            I = function() {
                for (var t, e, n, i, r = "", o = 0; o < g.shareButtons.length; o++) t = g.shareButtons[o], e = g.getImageURLForShare(t), n = g.getPageURLForShare(t), i = g.getTextForShare(t), r += '<a href="' + t.url.replace("{{url}}", encodeURIComponent(n)).replace("{{image_url}}", encodeURIComponent(e)).replace("{{raw_image_url}}", e).replace("{{text}}", encodeURIComponent(i)) + '" target="_blank" class="pswp__share--' + t.id + '"' + (t.download ? "download" : "") + ">" + t.label + "</a>", g.parseShareButtonOut && (r = g.parseShareButtonOut(t, r));
                l.children[0].innerHTML = r, l.children[0].onclick = O
            },
            M = function(t) {
                for (var n = 0; n < g.closeElClasses.length; n++)
                    if (e.hasClass(t, "pswp__" + g.closeElClasses[n])) return !0
            },
            L = 0,
            j = function() {
                clearTimeout(_), L = 0, c && b.setIdle(!1)
            },
            N = function(t) {
                var e = (t = t || window.event).relatedTarget || t.toElement;
                e && "HTML" !== e.nodeName || (clearTimeout(_), _ = setTimeout(function() {
                    b.setIdle(!0)
                }, g.timeToIdleOutside))
            },
            $ = function(t) {
                p !== t && (E(h, "preloader--active", !t), p = t)
            },
            z = function(t) {
                var n = t.vGap;
                if (C()) {
                    var s = g.barsSize;
                    if (g.captionEl && "auto" === s.bottom)
                        if (o || ((o = e.createEl("pswp__caption pswp__caption--fake")).appendChild(e.createEl("pswp__caption__center")), i.insertBefore(o, r), e.addClass(i, "pswp__ui--fit")), g.addCaptionHTMLFn(t, o, !0)) {
                            var a = o.clientHeight;
                            n.bottom = parseInt(a, 10) || 44
                        } else n.bottom = s.top;
                    else n.bottom = "auto" === s.bottom ? 0 : s.bottom;
                    n.top = s.top
                } else n.top = n.bottom = 0
            },
            F = [{
                name: "caption",
                option: "captionEl",
                onInit: function(t) {
                    r = t
                }
            }, {
                name: "share-modal",
                option: "shareEl",
                onInit: function(t) {
                    l = t
                },
                onTap: function() {
                    P()
                }
            }, {
                name: "button--share",
                option: "shareEl",
                onInit: function(t) {
                    a = t
                },
                onTap: function() {
                    P()
                }
            }, {
                name: "button--zoom",
                option: "zoomEl",
                onTap: t.toggleDesktopZoom
            }, {
                name: "counter",
                option: "counterEl",
                onInit: function(t) {
                    s = t
                }
            }, {
                name: "button--close",
                option: "closeEl",
                onTap: t.close
            }, {
                name: "button--arrow--left",
                option: "arrowEl",
                onTap: t.prev
            }, {
                name: "button--arrow--right",
                option: "arrowEl",
                onTap: t.next
            }, {
                name: "button--fs",
                option: "fullscreenEl",
                onTap: function() {
                    n.isFullscreen() ? n.exit() : n.enter()
                }
            }, {
                name: "preloader",
                option: "preloaderEl",
                onInit: function(t) {
                    h = t
                }
            }];
        b.init = function() {
            e.extend(t.options, T, !0), g = t.options, i = e.getChildByClass(t.scrollWrap, "pswp__ui"), d = t.listen,
                function() {
                    var t;
                    d("onVerticalDrag", function(t) {
                        x && t < .95 ? b.hideControls() : !x && t >= .95 && b.showControls()
                    }), d("onPinchClose", function(e) {
                        x && e < .9 ? (b.hideControls(), t = !0) : t && !x && e > .9 && b.showControls()
                    }), d("zoomGestureEnded", function() {
                        (t = !1) && !x && b.showControls()
                    })
                }(), d("beforeChange", b.update), d("doubleTap", function(e) {
                    var n = t.currItem.initialZoomLevel;
                    t.getZoomLevel() !== n ? t.zoomTo(n, e, 333) : t.zoomTo(g.getDoubleTapZoom(!1, t.currItem), e, 333)
                }), d("preventDragEvent", function(t, e, n) {
                    var i = t.target || t.srcElement;
                    i && i.getAttribute("class") && t.type.indexOf("mouse") > -1 && (i.getAttribute("class").indexOf("__caption") > 0 || /(SMALL|STRONG|EM)/i.test(i.tagName)) && (n.prevent = !1)
                }), d("bindEvents", function() {
                    e.bind(i, "pswpTap click", k), e.bind(t.scrollWrap, "pswpTap", b.onGlobalTap), t.likelyTouchDevice || e.bind(t.scrollWrap, "mouseover", b.onMouseOver)
                }), d("unbindEvents", function() {
                    S || P(), v && clearInterval(v), e.unbind(document, "mouseout", N), e.unbind(document, "mousemove", j), e.unbind(i, "pswpTap click", k), e.unbind(t.scrollWrap, "pswpTap", b.onGlobalTap), e.unbind(t.scrollWrap, "mouseover", b.onMouseOver), n && (e.unbind(document, n.eventK, b.updateFullscreen), n.isFullscreen() && (g.hideAnimationDuration = 0, n.exit()), n = null)
                }), d("destroy", function() {
                    g.captionEl && (o && i.removeChild(o), e.removeClass(r, "pswp__caption--empty")), l && (l.children[0].onclick = null), e.removeClass(i, "pswp__ui--over-close"), e.addClass(i, "pswp__ui--hidden"), b.setIdle(!1)
                }), g.showAnimationDuration || e.removeClass(i, "pswp__ui--hidden"), d("initialZoomIn", function() {
                    g.showAnimationDuration && e.removeClass(i, "pswp__ui--hidden")
                }), d("initialZoomOut", function() {
                    e.addClass(i, "pswp__ui--hidden")
                }), d("parseVerticalMargin", z),
                function() {
                    var t, n, r, o = function(i) {
                        if (i)
                            for (var o = i.length, s = 0; s < o; s++) {
                                t = i[s], n = t.className;
                                for (var a = 0; a < F.length; a++) r = F[a], n.indexOf("pswp__" + r.name) > -1 && (g[r.option] ? (e.removeClass(t, "pswp__element--disabled"), r.onInit && r.onInit(t)) : e.addClass(t, "pswp__element--disabled"))
                            }
                    };
                    o(i.children);
                    var s = e.getChildByClass(i, "pswp__top-bar");
                    s && o(s.children)
                }(), g.shareEl && a && l && (S = !0), A(), g.timeToIdle && d("mouseUsed", function() {
                    e.bind(document, "mousemove", j), e.bind(document, "mouseout", N), v = setInterval(function() {
                        2 == ++L && b.setIdle(!0)
                    }, g.timeToIdle / 2)
                }), g.fullscreenEl && !e.features.isOldAndroid && (n || (n = b.getFullscreenAPI()), n ? (e.bind(document, n.eventK, b.updateFullscreen), b.updateFullscreen(), e.addClass(t.template, "pswp--supports-fs")) : e.removeClass(t.template, "pswp--supports-fs")), g.preloaderEl && ($(!0), d("beforeChange", function() {
                    clearTimeout(f), f = setTimeout(function() {
                        t.currItem && t.currItem.loading ? (!t.allowProgressiveImg() || t.currItem.img && !t.currItem.img.naturalWidth) && $(!1) : $(!0)
                    }, g.loadingIndicatorDelay)
                }), d("imageLoadComplete", function(e, n) {
                    t.currItem === n && $(!0)
                }))
        }, b.setIdle = function(t) {
            c = t, E(i, "ui--idle", t)
        }, b.update = function() {
            x && t.currItem ? (b.updateIndexIndicator(), g.captionEl && (g.addCaptionHTMLFn(t.currItem, r), E(r, "caption--empty", !t.currItem.title)), w = !0) : w = !1, S || P(), A()
        }, b.updateFullscreen = function(i) {
            i && setTimeout(function() {
                t.setScrollOffset(0, e.getScrollY())
            }, 50), e[(n.isFullscreen() ? "add" : "remove") + "Class"](t.template, "pswp--fs")
        }, b.updateIndexIndicator = function() {
            g.counterEl && (s.innerHTML = t.getCurrentIndex() + 1 + g.indexIndicatorSep + g.getNumItemsFn())
        }, b.onGlobalTap = function(n) {
            var i = (n = n || window.event).target || n.srcElement;
            if (!y)
                if (n.detail && "mouse" === n.detail.pointerType) {
                    if (M(i)) return void t.close();
                    e.hasClass(i, "pswp__img") && (1 === t.getZoomLevel() && t.getZoomLevel() <= t.currItem.fitRatio ? g.clickToCloseNonZoomable && t.close() : t.toggleDesktopZoom(n.detail.releasePoint))
                } else if (g.tapToToggleControls && (x ? b.hideControls() : b.showControls()), g.tapToClose && (e.hasClass(i, "pswp__img") || M(i))) return void t.close()
        }, b.onMouseOver = function(t) {
            var e = (t = t || window.event).target || t.srcElement;
            E(i, "ui--over-close", M(e))
        }, b.hideControls = function() {
            e.addClass(i, "pswp__ui--hidden"), x = !1
        }, b.showControls = function() {
            x = !0, w || b.update(), e.removeClass(i, "pswp__ui--hidden")
        }, b.supportsFullscreen = function() {
            var t = document;
            return !!(t.exitFullscreen || t.mozCancelFullScreen || t.webkitExitFullscreen || t.msExitFullscreen)
        }, b.getFullscreenAPI = function() {
            var e, n = document.documentElement,
                i = "fullscreenchange";
            return n.requestFullscreen ? e = {
                enterK: "requestFullscreen",
                exitK: "exitFullscreen",
                elementK: "fullscreenElement",
                eventK: i
            } : n.mozRequestFullScreen ? e = {
                enterK: "mozRequestFullScreen",
                exitK: "mozCancelFullScreen",
                elementK: "mozFullScreenElement",
                eventK: "moz" + i
            } : n.webkitRequestFullscreen ? e = {
                enterK: "webkitRequestFullscreen",
                exitK: "webkitExitFullscreen",
                elementK: "webkitFullscreenElement",
                eventK: "webkit" + i
            } : n.msRequestFullscreen && (e = {
                enterK: "msRequestFullscreen",
                exitK: "msExitFullscreen",
                elementK: "msFullscreenElement",
                eventK: "MSFullscreenChange"
            }), e && (e.enter = function() {
                return u = g.closeOnScroll, g.closeOnScroll = !1, "webkitRequestFullscreen" !== this.enterK ? t.template[this.enterK]() : void t.template[this.enterK](Element.ALLOW_KEYBOARD_INPUT)
            }, e.exit = function() {
                return g.closeOnScroll = u, document[this.exitK]()
            }, e.isFullscreen = function() {
                return document[this.elementK]
            }), e
        }
    }
}),
function() {
    var t, e;
    t = this.jQuery || window.jQuery, e = t(window), t.fn.stick_in_parent = function(n) {
        var i, r, o, s, a, l, u, c, d, h, p;
        for (null == n && (n = {}), p = n.sticky_class, a = n.inner_scrolling, h = n.recalc_every, d = n.parent, c = n.offset_top, u = n.spacer, r = n.bottoming, null == c && (c = 0), null == d && (d = void 0), null == a && (a = !0), null == p && (p = "is_stuck"), i = t(document), null == r && (r = !0), o = function(n, o, s, l, f, m, g, y) {
                var v, _, b, w, x, S, T, k, C, E, A, D;
                if (!n.data("sticky_kit")) {
                    if (n.data("sticky_kit", !0), x = i.height(), T = n.parent(), null != d && (T = T.closest(d)), !T.length) throw "failed to find stick parent";
                    if (v = b = !1, (A = null != u ? u && n.closest(u) : t("<div />")) && A.css("position", n.css("position")), (k = function() {
                            var t, e, r;
                            if (!y && (x = i.height(), t = parseInt(T.css("border-top-width"), 10), e = parseInt(T.css("padding-top"), 10), o = parseInt(T.css("padding-bottom"), 10), s = T.offset().top + t + e, l = T.height(), b && (v = b = !1, null == u && (n.insertAfter(A), A.detach()), n.css({
                                    position: "",
                                    top: "",
                                    width: "",
                                    bottom: ""
                                }).removeClass(p), r = !0), f = n.offset().top - (parseInt(n.css("margin-top"), 10) || 0) - c, m = n.outerHeight(!0), g = n.css("float"), A && A.css({
                                    width: n.outerWidth(!0),
                                    height: m,
                                    display: n.css("display"),
                                    "vertical-align": n.css("vertical-align"),
                                    float: g
                                }), r)) return D()
                        })(), m !== l) return w = void 0, S = c, E = h, D = function() {
                        var t, d, _, C;
                        if (!y && (_ = !1, null != E && 0 >= --E && (E = h, k(), _ = !0), _ || i.height() === x || k(), _ = e.scrollTop(), null != w && (d = _ - w), w = _, b ? (r && (C = _ + m + S > l + s, v && !C && (v = !1, n.css({
                                position: "fixed",
                                bottom: "",
                                top: S
                            }).trigger("sticky_kit:unbottom"))), _ < f && (b = !1, S = c, null == u && ("left" !== g && "right" !== g || n.insertAfter(A), A.detach()), t = {
                                position: "",
                                width: "",
                                top: ""
                            }, n.css(t).removeClass(p).trigger("sticky_kit:unstick")), a && (t = e.height(), m + c > t && !v && (S -= d, S = Math.max(t - m, S), S = Math.min(c, S), b && n.css({
                                top: S + "px"
                            })))) : _ > f && (b = !0, (t = {
                                position: "fixed",
                                top: S
                            }).width = "border-box" === n.css("box-sizing") ? n.outerWidth() + "px" : n.width() + "px", n.css(t).addClass(p), null == u && (n.after(A), "left" !== g && "right" !== g || A.append(n)), n.trigger("sticky_kit:stick")), b && r && (null == C && (C = _ + m + S > l + s), !v && C))) return v = !0, "static" === T.css("position") && T.css({
                            position: "relative"
                        }), n.css({
                            position: "absolute",
                            bottom: o,
                            top: "auto"
                        }).trigger("sticky_kit:bottom")
                    }, C = function() {
                        return k(), D()
                    }, _ = function() {
                        if (y = !0, e.off("touchmove", D), e.off("scroll", D), e.off("resize", C), t(document.body).off("sticky_kit:recalc", C), n.off("sticky_kit:detach", _), n.removeData("sticky_kit"), n.css({
                                position: "",
                                bottom: "",
                                top: "",
                                width: ""
                            }), T.position("position", ""), b) return null == u && ("left" !== g && "right" !== g || n.insertAfter(A), A.remove()), n.removeClass(p)
                    }, e.on("touchmove", D), e.on("scroll", D), e.on("resize", C), t(document.body).on("sticky_kit:recalc", C), n.on("sticky_kit:detach", _), setTimeout(D, 0)
                }
            }, s = 0, l = this.length; s < l; s++) n = this[s], o(t(n));
        return this
    }
}.call(this),
function() {
    "use strict";
    var t = !1;
    window.JQClass = function() {}, JQClass.classes = {}, JQClass.extend = function e(n) {
        function i() {
            !t && this._init && this._init.apply(this, arguments)
        }
        var r = this.prototype;
        t = !0;
        var o = new this;
        for (var s in t = !1, n)
            if ("function" == typeof n[s] && "function" == typeof r[s]) o[s] = function(t, e) {
                return function() {
                    var n = this._super;
                    this._super = function(e) {
                        return r[t].apply(this, e || [])
                    };
                    var i = e.apply(this, arguments);
                    return this._super = n, i
                }
            }(s, n[s]);
            else if ("object" == typeof n[s] && "object" == typeof r[s] && "defaultOptions" === s) {
            var a, l = r[s],
                u = n[s],
                c = {};
            for (a in l) c[a] = l[a];
            for (a in u) c[a] = u[a];
            o[s] = c
        } else o[s] = n[s];
        return i.prototype = o, i.prototype.constructor = i, i.extend = e, i
    }
}(),
function($) {
    "use strict";

    function camelCase(t) {
        return t.replace(/-([a-z])/g, function(t, e) {
            return e.toUpperCase()
        })
    }
    JQClass.classes.JQPlugin = JQClass.extend({
        name: "plugin",
        defaultOptions: {},
        regionalOptions: {},
        deepMerge: !0,
        _getMarker: function() {
            return "is-" + this.name
        },
        _init: function() {
            $.extend(this.defaultOptions, this.regionalOptions && this.regionalOptions[""] || {});
            var t = camelCase(this.name);
            $[t] = this, $.fn[t] = function(e) {
                var n = Array.prototype.slice.call(arguments, 1),
                    i = this,
                    r = this;
                return this.each(function() {
                    if ("string" == typeof e) {
                        if ("_" === e[0] || !$[t][e]) throw "Unknown method: " + e;
                        var o = $[t][e].apply($[t], [this].concat(n));
                        if (o !== i && void 0 !== o) return r = o, !1
                    } else $[t]._attach(this, e)
                }), r
            }
        },
        setDefaults: function(t) {
            $.extend(this.defaultOptions, t || {})
        },
        _attach: function(t, e) {
            if (!(t = $(t)).hasClass(this._getMarker())) {
                t.addClass(this._getMarker()), e = $.extend(this.deepMerge, {}, this.defaultOptions, this._getMetadata(t), e || {});
                var n = $.extend({
                    name: this.name,
                    elem: t,
                    options: e
                }, this._instSettings(t, e));
                t.data(this.name, n), this._postAttach(t, n), this.option(t, e)
            }
        },
        _instSettings: function(t, e) {
            return {}
        },
        _postAttach: function(t, e) {},
        _getMetadata: function(elem) {
            try {
                var data = elem.data(this.name.toLowerCase()) || "";
                for (var key in data = data.replace(/(\\?)'/g, function(t, e) {
                        return e ? "'" : '"'
                    }).replace(/([a-zA-Z0-9]+):/g, function(t, e, n) {
                        var i = data.substring(0, n).match(/"/g);
                        return i && i.length % 2 != 0 ? e + ":" : '"' + e + '":'
                    }).replace(/\\:/g, ":"), data = $.parseJSON("{" + data + "}"), data)
                    if (data.hasOwnProperty(key)) {
                        var value = data[key];
                        "string" == typeof value && value.match(/^new Date\(([-0-9,\s]*)\)$/) && (data[key] = eval(value))
                    } return data
            } catch (t) {
                return {}
            }
        },
        _getInst: function(t) {
            return $(t).data(this.name) || {}
        },
        option: function(t, e, n) {
            var i = (t = $(t)).data(this.name),
                r = e || {};
            return !e || "string" == typeof e && void 0 === n ? (r = (i || {}).options) && e ? r[e] : r : void(t.hasClass(this._getMarker()) && ("string" == typeof e && (r = {}, r[e] = n), this._optionsChanged(t, i, r), $.extend(i.options, r)))
        },
        _optionsChanged: function(t, e, n) {},
        destroy: function(t) {
            (t = $(t)).hasClass(this._getMarker()) && (this._preDestroy(t, this._getInst(t)), t.removeData(this.name).removeClass(this._getMarker()))
        },
        _preDestroy: function(t, e) {}
    }), $.JQPlugin = {
        createPlugin: function(t, e) {
            "object" == typeof t && (e = t, t = "JQPlugin"), t = camelCase(t);
            var n = camelCase(e.name);
            JQClass.classes[n] = JQClass.classes[t].extend(e), new JQClass.classes[n]
        }
    }
}(jQuery),
function(t) {
    "use strict";
    var e = "countdown";
    t.JQPlugin.createPlugin({
        name: e,
        defaultOptions: {
            until: null,
            since: null,
            timezone: null,
            serverSync: null,
            format: "dHMS",
            layout: "",
            compact: !1,
            padZeroes: !1,
            significant: 0,
            description: "",
            expiryUrl: "",
            expiryText: "",
            alwaysExpire: !1,
            onExpiry: null,
            onTick: null,
            tickInterval: 1
        },
        regionalOptions: {
            "": {
                labels: ["Years", "Months", "Weeks", "Days", "Hours", "Minutes", "Seconds"],
                labels1: ["Year", "Month", "Week", "Day", "Hour", "Minute", "Second"],
                compactLabels: ["y", "m", "w", "d"],
                whichLabels: null,
                digits: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
                timeSeparator: ":",
                isRTL: !1
            }
        },
        _rtlClass: e + "-rtl",
        _sectionClass: e + "-section",
        _amountClass: e + "-amount",
        _periodClass: e + "-period",
        _rowClass: e + "-row",
        _holdingClass: e + "-holding",
        _showClass: e + "-show",
        _descrClass: e + "-descr",
        _timerElems: [],
        _init: function() {
            var e = this;
            this._super(), this._serverSyncs = [];
            var n = "function" == typeof Date.now ? Date.now : function() {
                    return (new Date).getTime()
                },
                i = window.performance && "function" == typeof window.performance.now,
                r = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || null,
                o = 0;
            !r || t.noRequestAnimationFrame ? (t.noRequestAnimationFrame = null, t.countdown._timer = setInterval(function() {
                e._updateElems()
            }, 1e3)) : (o = window.animationStartTime || window.webkitAnimationStartTime || window.mozAnimationStartTime || window.oAnimationStartTime || window.msAnimationStartTime || n(), r(function t(s) {
                var a = s < 1e12 ? i ? window.performance.now() + window.performance.timing.navigationStart : n() : s || n();
                a - o >= 1e3 && (e._updateElems(), o = a), r(t)
            }))
        },
        UTCDate: function(t, e, n, i, r, o, s, a) {
            "object" == typeof e && e instanceof Date && (a = e.getMilliseconds(), s = e.getSeconds(), o = e.getMinutes(), r = e.getHours(), i = e.getDate(), n = e.getMonth(), e = e.getFullYear());
            var l = new Date;
            return l.setUTCFullYear(e), l.setUTCDate(1), l.setUTCMonth(n || 0), l.setUTCDate(i || 1), l.setUTCHours(r || 0), l.setUTCMinutes((o || 0) - (Math.abs(t) < 30 ? 60 * t : t)), l.setUTCSeconds(s || 0), l.setUTCMilliseconds(a || 0), l
        },
        periodsToSeconds: function(t) {
            return 31557600 * t[0] + 2629800 * t[1] + 604800 * t[2] + 86400 * t[3] + 3600 * t[4] + 60 * t[5] + t[6]
        },
        resync: function() {
            var e = this;
            t("." + this._getMarker()).each(function() {
                var n = t.data(this, e.name);
                if (n.options.serverSync) {
                    for (var i = null, r = 0; r < e._serverSyncs.length; r++)
                        if (e._serverSyncs[r][0] === n.options.serverSync) {
                            i = e._serverSyncs[r];
                            break
                        } if (e._eqNull(i[2])) {
                        var o = t.isFunction(n.options.serverSync) ? n.options.serverSync.apply(this, []) : null;
                        i[2] = (o ? (new Date).getTime() - o.getTime() : 0) - i[1]
                    }
                    n._since && n._since.setMilliseconds(n._since.getMilliseconds() + i[2]), n._until.setMilliseconds(n._until.getMilliseconds() + i[2])
                }
            });
            for (var n = 0; n < e._serverSyncs.length; n++) e._eqNull(e._serverSyncs[n][2]) || (e._serverSyncs[n][1] += e._serverSyncs[n][2], delete e._serverSyncs[n][2])
        },
        _instSettings: function(t, e) {
            return {
                _periods: [0, 0, 0, 0, 0, 0, 0]
            }
        },
        _addElem: function(t) {
            this._hasElem(t) || this._timerElems.push(t)
        },
        _hasElem: function(e) {
            return t.inArray(e, this._timerElems) > -1
        },
        _removeElem: function(e) {
            this._timerElems = t.map(this._timerElems, function(t) {
                return t === e ? null : t
            })
        },
        _updateElems: function() {
            for (var t = this._timerElems.length - 1; t >= 0; t--) this._updateCountdown(this._timerElems[t])
        },
        _optionsChanged: function(e, n, i) {
            i.layout && (i.layout = i.layout.replace(/&lt;/g, "<").replace(/&gt;/g, ">")), this._resetExtraLabels(n.options, i);
            var r = n.options.timezone !== i.timezone;
            t.extend(n.options, i), this._adjustSettings(e, n, !this._eqNull(i.until) || !this._eqNull(i.since) || r);
            var o = new Date;
            (n._since && n._since < o || n._until && n._until > o) && this._addElem(e[0]), this._updateCountdown(e, n)
        },
        _updateCountdown: function(e, n) {
            if (e = e.jquery ? e : t(e), n = n || this._getInst(e)) {
                if (e.html(this._generateHTML(n)).toggleClass(this._rtlClass, n.options.isRTL), "pause" !== n._hold && t.isFunction(n.options.onTick)) {
                    var i = "lap" !== n._hold ? n._periods : this._calculatePeriods(n, n._show, n.options.significant, new Date);
                    1 !== n.options.tickInterval && this.periodsToSeconds(i) % n.options.tickInterval != 0 || n.options.onTick.apply(e[0], [i])
                }
                if ("pause" !== n._hold && (n._since ? n._now.getTime() < n._since.getTime() : n._now.getTime() >= n._until.getTime()) && !n._expiring) {
                    if (n._expiring = !0, this._hasElem(e[0]) || n.options.alwaysExpire) {
                        if (this._removeElem(e[0]), t.isFunction(n.options.onExpiry) && n.options.onExpiry.apply(e[0], []), n.options.expiryText) {
                            var r = n.options.layout;
                            n.options.layout = n.options.expiryText, this._updateCountdown(e[0], n), n.options.layout = r
                        }
                        n.options.expiryUrl && (window.location = n.options.expiryUrl)
                    }
                    n._expiring = !1
                } else "pause" === n._hold && this._removeElem(e[0])
            }
        },
        _resetExtraLabels: function(t, e) {
            var n = null;
            for (n in e) n.match(/[Ll]abels[02-9]|compactLabels1/) && (t[n] = e[n]);
            for (n in t) n.match(/[Ll]abels[02-9]|compactLabels1/) && void 0 === e[n] && (t[n] = null)
        },
        _eqNull: function(t) {
            return null == t
        },
        _adjustSettings: function(e, n, i) {
            for (var r = null, o = 0; o < this._serverSyncs.length; o++)
                if (this._serverSyncs[o][0] === n.options.serverSync) {
                    r = this._serverSyncs[o][1];
                    break
                } var s = null,
                a = null;
            if (this._eqNull(r)) {
                var l = t.isFunction(n.options.serverSync) ? n.options.serverSync.apply(e[0], []) : null;
                s = new Date, a = l ? s.getTime() - l.getTime() : 0, this._serverSyncs.push([n.options.serverSync, a])
            } else s = new Date, a = n.options.serverSync ? r : 0;
            var u = n.options.timezone;
            u = this._eqNull(u) ? -s.getTimezoneOffset() : u, (i || !i && this._eqNull(n._until) && this._eqNull(n._since)) && (n._since = n.options.since, this._eqNull(n._since) || (n._since = this.UTCDate(u, this._determineTime(n._since, null)), n._since && a && n._since.setMilliseconds(n._since.getMilliseconds() + a)), n._until = this.UTCDate(u, this._determineTime(n.options.until, s)), a && n._until.setMilliseconds(n._until.getMilliseconds() + a)), n._show = this._determineShow(n)
        },
        _preDestroy: function(t, e) {
            this._removeElem(t[0]), t.empty()
        },
        pause: function(t) {
            this._hold(t, "pause")
        },
        lap: function(t) {
            this._hold(t, "lap")
        },
        resume: function(t) {
            this._hold(t, null)
        },
        toggle: function(e) {
            this[(t.data(e, this.name) || {})._hold ? "resume" : "pause"](e)
        },
        toggleLap: function(e) {
            this[(t.data(e, this.name) || {})._hold ? "resume" : "lap"](e)
        },
        _hold: function(e, n) {
            var i = t.data(e, this.name);
            if (i) {
                if ("pause" === i._hold && !n) {
                    i._periods = i._savePeriods;
                    var r = i._since ? "-" : "+";
                    i[i._since ? "_since" : "_until"] = this._determineTime(r + i._periods[0] + "y" + r + i._periods[1] + "o" + r + i._periods[2] + "w" + r + i._periods[3] + "d" + r + i._periods[4] + "h" + r + i._periods[5] + "m" + r + i._periods[6] + "s"), this._addElem(e)
                }
                i._hold = n, i._savePeriods = "pause" === n ? i._periods : null, t.data(e, this.name, i), this._updateCountdown(e, i)
            }
        },
        getTimes: function(e) {
            var n = t.data(e, this.name);
            return n ? "pause" === n._hold ? n._savePeriods : n._hold ? this._calculatePeriods(n, n._show, n.options.significant, new Date) : n._periods : null
        },
        _determineTime: function(t, e) {
            var n, i, r = this,
                o = this._eqNull(t) ? e : "string" == typeof t ? function(t) {
                    t = t.toLowerCase();
                    for (var e = new Date, n = e.getFullYear(), i = e.getMonth(), o = e.getDate(), s = e.getHours(), a = e.getMinutes(), l = e.getSeconds(), u = /([+-]?[0-9]+)\s*(s|m|h|d|w|o|y)?/g, c = u.exec(t); c;) {
                        switch (c[2] || "s") {
                            case "s":
                                l += parseInt(c[1], 10);
                                break;
                            case "m":
                                a += parseInt(c[1], 10);
                                break;
                            case "h":
                                s += parseInt(c[1], 10);
                                break;
                            case "d":
                                o += parseInt(c[1], 10);
                                break;
                            case "w":
                                o += 7 * parseInt(c[1], 10);
                                break;
                            case "o":
                                i += parseInt(c[1], 10), o = Math.min(o, r._getDaysInMonth(n, i));
                                break;
                            case "y":
                                n += parseInt(c[1], 10), o = Math.min(o, r._getDaysInMonth(n, i))
                        }
                        c = u.exec(t)
                    }
                    return new Date(n, i, o, s, a, l, 0)
                }(t) : "number" == typeof t ? (n = t, (i = new Date).setTime(i.getTime() + 1e3 * n), i) : t;
            return o && o.setMilliseconds(0), o
        },
        _getDaysInMonth: function(t, e) {
            return 32 - new Date(t, e, 32).getDate()
        },
        _normalLabels: function(t) {
            return t
        },
        _generateHTML: function(e) {
            var n = this;
            e._periods = e._hold ? e._periods : this._calculatePeriods(e, e._show, e.options.significant, new Date);
            var i = !1,
                r = 0,
                o = e.options.significant,
                s = t.extend({}, e._show),
                a = null;
            for (a = 0; a <= 6; a++) i = i || "?" === e._show[a] && e._periods[a] > 0, s[a] = "?" !== e._show[a] || i ? e._show[a] : null, r += s[a] ? 1 : 0, o -= e._periods[a] > 0 ? 1 : 0;
            var l = [!1, !1, !1, !1, !1, !1, !1];
            for (a = 6; a >= 0; a--) e._show[a] && (e._periods[a] ? l[a] = !0 : (l[a] = o > 0, o--));
            var u = e.options.compact ? e.options.compactLabels : e.options.labels,
                c = e.options.whichLabels || this._normalLabels,
                d = function(t) {
                    var i = e.options["compactLabels" + c(e._periods[t])];
                    return s[t] ? n._translateDigits(e, e._periods[t]) + (i ? i[t] : u[t]) + " " : ""
                },
                h = e.options.padZeroes ? 2 : 1,
                p = function(t) {
                    var i = e.options["labels" + c(e._periods[t])];
                    return !e.options.significant && s[t] || e.options.significant && l[t] ? '<span class="' + n._sectionClass + '"><span class="' + n._amountClass + '">' + n._minDigits(e, e._periods[t], h) + '</span><span class="' + n._periodClass + '">' + (i ? i[t] : u[t]) + "</span></span>" : ""
                };
            return e.options.layout ? this._buildLayout(e, s, e.options.layout, e.options.compact, e.options.significant, l) : (e.options.compact ? '<span class="' + this._rowClass + " " + this._amountClass + (e._hold ? " " + this._holdingClass : "") + '">' + d(0) + d(1) + d(2) + d(3) + (s[4] ? this._minDigits(e, e._periods[4], 2) : "") + (s[5] ? (s[4] ? e.options.timeSeparator : "") + this._minDigits(e, e._periods[5], 2) : "") + (s[6] ? (s[4] || s[5] ? e.options.timeSeparator : "") + this._minDigits(e, e._periods[6], 2) : "") : '<span class="' + this._rowClass + " " + this._showClass + (e.options.significant || r) + (e._hold ? " " + this._holdingClass : "") + '">' + p(0) + p(1) + p(2) + p(3) + p(4) + p(5) + p(6)) + "</span>" + (e.options.description ? '<span class="' + this._rowClass + " " + this._descrClass + '">' + e.options.description + "</span>" : "")
        },
        _buildLayout: function(e, n, i, r, o, s) {
            for (var a = e.options[r ? "compactLabels" : "labels"], l = e.options.whichLabels || this._normalLabels, u = function(t) {
                    return (e.options[(r ? "compactLabels" : "labels") + l(e._periods[t])] || a)[t]
                }, c = function(t, n) {
                    return e.options.digits[Math.floor(t / n) % 10]
                }, d = {
                    desc: e.options.description,
                    sep: e.options.timeSeparator,
                    yl: u(0),
                    yn: this._minDigits(e, e._periods[0], 1),
                    ynn: this._minDigits(e, e._periods[0], 2),
                    ynnn: this._minDigits(e, e._periods[0], 3),
                    y1: c(e._periods[0], 1),
                    y10: c(e._periods[0], 10),
                    y100: c(e._periods[0], 100),
                    y1000: c(e._periods[0], 1e3),
                    ol: u(1),
                    on: this._minDigits(e, e._periods[1], 1),
                    onn: this._minDigits(e, e._periods[1], 2),
                    onnn: this._minDigits(e, e._periods[1], 3),
                    o1: c(e._periods[1], 1),
                    o10: c(e._periods[1], 10),
                    o100: c(e._periods[1], 100),
                    o1000: c(e._periods[1], 1e3),
                    wl: u(2),
                    wn: this._minDigits(e, e._periods[2], 1),
                    wnn: this._minDigits(e, e._periods[2], 2),
                    wnnn: this._minDigits(e, e._periods[2], 3),
                    w1: c(e._periods[2], 1),
                    w10: c(e._periods[2], 10),
                    w100: c(e._periods[2], 100),
                    w1000: c(e._periods[2], 1e3),
                    dl: u(3),
                    dn: this._minDigits(e, e._periods[3], 1),
                    dnn: this._minDigits(e, e._periods[3], 2),
                    dnnn: this._minDigits(e, e._periods[3], 3),
                    d1: c(e._periods[3], 1),
                    d10: c(e._periods[3], 10),
                    d100: c(e._periods[3], 100),
                    d1000: c(e._periods[3], 1e3),
                    hl: u(4),
                    hn: this._minDigits(e, e._periods[4], 1),
                    hnn: this._minDigits(e, e._periods[4], 2),
                    hnnn: this._minDigits(e, e._periods[4], 3),
                    h1: c(e._periods[4], 1),
                    h10: c(e._periods[4], 10),
                    h100: c(e._periods[4], 100),
                    h1000: c(e._periods[4], 1e3),
                    ml: u(5),
                    mn: this._minDigits(e, e._periods[5], 1),
                    mnn: this._minDigits(e, e._periods[5], 2),
                    mnnn: this._minDigits(e, e._periods[5], 3),
                    m1: c(e._periods[5], 1),
                    m10: c(e._periods[5], 10),
                    m100: c(e._periods[5], 100),
                    m1000: c(e._periods[5], 1e3),
                    sl: u(6),
                    sn: this._minDigits(e, e._periods[6], 1),
                    snn: this._minDigits(e, e._periods[6], 2),
                    snnn: this._minDigits(e, e._periods[6], 3),
                    s1: c(e._periods[6], 1),
                    s10: c(e._periods[6], 10),
                    s100: c(e._periods[6], 100),
                    s1000: c(e._periods[6], 1e3)
                }, h = i, p = 0; p <= 6; p++) {
                var f = "yowdhms".charAt(p),
                    m = new RegExp("\\{" + f + "<\\}([\\s\\S]*)\\{" + f + ">\\}", "g");
                h = h.replace(m, !o && n[p] || o && s[p] ? "$1" : "")
            }
            return t.each(d, function(t, e) {
                var n = new RegExp("\\{" + t + "\\}", "g");
                h = h.replace(n, e)
            }), h
        },
        _minDigits: function(t, e, n) {
            return (e = "" + e).length >= n ? this._translateDigits(t, e) : (e = "0000000000" + e, this._translateDigits(t, e.substr(e.length - n)))
        },
        _translateDigits: function(t, e) {
            return ("" + e).replace(/[0-9]/g, function(e) {
                return t.options.digits[e]
            })
        },
        _determineShow: function(t) {
            var e = t.options.format,
                n = [];
            return n[0] = e.match("y") ? "?" : e.match("Y") ? "!" : null, n[1] = e.match("o") ? "?" : e.match("O") ? "!" : null, n[2] = e.match("w") ? "?" : e.match("W") ? "!" : null, n[3] = e.match("d") ? "?" : e.match("D") ? "!" : null, n[4] = e.match("h") ? "?" : e.match("H") ? "!" : null, n[5] = e.match("m") ? "?" : e.match("M") ? "!" : null, n[6] = e.match("s") ? "?" : e.match("S") ? "!" : null, n
        },
        _calculatePeriods: function(t, e, n, i) {
            t._now = i, t._now.setMilliseconds(0);
            var r = new Date(t._now.getTime());
            t._since ? i.getTime() < t._since.getTime() ? t._now = i = r : i = t._since : (r.setTime(t._until.getTime()), i.getTime() > t._until.getTime() && (t._now = i = r));
            var o = [0, 0, 0, 0, 0, 0, 0];
            if (e[0] || e[1]) {
                var s = this._getDaysInMonth(i.getFullYear(), i.getMonth()),
                    a = this._getDaysInMonth(r.getFullYear(), r.getMonth()),
                    l = r.getDate() === i.getDate() || r.getDate() >= Math.min(s, a) && i.getDate() >= Math.min(s, a),
                    u = function(t) {
                        return 60 * (60 * t.getHours() + t.getMinutes()) + t.getSeconds()
                    },
                    c = Math.max(0, 12 * (r.getFullYear() - i.getFullYear()) + r.getMonth() - i.getMonth() + (r.getDate() < i.getDate() && !l || l && u(r) < u(i) ? -1 : 0));
                o[0] = e[0] ? Math.floor(c / 12) : 0, o[1] = e[1] ? c - 12 * o[0] : 0;
                var d = (i = new Date(i.getTime())).getDate() === s,
                    h = this._getDaysInMonth(i.getFullYear() + o[0], i.getMonth() + o[1]);
                i.getDate() > h && i.setDate(h), i.setFullYear(i.getFullYear() + o[0]), i.setMonth(i.getMonth() + o[1]), d && i.setDate(h)
            }
            var p = Math.floor((r.getTime() - i.getTime()) / 1e3),
                f = null,
                m = function(t, n) {
                    o[t] = e[t] ? Math.floor(p / n) : 0, p -= o[t] * n
                };
            if (m(2, 604800), m(3, 86400), m(4, 3600), m(5, 60), m(6, 1), p > 0 && !t._since) {
                var g = [1, 12, 4.3482, 7, 24, 60, 60],
                    y = 6,
                    v = 1;
                for (f = 6; f >= 0; f--) e[f] && (o[y] >= v && (o[y] = 0, p = 1), p > 0 && (o[f]++, p = 0, y = f, v = 1)), v *= g[f]
            }
            if (n)
                for (f = 0; f <= 6; f++) n && o[f] ? n-- : n || (o[f] = 0);
            return o
        }
    })
}(jQuery),
function(t, e) {
    "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", e) : "object" == typeof module && module.exports ? module.exports = e() : t.EvEmitter = e()
}("undefined" != typeof window ? window : this, function() {
    function t() {}
    var e = t.prototype;
    return e.on = function(t, e) {
        if (t && e) {
            var n = this._events = this._events || {},
                i = n[t] = n[t] || [];
            return -1 == i.indexOf(e) && i.push(e), this
        }
    }, e.once = function(t, e) {
        if (t && e) {
            this.on(t, e);
            var n = this._onceEvents = this._onceEvents || {};
            return (n[t] = n[t] || {})[e] = !0, this
        }
    }, e.off = function(t, e) {
        var n = this._events && this._events[t];
        if (n && n.length) {
            var i = n.indexOf(e);
            return -1 != i && n.splice(i, 1), this
        }
    }, e.emitEvent = function(t, e) {
        var n = this._events && this._events[t];
        if (n && n.length) {
            var i = 0,
                r = n[i];
            e = e || [];
            for (var o = this._onceEvents && this._onceEvents[t]; r;) {
                var s = o && o[r];
                s && (this.off(t, r), delete o[r]), r.apply(this, e), r = n[i += s ? 0 : 1]
            }
            return this
        }
    }, e.allOff = e.removeAllListeners = function() {
        delete this._events, delete this._onceEvents
    }, t
}),
function(t, e) {
    "use strict";
    "function" == typeof define && define.amd ? define(["ev-emitter/ev-emitter"], function(n) {
        return e(t, n)
    }) : "object" == typeof module && module.exports ? module.exports = e(t, require("ev-emitter")) : t.imagesLoaded = e(t, t.EvEmitter)
}("undefined" != typeof window ? window : this, function(t, e) {
    function n(t, e) {
        for (var n in e) t[n] = e[n];
        return t
    }

    function i(t, e, r) {
        return this instanceof i ? ("string" == typeof t && (t = document.querySelectorAll(t)), this.elements = function(t) {
            var e = [];
            if (Array.isArray(t)) e = t;
            else if ("number" == typeof t.length)
                for (var n = 0; n < t.length; n++) e.push(t[n]);
            else e.push(t);
            return e
        }(t), this.options = n({}, this.options), "function" == typeof e ? r = e : n(this.options, e), r && this.on("always", r), this.getImages(), s && (this.jqDeferred = new s.Deferred), void setTimeout(function() {
            this.check()
        }.bind(this))) : new i(t, e, r)
    }

    function r(t) {
        this.img = t
    }

    function o(t, e) {
        this.url = t, this.element = e, this.img = new Image
    }
    var s = t.jQuery,
        a = t.console;
    i.prototype = Object.create(e.prototype), i.prototype.options = {}, i.prototype.getImages = function() {
        this.images = [], this.elements.forEach(this.addElementImages, this)
    }, i.prototype.addElementImages = function(t) {
        "IMG" == t.nodeName && this.addImage(t), !0 === this.options.background && this.addElementBackgroundImages(t);
        var e = t.nodeType;
        if (e && l[e]) {
            for (var n = t.querySelectorAll("img"), i = 0; i < n.length; i++) {
                var r = n[i];
                this.addImage(r)
            }
            if ("string" == typeof this.options.background) {
                var o = t.querySelectorAll(this.options.background);
                for (i = 0; i < o.length; i++) {
                    var s = o[i];
                    this.addElementBackgroundImages(s)
                }
            }
        }
    };
    var l = {
        1: !0,
        9: !0,
        11: !0
    };
    return i.prototype.addElementBackgroundImages = function(t) {
        var e = getComputedStyle(t);
        if (e)
            for (var n = /url\((['"])?(.*?)\1\)/gi, i = n.exec(e.backgroundImage); null !== i;) {
                var r = i && i[2];
                r && this.addBackground(r, t), i = n.exec(e.backgroundImage)
            }
    }, i.prototype.addImage = function(t) {
        var e = new r(t);
        this.images.push(e)
    }, i.prototype.addBackground = function(t, e) {
        var n = new o(t, e);
        this.images.push(n)
    }, i.prototype.check = function() {
        function t(t, n, i) {
            setTimeout(function() {
                e.progress(t, n, i)
            })
        }
        var e = this;
        return this.progressedCount = 0, this.hasAnyBroken = !1, this.images.length ? void this.images.forEach(function(e) {
            e.once("progress", t), e.check()
        }) : void this.complete()
    }, i.prototype.progress = function(t, e, n) {
        this.progressedCount++, this.hasAnyBroken = this.hasAnyBroken || !t.isLoaded, this.emitEvent("progress", [this, t, e]), this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, t), this.progressedCount == this.images.length && this.complete(), this.options.debug && a && a.log("progress: " + n, t, e)
    }, i.prototype.complete = function() {
        var t = this.hasAnyBroken ? "fail" : "done";
        if (this.isComplete = !0, this.emitEvent(t, [this]), this.emitEvent("always", [this]), this.jqDeferred) {
            var e = this.hasAnyBroken ? "reject" : "resolve";
            this.jqDeferred[e](this)
        }
    }, r.prototype = Object.create(e.prototype), r.prototype.check = function() {
        return this.getIsImageComplete() ? void this.confirm(0 !== this.img.naturalWidth, "naturalWidth") : (this.proxyImage = new Image, this.proxyImage.addEventListener("load", this), this.proxyImage.addEventListener("error", this), this.img.addEventListener("load", this), this.img.addEventListener("error", this), void(this.proxyImage.src = this.img.src))
    }, r.prototype.getIsImageComplete = function() {
        return this.img.complete && void 0 !== this.img.naturalWidth
    }, r.prototype.confirm = function(t, e) {
        this.isLoaded = t, this.emitEvent("progress", [this, this.img, e])
    }, r.prototype.handleEvent = function(t) {
        var e = "on" + t.type;
        this[e] && this[e](t)
    }, r.prototype.onload = function() {
        this.confirm(!0, "onload"), this.unbindEvents()
    }, r.prototype.onerror = function() {
        this.confirm(!1, "onerror"), this.unbindEvents()
    }, r.prototype.unbindEvents = function() {
        this.proxyImage.removeEventListener("load", this), this.proxyImage.removeEventListener("error", this), this.img.removeEventListener("load", this), this.img.removeEventListener("error", this)
    }, o.prototype = Object.create(r.prototype), o.prototype.check = function() {
        this.img.addEventListener("load", this), this.img.addEventListener("error", this), this.img.src = this.url, this.getIsImageComplete() && (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"), this.unbindEvents())
    }, o.prototype.unbindEvents = function() {
        this.img.removeEventListener("load", this), this.img.removeEventListener("error", this)
    }, o.prototype.confirm = function(t, e) {
        this.isLoaded = t, this.emitEvent("progress", [this, this.element, e])
    }, i.makeJQueryPlugin = function(e) {
        (e = e || t.jQuery) && ((s = e).fn.imagesLoaded = function(t, e) {
            return new i(this, t, e).jqDeferred.promise(s(this))
        })
    }, i.makeJQueryPlugin(), i
}),
function(t) {
    "use strict";

    function e(e, r) {
        this.element = e, this.$element = t(e), this.settings = t.extend({}, i, r), this._defaults = i, this._name = n, this.init()
    }
    var n = "RoarMasonryAnimate",
        i = {
            columns: ".masonry-animation-column",
            items: ".masonry-animation-item",
            respEl: ".masonry-animation-split",
            moveEl: ".masonry-animation-move",
            offset: .2
        },
        r = t(window);
    t.extend(e.prototype, {
        init: function() {
            this.$cols = this.$element.find(this.settings.columns), this.$respEl = this.$element.find(this.settings.respEl), this.$moveEl = this.$element.find(this.settings.moveEl), r.on("scroll resize", this.update.bind(this)), r.on("resize", this._responsive.bind(this)), this._responsive()
        },
        update: function() {
            if (window.innerWidth < 992) return this.$cols.css(window._jcsspfx + "Transform", "none"), void(this.element.style.marginBottom = 0);
            var t;
            this.$cols.each(function(e, n) {
                return t ? void(t.offsetHeight > n.offsetHeight && (t = n)) : void(t = n)
            }.bind(this)), this.element.style.marginBottom = t.offsetHeight - t.parentNode.offsetHeight + "px";
            var e = t.getBoundingClientRect(),
                n = window.innerHeight - window.innerHeight * this.settings.offset - e.top,
                i = n / e.height;
            this.$cols.each(function(r, o) {
                var s;
                s = o !== t ? (o.offsetHeight - 50 * r - e.height) * i : -.03 * n, o.style[window._jcsspfx + "Transform"] = "translateY(" + -s + "px)", o.style[window._jcsspfx + "TransitionDuration"] = 900 + 200 * r + "ms"
            }.bind(this))
        },
        _responsive: function() {
            window.innerWidth < 992 ? (this.$respEl.removeClass("hide"), this.$moveEl.find(this.settings.items).appendTo(this.$respEl), this.$moveEl.addClass("hide")) : (this.$moveEl.removeClass("hide"), this.$moveEl.find(this.settings.columns).each(function(e, n) {
                this.$respEl.find(this.settings.items).filter(function() {
                    return t(this).data("column_num") == e + 1
                }).appendTo(n)
            }.bind(this)), this.$respEl.addClass("hide"))
        }
    }), t.fn[n] = function(i) {
        return this.each(function() {
            t.data(this, "plugin_" + n) || t.data(this, "plugin_" + n, new e(this, i))
        })
    }
}(jQuery), window._jcsspfx = getVendorPrefix(),
function(t, e) {
    "function" == typeof define && define.amd ? define([], e) : "object" == typeof module && module.exports ? module.exports = e() : t.anime = e()
}(this, function() {
    var t, e, n, i, r, o = {
            duration: 1e3,
            delay: 0,
            loop: !1,
            autoplay: !0,
            direction: "normal",
            easing: "easeOutElastic",
            elasticity: 400,
            round: !1,
            begin: void 0,
            update: void 0,
            complete: void 0
        },
        s = "translateX translateY translateZ rotate rotateX rotateY rotateZ scale scaleX scaleY scaleZ skewX skewY".split(" "),
        a = {
            arr: function(t) {
                return Array.isArray(t)
            },
            obj: function(t) {
                return -1 < Object.prototype.toString.call(t).indexOf("Object")
            },
            svg: function(t) {
                return t instanceof SVGElement
            },
            dom: function(t) {
                return t.nodeType || a.svg(t)
            },
            num: function(t) {
                return !isNaN(parseInt(t))
            },
            str: function(t) {
                return "string" == typeof t
            },
            fnc: function(t) {
                return "function" == typeof t
            },
            und: function(t) {
                return void 0 === t
            },
            nul: function(t) {
                return "null" == typeof t
            },
            hex: function(t) {
                return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(t)
            },
            rgb: function(t) {
                return /^rgb/.test(t)
            },
            hsl: function(t) {
                return /^hsl/.test(t)
            },
            col: function(t) {
                return a.hex(t) || a.rgb(t) || a.hsl(t)
            }
        },
        l = (i = {}, r = {
            Sine: function(t) {
                return 1 - Math.cos(t * Math.PI / 2)
            },
            Circ: function(t) {
                return 1 - Math.sqrt(1 - t * t)
            },
            Elastic: function(t, e) {
                if (0 === t || 1 === t) return t;
                var n = 1 - Math.min(e, 998) / 1e3,
                    i = t / 1 - 1;
                return -Math.pow(2, 10 * i) * Math.sin(2 * (i - n / (2 * Math.PI) * Math.asin(1)) * Math.PI / n)
            },
            Back: function(t) {
                return t * t * (3 * t - 2)
            },
            Bounce: function(t) {
                for (var e, n = 4; t < ((e = Math.pow(2, --n)) - 1) / 11;);
                return 1 / Math.pow(4, 3 - n) - 7.5625 * Math.pow((3 * e - 2) / 22 - t, 2)
            }
        }, ["Quad", "Cubic", "Quart", "Quint", "Expo"].forEach(function(t, e) {
            r[t] = function(t) {
                return Math.pow(t, e + 2)
            }
        }), Object.keys(r).forEach(function(t) {
            var e = r[t];
            i["easeIn" + t] = e, i["easeOut" + t] = function(t, n) {
                return 1 - e(1 - t, n)
            }, i["easeInOut" + t] = function(t, n) {
                return t < .5 ? e(2 * t, n) / 2 : 1 - e(-2 * t + 2, n) / 2
            }, i["easeOutIn" + t] = function(t, n) {
                return t < .5 ? (1 - e(1 - 2 * t, n)) / 2 : (e(2 * t - 1, n) + 1) / 2
            }
        }), i.linear = function(t) {
            return t
        }, i),
        u = function(t) {
            return a.str(t) ? t : t + ""
        },
        c = function(t) {
            return t.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()
        },
        d = function(t) {
            if (a.col(t)) return !1;
            try {
                return document.querySelectorAll(t)
            } catch (t) {
                return !1
            }
        },
        h = function(t) {
            return t.reduce(function(t, e) {
                return t.concat(a.arr(e) ? h(e) : e)
            }, [])
        },
        p = function(t) {
            return a.arr(t) ? t : (a.str(t) && (t = d(t) || t), t instanceof NodeList || t instanceof HTMLCollection ? [].slice.call(t) : [t])
        },
        f = function(t, e) {
            return t.some(function(t) {
                return t === e
            })
        },
        m = function(t) {
            return t.filter(function(t, e, n) {
                return n.indexOf(t) === e
            })
        },
        g = function(t) {
            var e, n = {};
            for (e in t) n[e] = t[e];
            return n
        },
        y = function(t, e) {
            for (var n in e) t[n] = a.und(t[n]) ? e[n] : t[n];
            return t
        },
        v = function(t) {
            return /([\+\-]?[0-9|auto\.]+)(%|px|pt|em|rem|in|cm|mm|ex|pc|vw|vh|deg)?/.exec(t)[2]
        },
        _ = function(t, e, n) {
            return v(e) ? e : -1 < t.indexOf("translate") ? v(n) ? e + v(n) : e + "px" : -1 < t.indexOf("rotate") || -1 < t.indexOf("skew") ? e + "deg" : e
        },
        b = function(t, e) {
            if (e in t.style) return getComputedStyle(t).getPropertyValue(c(e)) || "0"
        },
        w = function(t, e) {
            return a.dom(t) && f(s, e) ? "transform" : a.dom(t) && (t.getAttribute(e) || a.svg(t) && t[e]) ? "attribute" : a.dom(t) && "transform" !== e && b(t, e) ? "css" : a.nul(t[e]) || a.und(t[e]) ? void 0 : "object"
        },
        x = function(t, e) {
            switch (w(t, e)) {
                case "transform":
                    return function(t, e) {
                        var n = -1 < e.indexOf("scale") ? 1 : 0,
                            i = t.style.transform;
                        if (!i) return n;
                        for (var r = /(\w+)\((.+?)\)/g, o = [], s = [], a = []; o = r.exec(i);) s.push(o[1]), a.push(o[2]);
                        return (i = a.filter(function(t, n) {
                            return s[n] === e
                        })).length ? i[0] : n
                    }(t, e);
                case "css":
                    return b(t, e);
                case "attribute":
                    return t.getAttribute(e)
            }
            return t[e] || 0
        },
        S = function(t, e, n) {
            return a.col(e) ? e = a.rgb(e) ? e : a.hex(e) ? function(t) {
                t = t.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function(t, e, n, i) {
                    return e + e + n + n + i + i
                });
                var e = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t);
                return "rgb(" + (t = parseInt(e[1], 16)) + "," + parseInt(e[2], 16) + "," + (e = parseInt(e[3], 16)) + ")"
            }(e) : a.hsl(e) ? function(t) {
                t = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(t);
                var e = parseInt(t[1]) / 360,
                    n = parseInt(t[2]) / 100,
                    i = parseInt(t[3]) / 100;
                if (t = function(t, e, n) {
                        return n < 0 && (n += 1), 1 < n && --n, n < 1 / 6 ? t + 6 * (e - t) * n : n < .5 ? e : n < 2 / 3 ? t + (e - t) * (2 / 3 - n) * 6 : t
                    }, 0 == n) n = i = e = i;
                else {
                    var r = i < .5 ? i * (1 + n) : i + n - i * n,
                        o = 2 * i - r;
                    n = t(o, r, e + 1 / 3), i = t(o, r, e), e = t(o, r, e - 1 / 3)
                }
                return "rgb(" + 255 * n + "," + 255 * i + "," + 255 * e + ")"
            }(e) : void 0 : v(e) ? e : (!(t = v(t.to) ? v(t.to) : v(t.from)) && n && (t = v(n)), t ? e + t : e)
        },
        T = function(t) {
            var e = /-?\d*\.?\d+/g;
            return {
                original: t,
                numbers: u(t).match(e) ? u(t).match(e).map(Number) : [0],
                strings: u(t).split(e)
            }
        },
        k = function(t, e, n, i) {
            return "transform" === n ? (n = t + "(" + _(t, e.from, e.to) + ")", e = t + "(" + _(t, e.to) + ")") : (t = "css" === n ? b(i, t) : void 0, n = S(e, e.from, t), e = S(e, e.to, t)), {
                from: T(n),
                to: T(e)
            }
        },
        C = function(t, e) {
            t.tweens.forEach(function(n) {
                var i = n.from,
                    r = t.duration - (n.delay + n.duration);
                n.from = n.to, n.to = i, e && (n.delay = r)
            }), t.reversed = !t.reversed
        },
        E = function(t) {
            var e = [],
                n = [];
            return t.tweens.forEach(function(t) {
                "css" !== t.type && "transform" !== t.type || (e.push("css" === t.type ? c(t.name) : "transform"), t.animatables.forEach(function(t) {
                    n.push(t.target)
                }))
            }), {
                properties: m(e).join(", "),
                elements: m(n)
            }
        },
        A = function(t, e) {
            var n, i, r, o = Math.min(Math.max(e - t.delay, 0), t.duration) / t.duration,
                s = t.to.numbers.map(function(e, n) {
                    var i = t.from.numbers[n],
                        r = l[t.easing](o, t.elasticity);
                    return i = t.path ? function(t, e) {
                        var n = t.path,
                            i = t.value * e,
                            r = (s = function(r) {
                                return r = r || 0, n.getPointAtLength(1 < e ? t.value + r : i + r)
                            })(),
                            o = s(-1),
                            s = s(1);
                        switch (t.name) {
                            case "translateX":
                                return r.x;
                            case "translateY":
                                return r.y;
                            case "rotate":
                                return 180 * Math.atan2(s.y - o.y, s.x - o.x) / Math.PI
                        }
                    }(t, r) : i + r * (e - i), t.round ? Math.round(i * t.round) / t.round : i
                });
            return n = s, i = t.to.strings, r = t.from.strings, i.reduce(function(t, e, i) {
                return e = e || r[i - 1], t + n[i - 1] + e
            })
        },
        D = function(e, n) {
            var i;
            e.currentTime = n, e.progress = n / e.duration * 100;
            for (var r = 0; r < e.tweens.length; r++) {
                var o = e.tweens[r];
                o.currentValue = A(o, n);
                for (var s = o.currentValue, a = 0; a < o.animatables.length; a++) {
                    var l = (u = o.animatables[a]).id,
                        u = u.target,
                        c = o.name;
                    switch (o.type) {
                        case "css":
                            u.style[c] = s;
                            break;
                        case "attribute":
                            u.setAttribute(c, s);
                            break;
                        case "object":
                            u[c] = s;
                            break;
                        case "transform":
                            i || (i = {}), i[l] || (i[l] = []), i[l].push(s)
                    }
                }
            }
            if (i)
                for (r in t || (t = (b(document.body, "transform") ? "" : "-webkit-") + "transform"), i) e.animatables[r].target.style[t] = i[r].join(" ");
            e.settings.update && e.settings.update(e)
        },
        P = function(t) {
            var e, n = {};
            n.animatables = (e = (e = t.targets) ? h(a.arr(e) ? e.map(p) : p(e)) : []).map(function(t, e) {
                return {
                    target: t,
                    id: e
                }
            }), n.settings = y(t, o);
            var i, r = n.settings,
                s = [];
            for (i in t)
                if (!o.hasOwnProperty(i) && "targets" !== i) {
                    var l = a.obj(t[i]) ? g(t[i]) : {
                        value: t[i]
                    };
                    l.name = i, s.push(y(l, r))
                } return n.properties = s, n.tweens = function(t, e) {
                var n, i, r, o, s, l, u = (i = e, r = [], (n = t).forEach(function(t, e) {
                    var o = t.target;
                    return i.forEach(function(i) {
                        var s = w(o, i.name);
                        if (s) {
                            var l;
                            l = i.name;
                            var u = i.value;
                            l = {
                                from: 1 < (u = p(a.fnc(u) ? u(o, e) : u)).length ? u[0] : x(o, l),
                                to: 1 < u.length ? u[1] : u[0]
                            }, (u = g(i)).animatables = t, u.type = s, u.from = k(i.name, l, u.type, o).from, u.to = k(i.name, l, u.type, o).to, u.round = a.col(l.from) || u.round ? 1 : 0, u.delay = (a.fnc(u.delay) ? u.delay(o, e, n.length) : u.delay) / L.speed, u.duration = (a.fnc(u.duration) ? u.duration(o, e, n.length) : u.duration) / L.speed, r.push(u)
                        }
                    })
                }), r);
                return (o = u, s = ["name", "from", "to", "delay", "duration"], l = {}, o.forEach(function(t) {
                    var e = JSON.stringify(s.map(function(e) {
                        return t[e]
                    }));
                    l[e] = l[e] || [], l[e].push(t)
                }), Object.keys(l).map(function(t) {
                    return l[t]
                })).map(function(t) {
                    var e = g(t[0]);
                    return e.animatables = t.map(function(t) {
                        return t.animatables
                    }), e.totalDuration = e.delay + e.duration, e
                })
            }(n.animatables, n.properties), n.duration = function(t) {
                if (t.length) return Math.max.apply(Math, t.map(function(t) {
                    return t.totalDuration
                }))
            }(n.tweens) || t.duration, n.currentTime = 0, n.progress = 0, n.ended = !1, n
        },
        O = [],
        I = 0,
        M = (e = function() {
            I = requestAnimationFrame(n)
        }, n = function(t) {
            if (O.length) {
                for (var n = 0; n < O.length; n++) O[n].tick(t);
                e()
            } else cancelAnimationFrame(I), I = 0
        }, e),
        L = function(t) {
            var e = P(t),
                n = {};
            return e.tick = function(t) {
                e.ended = !1, n.start || (n.start = t), n.current = Math.min(Math.max(n.last + t - n.start, 0), e.duration), D(e, n.current);
                var i = e.settings;
                i.begin && n.current >= i.delay && (i.begin(e), i.begin = void 0), n.current >= e.duration && (i.loop ? (n.start = t, "alternate" === i.direction && C(e, !0), a.num(i.loop) && i.loop--) : (e.ended = !0, e.pause(), i.complete && i.complete(e)), n.last = 0)
            }, e.seek = function(t) {
                D(e, t / 100 * e.duration)
            }, e.pause = function() {
                E(e).elements.forEach(function(t) {
                    t.style.removeProperty("will-change")
                });
                var t = O.indexOf(e); - 1 < t && O.splice(t, 1)
            }, e.play = function(t) {
                var i;
                e.pause(), t && (e = y(P(y(t, e.settings)), e)), n.start = 0, n.last = e.ended ? 0 : e.currentTime, "reverse" === (t = e.settings).direction && C(e), "alternate" !== t.direction || t.loop || (t.loop = 1), (i = E(e)).elements.forEach(function(t) {
                    t.style.willChange = i.properties
                }), O.push(e), I || M()
            }, e.restart = function() {
                e.reversed && C(e), e.pause(), e.seek(0), e.play()
            }, e.settings.autoplay && e.play(), e
        };
    return L.version = "1.1.1", L.speed = 1, L.list = O, L.remove = function(t) {
        t = h(a.arr(t) ? t.map(p) : p(t));
        for (var e = O.length - 1; 0 <= e; e--)
            for (var n = O[e], i = n.tweens, r = i.length - 1; 0 <= r; r--)
                for (var o = i[r].animatables, s = o.length - 1; 0 <= s; s--) f(t, o[s].target) && (o.splice(s, 1), o.length || i.splice(r, 1), i.length || n.pause())
    }, L.easings = l, L.getValue = x, L.path = function(t) {
        return {
            path: t = a.str(t) ? d(t)[0] : t,
            value: t.getTotalLength()
        }
    }, L.random = function(t, e) {
        return Math.floor(Math.random() * (e - t + 1)) + t
    }, L
}),
function(t) {
    "use strict";

    function e(t, e) {
        for (var n in e) e.hasOwnProperty(n) && (t[n] = e[n]);
        return t
    }

    function n(t, n) {
        this.DOM = {}, this.DOM.el = t, this.options = e({}, this.options), e(this.options, n), this._init()
    }
    n.prototype.options = {
        movement: {
            imgWrapper: {
                translation: {
                    x: 0,
                    y: 0,
                    z: 0
                },
                rotation: {
                    x: -5,
                    y: 5,
                    z: 0
                },
                reverseAnimation: {
                    duration: 1200,
                    easing: "easeOutElastic",
                    elasticity: 600
                }
            },
            lines: {
                translation: {
                    x: 10,
                    y: 10,
                    z: [0, 10]
                },
                reverseAnimation: {
                    duration: 1e3,
                    easing: "easeOutExpo",
                    elasticity: 600
                }
            },
            caption: {
                translation: {
                    x: 20,
                    y: 20,
                    z: 0
                },
                rotation: {
                    x: 0,
                    y: 0,
                    z: 0
                },
                reverseAnimation: {
                    duration: 1500,
                    easing: "easeOutElastic",
                    elasticity: 600
                }
            },
            shine: {
                translation: {
                    x: 50,
                    y: 50,
                    z: 0
                },
                reverseAnimation: {
                    duration: 1200,
                    easing: "easeOutElastic",
                    elasticity: 600
                }
            }
        }
    }, n.prototype._init = function() {
        this.DOM.animatable = {}, this.DOM.animatable.imgWrapper = this.DOM.el.querySelector(".tilter__figure"), this.DOM.animatable.lines = this.DOM.el.querySelector(".tilter__deco--lines"), this.DOM.animatable.caption = this.DOM.el.querySelector(".tilter__caption"), this.DOM.animatable.overlay = this.DOM.el.querySelector(".tilter__deco--overlay"), this.DOM.animatable.shine = this.DOM.el.querySelector(".tilter__deco--shine > div"), this._initEvents()
    }, n.prototype._initEvents = function() {
        var t = this;
        this.mouseenterFn = function() {
            for (var e in t.DOM.animatable) anime.remove(t.DOM.animatable[e])
        }, this.mousemoveFn = function(e) {
            requestAnimationFrame(function() {
                t._layout(e)
            })
        }, this.mouseleaveFn = function(e) {
            requestAnimationFrame(function() {
                for (var e in t.DOM.animatable) null != t.options.movement[e] && anime({
                    targets: t.DOM.animatable[e],
                    duration: null != t.options.movement[e].reverseAnimation ? t.options.movement[e].reverseAnimation.duration || 0 : 1,
                    easing: null != t.options.movement[e].reverseAnimation && t.options.movement[e].reverseAnimation.easing || "linear",
                    elasticity: null != t.options.movement[e].reverseAnimation && t.options.movement[e].reverseAnimation.elasticity || null,
                    scaleX: 1,
                    scaleY: 1,
                    scaleZ: 1,
                    translateX: 0,
                    translateY: 0,
                    translateZ: 0,
                    rotateX: 0,
                    rotateY: 0,
                    rotateZ: 0
                })
            })
        }, this.DOM.el.addEventListener("mousemove", this.mousemoveFn), this.DOM.el.addEventListener("mouseleave", this.mouseleaveFn), this.DOM.el.addEventListener("mouseenter", this.mouseenterFn)
    }, n.prototype._layout = function(e) {
        var n = function(e) {
                var n = 0,
                    i = 0;
                return e || (e = t.event), e.pageX || e.pageY ? (n = e.pageX, i = e.pageY) : (e.clientX || e.clientY) && (n = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft, i = e.clientY + document.body.scrollTop + document.documentElement.scrollTop), {
                    x: n,
                    y: i
                }
            }(e),
            i = document.body.scrollLeft + document.documentElement.scrollLeft,
            r = document.body.scrollTop + document.documentElement.scrollTop,
            o = this.DOM.el.getBoundingClientRect(),
            s = n.x - o.left - i,
            a = n.y - o.top - r;
        for (var l in this.DOM.animatable)
            if (null != this.DOM.animatable[l] && null != this.options.movement[l]) {
                var u = null != this.options.movement[l] && this.options.movement[l].translation || {
                        x: 0,
                        y: 0,
                        z: 0
                    },
                    c = null != this.options.movement[l] && this.options.movement[l].rotation || {
                        x: 0,
                        y: 0,
                        z: 0
                    },
                    d = function(t) {
                        for (var e in t) null == t[e] ? t[e] = [0, 0] : "number" == typeof t[e] && (t[e] = [-1 * t[e], t[e]])
                    };
                d(u), d(c);
                var h = {
                        x: (u.x[1] - u.x[0]) / o.width * s + u.x[0],
                        y: (u.y[1] - u.y[0]) / o.height * a + u.y[0],
                        z: (u.z[1] - u.z[0]) / o.height * a + u.z[0]
                    },
                    p = {
                        x: (c.x[1] - c.x[0]) / o.height * a + c.x[0],
                        y: (c.y[1] - c.y[0]) / o.width * s + c.y[0],
                        z: (c.z[1] - c.z[0]) / o.width * s + c.z[0]
                    };
                this.DOM.animatable[l].style.WebkitTransform = this.DOM.animatable[l].style.transform = "translateX(" + h.x + "px) translateY(" + h.y + "px) translateZ(" + h.z + "px) rotateX(" + p.x + "deg) rotateY(" + p.y + "deg) rotateZ(" + p.z + "deg)"
            }
    }, t.TiltFx = n
}(window);
var $jscomp = {
scope: {}
};
$jscomp.defineProperty = "function" == typeof Object.defineProperties ? Object.defineProperty : function(t, e, n) {
if (n.get || n.set) throw new TypeError("ES3 does not support getters and setters.");
t != Array.prototype && t != Object.prototype && (t[e] = n.value)
}, $jscomp.getGlobal = function(t) {
return "undefined" != typeof window && window === t ? t : "undefined" != typeof global && null != global ? global : t
}, $jscomp.global = $jscomp.getGlobal(this), $jscomp.SYMBOL_PREFIX = "jscomp_symbol_", $jscomp.initSymbol = function() {
$jscomp.initSymbol = function() {}, $jscomp.global.Symbol || ($jscomp.global.Symbol = $jscomp.Symbol)
}, $jscomp.symbolCounter_ = 0, $jscomp.Symbol = function(t) {
return $jscomp.SYMBOL_PREFIX + (t || "") + $jscomp.symbolCounter_++
}, $jscomp.initSymbolIterator = function() {
$jscomp.initSymbol();
var t = $jscomp.global.Symbol.iterator;
t || (t = $jscomp.global.Symbol.iterator = $jscomp.global.Symbol("iterator")), "function" != typeof Array.prototype[t] && $jscomp.defineProperty(Array.prototype, t, {
    configurable: !0,
    writable: !0,
    value: function() {
        return $jscomp.arrayIterator(this)
    }
}), $jscomp.initSymbolIterator = function() {}
}, $jscomp.arrayIterator = function(t) {
var e = 0;
return $jscomp.iteratorPrototype(function() {
    return e < t.length ? {
        done: !1,
        value: t[e++]
    } : {
        done: !0
    }
})
}, $jscomp.iteratorPrototype = function(t) {
return $jscomp.initSymbolIterator(), (t = {
    next: t
})[$jscomp.global.Symbol.iterator] = function() {
    return this
}, t
}, $jscomp.array = $jscomp.array || {}, $jscomp.iteratorFromArray = function(t, e) {
$jscomp.initSymbolIterator(), t instanceof String && (t += "");
var n = 0,
    i = {
        next: function() {
            if (n < t.length) {
                var r = n++;
                return {
                    value: e(r, t[r]),
                    done: !1
                }
            }
            return i.next = function() {
                return {
                    done: !0,
                    value: void 0
                }
            }, i.next()
        }
    };
return i[Symbol.iterator] = function() {
    return i
}, i
}, $jscomp.polyfill = function(t, e, n, i) {
if (e) {
    for (n = $jscomp.global, t = t.split("."), i = 0; i < t.length - 1; i++) {
        var r = t[i];
        r in n || (n[r] = {}), n = n[r]
    }(e = e(i = n[t = t[t.length - 1]])) != i && null != e && $jscomp.defineProperty(n, t, {
        configurable: !0,
        writable: !0,
        value: e
    })
}
}, $jscomp.polyfill("Array.prototype.keys", function(t) {
return t || function() {
    return $jscomp.iteratorFromArray(this, function(t) {
        return t
    })
}
}, "es6-impl", "es3");
var $jscomp$this = this;
! function(t, e) {
"function" == typeof define && define.amd ? define([], e) : "object" == typeof module && module.exports ? module.exports = e() : t.anime = e()
}(this, function() {
function t(t) {
    if (!D.col(t)) try {
        return document.querySelectorAll(t)
    } catch (t) {}
}

function e(t, e) {
    for (var n = t.length, i = 2 <= arguments.length ? e : void 0, r = [], o = 0; o < n; o++)
        if (o in t) {
            var s = t[o];
            e.call(i, s, o, t) && r.push(s)
        } return r
}

function n(t) {
    return t.reduce(function(t, e) {
        return t.concat(D.arr(e) ? n(e) : e)
    }, [])
}

function i(e) {
    return D.arr(e) ? e : (D.str(e) && (e = t(e) || e), e instanceof NodeList || e instanceof HTMLCollection ? [].slice.call(e) : [e])
}

function r(t, e) {
    return t.some(function(t) {
        return t === e
    })
}

function o(t) {
    var e, n = {};
    for (e in t) n[e] = t[e];
    return n
}

function s(t, e) {
    var n, i = o(t);
    for (n in t) i[n] = e.hasOwnProperty(n) ? e[n] : t[n];
    return i
}

function a(t, e) {
    var n, i = o(t);
    for (n in e) i[n] = D.und(t[n]) ? e[n] : t[n];
    return i
}

function l(t) {
    if (t = /([\+\-]?[0-9#\.]+)(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(t)) return t[2]
}

function u(t, e) {
    return D.fnc(t) ? t(e.target, e.id, e.total) : t
}

function c(t, e) {
    if (e in t.style) return getComputedStyle(t).getPropertyValue(e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()) || "0"
}

function d(t, e) {
    return D.dom(t) && r(A, e) ? "transform" : D.dom(t) && (t.getAttribute(e) || D.svg(t) && t[e]) ? "attribute" : D.dom(t) && "transform" !== e && c(t, e) ? "css" : null != t[e] ? "object" : void 0
}

function h(t, n) {
    switch (d(t, n)) {
        case "transform":
            return function(t, n) {
                var i, r = -1 < (i = n).indexOf("translate") || "perspective" === i ? "px" : -1 < i.indexOf("rotate") || -1 < i.indexOf("skew") ? "deg" : void 0;
                if (r = -1 < n.indexOf("scale") ? 1 : 0 + r, !(t = t.style.transform)) return r;
                for (var o = [], s = [], a = [], l = /(\w+)\((.+?)\)/g; o = l.exec(t);) s.push(o[1]), a.push(o[2]);
                return (t = e(a, function(t, e) {
                    return s[e] === n
                })).length ? t[0] : r
            }(t, n);
        case "css":
            return c(t, n);
        case "attribute":
            return t.getAttribute(n)
    }
    return t[n] || 0
}

function p(t, e) {
    var n = /^(\*=|\+=|-=)/.exec(t);
    if (!n) return t;
    var i = l(t) || 0;
    switch (e = parseFloat(e), t = parseFloat(t.replace(n[0], "")), n[0][0]) {
        case "+":
            return e + t + i;
        case "-":
            return e - t + i;
        case "*":
            return e * t + i
    }
}

function f(t, e) {
    return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2))
}

function m(t) {
    t = t.points;
    for (var e, n = 0, i = 0; i < t.numberOfItems; i++) {
        var r = t.getItem(i);
        0 < i && (n += f(e, r)), e = r
    }
    return n
}

function g(t) {
    if (t.getTotalLength) return t.getTotalLength();
    switch (t.tagName.toLowerCase()) {
        case "circle":
            return 2 * Math.PI * t.getAttribute("r");
        case "rect":
            return 2 * t.getAttribute("width") + 2 * t.getAttribute("height");
        case "line":
            return f({
                x: t.getAttribute("x1"),
                y: t.getAttribute("y1")
            }, {
                x: t.getAttribute("x2"),
                y: t.getAttribute("y2")
            });
        case "polyline":
            return m(t);
        case "polygon":
            var e = t.points;
            return m(t) + f(e.getItem(e.numberOfItems - 1), e.getItem(0))
    }
}

function y(t, e) {
    function n(n) {
        return n = void 0 === n ? 0 : n, t.el.getPointAtLength(1 <= e + n ? e + n : 0)
    }
    var i = n(),
        r = n(-1),
        o = n(1);
    switch (t.property) {
        case "x":
            return i.x;
        case "y":
            return i.y;
        case "angle":
            return 180 * Math.atan2(o.y - r.y, o.x - r.x) / Math.PI
    }
}

function v(t, e) {
    var n, i = /-?\d*\.?\d+/g;
    if (n = D.pth(t) ? t.totalLength : t, D.col(n))
        if (D.rgb(n)) {
            var r = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(n);
            n = r ? "rgba(" + r[1] + ",1)" : n
        } else n = D.hex(n) ? function(t) {
            t = t.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function(t, e, n, i) {
                return e + e + n + n + i + i
            });
            var e = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t);
            return "rgba(" + (t = parseInt(e[1], 16)) + "," + parseInt(e[2], 16) + "," + (e = parseInt(e[3], 16)) + ",1)"
        }(n) : D.hsl(n) ? function(t) {
            function e(t, e, n) {
                return n < 0 && (n += 1), 1 < n && --n, n < 1 / 6 ? t + 6 * (e - t) * n : n < .5 ? e : n < 2 / 3 ? t + (e - t) * (2 / 3 - n) * 6 : t
            }
            var n = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(t) || /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(t);
            t = parseInt(n[1]) / 360;
            var i = parseInt(n[2]) / 100,
                r = parseInt(n[3]) / 100;
            if (n = n[4] || 1, 0 == i) r = i = t = r;
            else {
                var o = r < .5 ? r * (1 + i) : r + i - r * i,
                    s = 2 * r - o;
                r = e(s, o, t + 1 / 3), i = e(s, o, t), t = e(s, o, t - 1 / 3)
            }
            return "rgba(" + 255 * r + "," + 255 * i + "," + 255 * t + "," + n + ")"
        }(n) : void 0;
    else r = (r = l(n)) ? n.substr(0, n.length - r.length) : n, n = e && !/\s/g.test(n) ? r + e : r;
    return {
        original: n += "",
        numbers: n.match(i) ? n.match(i).map(Number) : [0],
        strings: D.str(t) || e ? n.split(i) : []
    }
}

function _(t) {
    return e(t = t ? n(D.arr(t) ? t.map(i) : i(t)) : [], function(t, e, n) {
        return n.indexOf(t) === e
    })
}

function b(t, e) {
    var n = o(e);
    if (D.arr(t)) {
        var r = t.length;
        2 !== r || D.obj(t[0]) ? D.fnc(e.duration) || (n.duration = e.duration / r) : t = {
            value: t
        }
    }
    return i(t).map(function(t, n) {
        return n = n ? 0 : e.delay, t = D.obj(t) && !D.pth(t) ? t : {
            value: t
        }, D.und(t.delay) && (t.delay = n), t
    }).map(function(t) {
        return a(t, n)
    })
}

function w(t, e) {
    var n;
    return t.tweens.map(function(i) {
        var r = (i = function(t, e) {
                var n, i = {};
                for (n in t) {
                    var r = u(t[n], e);
                    D.arr(r) && 1 === (r = r.map(function(t) {
                        return u(t, e)
                    })).length && (r = r[0]), i[n] = r
                }
                return i.duration = parseFloat(i.duration), i.delay = parseFloat(i.delay), i
            }(i, e)).value,
            o = h(e.target, t.name),
            s = n ? n.to.original : o,
            a = (s = D.arr(r) ? r[0] : s, p(D.arr(r) ? r[1] : r, s));
        return o = l(a) || l(s) || l(o), i.from = v(s, o), i.to = v(a, o), i.start = n ? n.end : t.offset, i.end = i.start + i.delay + i.duration, i.easing = function(t) {
            return D.arr(t) ? P.apply(this, t) : O[t]
        }(i.easing), i.elasticity = (1e3 - Math.min(Math.max(i.elasticity, 1), 999)) / 1e3, i.isPath = D.pth(r), i.isColor = D.col(i.from.original), i.isColor && (i.round = 1), n = i
    })
}

function x(t, e, n, i) {
    var r = "delay" === t;
    return e.length ? (r ? Math.min : Math.max).apply(Math, e.map(function(e) {
        return e[t]
    })) : r ? i.delay : n.offset + i.delay + i.duration
}

function S(t) {
    var i, r, o, l, u, c = s(C, t),
        h = s(E, t),
        p = (r = t.targets, (o = _(r)).map(function(t, e) {
            return {
                target: t,
                id: e,
                total: o.length
            }
        })),
        f = [],
        m = a(c, h);
    for (i in t) m.hasOwnProperty(i) || "targets" === i || f.push({
        name: i,
        offset: m.offset,
        tweens: b(t[i], h)
    });
    return u = f, a(c, {
        children: [],
        animatables: l = p,
        animations: t = e(n(l.map(function(t) {
            return u.map(function(e) {
                var n = d(t.target, e.name);
                if (n) {
                    var i = w(e, t);
                    e = {
                        type: n,
                        property: e.name,
                        animatable: t,
                        tweens: i,
                        duration: i[i.length - 1].end,
                        delay: i[0].delay
                    }
                } else e = void 0;
                return e
            })
        })), function(t) {
            return !D.und(t)
        }),
        duration: x("duration", t, c, h),
        delay: x("delay", t, c, h)
    })
}

function T(t) {
    function n() {
        return window.Promise && new Promise(function(t) {
            return h = t
        })
    }

    function i(t) {
        return f.reversed ? f.duration - t : t
    }

    function r(t) {
        for (var n = 0, i = {}, r = f.animations, o = r.length; n < o;) {
            var s = r[n],
                a = s.animatable,
                l = (u = s.tweens)[p = u.length - 1];
            p && (l = e(u, function(e) {
                return t < e.end
            })[0] || l);
            for (var u = Math.min(Math.max(t - l.start - l.delay, 0), l.duration) / l.duration, d = isNaN(u) ? 1 : l.easing(u, l.elasticity), h = (u = l.to.strings, l.round), p = [], m = void 0, g = (m = l.to.numbers.length, 0); g < m; g++) {
                var v = void 0,
                    _ = (v = l.to.numbers[g], l.from.numbers[g]);
                v = l.isPath ? y(l.value, d * v) : _ + d * (v - _), h && (l.isColor && 2 < g || (v = Math.round(v * h) / h)), p.push(v)
            }
            if (l = u.length)
                for (m = u[0], d = 0; d < l; d++) h = u[d + 1], g = p[d], isNaN(g) || (m = h ? m + (g + h) : m + (g + " "));
            else m = p[0];
            I[s.type](a.target, s.property, m, i, a.id), s.currentValue = m, n++
        }
        if (n = Object.keys(i).length)
            for (r = 0; r < n; r++) k || (k = c(document.body, "transform") ? "transform" : "-webkit-transform"), f.animatables[r].target.style[k] = i[r].join(" ");
        f.currentTime = t, f.progress = t / f.duration * 100
    }

    function o(t) {
        f[t] && f[t](f)
    }

    function s() {
        f.remaining && !0 !== f.remaining && f.remaining--
    }

    function a(t) {
        var e = f.duration,
            a = f.offset,
            c = a + f.delay,
            m = f.currentTime,
            g = f.reversed,
            y = i(t);
        if (f.children.length) {
            var v = f.children,
                _ = v.length;
            if (y >= f.currentTime)
                for (var b = 0; b < _; b++) v[b].seek(y);
            else
                for (; _--;) v[_].seek(y)
        }(c <= y || !e) && (f.began || (f.began = !0, o("begin")), o("run")), a < y && y < e ? r(y) : (y <= a && 0 !== m && (r(0), g && s()), (e <= y && m !== e || !e) && (r(e), g || s())), o("update"), e <= t && (f.remaining ? (u = l, "alternate" === f.direction && (f.reversed = !f.reversed)) : (f.pause(), f.completed || (f.completed = !0, o("complete"), "Promise" in window && (h(), p = n()))), d = 0)
    }
    t = void 0 === t ? {} : t;
    var l, u, d = 0,
        h = null,
        p = n(),
        f = S(t);
    return f.reset = function() {
        var t = f.direction,
            e = f.loop;
        for (f.currentTime = 0, f.progress = 0, f.paused = !0, f.began = !1, f.completed = !1, f.reversed = "reverse" === t, f.remaining = "alternate" === t && 1 === e ? 2 : e, r(0), t = f.children.length; t--;) f.children[t].reset()
    }, f.tick = function(t) {
        l = t, u || (u = l), a((d + l - u) * T.speed)
    }, f.seek = function(t) {
        a(i(t))
    }, f.pause = function() {
        var t = M.indexOf(f); - 1 < t && M.splice(t, 1), f.paused = !0
    }, f.play = function() {
        f.paused && (f.paused = !1, u = 0, d = i(f.currentTime), M.push(f), L || j())
    }, f.reverse = function() {
        f.reversed = !f.reversed, u = 0, d = i(f.currentTime)
    }, f.restart = function() {
        f.pause(), f.reset(), f.play()
    }, f.finished = p, f.reset(), f.autoplay && f.play(), f
}
var k, C = {
        update: void 0,
        begin: void 0,
        run: void 0,
        complete: void 0,
        loop: 1,
        direction: "normal",
        autoplay: !0,
        offset: 0
    },
    E = {
        duration: 1e3,
        delay: 0,
        easing: "easeOutElastic",
        elasticity: 500,
        round: 0
    },
    A = "translateX translateY translateZ rotate rotateX rotateY rotateZ scale scaleX scaleY scaleZ skewX skewY perspective".split(" "),
    D = {
        arr: function(t) {
            return Array.isArray(t)
        },
        obj: function(t) {
            return -1 < Object.prototype.toString.call(t).indexOf("Object")
        },
        pth: function(t) {
            return D.obj(t) && t.hasOwnProperty("totalLength")
        },
        svg: function(t) {
            return t instanceof SVGElement
        },
        dom: function(t) {
            return t.nodeType || D.svg(t)
        },
        str: function(t) {
            return "string" == typeof t
        },
        fnc: function(t) {
            return "function" == typeof t
        },
        und: function(t) {
            return void 0 === t
        },
        hex: function(t) {
            return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(t)
        },
        rgb: function(t) {
            return /^rgb/.test(t)
        },
        hsl: function(t) {
            return /^hsl/.test(t)
        },
        col: function(t) {
            return D.hex(t) || D.rgb(t) || D.hsl(t)
        }
    },
    P = function() {
        function t(t, e, n) {
            return (((1 - 3 * n + 3 * e) * t + (3 * n - 6 * e)) * t + 3 * e) * t
        }
        return function(e, n, i, r) {
            if (0 <= e && e <= 1 && 0 <= i && i <= 1) {
                var o = new Float32Array(11);
                if (e !== n || i !== r)
                    for (var s = 0; s < 11; ++s) o[s] = t(.1 * s, e, i);
                return function(s) {
                    if (e === n && i === r) return s;
                    if (0 === s) return 0;
                    if (1 === s) return 1;
                    for (var a = 0, l = 1; 10 !== l && o[l] <= s; ++l) a += .1;
                    l = a + (s - o[--l]) / (o[l + 1] - o[l]) * .1;
                    var u = 3 * (1 - 3 * i + 3 * e) * l * l + 2 * (3 * i - 6 * e) * l + 3 * e;
                    if (.001 <= u) {
                        for (a = 0; a < 4 && 0 != (u = 3 * (1 - 3 * i + 3 * e) * l * l + 2 * (3 * i - 6 * e) * l + 3 * e); ++a) {
                            var c = t(l, e, i) - s;
                            l -= c / u
                        }
                        s = l
                    } else if (0 === u) s = l;
                    else {
                        l = a, a += .1;
                        for (var d = 0; 0 < (u = t(c = l + (a - l) / 2, e, i) - s) ? a = c : l = c, 1e-7 < Math.abs(u) && ++d < 10;);
                        s = c
                    }
                    return t(s, n, r)
                }
            }
        }
    }(),
    O = function() {
        function t(t, e) {
            return 0 === t || 1 === t ? t : -Math.pow(2, 10 * (t - 1)) * Math.sin(2 * (t - 1 - e / (2 * Math.PI) * Math.asin(1)) * Math.PI / e)
        }
        var e, n = "Quad Cubic Quart Quint Sine Expo Circ Back Elastic".split(" "),
            i = {
                In: [
                    [.55, .085, .68, .53],
                    [.55, .055, .675, .19],
                    [.895, .03, .685, .22],
                    [.755, .05, .855, .06],
                    [.47, 0, .745, .715],
                    [.95, .05, .795, .035],
                    [.6, .04, .98, .335],
                    [.6, -.28, .735, .045], t
                ],
                Out: [
                    [.25, .46, .45, .94],
                    [.215, .61, .355, 1],
                    [.165, .84, .44, 1],
                    [.23, 1, .32, 1],
                    [.39, .575, .565, 1],
                    [.19, 1, .22, 1],
                    [.075, .82, .165, 1],
                    [.175, .885, .32, 1.275],
                    function(e, n) {
                        return 1 - t(1 - e, n)
                    }
                ],
                InOut: [
                    [.455, .03, .515, .955],
                    [.645, .045, .355, 1],
                    [.77, 0, .175, 1],
                    [.86, 0, .07, 1],
                    [.445, .05, .55, .95],
                    [1, 0, 0, 1],
                    [.785, .135, .15, .86],
                    [.68, -.55, .265, 1.55],
                    function(e, n) {
                        return e < .5 ? t(2 * e, n) / 2 : 1 - t(-2 * e + 2, n) / 2
                    }
                ]
            },
            r = {
                linear: P(.25, .25, .75, .75)
            },
            o = {};
        for (e in i) o.type = e, i[o.type].forEach(function(t) {
            return function(e, i) {
                r["ease" + t.type + n[i]] = D.fnc(e) ? e : P.apply($jscomp$this, e)
            }
        }(o)), o = {
            type: o.type
        };
        return r
    }(),
    I = {
        css: function(t, e, n) {
            return t.style[e] = n
        },
        attribute: function(t, e, n) {
            return t.setAttribute(e, n)
        },
        object: function(t, e, n) {
            return t[e] = n
        },
        transform: function(t, e, n, i, r) {
            i[r] || (i[r] = []), i[r].push(e + "(" + n + ")")
        }
    },
    M = [],
    L = 0,
    j = function() {
        function t() {
            L = requestAnimationFrame(e)
        }

        function e(e) {
            var n = M.length;
            if (n) {
                for (var i = 0; i < n;) M[i] && M[i].tick(e), i++;
                t()
            } else cancelAnimationFrame(L), L = 0
        }
        return t
    }();
return T.version = "2.2.0", T.speed = 1, T.running = M, T.remove = function(t) {
    t = _(t);
    for (var e = M.length; e--;)
        for (var n = M[e], i = n.animations, o = i.length; o--;) r(t, i[o].animatable.target) && (i.splice(o, 1), i.length || n.pause())
}, T.getValue = h, T.path = function(e, n) {
    var i = D.str(e) ? t(e)[0] : e,
        r = n || 100;
    return function(t) {
        return {
            el: i,
            property: t,
            totalLength: g(i) * (r / 100)
        }
    }
}, T.setDashoffset = function(t) {
    var e = g(t);
    return t.setAttribute("stroke-dasharray", e), e
}, T.bezier = P, T.easings = O, T.timeline = function(t) {
    var e = T(t);
    return e.pause(), e.duration = 0, e.add = function(n) {
        return e.children.forEach(function(t) {
            t.began = !0, t.completed = !0
        }), i(n).forEach(function(n) {
            var i = a(n, s(E, t || {}));
            i.targets = i.targets || t.targets, n = e.duration;
            var r = i.offset;
            i.autoplay = !1, i.direction = e.direction, i.offset = D.und(r) ? n : p(r, n), e.began = !0, e.completed = !0, e.seek(i.offset), (i = T(i)).began = !0, i.completed = !0, i.duration > n && (e.duration = i.duration), e.children.push(i)
        }), e.seek(0), e.reset(), e.autoplay && e.restart(), e
    }, e
}, T.random = function(t, e) {
    return Math.floor(Math.random() * (e - t + 1)) + t
}, T
}),
function(t) {
t.fn.roarmenu = function(e) {
    var n = t.extend({}, {
        navbar: {
            add: !0,
            close: !1,
            title: "Menu",
            titleLink: "parent"
        },
        openingInterval: 25,
        panelNodetype: "ul, ol, div",
        panel2Nodetype: ".drilldown",
        transitionDuration: 400
    }, e);
    return this.$pnls = null, (this.$menu = this).conf = n, this.uniqueId = 0, this.support = {
        touch: "ontouchstart" in window || navigator.msMaxTouchPoints || !1,
        csstransitions: "undefined" == typeof Modernizr || void 0 === Modernizr.csstransitions || Modernizr.csstransitions
    }, this.run = function() {
        return this._initMenu(), this._initPanels(), this._initAnchors(), this
    }, this._initMenu = function() {
        this.$menu.attr("id", this.$menu.attr("id") || this.__getUniqueId()), this.$pnls = t('<div class="panels" />').append(this.$menu.children(this.conf.panelNodetype)).prependTo(this.$menu), this.$menu.addClass("mm-menu")
    }, this._initPanels = function() {
        var e = this.$pnls.children(this.conf.panelNodetype),
            n = this,
            i = function(e) {
                e.filter(n.conf.panelNodetype).each(function() {
                    var e = n._initPanel(t(this));
                    if (e) {
                        n._initNavbar(e), n._initListview(e, "ul, ol");
                        var r = e.children(".listview").children("li").children(n.conf.panelNodetype).add(e.children(".panel"));
                        if (r.length) i(r);
                        else {
                            var o = e.find(n.conf.panel2Nodetype);
                            o.length && o.filter(n.conf.panel2Nodetype).each(function() {
                                var e = n._initPanel(t(this));
                                e && (n._initNavbar(e), n._initListview(e, ".drilldown"))
                            })
                        }
                    }
                })
            };
        i(e)
    }, this._initPanel = function(t) {
        if (t.hasClass("panel")) return t;
        if (t.hasClass("nopanel")) return !1;
        var e = t.attr("id") || this.__getUniqueId();
        t.is("ul, ol") && (t.removeAttr("id"), t.wrap("<div />"), t = t.parent()), t.attr("id", e), t.addClass("panel"), 2 == this.uniqueId ? t.addClass("panel_opened") : t.addClass("hidden");
        var n = t.parent("li");
        return t.appendTo(this.$pnls), n.length && (n.data("child", t).addClass("listitem"), t.data("parent", n)), t
    }, this._initNavbar = function(e) {
        if (!e.children(".navbar").length) {
            var n = e.data("parent"),
                i = t('<div class="navbar" />'),
                r = this.conf.navbar.title,
                o = "";
            if (n && n.length) {
                var s = n.closest(".panel").find('a[href="#' + e.attr("id") + '"]');
                (n.parent().is(".listview") || "mm-0" != e.attr("id")) && (s = n.children("a, span").not(".btn_next"));
                var a = (n = (s = s.first()).closest(".panel")).attr("id");
                switch (r = t("<span>" + s.html() + "</span>").html(), this.conf.navbar.titleLink) {
                    case "anchor":
                        o = s.attr("href");
                        break;
                    case "parent":
                        o = "#" + a
                }
                i.append('<a class="btn_prev navbar__btn" href="#' + a + '" />'), e.children().addClass("listview")
            } else if (!this.conf.navbar.title) return;
            this.conf.navbar.add && (e.addClass("panel_has-navbar"), i.append('<a class="navbar__title" href="' + (o.length ? o : "#mm-0") + '">' + r + "</a>"), this.conf.navbar.close && i.append('<a class="navbar__close ' + this.conf.navbar.close + '" href="#"><span class="close-icon"></span></a>'), i.prependTo(e))
        }
    }, this._initListview = function(e, n) {
        this.__childAddBack(e, n).addClass("listview").children().addClass("listitem").children("a, span").not(".mm-btn").addClass("listitem__text");
        var i = e.data("parent");
        if (i && i.is(".listitem") && !i.children(".mm-btn").length) {
            var r = i.children("a, span").first(),
                o = t('<a class="mm-btn btn_next listitem__btn" href="#' + e.attr("id") + '" />');
            o.insertAfter(r), r.is("a") && (t('<span class="' + r.attr("class") + '"/>').removeClass("listitem__text").html(r.html()).insertAfter(o), r.remove())
        }
    }, this._initAnchors = function() {
        var e = this;
        e.on("click", "a[href]", function(n) {
            var i = t(this),
                r = i.attr("href"),
                o = e.$menu.find(i).length;
            if (i.is(".listitem > a"), i.is('[rel="external"]') || i.is('[target="_blank"]'), o && 1 < r.length && "#" == r.slice(0, 1)) try {
                var s = e.$menu.find(r);
                if (s.is(".panel")) return e.openPanel(s), void n.preventDefault()
            } catch (n) {}
        })
    }, this.openPanel = function(t, e) {
        if (t && t.length && (t.is(".panel") || (t = t.closest(".panel")), t.is(".panel"))) {
            var n = this;
            if (t.hasClass("panel_opened")) return;
            var i = n.$pnls.children(".panel"),
                r = n.$pnls.children(".panel_opened");
            if (!n.support.csstransitions) return r.addClass("hidden").removeClass("panel_opened"), void t.removeClass("hidden").addClass("panel_opened");
            i.not(t).removeClass("panel_opened-parent");
            for (var o = t.data("parent"); o;)(o = o.closest(".panel")).parent(".listitem_vertical").length || o.addClass("panel_opened-parent"), o = o.data("parent");
            i.removeClass("panel_highest").not(r).not(t).addClass("hidden"), t.removeClass("hidden");
            var s = function() {
                    r.removeClass("panel_opened"), t.addClass("panel_opened"), t.hasClass("panel_opened-parent") ? (r.addClass("panel_highest"), t.removeClass("panel_opened-parent")) : (r.addClass("panel_opened-parent"), t.addClass("panel_highest"))
                },
                a = function() {
                    r.removeClass("panel_highest").addClass("hidden"), t.removeClass("panel_highest")
                };
            e && !t.hasClass("panel_noanimation") ? setTimeout(function() {
                n.__transitionend(t, function() {
                    a()
                }, n.conf.transitionDuration), s()
            }, n.conf.openingInterval) : (s(), a())
        }
    }, this.__transitionend = function(t, e, n) {
        var i = !1,
            r = function(n) {
                void 0 !== n && n.target != t[0] || (i || (t.off("transitionend"), t.off("webkitTransitionEnd"), e.call(t[0])), i = !0)
            };
        t.on("transitionend", r), t.on("webkitTransitionEnd", r), setTimeout(r, 1.1 * n)
    }, this.__getUniqueId = function() {
        return "mm-" + this.uniqueId++
    }, this.__childAddBack = function(t, e) {
        return t.children(e).add(t.filter(e))
    }, this.run()
}
}(jQuery);
var ParallaxScroll = {
    showLogs: !1,
    round: 1e3,
    init: function() {
        if (this._log("init"), this._inited) return this._log("Already Inited"), void(this._inited = !0);
        this._requestAnimationFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function(t, e) {
            window.setTimeout(t, 1e3 / 60)
        }, this._onScroll(!0)
    },
    _inited: !1,
    _properties: ["x", "y", "z", "rotateX", "rotateY", "rotateZ", "scaleX", "scaleY", "scaleZ", "scale", "opacity"],
    _requestAnimationFrame: null,
    _log: function(t) {
        this.showLogs && console.log("Parallax Scroll / " + t)
    },
    _onScroll: function(t) {
        var e = jQuery(document).scrollTop(),
            n = jQuery(window).height();
        this._log("onScroll " + e), jQuery("[data-parallax]").each(jQuery.proxy(function(i, r) {
            var o = jQuery(r),
                s = [],
                a = !1,
                l = o.data("style");
            null == l && (l = o.attr("style") || "", o.data("style", l));
            var u, c = [o.data("parallax")];
            for (u = 2; o.data("parallax" + u); u++) c.push(o.data("parallax-" + u));
            var d = c.length;
            for (u = 0; u < d; u++) {
                var h = c[u],
                    p = h["from-scroll"];
                null == p && (p = Math.max(0, jQuery(r).offset().top - n)), p |= 0;
                var f = h.distance,
                    m = h["to-scroll"];
                null == f && null == m && (f = n), f = Math.max(0 | f, 1);
                var g = h.easing,
                    y = h["easing-return"];
                if (null != g && jQuery.easing && jQuery.easing[g] || (g = null), null != y && jQuery.easing && jQuery.easing[y] || (y = g), g) {
                    var v = h.duration;
                    null == v && (v = f), v = Math.max(0 | v, 1);
                    var _ = h["duration-return"];
                    null == _ && (_ = v), f = 1;
                    var b = o.data("current-time");
                    null == b && (b = 0)
                }
                null == m && (m = p + f), m |= 0;
                var w = h.smoothness;
                null == w && (w = 30), w |= 0, (t || 0 == w) && (w = 1), w |= 0;
                var x = e;
                x = Math.max(x, p), x = Math.min(x, m), g && (null == o.data("sens") && o.data("sens", "back"), p < x && ("back" == o.data("sens") ? (b = 1, o.data("sens", "go")) : b++), x < m && ("go" == o.data("sens") ? (b = 1, o.data("sens", "back")) : b++), t && (b = v), o.data("current-time", b)), this._properties.map(jQuery.proxy(function(t) {
                    var e = 0,
                        n = h[t];
                    if (null != n) {
                        "scale" == t || "scaleX" == t || "scaleY" == t || "scaleZ" == t ? e = 1 : n |= 0;
                        var i = o.data("_" + t);
                        null == i && (i = e);
                        var r = (x - p) / (m - p) * (n - e) + e,
                            l = i + (r - i) / w;
                        if (g && 0 < b && b <= v) {
                            var u = e;
                            "back" == o.data("sens") && (n = -(u = n), g = y, v = _), l = jQuery.easing[g](null, b, u, n, v)
                        }(l = Math.ceil(l * this.round) / this.round) == i && r == n && (l = n), s[t] || (s[t] = 0), s[t] += l, i != s[t] && (o.data("_" + t, s[t]), a = !0)
                    }
                }, this))
            }
            if (a) {
                if (null != s.z) {
                    var S = h.perspective;
                    null == S && (S = 800);
                    var T = o.parent();
                    T.data("style") || T.data("style", T.attr("style") || ""), T.attr("style", "perspective:" + S + "px; -webkit-perspective:" + S + "px; " + T.data("style"))
                }
                null == s.scaleX && (s.scaleX = 1), null == s.scaleY && (s.scaleY = 1), null == s.scaleZ && (s.scaleZ = 1), null != s.scale && (s.scaleX *= s.scale, s.scaleY *= s.scale, s.scaleZ *= s.scale);
                var k;
                k = 1 == h.opacity ? "opacity:1" : "";
                var C = "translate3d(" + (s.x ? s.x : 0) + "px, " + (s.y ? s.y : 0) + "px, " + (s.z ? s.z : 0) + "px) rotateX(" + (s.rotateX ? s.rotateX : 0) + "deg) rotateY(" + (s.rotateY ? s.rotateY : 0) + "deg) rotateZ(" + (s.rotateZ ? s.rotateZ : 0) + "deg) scaleX(" + s.scaleX + ") scaleY(" + s.scaleY + ") scaleZ(" + s.scaleZ + ");";
                this._log(C), o.attr("style", "transform:" + C + " -webkit-transform:" + C + " " + l + k)
            }
        }, this)), window.requestAnimationFrame ? window.requestAnimationFrame(jQuery.proxy(this._onScroll, this, !1)) : this._requestAnimationFrame(jQuery.proxy(this._onScroll, this, !1))
    }
},
ScrollReveal = function() {
    "use strict";
    var t = {
            delay: 0,
            distance: "0",
            duration: 600,
            easing: "cubic-bezier(0.5, 0, 0, 1)",
            interval: 0,
            opacity: 0,
            origin: "bottom",
            rotate: {
                x: 0,
                y: 0,
                z: 0
            },
            scale: 1,
            cleanup: !0,
            container: document.documentElement,
            desktop: !0,
            mobile: !0,
            reset: !1,
            useDelay: "always",
            viewFactor: 0,
            viewOffset: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            },
            afterReset: function() {},
            afterReveal: function() {},
            beforeReset: function() {},
            beforeReveal: function() {}
        },
        e = {
            clean: function() {},
            destroy: function() {},
            reveal: function() {},
            sync: function() {},
            get noop() {
                return !0
            }
        };

    function n(t) {
        return "object" == typeof window.Node ? t instanceof window.Node : null !== t && "object" == typeof t && "number" == typeof t.nodeType && "string" == typeof t.nodeName
    }

    function i(t, e) {
        if (void 0 === e && (e = document), t instanceof Array) return t.filter(n);
        if (n(t)) return [t];
        if (i = t, r = Object.prototype.toString.call(i), "object" == typeof window.NodeList ? i instanceof window.NodeList : null !== i && "object" == typeof i && "number" == typeof i.length && /^\[object (HTMLCollection|NodeList|Object)\]$/.test(r) && (0 === i.length || n(i[0]))) return Array.prototype.slice.call(t);
        var i, r;
        if ("string" == typeof t) try {
            var o = e.querySelectorAll(t);
            return Array.prototype.slice.call(o)
        } catch (t) {
            return []
        }
        return []
    }

    function r(t) {
        return null !== t && t instanceof Object && (t.constructor === Object || "[object Object]" === Object.prototype.toString.call(t))
    }

    function o(t, e) {
        if (r(t)) return Object.keys(t).forEach(function(n) {
            return e(t[n], n, t)
        });
        if (t instanceof Array) return t.forEach(function(n, i) {
            return e(n, i, t)
        });
        throw new TypeError("Expected either an array or object literal.")
    }

    function s(t) {
        for (var e = [], n = arguments.length - 1; 0 < n--;) e[n] = arguments[n + 1];
        if (this.constructor.debug && console) {
            var i = "%cScrollReveal: " + t;
            e.forEach(function(t) {
                return i += "\n — " + t
            }), console.log(i, "color: #ea654b;")
        }
    }

    function a() {
        var t = this,
            e = {
                active: [],
                stale: []
            },
            n = {
                active: [],
                stale: []
            },
            r = {
                active: [],
                stale: []
            };
        try {
            o(i("[data-sr-id]"), function(t) {
                var n = parseInt(t.getAttribute("data-sr-id"));
                e.active.push(n)
            })
        } catch (t) {
            throw t
        }
        o(this.store.elements, function(t) {
            -1 === e.active.indexOf(t.id) && e.stale.push(t.id)
        }), o(e.stale, function(e) {
            return delete t.store.elements[e]
        }), o(this.store.elements, function(t) {
            -1 === r.active.indexOf(t.containerId) && r.active.push(t.containerId), t.hasOwnProperty("sequence") && -1 === n.active.indexOf(t.sequence.id) && n.active.push(t.sequence.id)
        }), o(this.store.containers, function(t) {
            -1 === r.active.indexOf(t.id) && r.stale.push(t.id)
        }), o(r.stale, function(e) {
            var n = t.store.containers[e].node;
            n.removeEventListener("scroll", t.delegate), n.removeEventListener("resize", t.delegate), delete t.store.containers[e]
        }), o(this.store.sequences, function(t) {
            -1 === n.active.indexOf(t.id) && n.stale.push(t.id)
        }), o(n.stale, function(e) {
            return delete t.store.sequences[e]
        })
    }

    function l(t) {
        var e, n = this;
        try {
            o(i(t), function(t) {
                var i = t.getAttribute("data-sr-id");
                if (null !== i) {
                    e = !0;
                    var r = n.store.elements[i];
                    r.callbackTimer && window.clearTimeout(r.callbackTimer.clock), t.setAttribute("style", r.styles.inline.generated), t.removeAttribute("data-sr-id"), delete n.store.elements[i]
                }
            })
        } catch (t) {
            return s.call(this, "Clean failed.", t.message)
        }
        if (e) try {
            a.call(this)
        } catch (t) {
            return s.call(this, "Clean failed.", t.message)
        }
    }

    function u(t) {
        if (t.constructor !== Array) throw new TypeError("Expected array.");
        if (16 === t.length) return t;
        if (6 === t.length) {
            var e = c();
            return e[0] = t[0], e[1] = t[1], e[4] = t[2], e[5] = t[3], e[12] = t[4], e[13] = t[5], e
        }
        throw new RangeError("Expected array with either 6 or 16 values.")
    }

    function c() {
        for (var t = [], e = 0; e < 16; e++) e % 5 == 0 ? t.push(1) : t.push(0);
        return t
    }

    function d(t, e) {
        for (var n = u(t), i = u(e), r = [], o = 0; o < 4; o++)
            for (var s = [n[o], n[o + 4], n[o + 8], n[o + 12]], a = 0; a < 4; a++) {
                var l = 4 * a,
                    c = [i[l], i[l + 1], i[l + 2], i[l + 3]],
                    d = s[0] * c[0] + s[1] * c[1] + s[2] * c[2] + s[3] * c[3];
                r[o + l] = d
            }
        return r
    }

    function h(t, e) {
        var n = c();
        return n[0] = t, n[5] = "number" == typeof e ? e : t, n
    }
    var p = function() {
        var t = {},
            e = document.documentElement.style;

        function n(n, i) {
            if (void 0 === i && (i = e), n && "string" == typeof n) {
                if (t[n]) return t[n];
                if ("string" == typeof i[n]) return t[n] = n;
                if ("string" == typeof i["-webkit-" + n]) return t[n] = "-webkit-" + n;
                throw new RangeError('Unable to find "' + n + '" style property.')
            }
            throw new TypeError("Expected a string.")
        }
        return n.clearCache = function() {
            return t = {}
        }, n
    }();

    function f(t, e) {
        void 0 === e && (e = {});
        var n = e.pristine || this.pristine,
            i = "always" === t.config.useDelay || "onload" === t.config.useDelay && n || "once" === t.config.useDelay && !t.seen,
            r = t.visible && !t.revealed,
            o = !t.visible && t.revealed && t.config.reset;
        return e.reveal || r ? function(t, e) {
            var n = [t.styles.inline.generated, t.styles.opacity.computed, t.styles.transform.generated.final];
            e ? n.push(t.styles.transition.generated.delayed) : n.push(t.styles.transition.generated.instant), t.revealed = t.seen = !0, t.node.setAttribute("style", n.filter(function(t) {
                return "" !== t
            }).join(" ")), m.call(this, t, e)
        }.call(this, t, i) : e.reset || o ? function(t) {
            var e = [t.styles.inline.generated, t.styles.opacity.generated, t.styles.transform.generated.initial, t.styles.transition.generated.instant];
            t.revealed = !1, t.node.setAttribute("style", e.filter(function(t) {
                return "" !== t
            }).join(" ")), m.call(this, t)
        }.call(this, t) : void 0
    }

    function m(t, e) {
        var n = this,
            i = e ? t.config.duration + t.config.delay : t.config.duration,
            r = t.revealed ? t.config.beforeReveal : t.config.beforeReset,
            o = t.revealed ? t.config.afterReveal : t.config.afterReset,
            s = 0;
        t.callbackTimer && (s = Date.now() - t.callbackTimer.start, window.clearTimeout(t.callbackTimer.clock)), r(t.node), t.callbackTimer = {
            start: Date.now(),
            clock: window.setTimeout(function() {
                o(t.node), t.callbackTimer = null, t.revealed && !t.config.reset && t.config.cleanup && l.call(n, t.node)
            }, i - s)
        }
    }
    var g, y = (g = 0, function() {
        return g++
    });

    function v(t, e) {
        if (void 0 === e && (e = this.pristine), !t.visible && t.revealed && t.config.reset) return f.call(this, t, {
            reset: !0
        });
        var n = this.store.sequences[t.sequence.id],
            i = t.sequence.index;
        if (n) {
            var r = new b(n, "visible", this.store),
                o = new b(n, "revealed", this.store);
            if (n.models = {
                    visible: r,
                    revealed: o
                }, !o.body.length) {
                var s = n.members[r.body[0]],
                    a = this.store.elements[s];
                if (a) return w.call(this, n, r.body[0], -1, e), w.call(this, n, r.body[0], 1, e), f.call(this, a, {
                    reveal: !0,
                    pristine: e
                })
            }
            if (!n.blocked.head && i === [].concat(o.head).pop() && i >= [].concat(r.body).shift()) return w.call(this, n, i, -1, e), f.call(this, t, {
                reveal: !0,
                pristine: e
            });
            if (!n.blocked.foot && i === [].concat(o.foot).shift() && i <= [].concat(r.body).pop()) return w.call(this, n, i, 1, e), f.call(this, t, {
                reveal: !0,
                pristine: e
            })
        }
    }

    function _(t) {
        var e = Math.abs(t);
        if (isNaN(e)) throw new RangeError("Invalid sequence interval.");
        this.id = y(), this.interval = Math.max(e, 16), this.members = [], this.models = {}, this.blocked = {
            head: !1,
            foot: !1
        }
    }

    function b(t, e, n) {
        var i = this;
        this.head = [], this.body = [], this.foot = [], o(t.members, function(t, r) {
            var o = n.elements[t];
            o && o[e] && i.body.push(r)
        }), this.body.length && o(t.members, function(t, r) {
            var o = n.elements[t];
            o && !o[e] && (r < i.body[0] ? i.head.push(r) : i.foot.push(r))
        })
    }

    function w(t, e, n, i) {
        var r = this,
            o = ["head", null, "foot"][1 + n],
            s = t.members[e + n],
            a = this.store.elements[s];
        t.blocked[o] = !0, setTimeout(function() {
            t.blocked[o] = !1, a && v.call(r, a, i)
        }, t.interval)
    }

    function x() {
        var t = this;
        a.call(this), o(this.store.elements, function(t) {
            var e = [t.styles.inline.generated];
            t.visible ? (e.push(t.styles.opacity.computed), e.push(t.styles.transform.generated.final)) : (e.push(t.styles.opacity.generated), e.push(t.styles.transform.generated.initial)), t.node.setAttribute("style", e.filter(function(t) {
                return "" !== t
            }).join(" "))
        }), o(this.store.containers, function(e) {
            var n = e.node === document.documentElement ? window : e.node;
            n.addEventListener("scroll", t.delegate), n.addEventListener("resize", t.delegate)
        }), this.delegate(), this.initTimeout = null
    }

    function S(t) {
        return void 0 === t && (t = navigator.userAgent), /Android|iPhone|iPad|iPod/i.test(t)
    }

    function T(t) {
        for (var e = [], n = arguments.length - 1; 0 < n--;) e[n] = arguments[n + 1];
        if (r(t)) return o(e, function(e) {
            o(e, function(e, n) {
                r(e) ? (t[n] && r(t[n]) || (t[n] = {}), T(t[n], e)) : t[n] = e
            })
        }), t;
        throw new TypeError("Target must be an object literal.")
    }

    function k(e, n, r) {
        var a = this;
        void 0 === n && (n = {}), void 0 === r && (r = !1);
        var f, m = [],
            g = n.interval || t.interval;
        try {
            g && (f = new _(g));
            var v = i(e);
            if (!v.length) throw new Error("Invalid reveal target.");
            o(v.reduce(function(t, e) {
                var r = {},
                    s = e.getAttribute("data-sr-id");
                s ? (T(r, a.store.elements[s]), r.node.setAttribute("style", r.styles.inline.computed)) : (r.id = y(), r.node = e, r.seen = !1, r.revealed = !1, r.visible = !1);
                var g = T({}, r.config || a.defaults, n);
                if (!g.mobile && S() || !g.desktop && !S()) return s && l.call(a, r), t;
                var v, _ = i(g.container)[0];
                if (!_) throw new Error("Invalid container.");
                return _.contains(e) && (null === (v = function(t) {
                    for (var e = [], n = arguments.length - 1; 0 < n--;) e[n] = arguments[n + 1];
                    var i = null;
                    return o(e, function(e) {
                        o(e, function(e) {
                            null === i && e.node === t && (i = e.id)
                        })
                    }), i
                }(_, m, a.store.containers)) && (v = y(), m.push({
                    id: v,
                    node: _
                })), r.config = g, r.containerId = v, r.styles = function(t) {
                    var e = window.getComputedStyle(t.node),
                        n = e.position,
                        i = t.config,
                        r = {},
                        o = (t.node.getAttribute("style") || "").match(/[\w-]+\s*:\s*[^;]+\s*/gi) || [];
                    r.computed = o ? o.map(function(t) {
                        return t.trim()
                    }).join("; ") + ";" : "", r.generated = o.some(function(t) {
                        return t.match(/visibility\s?:\s?visible/i)
                    }) ? r.computed : o.concat(["visibility: visible"]).map(function(t) {
                        return t.trim()
                    }).join("; ") + ";";
                    var s, a, l, f, m, g, y, v, _, b, w, x, S, T = parseFloat(e.opacity),
                        k = isNaN(parseFloat(i.opacity)) ? parseFloat(e.opacity) : parseFloat(i.opacity),
                        C = {
                            computed: T !== k ? "opacity: " + T + ";" : "",
                            generated: T !== k ? "opacity: " + k + ";" : ""
                        },
                        E = [];
                    if (parseFloat(i.distance)) {
                        var A = "top" === i.origin || "bottom" === i.origin ? "Y" : "X",
                            D = i.distance;
                        "top" !== i.origin && "left" !== i.origin || (D = /^-/.test(D) ? D.substr(1) : "-" + D);
                        var P = D.match(/(^-?\d+\.?\d?)|(em$|px$|%$)/g),
                            O = P[0];
                        switch (P[1]) {
                            case "em":
                                D = parseInt(e.fontSize) * O;
                                break;
                            case "px":
                                D = O;
                                break;
                            case "%":
                                D = "Y" === A ? t.node.getBoundingClientRect().height * O / 100 : t.node.getBoundingClientRect().width * O / 100;
                                break;
                            default:
                                throw new RangeError("Unrecognized or missing distance unit.")
                        }
                        "Y" === A ? E.push((l = D, (f = c())[13] = l, f)) : E.push((s = D, (a = c())[12] = s, a))
                    }
                    i.rotate.x && E.push((m = i.rotate.x, g = Math.PI / 180 * m, (y = c())[5] = y[10] = Math.cos(g), y[6] = y[9] = Math.sin(g), y[9] *= -1, y)), i.rotate.y && E.push((v = i.rotate.y, _ = Math.PI / 180 * v, (b = c())[0] = b[10] = Math.cos(_), b[2] = b[8] = Math.sin(_), b[2] *= -1, b)), i.rotate.z && E.push((w = i.rotate.z, x = Math.PI / 180 * w, (S = c())[0] = S[5] = Math.cos(x), S[1] = S[4] = Math.sin(x), S[4] *= -1, S)), 1 !== i.scale && (0 === i.scale ? E.push(h(2e-4)) : E.push(h(i.scale)));
                    var I = {};
                    if (E.length) {
                        I.property = p("transform"), I.computed = {
                            raw: e[I.property],
                            matrix: function(t) {
                                if ("string" == typeof t) {
                                    var e = t.match(/matrix(3d)?\(([^)]+)\)/);
                                    if (e) return u(e[2].split(", ").map(parseFloat))
                                }
                                return c()
                            }(e[I.property])
                        }, E.unshift(I.computed.matrix);
                        var M = E.reduce(d);
                        I.generated = {
                            initial: I.property + ": matrix3d(" + M.join(", ") + ");",
                            final: I.property + ": matrix3d(" + I.computed.matrix.join(", ") + ");"
                        }
                    } else I.generated = {
                        initial: "",
                        final: ""
                    };
                    var L = {};
                    if (C.generated || I.generated.initial) {
                        L.property = p("transition"), L.computed = e[L.property], L.fragments = [];
                        var j = i.delay,
                            N = i.duration,
                            $ = i.easing;
                        C.generated && L.fragments.push({
                            delayed: "opacity " + N / 1e3 + "s " + $ + " " + j / 1e3 + "s",
                            instant: "opacity " + N / 1e3 + "s " + $ + " 0s"
                        }), I.generated.initial && L.fragments.push({
                            delayed: I.property + " " + N / 1e3 + "s " + $ + " " + j / 1e3 + "s",
                            instant: I.property + " " + N / 1e3 + "s " + $ + " 0s"
                        }), L.computed && !L.computed.match(/all 0s/) && L.fragments.unshift({
                            delayed: L.computed,
                            instant: L.computed
                        });
                        var z = L.fragments.reduce(function(t, e, n) {
                            return t.delayed += 0 === n ? e.delayed : ", " + e.delayed, t.instant += 0 === n ? e.instant : ", " + e.instant, t
                        }, {
                            delayed: "",
                            instant: ""
                        });
                        L.generated = {
                            delayed: L.property + ": " + z.delayed + ";",
                            instant: L.property + ": " + z.instant + ";"
                        }
                    } else L.generated = {
                        delayed: "",
                        instant: ""
                    };
                    return {
                        inline: r,
                        opacity: C,
                        position: n,
                        transform: I,
                        transition: L
                    }
                }(r), f && (r.sequence = {
                    id: f.id,
                    index: f.members.length
                }, f.members.push(r.id)), t.push(r)), t
            }, []), function(t) {
                (a.store.elements[t.id] = t).node.setAttribute("data-sr-id", t.id)
            })
        } catch (e) {
            return s.call(this, "Reveal failed.", e.message)
        }
        o(m, function(t) {
            a.store.containers[t.id] = {
                id: t.id,
                node: t.node
            }
        }), f && (this.store.sequences[f.id] = f), !0 !== r && (this.store.history.push({
            target: e,
            options: n
        }), this.initTimeout && window.clearTimeout(this.initTimeout), this.initTimeout = window.setTimeout(x.bind(this), 0))
    }
    var C, E = Math.sign || function(t) {
            return (0 < t) - (t < 0) || +t
        },
        A = (C = Date.now(), function(t) {
            var e = Date.now();
            16 < e - C ? t(C = e) : setTimeout(function() {
                return A(t)
            }, 0)
        }),
        D = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || A;

    function P(t, e) {
        for (var n = e ? t.node.clientHeight : t.node.offsetHeight, i = e ? t.node.clientWidth : t.node.offsetWidth, r = 0, o = 0, s = t.node; isNaN(s.offsetTop) || (r += s.offsetTop), isNaN(s.offsetLeft) || (o += s.offsetLeft), s = s.offsetParent;);
        return {
            bounds: {
                top: r,
                right: o + i,
                bottom: r + n,
                left: o
            },
            height: n,
            width: i
        }
    }
    var O, I, M, L, j, N, $, z, F = "4.0.0";

    function R(n) {
        var r;
        if (void 0 === n && (n = {}), void 0 === this || Object.getPrototypeOf(this) !== R.prototype) return new R(n);
        if (!R.isSupported()) return s.call(this, "Instantiation failed.", "This browser is not supported."), e;
        try {
            r = T({}, N || t, n)
        } catch (n) {
            return s.call(this, "Instantiation failed.", "Invalid configuration.", n.message), e
        }
        try {
            if (!i(r.container)[0]) throw new Error("Invalid container.");
            if (!r.mobile && S() || !r.desktop && !S()) throw new Error("This device is disabled.")
        } catch (n) {
            return s.call(this, "Instantiation failed.", n.message), e
        }
        return N = r, document.documentElement.classList.add("sr"), document.body ? document.body.style.height = "100%" : document.addEventListener("DOMContentLoaded", function() {
            document.body.style.height = "100%"
        }), this.store = {
            containers: {},
            elements: {},
            history: [],
            sequences: {}
        }, this.pristine = !0, O = O || function(t, e) {
            var n = this;
            void 0 === t && (t = {
                type: "init"
            }), void 0 === e && (e = this.store.elements), D(function() {
                var i = "init" === t.type || "resize" === t.type;
                o(n.store.containers, function(t) {
                    i && (t.geometry = P.call(n, t, !0));
                    var e = function(t) {
                        var e, n;
                        return t.node === document.documentElement ? (e = window.pageYOffset, n = window.pageXOffset) : (e = t.node.scrollTop, n = t.node.scrollLeft), {
                            top: e,
                            left: n
                        }
                    }.call(n, t);
                    t.scroll && (t.direction = {
                        x: E(e.left - t.scroll.left),
                        y: E(e.top - t.scroll.top)
                    }), t.scroll = e
                }), o(e, function(t) {
                    i && (t.geometry = P.call(n, t)), t.visible = function(t) {
                        void 0 === t && (t = {});
                        var e = this.store.containers[t.containerId];
                        if (e) {
                            var n = Math.max(0, Math.min(1, t.config.viewFactor)),
                                i = t.config.viewOffset,
                                r = t.geometry.bounds.top + t.geometry.height * n,
                                o = t.geometry.bounds.right - t.geometry.width * n,
                                s = t.geometry.bounds.bottom - t.geometry.height * n,
                                a = t.geometry.bounds.left + t.geometry.width * n,
                                l = e.geometry.bounds.top + e.scroll.top + i.top,
                                u = e.geometry.bounds.right + e.scroll.left - i.right,
                                c = e.geometry.bounds.bottom + e.scroll.top - i.bottom,
                                d = e.geometry.bounds.left + e.scroll.left + i.left;
                            return r < c && d < o && l < s && a < u || "fixed" === t.styles.position
                        }
                    }.call(n, t)
                }), o(e, function(t) {
                    t.sequence ? v.call(n, t) : f.call(n, t)
                }), n.pristine = !1
            })
        }.bind(this), I = I || function() {
            var t = this;
            o(this.store.elements, function(t) {
                t.node.setAttribute("style", t.styles.inline.generated), t.node.removeAttribute("data-sr-id")
            }), o(this.store.containers, function(e) {
                var n = e.node === document.documentElement ? window : e.node;
                n.removeEventListener("scroll", t.delegate), n.removeEventListener("resize", t.delegate)
            }), this.store = {
                containers: {},
                elements: {},
                history: [],
                sequences: {}
            }
        }.bind(this), M = M || k.bind(this), L = L || l.bind(this), j = j || function() {
            var t = this;
            o(this.store.history, function(e) {
                k.call(t, e.target, e.options, !0)
            }), x.call(this)
        }.bind(this), Object.defineProperty(this, "delegate", {
            get: function() {
                return O
            }
        }), Object.defineProperty(this, "destroy", {
            get: function() {
                return I
            }
        }), Object.defineProperty(this, "reveal", {
            get: function() {
                return M
            }
        }), Object.defineProperty(this, "clean", {
            get: function() {
                return L
            }
        }), Object.defineProperty(this, "sync", {
            get: function() {
                return j
            }
        }), Object.defineProperty(this, "defaults", {
            get: function() {
                return N
            }
        }), Object.defineProperty(this, "version", {
            get: function() {
                return F
            }
        }), Object.defineProperty(this, "noop", {
            get: function() {
                return !1
            }
        }), z || (z = this)
    }
    return R.isSupported = function() {
        return ("transform" in (e = document.documentElement.style) || "WebkitTransform" in e) && ("transition" in (t = document.documentElement.style) || "WebkitTransition" in t);
        var t, e
    }, Object.defineProperty(R, "debug", {
        get: function() {
            return $ || !1
        },
        set: function(t) {
            return $ = "boolean" == typeof t ? t : $
        }
    }), R(), R
}(),
_gsScope;
! function(t) {
"use strict";
t.fn.extend({
    socialShare: function(e) {
        function n(e) {
            e.blur && t("body").removeClass("blurred"), t(".arthrefSocialShare").find(".overlay").removeClass("active"), t(".arthrefSocialShare").find("ul").removeClass("active"), setTimeout(function() {
                t(".arthrefSocialShare").find(".overlay").css("display", "none"), t(".arthrefSocialShare").remove()
            }, 300)
        }
        var i = {
            social: "",
            name: "",
            title: document.title,
            shareUrl: window.location.href,
            description: t('meta[name="description"]').attr("content"),
            mediaUrl: "",
            animation: "launchpad",
            chainAnimationSpeed: 100,
            whenSelect: !1,
            selectContainer: "body",
            blur: !1
        };
        if (t("#page-wrap").hasClass("mc-dark")) var r = "sdark";
        else r = "";
        var o = '<div class="arthref arthrefSocialShare ' + r + '"><div class="overlay ' + (e = t.extend(!0, i, e)).animation + '"><div class="icon-container"><div class="centered"><div class="share-title"><h4>' + e.name + "</h4><h2>" + e.title + '</h2></div><ul class="social-icons">';
        return this.each(function() {
            var i = e,
                r = t(this);
            i.whenSelect && t(i.selectContainer).mouseup(function(t) {
                var n = function() {
                    if (window.getSelection) return window.getSelection();
                    if (document.getSelection) return document.getSelection();
                    var t = document.selection && document.selection.createRange();
                    return !!t.text && t.text
                }();
                n && (n = new String(n).replace(/^\s+|\s+$/g, "")) && (e.title = n)
            }), r.on("click", function() {
                (function() {
                    for (var n = {
                            facebook: {
                                text: "Facebook",
                                className: "facebook",
                                url: "http://www.facebook.com/sharer.php?u={u}",
                                svg: '<use x="0" y="0" xlink:href="#global__symbols-facebook"></use>',
                                da: ""
                            },
                            twitter: {
                                text: "Twitter",
                                className: "twitter",
                                url: "http://twitter.com/home?status={t}%20{u}",
                                svg: '<use x="0" y="0" xlink:href="#global__symbols-twitter"></use>',
                                da: ""
                            },
                            google: {
                                text: "Google+",
                                className: "googleplus",
                                url: "https://plus.google.com/share?url={u}",
                                svg: '<use x="0" y="0" xlink:href="#global__symbols-gplus"></use>',
                                da: ""
                            },
                            pinterest: {
                                text: "Pinterest",
                                className: "pinterest",
                                url: "http://pinterest.com/pin/create/button/?url={u}&amp;media={m}&amp;description={t}",
                                svg: '<use x="0" y="0" xlink:href="#global__symbols-pinterest"></use>',
                                da: ""
                            },
                            linkedin: {
                                text: "LinkedIn",
                                className: "linkedin",
                                url: "http://www.linkedin.com/shareArticle?mini=true&amp;url={u}&amp;title={t}&amp;ro=false&amp;summary=&amp;source=",
                                svg: '<use x="0" y="0" xlink:href="#global__symbols-linkedin"></use>',
                                da: ""
                            },
                            vkontakte: {
                                text: "VKontakte",
                                className: "vkontakte",
                                url: "http://vk.com/share.php?url={u}&amp;title={t}&amp;image={m}",
                                svg: '<use x="0" y="0" xlink:href="#global__symbols-vkontakte"></use>',
                                da: ""
                            },
                            whatsapp: {
                                text: "WhatsApp",
                                className: "whatsapp",
                                url: "whatsapp://send?text={u}",
                                svg: '<use x="0" y="0" xlink:href="#global__symbols-whatsapp"></use>',
                                da: "data-action='share/whatsapp/share'"
                            },
                            telegram: {
                                text: "Telegram",
                                className: "telegram",
                                url: "https://t.me/share/url?url={u}",
                                svg: '<use x="0" y="0" xlink:href="#global__symbols-telegram"></use>',
                                da: ""
                            },
                            blogger: {
                                text: "Blogger",
                                className: "blogger",
                                url: "http://www.blogger.com/blog_this.pyra?t=&amp;u={u}&amp;n={t}",
                                svg: '<use x="0" y="0" xlink:href="#global__symbols-blogger"></use>',
                                da: ""
                            }
                        }, i = e.social.split(","), r = "", s = 0; s <= i.length - 1; s++) n[i[s]].url = n[i[s]].url.replace("{t}", encodeURIComponent(e.title)).replace("{u}", encodeURI(e.shareUrl)).replace("{d}", encodeURIComponent(e.description)).replace("{m}", encodeURI(e.mediaUrl)), r += '<li class="' + n[i[s]].className + '"><a href="' + n[i[s]].url + '" class="social-icons__link" target="_blank" ' + n[i[s]].da + "><svg class='svg-icon' viewBox='0 0 24 24'>" + n[i[s]].svg + "</svg><span class='circle_bg'></span></a></li>";
                    t("body").append(o + r + "</ul></div></div></div></div>")
                })(), i.blur && (t(".arthrefSocialShare").find(".overlay").addClass("opaque"), t("body").addClass("blurred")), t(".arthrefSocialShare").find(".overlay").css("display", "block"), setTimeout(function() {
                    var e, n;
                    t(".arthrefSocialShare").find(".overlay").addClass("active"), t(".arthrefSocialShare").find("ul").addClass("active"), "chain" == i.animation && (e = t(".arthrefSocialShare").find("li"), n = i.chainAnimationSpeed, "1", t(e).each(function(e) {
                        t(this).delay(e * n).fadeTo(n, "1")
                    }))
                }, 0)
            }), t(document).on("click touchstart", ".arthrefSocialShare .overlay", function(t) {
                n(i)
            }), t(document).on("keydown", function(t) {
                27 == t.keyCode && n(i)
            }), t(document).on("click touchstart", ".arthrefSocialShare li", function(t) {
                t.stopPropagation()
            })
        })
    }
})
}(jQuery),
function(t, e, n) {
"use strict";
var i = function(t, e) {
    var i = this;
    this.el = t, this.options = {}, Object.keys(r).forEach(function(t) {
        i.options[t] = r[t]
    }), Object.keys(e).forEach(function(t) {
        i.options[t] = e[t]
    }), this.isInput = "input" === this.el.tagName.toLowerCase(), this.attr = this.options.attr, this.showCursor = !this.isInput && this.options.showCursor, this.elContent = this.attr ? this.el.getAttribute(this.attr) : this.el.textContent, this.contentType = this.options.contentType, this.typeSpeed = this.options.typeSpeed, this.startDelay = this.options.startDelay, this.backSpeed = this.options.backSpeed, this.backDelay = this.options.backDelay, this.fadeOut = this.options.fadeOut, this.fadeOutClass = this.options.fadeOutClass, this.fadeOutDelay = this.options.fadeOutDelay, n && this.options.stringsElement instanceof n ? this.stringsElement = this.options.stringsElement[0] : this.stringsElement = this.options.stringsElement, this.strings = this.options.strings, this.strPos = 0, this.arrayPos = 0, this.stopNum = 0, this.loop = this.options.loop, this.loopCount = this.options.loopCount, this.curLoop = 0, this.stop = !1, this.cursorChar = this.options.cursorChar, this.shuffle = this.options.shuffle, this.sequence = [], this.build()
};
i.prototype = {
    constructor: i,
    init: function() {
        var t = this;
        t.timeout = setTimeout(function() {
            for (var e = 0; e < t.strings.length; ++e) t.sequence[e] = e;
            t.shuffle && (t.sequence = t.shuffleArray(t.sequence)), t.typewrite(t.strings[t.sequence[t.arrayPos]], t.strPos)
        }, t.startDelay)
    },
    build: function() {
        var t = this;
        (!0 === this.showCursor && (this.cursor = e.createElement("span"), this.cursor.className = "typed-cursor", this.cursor.innerHTML = this.cursorChar, this.el.parentNode && this.el.parentNode.insertBefore(this.cursor, this.el.nextSibling)), this.stringsElement) && (this.strings = [], this.stringsElement.style.display = "none", Array.prototype.slice.apply(this.stringsElement.children).forEach(function(e) {
            t.strings.push(e.innerHTML)
        }));
        this.init()
    },
    typewrite: function(t, e) {
        if (!0 !== this.stop) {
            this.fadeOut && this.el.classList.contains(this.fadeOutClass) && (this.el.classList.remove(this.fadeOutClass), this.cursor.classList.remove(this.fadeOutClass));
            var n = Math.round(70 * Math.random()) + this.typeSpeed,
                i = this;
            i.timeout = setTimeout(function() {
                var n = 0,
                    r = t.substr(e);
                if ("^" === r.charAt(0)) {
                    var o = 1;
                    /^\^\d+/.test(r) && (o += (r = /\d+/.exec(r)[0]).length, n = parseInt(r)), t = t.substring(0, e) + t.substring(e + o)
                }
                if ("html" === i.contentType) {
                    var s = t.substr(e).charAt(0);
                    if ("<" === s || "&" === s) {
                        var a;
                        for (a = "<" === s ? ">" : ";"; t.substr(e + 1).charAt(0) !== a && (t.substr(e).charAt(0), !(++e + 1 > t.length)););
                        e++, a
                    }
                }
                i.timeout = setTimeout(function() {
                    if (e === t.length) {
                        if (i.options.onStringTyped(i.arrayPos), i.arrayPos === i.strings.length - 1 && (i.options.callback(), i.curLoop++, !1 === i.loop || i.curLoop === i.loopCount)) return;
                        i.timeout = setTimeout(function() {
                            i.backspace(t, e)
                        }, i.backDelay)
                    } else {
                        0 === e && i.options.preStringTyped(i.arrayPos);
                        var n = t.substr(0, e + 1);
                        i.attr ? i.el.setAttribute(i.attr, n) : i.isInput ? i.el.value = n : "html" === i.contentType ? i.el.innerHTML = n : i.el.textContent = n, e++, i.typewrite(t, e)
                    }
                }, n)
            }, n)
        }
    },
    backspace: function(t, e) {
        var n = this;
        if (!0 !== this.stop) {
            if (this.fadeOut) return void this.initFadeOut();
            var i = Math.round(70 * Math.random()) + this.backSpeed;
            n.timeout = setTimeout(function() {
                if ("html" === n.contentType && ">" === t.substr(e).charAt(0)) {
                    for (;
                        "<" !== t.substr(e - 1).charAt(0) && (t.substr(e).charAt(0), !(--e < 0)););
                    e--, "<"
                }
                var i = t.substr(0, e);
                n.replaceText(i), e > n.stopNum ? (e--, n.backspace(t, e)) : e <= n.stopNum && (n.arrayPos++, n.arrayPos === n.strings.length ? (n.arrayPos = 0, n.shuffle && (n.sequence = n.shuffleArray(n.sequence)), n.init()) : n.typewrite(n.strings[n.sequence[n.arrayPos]], e))
            }, i)
        }
    },
    initFadeOut: function() {
        return self = this, this.el.className += " " + this.fadeOutClass, this.cursor.className += " " + this.fadeOutClass, setTimeout(function() {
            self.arrayPos++, self.replaceText(""), self.typewrite(self.strings[self.sequence[self.arrayPos]], 0)
        }, self.fadeOutDelay)
    },
    replaceText: function(t) {
        this.attr ? this.el.setAttribute(this.attr, t) : this.isInput ? this.el.value = t : "html" === this.contentType ? this.el.innerHTML = t : this.el.textContent = t
    },
    shuffleArray: function(t) {
        var e, n, i = t.length;
        if (i)
            for (; --i;) e = t[n = Math.floor(Math.random() * (i + 1))], t[n] = t[i], t[i] = e;
        return t
    },
    reset: function() {
        clearInterval(this.timeout), this.el.getAttribute("id"), this.el.textContent = "", void 0 !== this.cursor && void 0 !== this.cursor.parentNode && this.cursor.parentNode.removeChild(this.cursor), this.strPos = 0, this.arrayPos = 0, this.curLoop = 0, this.options.resetCallback()
    }
}, i.new = function(t, n) {
    Array.prototype.slice.apply(e.querySelectorAll(t)).forEach(function(t) {
        var e = t._typed,
            r = "object" == typeof n && n;
        e && e.reset(), t._typed = e = new i(t, r), "string" == typeof n && e[n]()
    })
}, n && (n.fn.typed = function(t) {
    return this.each(function() {
        var e = n(this),
            r = e.data("typed"),
            o = "object" == typeof t && t;
        r && r.reset(), e.data("typed", r = new i(this, o)), "string" == typeof t && r[t]()
    })
}), t.Typed = i;
var r = {
    strings: ["These are the default values...", "You know what you should do?", "Use your own!", "Have a great day!"],
    stringsElement: null,
    typeSpeed: 0,
    startDelay: 0,
    backSpeed: 0,
    shuffle: !1,
    backDelay: 500,
    fadeOut: !1,
    fadeOutClass: "typed-fade-out",
    fadeOutDelay: 500,
    loop: !1,
    loopCount: !1,
    showCursor: !0,
    cursorChar: "|",
    attr: null,
    contentType: "html",
    callback: function() {},
    preStringTyped: function() {},
    onStringTyped: function() {},
    resetCallback: function() {}
}
}(window, document, window.jQuery),
function(t, e) {
"use strict";
var n = {},
    i = t.document,
    r = t.GreenSockGlobals = t.GreenSockGlobals || t,
    o = r[e];
if (o) return "undefined" != typeof module && module.exports && (module.exports = o);
var s, a, l, u, c, d, h, p = function(t) {
        var e, n = t.split("."),
            i = r;
        for (e = 0; e < n.length; e++) i[n[e]] = i = i[n[e]] || {};
        return i
    },
    f = p("com.greensock"),
    m = 1e-10,
    g = function(t) {
        var e, n = [],
            i = t.length;
        for (e = 0; e !== i; n.push(t[e++]));
        return n
    },
    y = function() {},
    v = (d = Object.prototype.toString, h = d.call([]), function(t) {
        return null != t && (t instanceof Array || "object" == typeof t && !!t.push && d.call(t) === h)
    }),
    _ = {},
    b = function(i, o, s, a) {
        this.sc = _[i] ? _[i].sc : [], (_[i] = this).gsClass = null, this.func = s;
        var l = [];
        this.check = function(u) {
            for (var c, d, h, f, m = o.length, g = m; - 1 < --m;)(c = _[o[m]] || new b(o[m], [])).gsClass ? (l[m] = c.gsClass, g--) : u && c.sc.push(this);
            if (0 === g && s) {
                if (h = (d = ("com.greensock." + i).split(".")).pop(), f = p(d.join("."))[h] = this.gsClass = s.apply(s, l), a)
                    if (r[h] = n[h] = f, "undefined" != typeof module && module.exports)
                        if (i === e)
                            for (m in module.exports = n[e] = f, n) f[m] = n[m];
                        else n[e] && (n[e][h] = f);
                else "function" == typeof define && define.amd && define((t.GreenSockAMDPath ? t.GreenSockAMDPath + "/" : "") + i.split(".").pop(), [], function() {
                    return f
                });
                for (m = 0; m < this.sc.length; m++) this.sc[m].check()
            }
        }, this.check(!0)
    },
    w = t._gsDefine = function(t, e, n, i) {
        return new b(t, e, n, i)
    },
    x = f._class = function(t, e, n) {
        return e = e || function() {}, w(t, [], function() {
            return e
        }, n), e
    };
w.globals = r;
var S = [0, 0, 1, 1],
    T = x("easing.Ease", function(t, e, n, i) {
        this._func = t, this._type = n || 0, this._power = i || 0, this._params = e ? S.concat(e) : S
    }, !0),
    k = T.map = {},
    C = T.register = function(t, e, n, i) {
        for (var r, o, s, a, l = e.split(","), u = l.length, c = (n || "easeIn,easeOut,easeInOut").split(","); - 1 < --u;)
            for (o = l[u], r = i ? x("easing." + o, null, !0) : f.easing[o] || {}, s = c.length; - 1 < --s;) a = c[s], k[o + "." + a] = k[a + o] = r[a] = t.getRatio ? t : t[a] || new t
    };
for ((l = T.prototype)._calcEnd = !1, l.getRatio = function(t) {
        if (this._func) return this._params[0] = t, this._func.apply(null, this._params);
        var e = this._type,
            n = this._power,
            i = 1 === e ? 1 - t : 2 === e ? t : t < .5 ? 2 * t : 2 * (1 - t);
        return 1 === n ? i *= i : 2 === n ? i *= i * i : 3 === n ? i *= i * i * i : 4 === n && (i *= i * i * i * i), 1 === e ? 1 - i : 2 === e ? i : t < .5 ? i / 2 : 1 - i / 2
    }, a = (s = ["Linear", "Quad", "Cubic", "Quart", "Quint,Strong"]).length; - 1 < --a;) l = s[a] + ",Power" + a, C(new T(null, null, 1, a), l, "easeOut", !0), C(new T(null, null, 2, a), l, "easeIn" + (0 === a ? ",easeNone" : "")), C(new T(null, null, 3, a), l, "easeInOut");
k.linear = f.easing.Linear.easeIn, k.swing = f.easing.Quad.easeInOut;
var E = x("events.EventDispatcher", function(t) {
    this._listeners = {}, this._eventTarget = t || this
});
(l = E.prototype).addEventListener = function(t, e, n, i, r) {
    r = r || 0;
    var o, s, a = this._listeners[t],
        l = 0;
    for (this !== u || c || u.wake(), null == a && (this._listeners[t] = a = []), s = a.length; - 1 < --s;)(o = a[s]).c === e && o.s === n ? a.splice(s, 1) : 0 === l && o.pr < r && (l = s + 1);
    a.splice(l, 0, {
        c: e,
        s: n,
        up: i,
        pr: r
    })
}, l.removeEventListener = function(t, e) {
    var n, i = this._listeners[t];
    if (i)
        for (n = i.length; - 1 < --n;)
            if (i[n].c === e) return void i.splice(n, 1)
}, l.dispatchEvent = function(t) {
    var e, n, i, r = this._listeners[t];
    if (r)
        for (1 < (e = r.length) && (r = r.slice(0)), n = this._eventTarget; - 1 < --e;)(i = r[e]) && (i.up ? i.c.call(i.s || n, {
            type: t,
            target: n
        }) : i.c.call(i.s || n))
};
var A = t.requestAnimationFrame,
    D = t.cancelAnimationFrame,
    P = Date.now || function() {
        return (new Date).getTime()
    },
    O = P();
for (a = (s = ["ms", "moz", "webkit", "o"]).length; - 1 < --a && !A;) A = t[s[a] + "RequestAnimationFrame"], D = t[s[a] + "CancelAnimationFrame"] || t[s[a] + "CancelRequestAnimationFrame"];
x("Ticker", function(t, e) {
    var n, r, o, s, a, l = this,
        d = P(),
        h = !(!1 === e || !A) && "auto",
        p = 500,
        f = 33,
        g = function(t) {
            var e, i, u = P() - O;
            p < u && (d += u - f), O += u, l.time = (O - d) / 1e3, e = l.time - a, (!n || 0 < e || !0 === t) && (l.frame++, a += e + (s <= e ? .004 : s - e), i = !0), !0 !== t && (o = r(g)), i && l.dispatchEvent("tick")
        };
    E.call(l), l.time = l.frame = 0, l.tick = function() {
        g(!0)
    }, l.lagSmoothing = function(t, e) {
        return arguments.length ? (p = t || 1 / m, void(f = Math.min(e, p, 0))) : p < 1 / m
    }, l.sleep = function() {
        null != o && (h && D ? D(o) : clearTimeout(o), r = y, o = null, l === u && (c = !1))
    }, l.wake = function(t) {
        null !== o ? l.sleep() : t ? d += -O + (O = P()) : 10 < l.frame && (O = P() - p + 5), r = 0 === n ? y : h && A ? A : function(t) {
            return setTimeout(t, 1e3 * (a - l.time) + 1 | 0)
        }, l === u && (c = !0), g(2)
    }, l.fps = function(t) {
        return arguments.length ? (s = 1 / ((n = t) || 60), a = this.time + s, void l.wake()) : n
    }, l.useRAF = function(t) {
        return arguments.length ? (l.sleep(), h = t, void l.fps(n)) : h
    }, l.fps(t), setTimeout(function() {
        "auto" === h && l.frame < 5 && "hidden" !== (i || {}).visibilityState && l.useRAF(!1)
    }, 1500)
}), (l = f.Ticker.prototype = new f.events.EventDispatcher).constructor = f.Ticker;
var I = x("core.Animation", function(t, e) {
    if (this.vars = e = e || {}, this._duration = this._totalDuration = t || 0, this._delay = Number(e.delay) || 0, this._timeScale = 1, this._active = !0 === e.immediateRender, this.data = e.data, this._reversed = !0 === e.reversed, Q) {
        c || u.wake();
        var n = this.vars.useFrames ? G : Q;
        n.add(this, n._time), this.vars.paused && this.paused(!0)
    }
});
u = I.ticker = new f.Ticker, (l = I.prototype)._dirty = l._gc = l._initted = l._paused = !1, l._totalTime = l._time = 0, l._rawPrevTime = -1, l._next = l._last = l._onUpdate = l._timeline = l.timeline = null, l._paused = !1;
var M = function() {
    c && 2e3 < P() - O && ("hidden" !== (i || {}).visibilityState || !u.lagSmoothing()) && u.wake();
    var t = setTimeout(M, 2e3);
    t.unref && t.unref()
};
M(), l.play = function(t, e) {
    return null != t && this.seek(t, e), this.reversed(!1).paused(!1)
}, l.pause = function(t, e) {
    return null != t && this.seek(t, e), this.paused(!0)
}, l.resume = function(t, e) {
    return null != t && this.seek(t, e), this.paused(!1)
}, l.seek = function(t, e) {
    return this.totalTime(Number(t), !1 !== e)
}, l.restart = function(t, e) {
    return this.reversed(!1).paused(!1).totalTime(t ? -this._delay : 0, !1 !== e, !0)
}, l.reverse = function(t, e) {
    return null != t && this.seek(t || this.totalDuration(), e), this.reversed(!0).paused(!1)
}, l.render = function(t, e, n) {}, l.invalidate = function() {
    return this._time = this._totalTime = 0, this._initted = this._gc = !1, this._rawPrevTime = -1, (this._gc || !this.timeline) && this._enabled(!0), this
}, l.isActive = function() {
    var t, e = this._timeline,
        n = this._startTime;
    return !e || !this._gc && !this._paused && e.isActive() && (t = e.rawTime(!0)) >= n && t < n + this.totalDuration() / this._timeScale - 1e-7
}, l._enabled = function(t, e) {
    return c || u.wake(), this._gc = !t, this._active = this.isActive(), !0 !== e && (t && !this.timeline ? this._timeline.add(this, this._startTime - this._delay) : !t && this.timeline && this._timeline._remove(this, !0)), !1
}, l._kill = function(t, e) {
    return this._enabled(!1, !1)
}, l.kill = function(t, e) {
    return this._kill(t, e), this
}, l._uncache = function(t) {
    for (var e = t ? this : this.timeline; e;) e._dirty = !0, e = e.timeline;
    return this
}, l._swapSelfInParams = function(t) {
    for (var e = t.length, n = t.concat(); - 1 < --e;) "{self}" === t[e] && (n[e] = this);
    return n
}, l._callback = function(t) {
    var e = this.vars,
        n = e[t],
        i = e[t + "Params"],
        r = e[t + "Scope"] || e.callbackScope || this;
    switch (i ? i.length : 0) {
        case 0:
            n.call(r);
            break;
        case 1:
            n.call(r, i[0]);
            break;
        case 2:
            n.call(r, i[0], i[1]);
            break;
        default:
            n.apply(r, i)
    }
}, l.eventCallback = function(t, e, n, i) {
    if ("on" === (t || "").substr(0, 2)) {
        var r = this.vars;
        if (1 === arguments.length) return r[t];
        null == e ? delete r[t] : (r[t] = e, r[t + "Params"] = v(n) && -1 !== n.join("").indexOf("{self}") ? this._swapSelfInParams(n) : n, r[t + "Scope"] = i), "onUpdate" === t && (this._onUpdate = e)
    }
    return this
}, l.delay = function(t) {
    return arguments.length ? (this._timeline.smoothChildTiming && this.startTime(this._startTime + t - this._delay), this._delay = t, this) : this._delay
}, l.duration = function(t) {
    return arguments.length ? (this._duration = this._totalDuration = t, this._uncache(!0), this._timeline.smoothChildTiming && 0 < this._time && this._time < this._duration && 0 !== t && this.totalTime(this._totalTime * (t / this._duration), !0), this) : (this._dirty = !1, this._duration)
}, l.totalDuration = function(t) {
    return this._dirty = !1, arguments.length ? this.duration(t) : this._totalDuration
}, l.time = function(t, e) {
    return arguments.length ? (this._dirty && this.totalDuration(), this.totalTime(t > this._duration ? this._duration : t, e)) : this._time
}, l.totalTime = function(t, e, n) {
    if (c || u.wake(), !arguments.length) return this._totalTime;
    if (this._timeline) {
        if (t < 0 && !n && (t += this.totalDuration()), this._timeline.smoothChildTiming) {
            this._dirty && this.totalDuration();
            var i = this._totalDuration,
                r = this._timeline;
            if (i < t && !n && (t = i), this._startTime = (this._paused ? this._pauseTime : r._time) - (this._reversed ? i - t : t) / this._timeScale, r._dirty || this._uncache(!1), r._timeline)
                for (; r._timeline;) r._timeline._time !== (r._startTime + r._totalTime) / r._timeScale && r.totalTime(r._totalTime, !0), r = r._timeline
        }
        this._gc && this._enabled(!0, !1), (this._totalTime !== t || 0 === this._duration) && ($.length && J(), this.render(t, e, !1), $.length && J())
    }
    return this
}, l.progress = l.totalProgress = function(t, e) {
    var n = this.duration();
    return arguments.length ? this.totalTime(n * t, e) : n ? this._time / n : this.ratio
}, l.startTime = function(t) {
    return arguments.length ? (t !== this._startTime && (this._startTime = t, this.timeline && this.timeline._sortChildren && this.timeline.add(this, t - this._delay)), this) : this._startTime
}, l.endTime = function(t) {
    return this._startTime + (0 != t ? this.totalDuration() : this.duration()) / this._timeScale
}, l.timeScale = function(t) {
    if (!arguments.length) return this._timeScale;
    var e, n;
    for (t = t || m, this._timeline && this._timeline.smoothChildTiming && (n = (e = this._pauseTime) || 0 === e ? e : this._timeline.totalTime(), this._startTime = n - (n - this._startTime) * this._timeScale / t), this._timeScale = t, n = this.timeline; n && n.timeline;) n._dirty = !0, n.totalDuration(), n = n.timeline;
    return this
}, l.reversed = function(t) {
    return arguments.length ? (t != this._reversed && (this._reversed = t, this.totalTime(this._timeline && !this._timeline.smoothChildTiming ? this.totalDuration() - this._totalTime : this._totalTime, !0)), this) : this._reversed
}, l.paused = function(t) {
    if (!arguments.length) return this._paused;
    var e, n, i = this._timeline;
    return t != this._paused && i && (c || t || u.wake(), n = (e = i.rawTime()) - this._pauseTime, !t && i.smoothChildTiming && (this._startTime += n, this._uncache(!1)), this._pauseTime = t ? e : null, this._paused = t, this._active = this.isActive(), !t && 0 !== n && this._initted && this.duration() && (e = i.smoothChildTiming ? this._totalTime : (e - this._startTime) / this._timeScale, this.render(e, e === this._totalTime, !0))), this._gc && !t && this._enabled(!0, !1), this
};
var L = x("core.SimpleTimeline", function(t) {
    I.call(this, 0, t), this.autoRemoveChildren = this.smoothChildTiming = !0
});
(l = L.prototype = new I).constructor = L, l.kill()._gc = !1, l._first = l._last = l._recent = null, l._sortChildren = !1, l.add = l.insert = function(t, e, n, i) {
    var r, o;
    if (t._startTime = Number(e || 0) + t._delay, t._paused && this !== t._timeline && (t._pauseTime = this.rawTime() - (t._timeline.rawTime() - t._pauseTime)), t.timeline && t.timeline._remove(t, !0), t.timeline = t._timeline = this, t._gc && t._enabled(!0, !0), r = this._last, this._sortChildren)
        for (o = t._startTime; r && r._startTime > o;) r = r._prev;
    return r ? (t._next = r._next, r._next = t) : (t._next = this._first, this._first = t), t._next ? t._next._prev = t : this._last = t, t._prev = r, this._recent = t, this._timeline && this._uncache(!0), this
}, l._remove = function(t, e) {
    return t.timeline === this && (e || t._enabled(!1, !0), t._prev ? t._prev._next = t._next : this._first === t && (this._first = t._next), t._next ? t._next._prev = t._prev : this._last === t && (this._last = t._prev), t._next = t._prev = t.timeline = null, t === this._recent && (this._recent = this._last), this._timeline && this._uncache(!0)), this
}, l.render = function(t, e, n) {
    var i, r = this._first;
    for (this._totalTime = this._time = this._rawPrevTime = t; r;) i = r._next, (r._active || t >= r._startTime && !r._paused && !r._gc) && (r._reversed ? r.render((r._dirty ? r.totalDuration() : r._totalDuration) - (t - r._startTime) * r._timeScale, e, n) : r.render((t - r._startTime) * r._timeScale, e, n)), r = i
}, l.rawTime = function() {
    return c || u.wake(), this._totalTime
};
var j = x("TweenLite", function(e, n, i) {
        if (I.call(this, n, i), this.render = j.prototype.render, null == e) throw "Cannot tween a null target.";
        this.target = e = "string" != typeof e ? e : j.selector(e) || e;
        var r, o, s, a = e.jquery || e.length && e !== t && e[0] && (e[0] === t || e[0].nodeType && e[0].style && !e.nodeType),
            l = this.vars.overwrite;
        if (this._overwrite = l = null == l ? V[j.defaultOverwrite] : "number" == typeof l ? l >> 0 : V[l], (a || e instanceof Array || e.push && v(e)) && "number" != typeof e[0])
            for (this._targets = s = g(e), this._propLookup = [], this._siblings = [], r = 0; r < s.length; r++)(o = s[r]) ? "string" != typeof o ? o.length && o !== t && o[0] && (o[0] === t || o[0].nodeType && o[0].style && !o.nodeType) ? (s.splice(r--, 1), this._targets = s = s.concat(g(o))) : (this._siblings[r] = tt(o, this, !1), 1 === l && 1 < this._siblings[r].length && nt(o, this, null, 1, this._siblings[r])) : "string" == typeof(o = s[r--] = j.selector(o)) && s.splice(r + 1, 1) : s.splice(r--, 1);
        else this._propLookup = {}, this._siblings = tt(e, this, !1), 1 === l && 1 < this._siblings.length && nt(e, this, null, 1, this._siblings);
        (this.vars.immediateRender || 0 === n && 0 === this._delay && !1 !== this.vars.immediateRender) && (this._time = -m, this.render(Math.min(0, -this._delay)))
    }, !0),
    N = function(e) {
        return e && e.length && e !== t && e[0] && (e[0] === t || e[0].nodeType && e[0].style && !e.nodeType)
    };
(l = j.prototype = new I).constructor = j, l.kill()._gc = !1, l.ratio = 0, l._firstPT = l._targets = l._overwrittenProps = l._startAt = null, l._notifyPluginsOfEnabled = l._lazy = !1, j.version = "2.0.2", j.defaultEase = l._ease = new T(null, null, 1, 1), j.defaultOverwrite = "auto", j.ticker = u, j.autoSleep = 120, j.lagSmoothing = function(t, e) {
    u.lagSmoothing(t, e)
}, j.selector = t.$ || t.jQuery || function(e) {
    var n = t.$ || t.jQuery;
    return n ? (j.selector = n)(e) : (i || (i = t.document), i ? i.querySelectorAll ? i.querySelectorAll(e) : i.getElementById("#" === e.charAt(0) ? e.substr(1) : e) : e)
};
var $ = [],
    z = {},
    F = /(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/gi,
    R = /[\+-]=-?[\.\d]/,
    H = function(t) {
        for (var e, n = this._firstPT; n;) e = n.blob ? 1 === t && null != this.end ? this.end : t ? this.join("") : this.start : n.c * t + n.s, n.m ? e = n.m.call(this._tween, e, this._target || n.t, this._tween) : e < 1e-6 && -1e-6 < e && !n.blob && (e = 0), n.f ? n.fp ? n.t[n.p](n.fp, e) : n.t[n.p](e) : n.t[n.p] = e, n = n._next
    },
    q = function(t, e, n, i) {
        var r, o, s, a, l, u, c, d = [],
            h = 0,
            p = "",
            f = 0;
        for (d.start = t, d.end = e, t = d[0] = t + "", e = d[1] = e + "", n && (n(d), t = d[0], e = d[1]), d.length = 0, r = t.match(F) || [], o = e.match(F) || [], i && (i._next = null, i.blob = 1, d._firstPT = d._applyPT = i), l = o.length, a = 0; a < l; a++) c = o[a], p += (u = e.substr(h, e.indexOf(c, h) - h)) || !a ? u : ",", h += u.length, f ? f = (f + 1) % 5 : "rgba(" === u.substr(-5) && (f = 1), c === r[a] || r.length <= a ? p += c : (p && (d.push(p), p = ""), s = parseFloat(r[a]), d.push(s), d._firstPT = {
            _next: d._firstPT,
            t: d,
            p: d.length - 1,
            s: s,
            c: ("=" === c.charAt(1) ? parseInt(c.charAt(0) + "1", 10) * parseFloat(c.substr(2)) : parseFloat(c) - s) || 0,
            f: 0,
            m: f && f < 4 ? Math.round : 0
        }), h += c.length;
        return (p += e.substr(h)) && d.push(p), d.setRatio = H, R.test(e) && (d.end = null), d
    },
    B = function(t, e, n, i, r, o, s, a, l) {
        "function" == typeof i && (i = i(l || 0, t));
        var u = typeof t[e],
            c = "function" !== u ? "" : e.indexOf("set") || "function" != typeof t["get" + e.substr(3)] ? e : "get" + e.substr(3),
            d = "get" !== n ? n : c ? s ? t[c](s) : t[c]() : t[e],
            h = "string" == typeof i && "=" === i.charAt(1),
            p = {
                t: t,
                p: e,
                s: d,
                f: "function" === u,
                pg: 0,
                n: r || e,
                m: o ? "function" == typeof o ? o : Math.round : 0,
                pr: 0,
                c: h ? parseInt(i.charAt(0) + "1", 10) * parseFloat(i.substr(2)) : parseFloat(i) - d || 0
            };
        return ("number" != typeof d || "number" != typeof i && !h) && (s || isNaN(d) || !h && isNaN(i) || "boolean" == typeof d || "boolean" == typeof i ? (p.fp = s, p = {
            t: q(d, h ? parseFloat(p.s) + p.c + (p.s + "").replace(/[0-9\-\.]/g, "") : i, a || j.defaultStringFilter, p),
            p: "setRatio",
            s: 0,
            c: 1,
            f: 2,
            pg: 0,
            n: r || e,
            pr: 0,
            m: 0
        }) : (p.s = parseFloat(d), h || (p.c = parseFloat(i) - p.s || 0))), p.c ? ((p._next = this._firstPT) && (p._next._prev = p), this._firstPT = p) : void 0
    },
    U = j._internals = {
        isArray: v,
        isSelector: N,
        lazyTweens: $,
        blobDif: q
    },
    W = j._plugins = {},
    X = U.tweenLookup = {},
    Y = 0,
    Z = U.reservedProps = {
        ease: 1,
        delay: 1,
        overwrite: 1,
        onComplete: 1,
        onCompleteParams: 1,
        onCompleteScope: 1,
        useFrames: 1,
        runBackwards: 1,
        startAt: 1,
        onUpdate: 1,
        onUpdateParams: 1,
        onUpdateScope: 1,
        onStart: 1,
        onStartParams: 1,
        onStartScope: 1,
        onReverseComplete: 1,
        onReverseCompleteParams: 1,
        onReverseCompleteScope: 1,
        onRepeat: 1,
        onRepeatParams: 1,
        onRepeatScope: 1,
        easeParams: 1,
        yoyo: 1,
        immediateRender: 1,
        repeat: 1,
        repeatDelay: 1,
        data: 1,
        paused: 1,
        reversed: 1,
        autoCSS: 1,
        lazy: 1,
        onOverwrite: 1,
        callbackScope: 1,
        stringFilter: 1,
        id: 1,
        yoyoEase: 1
    },
    V = {
        none: 0,
        all: 1,
        auto: 2,
        concurrent: 3,
        allOnStart: 4,
        preexisting: 5,
        true: 1,
        false: 0
    },
    G = I._rootFramesTimeline = new L,
    Q = I._rootTimeline = new L,
    K = 30,
    J = U.lazyRender = function() {
        var t, e = $.length;
        for (z = {}; - 1 < --e;)(t = $[e]) && !1 !== t._lazy && (t.render(t._lazy[0], t._lazy[1], !0), t._lazy = !1);
        $.length = 0
    };
Q._startTime = u.time, G._startTime = u.frame, Q._active = G._active = !0, setTimeout(J, 1), I._updateRoot = j.render = function() {
    var t, e, n;
    if ($.length && J(), Q.render((u.time - Q._startTime) * Q._timeScale, !1, !1), G.render((u.frame - G._startTime) * G._timeScale, !1, !1), $.length && J(), u.frame >= K) {
        for (n in K = u.frame + (parseInt(j.autoSleep, 10) || 120), X) {
            for (t = (e = X[n].tweens).length; - 1 < --t;) e[t]._gc && e.splice(t, 1);
            0 === e.length && delete X[n]
        }
        if ((!(n = Q._first) || n._paused) && j.autoSleep && !G._first && 1 === u._listeners.tick.length) {
            for (; n && n._paused;) n = n._next;
            n || u.sleep()
        }
    }
}, u.addEventListener("tick", I._updateRoot);
var tt = function(t, e, n) {
        var i, r, o = t._gsTweenID;
        if (X[o || (t._gsTweenID = o = "t" + Y++)] || (X[o] = {
                target: t,
                tweens: []
            }), e && ((i = X[o].tweens)[r = i.length] = e, n))
            for (; - 1 < --r;) i[r] === e && i.splice(r, 1);
        return X[o].tweens
    },
    et = function(t, e, n, i) {
        var r, o, s = t.vars.onOverwrite;
        return s && (r = s(t, e, n, i)), (s = j.onOverwrite) && (o = s(t, e, n, i)), !1 !== r && !1 !== o
    },
    nt = function(t, e, n, i, r) {
        var o, s, a, l;
        if (1 === i || 4 <= i) {
            for (l = r.length, o = 0; o < l; o++)
                if ((a = r[o]) !== e) a._gc || a._kill(null, t, e) && (s = !0);
                else if (5 === i) break;
            return s
        }
        var u, c = e._startTime + m,
            d = [],
            h = 0,
            p = 0 === e._duration;
        for (o = r.length; - 1 < --o;)(a = r[o]) === e || a._gc || a._paused || (a._timeline !== e._timeline ? (u = u || it(e, 0, p), 0 === it(a, u, p) && (d[h++] = a)) : a._startTime <= c && a._startTime + a.totalDuration() / a._timeScale > c && ((p || !a._initted) && c - a._startTime <= 2e-10 || (d[h++] = a)));
        for (o = h; - 1 < --o;)
            if (l = (a = d[o])._firstPT, 2 === i && a._kill(n, t, e) && (s = !0), 2 !== i || !a._firstPT && a._initted && l) {
                if (2 !== i && !et(a, e)) continue;
                a._enabled(!1, !1) && (s = !0)
            } return s
    },
    it = function(t, e, n) {
        for (var i = t._timeline, r = i._timeScale, o = t._startTime; i._timeline;) {
            if (o += i._startTime, r *= i._timeScale, i._paused) return -100;
            i = i._timeline
        }
        return e < (o /= r) ? o - e : n && o === e || !t._initted && o - e < 2 * m ? m : (o += t.totalDuration() / t._timeScale / r) > e + m ? 0 : o - e - m
    };
l._init = function() {
    var t, e, n, i, r, o, s = this.vars,
        a = this._overwrittenProps,
        l = this._duration,
        u = !!s.immediateRender,
        c = s.ease;
    if (s.startAt) {
        for (i in this._startAt && (this._startAt.render(-1, !0), this._startAt.kill()), r = {}, s.startAt) r[i] = s.startAt[i];
        if (r.data = "isStart", r.overwrite = !1, r.immediateRender = !0, r.lazy = u && !1 !== s.lazy, r.startAt = r.delay = null, r.onUpdate = s.onUpdate, r.onUpdateParams = s.onUpdateParams, r.onUpdateScope = s.onUpdateScope || s.callbackScope || this, this._startAt = j.to(this.target || {}, 0, r), u)
            if (0 < this._time) this._startAt = null;
            else if (0 !== l) return
    } else if (s.runBackwards && 0 !== l)
        if (this._startAt) this._startAt.render(-1, !0), this._startAt.kill(), this._startAt = null;
        else {
            for (i in 0 !== this._time && (u = !1), n = {}, s) Z[i] && "autoCSS" !== i || (n[i] = s[i]);
            if (n.overwrite = 0, n.data = "isFromStart", n.lazy = u && !1 !== s.lazy, n.immediateRender = u, this._startAt = j.to(this.target, 0, n), u) {
                if (0 === this._time) return
            } else this._startAt._init(), this._startAt._enabled(!1), this.vars.immediateRender && (this._startAt = null)
        } if (this._ease = c = c ? c instanceof T ? c : "function" == typeof c ? new T(c, s.easeParams) : k[c] || j.defaultEase : j.defaultEase, s.easeParams instanceof Array && c.config && (this._ease = c.config.apply(c, s.easeParams)), this._easeType = this._ease._type, this._easePower = this._ease._power, this._firstPT = null, this._targets)
        for (o = this._targets.length, t = 0; t < o; t++) this._initProps(this._targets[t], this._propLookup[t] = {}, this._siblings[t], a ? a[t] : null, t) && (e = !0);
    else e = this._initProps(this.target, this._propLookup, this._siblings, a, 0);
    if (e && j._onPluginEvent("_onInitAllProps", this), a && (this._firstPT || "function" != typeof this.target && this._enabled(!1, !1)), s.runBackwards)
        for (n = this._firstPT; n;) n.s += n.c, n.c = -n.c, n = n._next;
    this._onUpdate = s.onUpdate, this._initted = !0
}, l._initProps = function(e, n, i, r, o) {
    var s, a, l, u, c, d;
    if (null == e) return !1;
    for (s in z[e._gsTweenID] && J(), this.vars.css || e.style && e !== t && e.nodeType && W.css && !1 !== this.vars.autoCSS && function(t, e) {
            var n, i = {};
            for (n in t) Z[n] || n in e && "transform" !== n && "x" !== n && "y" !== n && "width" !== n && "height" !== n && "className" !== n && "border" !== n || !(!W[n] || W[n] && W[n]._autoCSS) || (i[n] = t[n], delete t[n]);
            t.css = i
        }(this.vars, e), this.vars)
        if (d = this.vars[s], Z[s]) d && (d instanceof Array || d.push && v(d)) && -1 !== d.join("").indexOf("{self}") && (this.vars[s] = d = this._swapSelfInParams(d, this));
        else if (W[s] && (u = new W[s])._onInitTween(e, this.vars[s], this, o)) {
        for (this._firstPT = c = {
                _next: this._firstPT,
                t: u,
                p: "setRatio",
                s: 0,
                c: 1,
                f: 1,
                n: s,
                pg: 1,
                pr: u._priority,
                m: 0
            }, a = u._overwriteProps.length; - 1 < --a;) n[u._overwriteProps[a]] = this._firstPT;
        (u._priority || u._onInitAllProps) && (l = !0), (u._onDisable || u._onEnable) && (this._notifyPluginsOfEnabled = !0), c._next && (c._next._prev = c)
    } else n[s] = B.call(this, e, s, "get", d, s, 0, null, this.vars.stringFilter, o);
    return r && this._kill(r, e) ? this._initProps(e, n, i, r, o) : 1 < this._overwrite && this._firstPT && 1 < i.length && nt(e, this, n, this._overwrite, i) ? (this._kill(n, e), this._initProps(e, n, i, r, o)) : (this._firstPT && (!1 !== this.vars.lazy && this._duration || this.vars.lazy && !this._duration) && (z[e._gsTweenID] = !0), l)
}, l.render = function(t, e, n) {
    var i, r, o, s, a = this._time,
        l = this._duration,
        u = this._rawPrevTime;
    if (l - 1e-7 <= t && 0 <= t) this._totalTime = this._time = l, this.ratio = this._ease._calcEnd ? this._ease.getRatio(1) : 1, this._reversed || (i = !0, r = "onComplete", n = n || this._timeline.autoRemoveChildren), 0 === l && (this._initted || !this.vars.lazy || n) && (this._startTime === this._timeline._duration && (t = 0), (u < 0 || t <= 0 && -1e-7 <= t || u === m && "isPause" !== this.data) && u !== t && (n = !0, m < u && (r = "onReverseComplete")), this._rawPrevTime = s = !e || t || u === t ? t : m);
    else if (t < 1e-7) this._totalTime = this._time = 0, this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0, (0 !== a || 0 === l && 0 < u) && (r = "onReverseComplete", i = this._reversed), t < 0 && (this._active = !1, 0 === l && (this._initted || !this.vars.lazy || n) && (0 <= u && (u !== m || "isPause" !== this.data) && (n = !0), this._rawPrevTime = s = !e || t || u === t ? t : m)), (!this._initted || this._startAt && this._startAt.progress()) && (n = !0);
    else if (this._totalTime = this._time = t, this._easeType) {
        var c = t / l,
            d = this._easeType,
            h = this._easePower;
        (1 === d || 3 === d && .5 <= c) && (c = 1 - c), 3 === d && (c *= 2), 1 === h ? c *= c : 2 === h ? c *= c * c : 3 === h ? c *= c * c * c : 4 === h && (c *= c * c * c * c), this.ratio = 1 === d ? 1 - c : 2 === d ? c : t / l < .5 ? c / 2 : 1 - c / 2
    } else this.ratio = this._ease.getRatio(t / l);
    if (this._time !== a || n) {
        if (!this._initted) {
            if (this._init(), !this._initted || this._gc) return;
            if (!n && this._firstPT && (!1 !== this.vars.lazy && this._duration || this.vars.lazy && !this._duration)) return this._time = this._totalTime = a, this._rawPrevTime = u, $.push(this), void(this._lazy = [t, e]);
            this._time && !i ? this.ratio = this._ease.getRatio(this._time / l) : i && this._ease._calcEnd && (this.ratio = this._ease.getRatio(0 === this._time ? 0 : 1))
        }
        for (!1 !== this._lazy && (this._lazy = !1), this._active || !this._paused && this._time !== a && 0 <= t && (this._active = !0), 0 === a && (this._startAt && (0 <= t ? this._startAt.render(t, !0, n) : r || (r = "_dummyGS")), this.vars.onStart && (0 !== this._time || 0 === l) && (e || this._callback("onStart"))), o = this._firstPT; o;) o.f ? o.t[o.p](o.c * this.ratio + o.s) : o.t[o.p] = o.c * this.ratio + o.s, o = o._next;
        this._onUpdate && (t < 0 && this._startAt && -1e-4 !== t && this._startAt.render(t, !0, n), e || (this._time !== a || i || n) && this._callback("onUpdate")), r && (!this._gc || n) && (t < 0 && this._startAt && !this._onUpdate && -1e-4 !== t && this._startAt.render(t, !0, n), i && (this._timeline.autoRemoveChildren && this._enabled(!1, !1), this._active = !1), !e && this.vars[r] && this._callback(r), 0 === l && this._rawPrevTime === m && s !== m && (this._rawPrevTime = 0))
    }
}, l._kill = function(t, e, n) {
    if ("all" === t && (t = null), null == t && (null == e || e === this.target)) return this._lazy = !1, this._enabled(!1, !1);
    e = "string" != typeof e ? e || this._targets || this.target : j.selector(e) || e;
    var i, r, o, s, a, l, u, c, d, h = n && this._time && n._startTime === this._startTime && this._timeline === n._timeline,
        p = this._firstPT;
    if ((v(e) || N(e)) && "number" != typeof e[0])
        for (i = e.length; - 1 < --i;) this._kill(t, e[i], n) && (l = !0);
    else {
        if (this._targets) {
            for (i = this._targets.length; - 1 < --i;)
                if (e === this._targets[i]) {
                    a = this._propLookup[i] || {}, this._overwrittenProps = this._overwrittenProps || [], r = this._overwrittenProps[i] = t ? this._overwrittenProps[i] || {} : "all";
                    break
                }
        } else {
            if (e !== this.target) return !1;
            a = this._propLookup, r = this._overwrittenProps = t ? this._overwrittenProps || {} : "all"
        }
        if (a) {
            if (u = t || a, c = t !== r && "all" !== r && t !== a && ("object" != typeof t || !t._tempKill), n && (j.onOverwrite || this.vars.onOverwrite)) {
                for (o in u) a[o] && (d || (d = []), d.push(o));
                if ((d || !t) && !et(this, n, e, d)) return !1
            }
            for (o in u)(s = a[o]) && (h && (s.f ? s.t[s.p](s.s) : s.t[s.p] = s.s, l = !0), s.pg && s.t._kill(u) && (l = !0), s.pg && 0 !== s.t._overwriteProps.length || (s._prev ? s._prev._next = s._next : s === this._firstPT && (this._firstPT = s._next), s._next && (s._next._prev = s._prev), s._next = s._prev = null), delete a[o]), c && (r[o] = 1);
            !this._firstPT && this._initted && p && this._enabled(!1, !1)
        }
    }
    return l
}, l.invalidate = function() {
    return this._notifyPluginsOfEnabled && j._onPluginEvent("_onDisable", this), this._firstPT = this._overwrittenProps = this._startAt = this._onUpdate = null, this._notifyPluginsOfEnabled = this._active = this._lazy = !1, this._propLookup = this._targets ? {} : [], I.prototype.invalidate.call(this), this.vars.immediateRender && (this._time = -m, this.render(Math.min(0, -this._delay))), this
}, l._enabled = function(t, e) {
    if (c || u.wake(), t && this._gc) {
        var n, i = this._targets;
        if (i)
            for (n = i.length; - 1 < --n;) this._siblings[n] = tt(i[n], this, !0);
        else this._siblings = tt(this.target, this, !0)
    }
    return I.prototype._enabled.call(this, t, e), !(!this._notifyPluginsOfEnabled || !this._firstPT) && j._onPluginEvent(t ? "_onEnable" : "_onDisable", this)
}, j.to = function(t, e, n) {
    return new j(t, e, n)
}, j.from = function(t, e, n) {
    return n.runBackwards = !0, n.immediateRender = 0 != n.immediateRender, new j(t, e, n)
}, j.fromTo = function(t, e, n, i) {
    return i.startAt = n, i.immediateRender = 0 != i.immediateRender && 0 != n.immediateRender, new j(t, e, i)
}, j.delayedCall = function(t, e, n, i, r) {
    return new j(e, 0, {
        delay: t,
        onComplete: e,
        onCompleteParams: n,
        callbackScope: i,
        onReverseComplete: e,
        onReverseCompleteParams: n,
        immediateRender: !1,
        lazy: !1,
        useFrames: r,
        overwrite: 0
    })
}, j.set = function(t, e) {
    return new j(t, 0, e)
}, j.getTweensOf = function(t, e) {
    if (null == t) return [];
    var n, i, r, o;
    if (t = "string" != typeof t ? t : j.selector(t) || t, (v(t) || N(t)) && "number" != typeof t[0]) {
        for (n = t.length, i = []; - 1 < --n;) i = i.concat(j.getTweensOf(t[n], e));
        for (n = i.length; - 1 < --n;)
            for (o = i[n], r = n; - 1 < --r;) o === i[r] && i.splice(n, 1)
    } else if (t._gsTweenID)
        for (n = (i = tt(t).concat()).length; - 1 < --n;)(i[n]._gc || e && !i[n].isActive()) && i.splice(n, 1);
    return i || []
}, j.killTweensOf = j.killDelayedCallsTo = function(t, e, n) {
    "object" == typeof e && (n = e, e = !1);
    for (var i = j.getTweensOf(t, e), r = i.length; - 1 < --r;) i[r]._kill(n, t)
};
var rt = x("plugins.TweenPlugin", function(t, e) {
    this._overwriteProps = (t || "").split(","), this._propName = this._overwriteProps[0], this._priority = e || 0, this._super = rt.prototype
}, !0);
if (l = rt.prototype, rt.version = "1.19.0", rt.API = 2, l._firstPT = null, l._addTween = B, l.setRatio = H, l._kill = function(t) {
        var e, n = this._overwriteProps,
            i = this._firstPT;
        if (null != t[this._propName]) this._overwriteProps = [];
        else
            for (e = n.length; - 1 < --e;) null != t[n[e]] && n.splice(e, 1);
        for (; i;) null != t[i.n] && (i._next && (i._next._prev = i._prev), i._prev ? (i._prev._next = i._next, i._prev = null) : this._firstPT === i && (this._firstPT = i._next)), i = i._next;
        return !1
    }, l._mod = l._roundProps = function(t) {
        for (var e, n = this._firstPT; n;)(e = t[this._propName] || null != n.n && t[n.n.split(this._propName + "_").join("")]) && "function" == typeof e && (2 === n.f ? n.t._applyPT.m = e : n.m = e), n = n._next
    }, j._onPluginEvent = function(t, e) {
        var n, i, r, o, s, a = e._firstPT;
        if ("_onInitAllProps" === t) {
            for (; a;) {
                for (s = a._next, i = r; i && i.pr > a.pr;) i = i._next;
                (a._prev = i ? i._prev : o) ? a._prev._next = a: r = a, (a._next = i) ? i._prev = a : o = a, a = s
            }
            a = e._firstPT = r
        }
        for (; a;) a.pg && "function" == typeof a.t[t] && a.t[t]() && (n = !0), a = a._next;
        return n
    }, rt.activate = function(t) {
        for (var e = t.length; - 1 < --e;) t[e].API === rt.API && (W[(new t[e])._propName] = t[e]);
        return !0
    }, w.plugin = function(t) {
        if (!(t && t.propName && t.init && t.API)) throw "illegal plugin definition.";
        var e, n = t.propName,
            i = t.priority || 0,
            r = t.overwriteProps,
            o = {
                init: "_onInitTween",
                set: "setRatio",
                kill: "_kill",
                round: "_mod",
                mod: "_mod",
                initAll: "_onInitAllProps"
            },
            s = x("plugins." + n.charAt(0).toUpperCase() + n.substr(1) + "Plugin", function() {
                rt.call(this, n, i), this._overwriteProps = r || []
            }, !0 === t.global),
            a = s.prototype = new rt(n);
        for (e in (a.constructor = s).API = t.API, o) "function" == typeof t[e] && (a[o[e]] = t[e]);
        return s.version = t.version, rt.activate([s]), s
    }, s = t._gsQueue) {
    for (a = 0; a < s.length; a++) s[a]();
    for (l in _) _[l].func || t.console.log("GSAP encountered missing dependency: " + l)
}
c = !1
}("undefined" != typeof module && module.exports && "undefined" != typeof global ? global : this || window, "TweenLite"), ((_gsScope = "undefined" != typeof module && module.exports && "undefined" != typeof global ? global : this || window)._gsQueue || (_gsScope._gsQueue = [])).push(function() {
    "use strict";
    _gsScope._gsDefine("TimelineLite", ["core.Animation", "core.SimpleTimeline", "TweenLite"], function(t, e, n) {
        var i = function(t) {
                e.call(this, t), this._labels = {}, this.autoRemoveChildren = !0 === this.vars.autoRemoveChildren, this.smoothChildTiming = !0 === this.vars.smoothChildTiming, this._sortChildren = !0, this._onUpdate = this.vars.onUpdate;
                var n, i, r = this.vars;
                for (i in r) n = r[i], l(n) && -1 !== n.join("").indexOf("{self}") && (r[i] = this._swapSelfInParams(n));
                l(r.tweens) && this.add(r.tweens, 0, r.align, r.stagger)
            },
            r = 1e-10,
            o = n._internals,
            s = i._internals = {},
            a = o.isSelector,
            l = o.isArray,
            u = o.lazyTweens,
            c = o.lazyRender,
            d = _gsScope._gsDefine.globals,
            h = function(t) {
                var e, n = {};
                for (e in t) n[e] = t[e];
                return n
            },
            p = function(t, e, n) {
                var i, r, o = t.cycle;
                for (i in o) r = o[i], t[i] = "function" == typeof r ? r(n, e[n]) : r[n % r.length];
                delete t.cycle
            },
            f = s.pauseCallback = function() {},
            m = function(t) {
                var e, n = [],
                    i = t.length;
                for (e = 0; e !== i; n.push(t[e++]));
                return n
            },
            g = i.prototype = new e;
        return i.version = "2.0.2", g.constructor = i, g.kill()._gc = g._forcingPlayhead = g._hasPause = !1, g.to = function(t, e, i, r) {
            var o = i.repeat && d.TweenMax || n;
            return e ? this.add(new o(t, e, i), r) : this.set(t, i, r)
        }, g.from = function(t, e, i, r) {
            return this.add((i.repeat && d.TweenMax || n).from(t, e, i), r)
        }, g.fromTo = function(t, e, i, r, o) {
            var s = r.repeat && d.TweenMax || n;
            return e ? this.add(s.fromTo(t, e, i, r), o) : this.set(t, r, o)
        }, g.staggerTo = function(t, e, r, o, s, l, u, c) {
            var d, f, g = new i({
                    onComplete: l,
                    onCompleteParams: u,
                    callbackScope: c,
                    smoothChildTiming: this.smoothChildTiming
                }),
                y = r.cycle;
            for ("string" == typeof t && (t = n.selector(t) || t), a(t = t || []) && (t = m(t)), (o = o || 0) < 0 && ((t = m(t)).reverse(), o *= -1), f = 0; f < t.length; f++)(d = h(r)).startAt && (d.startAt = h(d.startAt), d.startAt.cycle && p(d.startAt, t, f)), y && (p(d, t, f), null != d.duration && (e = d.duration, delete d.duration)), g.to(t[f], e, d, f * o);
            return this.add(g, s)
        }, g.staggerFrom = function(t, e, n, i, r, o, s, a) {
            return n.immediateRender = 0 != n.immediateRender, n.runBackwards = !0, this.staggerTo(t, e, n, i, r, o, s, a)
        }, g.staggerFromTo = function(t, e, n, i, r, o, s, a, l) {
            return i.startAt = n, i.immediateRender = 0 != i.immediateRender && 0 != n.immediateRender, this.staggerTo(t, e, i, r, o, s, a, l)
        }, g.call = function(t, e, i, r) {
            return this.add(n.delayedCall(0, t, e, i), r)
        }, g.set = function(t, e, i) {
            return i = this._parseTimeOrLabel(i, 0, !0), null == e.immediateRender && (e.immediateRender = i === this._time && !this._paused), this.add(new n(t, 0, e), i)
        }, i.exportRoot = function(t, e) {
            null == (t = t || {}).smoothChildTiming && (t.smoothChildTiming = !0);
            var r, o, s, a, l = new i(t),
                u = l._timeline;
            for (null == e && (e = !0), u._remove(l, !0), l._startTime = 0, l._rawPrevTime = l._time = l._totalTime = u._time, s = u._first; s;) a = s._next, e && s instanceof n && s.target === s.vars.onComplete || ((o = s._startTime - s._delay) < 0 && (r = 1), l.add(s, o)), s = a;
            return u.add(l, 0), r && l.totalDuration(), l
        }, g.add = function(r, o, s, a) {
            var u, c, d, h, p, f;
            if ("number" != typeof o && (o = this._parseTimeOrLabel(o, 0, !0, r)), !(r instanceof t)) {
                if (r instanceof Array || r && r.push && l(r)) {
                    for (s = s || "normal", a = a || 0, u = o, c = r.length, d = 0; d < c; d++) l(h = r[d]) && (h = new i({
                        tweens: h
                    })), this.add(h, u), "string" != typeof h && "function" != typeof h && ("sequence" === s ? u = h._startTime + h.totalDuration() / h._timeScale : "start" === s && (h._startTime -= h.delay())), u += a;
                    return this._uncache(!0)
                }
                if ("string" == typeof r) return this.addLabel(r, o);
                if ("function" != typeof r) throw "Cannot add " + r + " into the timeline; it is not a tween, timeline, function, or string.";
                r = n.delayedCall(0, r)
            }
            if (e.prototype.add.call(this, r, o), r._time && (u = Math.max(0, Math.min(r.totalDuration(), (this.rawTime() - r._startTime) * r._timeScale)), 1e-5 < Math.abs(u - r._totalTime) && r.render(u, !1, !1)), (this._gc || this._time === this._duration) && !this._paused && this._duration < this.duration())
                for (f = (p = this).rawTime() > r._startTime; p._timeline;) f && p._timeline.smoothChildTiming ? p.totalTime(p._totalTime, !0) : p._gc && p._enabled(!0, !1), p = p._timeline;
            return this
        }, g.remove = function(e) {
            if (e instanceof t) {
                this._remove(e, !1);
                var n = e._timeline = e.vars.useFrames ? t._rootFramesTimeline : t._rootTimeline;
                return e._startTime = (e._paused ? e._pauseTime : n._time) - (e._reversed ? e.totalDuration() - e._totalTime : e._totalTime) / e._timeScale, this
            }
            if (e instanceof Array || e && e.push && l(e)) {
                for (var i = e.length; - 1 < --i;) this.remove(e[i]);
                return this
            }
            return "string" == typeof e ? this.removeLabel(e) : this.kill(null, e)
        }, g._remove = function(t, n) {
            return e.prototype._remove.call(this, t, n), this._last ? this._time > this.duration() && (this._time = this._duration, this._totalTime = this._totalDuration) : this._time = this._totalTime = this._duration = this._totalDuration = 0, this
        }, g.append = function(t, e) {
            return this.add(t, this._parseTimeOrLabel(null, e, !0, t))
        }, g.insert = g.insertMultiple = function(t, e, n, i) {
            return this.add(t, e || 0, n, i)
        }, g.appendMultiple = function(t, e, n, i) {
            return this.add(t, this._parseTimeOrLabel(null, e, !0, t), n, i)
        }, g.addLabel = function(t, e) {
            return this._labels[t] = this._parseTimeOrLabel(e), this
        }, g.addPause = function(t, e, i, r) {
            var o = n.delayedCall(0, f, i, r || this);
            return o.vars.onComplete = o.vars.onReverseComplete = e, o.data = "isPause", this._hasPause = !0, this.add(o, t)
        }, g.removeLabel = function(t) {
            return delete this._labels[t], this
        }, g.getLabelTime = function(t) {
            return null != this._labels[t] ? this._labels[t] : -1
        }, g._parseTimeOrLabel = function(e, n, i, r) {
            var o, s;
            if (r instanceof t && r.timeline === this) this.remove(r);
            else if (r && (r instanceof Array || r.push && l(r)))
                for (s = r.length; - 1 < --s;) r[s] instanceof t && r[s].timeline === this && this.remove(r[s]);
            if (o = "number" != typeof e || n ? 99999999999 < this.duration() ? this.recent().endTime(!1) : this._duration : 0, "string" == typeof n) return this._parseTimeOrLabel(n, i && "number" == typeof e && null == this._labels[n] ? e - o : 0, i);
            if (n = n || 0, "string" != typeof e || !isNaN(e) && null == this._labels[e]) null == e && (e = o);
            else {
                if (-1 === (s = e.indexOf("="))) return null == this._labels[e] ? i ? this._labels[e] = o + n : n : this._labels[e] + n;
                n = parseInt(e.charAt(s - 1) + "1", 10) * Number(e.substr(s + 1)), e = 1 < s ? this._parseTimeOrLabel(e.substr(0, s - 1), 0, i) : o
            }
            return Number(e) + n
        }, g.seek = function(t, e) {
            return this.totalTime("number" == typeof t ? t : this._parseTimeOrLabel(t), !1 !== e)
        }, g.stop = function() {
            return this.paused(!0)
        }, g.gotoAndPlay = function(t, e) {
            return this.play(t, e)
        }, g.gotoAndStop = function(t, e) {
            return this.pause(t, e)
        }, g.render = function(t, e, n) {
            this._gc && this._enabled(!0, !1);
            var i, o, s, a, l, d, h, p = this._time,
                f = this._dirty ? this.totalDuration() : this._totalDuration,
                m = this._startTime,
                g = this._timeScale,
                y = this._paused;
            if (p !== this._time && (t += this._time - p), f - 1e-7 <= t && 0 <= t) this._totalTime = this._time = f, this._reversed || this._hasPausedChild() || (o = !0, a = "onComplete", l = !!this._timeline.autoRemoveChildren, 0 === this._duration && (t <= 0 && -1e-7 <= t || this._rawPrevTime < 0 || this._rawPrevTime === r) && this._rawPrevTime !== t && this._first && (l = !0, this._rawPrevTime > r && (a = "onReverseComplete"))), this._rawPrevTime = this._duration || !e || t || this._rawPrevTime === t ? t : r, t = f + 1e-4;
            else if (t < 1e-7)
                if (this._totalTime = this._time = 0, (0 !== p || 0 === this._duration && this._rawPrevTime !== r && (0 < this._rawPrevTime || t < 0 && 0 <= this._rawPrevTime)) && (a = "onReverseComplete", o = this._reversed), t < 0) this._active = !1, this._timeline.autoRemoveChildren && this._reversed ? (l = o = !0, a = "onReverseComplete") : 0 <= this._rawPrevTime && this._first && (l = !0), this._rawPrevTime = t;
                else {
                    if (this._rawPrevTime = this._duration || !e || t || this._rawPrevTime === t ? t : r, 0 === t && o)
                        for (i = this._first; i && 0 === i._startTime;) i._duration || (o = !1), i = i._next;
                    t = 0, this._initted || (l = !0)
                }
            else {
                if (this._hasPause && !this._forcingPlayhead && !e) {
                    if (p <= t)
                        for (i = this._first; i && i._startTime <= t && !d;) i._duration || "isPause" !== i.data || i.ratio || 0 === i._startTime && 0 === this._rawPrevTime || (d = i), i = i._next;
                    else
                        for (i = this._last; i && i._startTime >= t && !d;) i._duration || "isPause" === i.data && 0 < i._rawPrevTime && (d = i), i = i._prev;
                    d && (this._time = t = d._startTime, this._totalTime = t + this._cycle * (this._totalDuration + this._repeatDelay))
                }
                this._totalTime = this._time = this._rawPrevTime = t
            }
            if (this._time !== p && this._first || n || l || d) {
                if (this._initted || (this._initted = !0), this._active || !this._paused && this._time !== p && 0 < t && (this._active = !0), 0 === p && this.vars.onStart && (0 === this._time && this._duration || e || this._callback("onStart")), p <= (h = this._time))
                    for (i = this._first; i && (s = i._next, h === this._time && (!this._paused || y));)(i._active || i._startTime <= h && !i._paused && !i._gc) && (d === i && this.pause(), i._reversed ? i.render((i._dirty ? i.totalDuration() : i._totalDuration) - (t - i._startTime) * i._timeScale, e, n) : i.render((t - i._startTime) * i._timeScale, e, n)), i = s;
                else
                    for (i = this._last; i && (s = i._prev, h === this._time && (!this._paused || y));) {
                        if (i._active || i._startTime <= p && !i._paused && !i._gc) {
                            if (d === i) {
                                for (d = i._prev; d && d.endTime() > this._time;) d.render(d._reversed ? d.totalDuration() - (t - d._startTime) * d._timeScale : (t - d._startTime) * d._timeScale, e, n), d = d._prev;
                                d = null, this.pause()
                            }
                            i._reversed ? i.render((i._dirty ? i.totalDuration() : i._totalDuration) - (t - i._startTime) * i._timeScale, e, n) : i.render((t - i._startTime) * i._timeScale, e, n)
                        }
                        i = s
                    }
                this._onUpdate && (e || (u.length && c(), this._callback("onUpdate"))), a && (this._gc || (m === this._startTime || g !== this._timeScale) && (0 === this._time || f >= this.totalDuration()) && (o && (u.length && c(), this._timeline.autoRemoveChildren && this._enabled(!1, !1), this._active = !1), !e && this.vars[a] && this._callback(a)))
            }
        }, g._hasPausedChild = function() {
            for (var t = this._first; t;) {
                if (t._paused || t instanceof i && t._hasPausedChild()) return !0;
                t = t._next
            }
            return !1
        }, g.getChildren = function(t, e, i, r) {
            r = r || -9999999999;
            for (var o = [], s = this._first, a = 0; s;) s._startTime < r || (s instanceof n ? !1 !== e && (o[a++] = s) : (!1 !== i && (o[a++] = s), !1 !== t && (a = (o = o.concat(s.getChildren(!0, e, i))).length))), s = s._next;
            return o
        }, g.getTweensOf = function(t, e) {
            var i, r, o = this._gc,
                s = [],
                a = 0;
            for (o && this._enabled(!0, !0), r = (i = n.getTweensOf(t)).length; - 1 < --r;)(i[r].timeline === this || e && this._contains(i[r])) && (s[a++] = i[r]);
            return o && this._enabled(!1, !0), s
        }, g.recent = function() {
            return this._recent
        }, g._contains = function(t) {
            for (var e = t.timeline; e;) {
                if (e === this) return !0;
                e = e.timeline
            }
            return !1
        }, g.shiftChildren = function(t, e, n) {
            n = n || 0;
            for (var i, r = this._first, o = this._labels; r;) r._startTime >= n && (r._startTime += t), r = r._next;
            if (e)
                for (i in o) o[i] >= n && (o[i] += t);
            return this._uncache(!0)
        }, g._kill = function(t, e) {
            if (!t && !e) return this._enabled(!1, !1);
            for (var n = e ? this.getTweensOf(e) : this.getChildren(!0, !0, !1), i = n.length, r = !1; - 1 < --i;) n[i]._kill(t, e) && (r = !0);
            return r
        }, g.clear = function(t) {
            var e = this.getChildren(!1, !0, !0),
                n = e.length;
            for (this._time = this._totalTime = 0; - 1 < --n;) e[n]._enabled(!1, !1);
            return !1 !== t && (this._labels = {}), this._uncache(!0)
        }, g.invalidate = function() {
            for (var e = this._first; e;) e.invalidate(), e = e._next;
            return t.prototype.invalidate.call(this)
        }, g._enabled = function(t, n) {
            if (t === this._gc)
                for (var i = this._first; i;) i._enabled(t, !0), i = i._next;
            return e.prototype._enabled.call(this, t, n)
        }, g.totalTime = function(e, n, i) {
            this._forcingPlayhead = !0;
            var r = t.prototype.totalTime.apply(this, arguments);
            return this._forcingPlayhead = !1, r
        }, g.duration = function(t) {
            return arguments.length ? (0 !== this.duration() && 0 !== t && this.timeScale(this._duration / t), this) : (this._dirty && this.totalDuration(), this._duration)
        }, g.totalDuration = function(t) {
            if (!arguments.length) {
                if (this._dirty) {
                    for (var e, n, i = 0, r = this._last, o = 999999999999; r;) e = r._prev, r._dirty && r.totalDuration(), r._startTime > o && this._sortChildren && !r._paused && !this._calculatingDuration ? (this._calculatingDuration = 1, this.add(r, r._startTime - r._delay), this._calculatingDuration = 0) : o = r._startTime, r._startTime < 0 && !r._paused && (i -= r._startTime, this._timeline.smoothChildTiming && (this._startTime += r._startTime / this._timeScale, this._time -= r._startTime, this._totalTime -= r._startTime, this._rawPrevTime -= r._startTime), this.shiftChildren(-r._startTime, !1, -9999999999), o = 0), i < (n = r._startTime + r._totalDuration / r._timeScale) && (i = n), r = e;
                    this._duration = this._totalDuration = i, this._dirty = !1
                }
                return this._totalDuration
            }
            return t && this.totalDuration() ? this.timeScale(this._totalDuration / t) : this
        }, g.paused = function(e) {
            if (!e)
                for (var n = this._first, i = this._time; n;) n._startTime === i && "isPause" === n.data && (n._rawPrevTime = 0), n = n._next;
            return t.prototype.paused.apply(this, arguments)
        }, g.usesFrames = function() {
            for (var e = this._timeline; e._timeline;) e = e._timeline;
            return e === t._rootFramesTimeline
        }, g.rawTime = function(t) {
            return t && (this._paused || this._repeat && 0 < this.time() && this.totalProgress() < 1) ? this._totalTime % (this._duration + this._repeatDelay) : this._paused ? this._totalTime : (this._timeline.rawTime(t) - this._startTime) * this._timeScale
        }, i
    }, !0)
}), _gsScope._gsDefine && _gsScope._gsQueue.pop()(),
function(t) {
    "use strict";
    var e = function() {
        return (_gsScope.GreenSockGlobals || _gsScope).TimelineLite
    };
    "undefined" != typeof module && module.exports ? (require("./TweenLite.min.js"), module.exports = e()) : "function" == typeof define && define.amd && define(["TweenLite"], e)
}(), ((_gsScope = "undefined" != typeof module && module.exports && "undefined" != typeof global ? global : this || window)._gsQueue || (_gsScope._gsQueue = [])).push(function() {
    "use strict";
    _gsScope._gsDefine("plugins.CSSPlugin", ["plugins.TweenPlugin", "TweenLite"], function(t, e) {
        var n, i, r, o, s = function() {
                t.call(this, "css"), this._overwriteProps.length = 0, this.setRatio = s.prototype.setRatio
            },
            a = _gsScope._gsDefine.globals,
            l = {},
            u = s.prototype = new t("css");
        (u.constructor = s).version = "2.0.2", s.API = 2, s.defaultTransformPerspective = 0, s.defaultSkewType = "compensated", s.defaultSmoothOrigin = !0, u = "px", s.suffixMap = {
            top: u,
            right: u,
            bottom: u,
            left: u,
            width: u,
            height: u,
            fontSize: u,
            padding: u,
            margin: u,
            perspective: u,
            lineHeight: ""
        };
        var c, d, h, p, f, m, g, y, v, _, b = /(?:\-|\.|\b)(\d|\.|e\-)+/g,
            w = /(?:\d|\-\d|\.\d|\-\.\d|\+=\d|\-=\d|\+=.\d|\-=\.\d)+/g,
            x = /(?:\+=|\-=|\-|\b)[\d\-\.]+[a-zA-Z0-9]*(?:%|\b)/gi,
            S = /(?![+-]?\d*\.?\d+|[+-]|e[+-]\d+)[^0-9]/g,
            T = /(?:\d|\-|\+|=|#|\.)*/g,
            k = /opacity *= *([^)]*)/i,
            C = /opacity:([^;]*)/i,
            E = /alpha\(opacity *=.+?\)/i,
            A = /^(rgb|hsl)/,
            D = /([A-Z])/g,
            P = /-([a-z])/gi,
            O = /(^(?:url\(\"|url\())|(?:(\"\))$|\)$)/gi,
            I = function(t, e) {
                return e.toUpperCase()
            },
            M = /(?:Left|Right|Width)/i,
            L = /(M11|M12|M21|M22)=[\d\-\.e]+/gi,
            j = /progid\:DXImageTransform\.Microsoft\.Matrix\(.+?\)/i,
            N = /,(?=[^\)]*(?:\(|$))/gi,
            $ = /[\s,\(]/i,
            z = Math.PI / 180,
            F = 180 / Math.PI,
            R = {},
            H = {
                style: {}
            },
            q = _gsScope.document || {
                createElement: function() {
                    return H
                }
            },
            B = function(t, e) {
                return q.createElementNS ? q.createElementNS(e || "http://www.w3.org/1999/xhtml", t) : q.createElement(t)
            },
            U = B("div"),
            W = B("img"),
            X = s._internals = {
                _specialProps: l
            },
            Y = (_gsScope.navigator || {}).userAgent || "",
            Z = (v = Y.indexOf("Android"), _ = B("a"), h = -1 !== Y.indexOf("Safari") && -1 === Y.indexOf("Chrome") && (-1 === v || 3 < parseFloat(Y.substr(v + 8, 2))), f = h && parseFloat(Y.substr(Y.indexOf("Version/") + 8, 2)) < 6, p = -1 !== Y.indexOf("Firefox"), (/MSIE ([0-9]{1,}[\.0-9]{0,})/.exec(Y) || /Trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/.exec(Y)) && (m = parseFloat(RegExp.$1)), !!_ && (_.style.cssText = "top:1px;opacity:.55;", /^0.55/.test(_.style.opacity))),
            V = function(t) {
                return k.test("string" == typeof t ? t : (t.currentStyle ? t.currentStyle.filter : t.style.filter) || "") ? parseFloat(RegExp.$1) / 100 : 1
            },
            G = function(t) {
                _gsScope.console && console.log(t)
            },
            Q = "",
            K = "",
            J = function(t, e) {
                var n, i, r = (e = e || U).style;
                if (void 0 !== r[t]) return t;
                for (t = t.charAt(0).toUpperCase() + t.substr(1), n = ["O", "Moz", "ms", "Ms", "Webkit"], i = 5; - 1 < --i && void 0 === r[n[i] + t];);
                return 0 <= i ? (Q = "-" + (K = 3 === i ? "ms" : n[i]).toLowerCase() + "-", K + t) : null
            },
            tt = ("undefined" != typeof window ? window : q.defaultView || {
                getComputedStyle: function() {}
            }).getComputedStyle,
            et = s.getStyle = function(t, e, n, i, r) {
                var o;
                return Z || "opacity" !== e ? (!i && t.style[e] ? o = t.style[e] : (n = n || tt(t)) ? o = n[e] || n.getPropertyValue(e) || n.getPropertyValue(e.replace(D, "-$1").toLowerCase()) : t.currentStyle && (o = t.currentStyle[e]), null == r || o && "none" !== o && "auto" !== o && "auto auto" !== o ? o : r) : V(t)
            },
            nt = X.convertToPixels = function(t, n, i, r, o) {
                if ("px" === r || !r && "lineHeight" !== n) return i;
                if ("auto" === r || !i) return 0;
                var a, l, u, c = M.test(n),
                    d = t,
                    h = U.style,
                    p = i < 0,
                    f = 1 === i;
                if (p && (i = -i), f && (i *= 100), "lineHeight" !== n || r)
                    if ("%" === r && -1 !== n.indexOf("border")) a = i / 100 * (c ? t.clientWidth : t.clientHeight);
                    else {
                        if (h.cssText = "border:0 solid red;position:" + et(t, "position") + ";line-height:0;", "%" !== r && d.appendChild && "v" !== r.charAt(0) && "rem" !== r) h[c ? "borderLeftWidth" : "borderTopWidth"] = i + r;
                        else {
                            if (d = t.parentNode || q.body, -1 !== et(d, "display").indexOf("flex") && (h.position = "absolute"), l = d._gsCache, u = e.ticker.frame, l && c && l.time === u) return l.width * i / 100;
                            h[c ? "width" : "height"] = i + r
                        }
                        d.appendChild(U), a = parseFloat(U[c ? "offsetWidth" : "offsetHeight"]), d.removeChild(U), c && "%" === r && !1 !== s.cacheWidths && ((l = d._gsCache = d._gsCache || {}).time = u, l.width = a / i * 100), 0 !== a || o || (a = nt(t, n, i, r, !0))
                    }
                else l = tt(t).lineHeight, t.style.lineHeight = i, a = parseFloat(tt(t).lineHeight), t.style.lineHeight = l;
                return f && (a /= 100), p ? -a : a
            },
            it = X.calculateOffset = function(t, e, n) {
                if ("absolute" !== et(t, "position", n)) return 0;
                var i = "left" === e ? "Left" : "Top",
                    r = et(t, "margin" + i, n);
                return t["offset" + i] - (nt(t, e, parseFloat(r), r.replace(T, "")) || 0)
            },
            rt = function(t, e) {
                var n, i, r, o = {};
                if (e = e || tt(t, null))
                    if (n = e.length)
                        for (; - 1 < --n;)(-1 === (r = e[n]).indexOf("-transform") || jt === r) && (o[r.replace(P, I)] = e.getPropertyValue(r));
                    else
                        for (n in e)(-1 === n.indexOf("Transform") || Lt === n) && (o[n] = e[n]);
                else if (e = t.currentStyle || t.style)
                    for (n in e) "string" == typeof n && void 0 === o[n] && (o[n.replace(P, I)] = e[n]);
                return Z || (o.opacity = V(t)), i = Zt(t, e, !1), o.rotation = i.rotation, o.skewX = i.skewX, o.scaleX = i.scaleX, o.scaleY = i.scaleY, o.x = i.x, o.y = i.y, $t && (o.z = i.z, o.rotationX = i.rotationX, o.rotationY = i.rotationY, o.scaleZ = i.scaleZ), o.filters && delete o.filters, o
            },
            ot = function(t, e, n, i, r) {
                var o, s, a, l = {},
                    u = t.style;
                for (s in n) "cssText" !== s && "length" !== s && isNaN(s) && (e[s] !== (o = n[s]) || r && r[s]) && -1 === s.indexOf("Origin") && ("number" == typeof o || "string" == typeof o) && (l[s] = "auto" !== o || "left" !== s && "top" !== s ? "" !== o && "auto" !== o && "none" !== o || "string" != typeof e[s] || "" === e[s].replace(S, "") ? o : 0 : it(t, s), void 0 !== u[s] && (a = new bt(u, s, u[s], a)));
                if (i)
                    for (s in i) "className" !== s && (l[s] = i[s]);
                return {
                    difs: l,
                    firstMPT: a
                }
            },
            st = {
                width: ["Left", "Right"],
                height: ["Top", "Bottom"]
            },
            at = ["marginLeft", "marginRight", "marginTop", "marginBottom"],
            lt = function(t, e, n) {
                if ("svg" === (t.nodeName + "").toLowerCase()) return (n || tt(t))[e] || 0;
                if (t.getCTM && Wt(t)) return t.getBBox()[e] || 0;
                var i = parseFloat("width" === e ? t.offsetWidth : t.offsetHeight),
                    r = st[e],
                    o = r.length;
                for (n = n || tt(t, null); - 1 < --o;) i -= parseFloat(et(t, "padding" + r[o], n, !0)) || 0, i -= parseFloat(et(t, "border" + r[o] + "Width", n, !0)) || 0;
                return i
            },
            ut = function(t, e) {
                if ("contain" === t || "auto" === t || "auto auto" === t) return t + " ";
                (null == t || "" === t) && (t = "0 0");
                var n, i = t.split(" "),
                    r = -1 !== t.indexOf("left") ? "0%" : -1 !== t.indexOf("right") ? "100%" : i[0],
                    o = -1 !== t.indexOf("top") ? "0%" : -1 !== t.indexOf("bottom") ? "100%" : i[1];
                if (3 < i.length && !e) {
                    for (i = t.split(", ").join(",").split(","), t = [], n = 0; n < i.length; n++) t.push(ut(i[n]));
                    return t.join(",")
                }
                return null == o ? o = "center" === r ? "50%" : "0" : "center" === o && (o = "50%"), ("center" === r || isNaN(parseFloat(r)) && -1 === (r + "").indexOf("=")) && (r = "50%"), t = r + " " + o + (2 < i.length ? " " + i[2] : ""), e && (e.oxp = -1 !== r.indexOf("%"), e.oyp = -1 !== o.indexOf("%"), e.oxr = "=" === r.charAt(1), e.oyr = "=" === o.charAt(1), e.ox = parseFloat(r.replace(S, "")), e.oy = parseFloat(o.replace(S, "")), e.v = t), e || t
            },
            ct = function(t, e) {
                return "function" == typeof t && (t = t(y, g)), "string" == typeof t && "=" === t.charAt(1) ? parseInt(t.charAt(0) + "1", 10) * parseFloat(t.substr(2)) : parseFloat(t) - parseFloat(e) || 0
            },
            dt = function(t, e) {
                "function" == typeof t && (t = t(y, g));
                var n = "string" == typeof t && "=" === t.charAt(1);
                return "string" == typeof t && "v" === t.charAt(t.length - 2) && (t = (n ? t.substr(0, 2) : 0) + window["inner" + ("vh" === t.substr(-2) ? "Height" : "Width")] * (parseFloat(n ? t.substr(2) : t) / 100)), null == t ? e : n ? parseInt(t.charAt(0) + "1", 10) * parseFloat(t.substr(2)) + e : parseFloat(t) || 0
            },
            ht = function(t, e, n, i) {
                var r, o, s, a, l;
                return "function" == typeof t && (t = t(y, g)), null == t ? a = e : "number" == typeof t ? a = t : (r = 360, o = t.split("_"), s = ((l = "=" === t.charAt(1)) ? parseInt(t.charAt(0) + "1", 10) * parseFloat(o[0].substr(2)) : parseFloat(o[0])) * (-1 === t.indexOf("rad") ? 1 : F) - (l ? 0 : e), o.length && (i && (i[n] = e + s), -1 !== t.indexOf("short") && (s %= r) != s % 180 && (s = s < 0 ? s + r : s - r), -1 !== t.indexOf("_cw") && s < 0 ? s = (s + 3599999999640) % r - (s / r | 0) * r : -1 !== t.indexOf("ccw") && 0 < s && (s = (s - 3599999999640) % r - (s / r | 0) * r)), a = e + s), a < 1e-6 && -1e-6 < a && (a = 0), a
            },
            pt = {
                aqua: [0, 255, 255],
                lime: [0, 255, 0],
                silver: [192, 192, 192],
                black: [0, 0, 0],
                maroon: [128, 0, 0],
                teal: [0, 128, 128],
                blue: [0, 0, 255],
                navy: [0, 0, 128],
                white: [255, 255, 255],
                fuchsia: [255, 0, 255],
                olive: [128, 128, 0],
                yellow: [255, 255, 0],
                orange: [255, 165, 0],
                gray: [128, 128, 128],
                purple: [128, 0, 128],
                green: [0, 128, 0],
                red: [255, 0, 0],
                pink: [255, 192, 203],
                cyan: [0, 255, 255],
                transparent: [255, 255, 255, 0]
            },
            ft = function(t, e, n) {
                return 255 * (6 * (t = t < 0 ? t + 1 : 1 < t ? t - 1 : t) < 1 ? e + (n - e) * t * 6 : t < .5 ? n : 3 * t < 2 ? e + (n - e) * (2 / 3 - t) * 6 : e) + .5 | 0
            },
            mt = s.parseColor = function(t, e) {
                var n, i, r, o, s, a, l, u, c, d, h;
                if (t)
                    if ("number" == typeof t) n = [t >> 16, t >> 8 & 255, 255 & t];
                    else {
                        if ("," === t.charAt(t.length - 1) && (t = t.substr(0, t.length - 1)), pt[t]) n = pt[t];
                        else if ("#" === t.charAt(0)) 4 === t.length && (t = "#" + (i = t.charAt(1)) + i + (r = t.charAt(2)) + r + (o = t.charAt(3)) + o), n = [(t = parseInt(t.substr(1), 16)) >> 16, t >> 8 & 255, 255 & t];
                        else if ("hsl" === t.substr(0, 3))
                            if (n = h = t.match(b), e) {
                                if (-1 !== t.indexOf("=")) return t.match(w)
                            } else s = Number(n[0]) % 360 / 360, a = Number(n[1]) / 100, i = 2 * (l = Number(n[2]) / 100) - (r = l <= .5 ? l * (a + 1) : l + a - l * a), 3 < n.length && (n[3] = Number(n[3])), n[0] = ft(s + 1 / 3, i, r), n[1] = ft(s, i, r), n[2] = ft(s - 1 / 3, i, r);
                        else n = t.match(b) || pt.transparent;
                        n[0] = Number(n[0]), n[1] = Number(n[1]), n[2] = Number(n[2]), 3 < n.length && (n[3] = Number(n[3]))
                    }
                else n = pt.black;
                return e && !h && (i = n[0] / 255, r = n[1] / 255, o = n[2] / 255, l = ((u = Math.max(i, r, o)) + (c = Math.min(i, r, o))) / 2, u === c ? s = a = 0 : (d = u - c, a = .5 < l ? d / (2 - u - c) : d / (u + c), s = u === i ? (r - o) / d + (r < o ? 6 : 0) : u === r ? (o - i) / d + 2 : (i - r) / d + 4, s *= 60), n[0] = s + .5 | 0, n[1] = 100 * a + .5 | 0, n[2] = 100 * l + .5 | 0), n
            },
            gt = function(t, e) {
                var n, i, r, o = t.match(yt) || [],
                    s = 0,
                    a = "";
                if (!o.length) return t;
                for (n = 0; n < o.length; n++) i = o[n], s += (r = t.substr(s, t.indexOf(i, s) - s)).length + i.length, 3 === (i = mt(i, e)).length && i.push(1), a += r + (e ? "hsla(" + i[0] + "," + i[1] + "%," + i[2] + "%," + i[3] : "rgba(" + i.join(",")) + ")";
                return a + t.substr(s)
            },
            yt = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3}){1,2}\\b";
        for (u in pt) yt += "|" + u + "\\b";
        yt = new RegExp(yt + ")", "gi"), s.colorStringFilter = function(t) {
            var e, n = t[0] + " " + t[1];
            yt.test(n) && (e = -1 !== n.indexOf("hsl(") || -1 !== n.indexOf("hsla("), t[0] = gt(t[0], e), t[1] = gt(t[1], e)), yt.lastIndex = 0
        }, e.defaultStringFilter || (e.defaultStringFilter = s.colorStringFilter);
        var vt = function(t, e, n, i) {
                if (null == t) return function(t) {
                    return t
                };
                var r, o = e ? (t.match(yt) || [""])[0] : "",
                    s = t.split(o).join("").match(x) || [],
                    a = t.substr(0, t.indexOf(s[0])),
                    l = ")" === t.charAt(t.length - 1) ? ")" : "",
                    u = -1 !== t.indexOf(" ") ? " " : ",",
                    c = s.length,
                    d = 0 < c ? s[0].replace(b, "") : "";
                return c ? r = e ? function(t) {
                    var e, h, p, f;
                    if ("number" == typeof t) t += d;
                    else if (i && N.test(t)) {
                        for (f = t.replace(N, "|").split("|"), p = 0; p < f.length; p++) f[p] = r(f[p]);
                        return f.join(",")
                    }
                    if (e = (t.match(yt) || [o])[0], p = (h = t.split(e).join("").match(x) || []).length, c > p--)
                        for (; ++p < c;) h[p] = n ? h[(p - 1) / 2 | 0] : s[p];
                    return a + h.join(u) + u + e + l + (-1 !== t.indexOf("inset") ? " inset" : "")
                } : function(t) {
                    var e, o, h;
                    if ("number" == typeof t) t += d;
                    else if (i && N.test(t)) {
                        for (o = t.replace(N, "|").split("|"), h = 0; h < o.length; h++) o[h] = r(o[h]);
                        return o.join(",")
                    }
                    if (h = (e = t.match(x) || []).length, c > h--)
                        for (; ++h < c;) e[h] = n ? e[(h - 1) / 2 | 0] : s[h];
                    return a + e.join(u) + l
                } : function(t) {
                    return t
                }
            },
            _t = function(t) {
                return t = t.split(","),
                    function(e, n, i, r, o, s, a) {
                        var l, u = (n + "").split(" ");
                        for (a = {}, l = 0; l < 4; l++) a[t[l]] = u[l] = u[l] || u[(l - 1) / 2 >> 0];
                        return r.parse(e, a, o, s)
                    }
            },
            bt = (X._setPluginRatio = function(t) {
                this.plugin.setRatio(t);
                for (var e, n, i, r, o, s = this.data, a = s.proxy, l = s.firstMPT; l;) e = a[l.v], l.r ? e = l.r(e) : e < 1e-6 && -1e-6 < e && (e = 0), l.t[l.p] = e, l = l._next;
                if (s.autoRotate && (s.autoRotate.rotation = s.mod ? s.mod.call(this._tween, a.rotation, this.t, this._tween) : a.rotation), 1 === t || 0 === t)
                    for (l = s.firstMPT, o = 1 === t ? "e" : "b"; l;) {
                        if ((n = l.t).type) {
                            if (1 === n.type) {
                                for (r = n.xs0 + n.s + n.xs1, i = 1; i < n.l; i++) r += n["xn" + i] + n["xs" + (i + 1)];
                                n[o] = r
                            }
                        } else n[o] = n.s + n.xs0;
                        l = l._next
                    }
            }, function(t, e, n, i, r) {
                this.t = t, this.p = e, this.v = n, this.r = r, i && ((i._prev = this)._next = i)
            }),
            wt = (X._parseToProxy = function(t, e, n, i, r, o) {
                var s, a, l, u, c, d = i,
                    h = {},
                    p = {},
                    f = n._transform,
                    m = R;
                for (n._transform = null, R = e, i = c = n.parse(t, e, i, r), R = m, o && (n._transform = f, d && (d._prev = null, d._prev && (d._prev._next = null))); i && i !== d;) {
                    if (i.type <= 1 && (p[a = i.p] = i.s + i.c, h[a] = i.s, o || (u = new bt(i, "s", a, u, i.r), i.c = 0), 1 === i.type))
                        for (s = i.l; 0 < --s;) l = "xn" + s, p[a = i.p + "_" + l] = i.data[l], h[a] = i[l], o || (u = new bt(i, l, a, u, i.rxp[l]));
                    i = i._next
                }
                return {
                    proxy: h,
                    end: p,
                    firstMPT: u,
                    pt: c
                }
            }, X.CSSPropTween = function(t, e, i, r, s, a, l, u, c, d, h) {
                this.t = t, this.p = e, this.s = i, this.c = r, this.n = l || e, t instanceof wt || o.push(this.n), this.r = u ? "function" == typeof u ? u : Math.round : u, this.type = a || 0, c && (this.pr = c, n = !0), this.b = void 0 === d ? i : d, this.e = void 0 === h ? i + r : h, s && ((this._next = s)._prev = this)
            }),
            xt = function(t, e, n, i, r, o) {
                var s = new wt(t, e, n, i - n, r, -1, o);
                return s.b = n, s.e = s.xs0 = i, s
            },
            St = s.parseComplex = function(t, e, n, i, r, o, a, l, u, d) {
                n = n || o || "", "function" == typeof i && (i = i(y, g)), a = new wt(t, e, 0, 0, a, d ? 2 : 1, null, !1, l, n, i), i += "", r && yt.test(i + n) && (i = [n, i], s.colorStringFilter(i), n = i[0], i = i[1]);
                var h, p, f, m, v, _, x, S, T, k, C, E, A, D = n.split(", ").join(",").split(" "),
                    P = i.split(", ").join(",").split(" "),
                    O = D.length,
                    I = !1 !== c;
                for ((-1 !== i.indexOf(",") || -1 !== n.indexOf(",")) && (-1 !== (i + n).indexOf("rgb") || -1 !== (i + n).indexOf("hsl") ? (D = D.join(" ").replace(N, ", ").split(" "), P = P.join(" ").replace(N, ", ").split(" ")) : (D = D.join(" ").split(",").join(", ").split(" "), P = P.join(" ").split(",").join(", ").split(" ")), O = D.length), O !== P.length && (O = (D = (o || "").split(" ")).length), a.plugin = u, a.setRatio = d, h = yt.lastIndex = 0; h < O; h++)
                    if (m = D[h], v = P[h] + "", (S = parseFloat(m)) || 0 === S) a.appendXtra("", S, ct(v, S), v.replace(w, ""), !(!I || -1 === v.indexOf("px")) && Math.round, !0);
                    else if (r && yt.test(m)) E = ")" + ((E = v.indexOf(")") + 1) ? v.substr(E) : ""), A = -1 !== v.indexOf("hsl") && Z, k = v, m = mt(m, A), v = mt(v, A), (T = 6 < m.length + v.length) && !Z && 0 === v[3] ? (a["xs" + a.l] += a.l ? " transparent" : "transparent", a.e = a.e.split(P[h]).join("transparent")) : (Z || (T = !1), A ? a.appendXtra(k.substr(0, k.indexOf("hsl")) + (T ? "hsla(" : "hsl("), m[0], ct(v[0], m[0]), ",", !1, !0).appendXtra("", m[1], ct(v[1], m[1]), "%,", !1).appendXtra("", m[2], ct(v[2], m[2]), T ? "%," : "%" + E, !1) : a.appendXtra(k.substr(0, k.indexOf("rgb")) + (T ? "rgba(" : "rgb("), m[0], v[0] - m[0], ",", Math.round, !0).appendXtra("", m[1], v[1] - m[1], ",", Math.round).appendXtra("", m[2], v[2] - m[2], T ? "," : E, Math.round), T && (m = m.length < 4 ? 1 : m[3], a.appendXtra("", m, (v.length < 4 ? 1 : v[3]) - m, E, !1))), yt.lastIndex = 0;
                else if (_ = m.match(b)) {
                    if (!(x = v.match(w)) || x.length !== _.length) return a;
                    for (p = f = 0; p < _.length; p++) C = _[p], k = m.indexOf(C, f), a.appendXtra(m.substr(f, k - f), Number(C), ct(x[p], C), "", !(!I || "px" !== m.substr(k + C.length, 2)) && Math.round, 0 === p), f = k + C.length;
                    a["xs" + a.l] += m.substr(f)
                } else a["xs" + a.l] += a.l || a["xs" + a.l] ? " " + v : v;
                if (-1 !== i.indexOf("=") && a.data) {
                    for (E = a.xs0 + a.data.s, h = 1; h < a.l; h++) E += a["xs" + h] + a.data["xn" + h];
                    a.e = E + a["xs" + h]
                }
                return a.l || (a.type = -1, a.xs0 = a.e), a.xfirst || a
            },
            Tt = 9;
        for ((u = wt.prototype).l = u.pr = 0; 0 < --Tt;) u["xn" + Tt] = 0, u["xs" + Tt] = "";
        u.xs0 = "", u._next = u._prev = u.xfirst = u.data = u.plugin = u.setRatio = u.rxp = null, u.appendXtra = function(t, e, n, i, r, o) {
            var s = this,
                a = s.l;
            return s["xs" + a] += o && (a || s["xs" + a]) ? " " + t : t || "", n || 0 === a || s.plugin ? (s.l++, s.type = s.setRatio ? 2 : 1, s["xs" + s.l] = i || "", 0 < a ? (s.data["xn" + a] = e + n, s.rxp["xn" + a] = r, s["xn" + a] = e, s.plugin || (s.xfirst = new wt(s, "xn" + a, e, n, s.xfirst || s, 0, s.n, r, s.pr), s.xfirst.xs0 = 0)) : (s.data = {
                s: e + n
            }, s.rxp = {}, s.s = e, s.c = n, s.r = r)) : s["xs" + a] += e + (i || ""), s
        };
        var kt = function(t, e) {
                e = e || {}, this.p = e.prefix && J(t) || t, l[t] = l[this.p] = this, this.format = e.formatter || vt(e.defaultValue, e.color, e.collapsible, e.multi), e.parser && (this.parse = e.parser), this.clrs = e.color, this.multi = e.multi, this.keyword = e.keyword, this.dflt = e.defaultValue, this.pr = e.priority || 0
            },
            Ct = X._registerComplexSpecialProp = function(t, e, n) {
                "object" != typeof e && (e = {
                    parser: n
                });
                var i, r = t.split(","),
                    o = e.defaultValue;
                for (n = n || [o], i = 0; i < r.length; i++) e.prefix = 0 === i && e.prefix, e.defaultValue = n[i] || o, new kt(r[i], e)
            },
            Et = X._registerPluginProp = function(t) {
                if (!l[t]) {
                    var e = t.charAt(0).toUpperCase() + t.substr(1) + "Plugin";
                    Ct(t, {
                        parser: function(t, n, i, r, o, s, u) {
                            var c = a.com.greensock.plugins[e];
                            return c ? (c._cssRegister(), l[i].parse(t, n, i, r, o, s, u)) : (G("Error: " + e + " js file not loaded."), o)
                        }
                    })
                }
            };
        (u = kt.prototype).parseComplex = function(t, e, n, i, r, o) {
            var s, a, l, u, c, d, h = this.keyword;
            if (this.multi && (N.test(n) || N.test(e) ? (a = e.replace(N, "|").split("|"), l = n.replace(N, "|").split("|")) : h && (a = [e], l = [n])), l) {
                for (u = l.length > a.length ? l.length : a.length, s = 0; s < u; s++) e = a[s] = a[s] || this.dflt, n = l[s] = l[s] || this.dflt, h && (c = e.indexOf(h)) !== (d = n.indexOf(h)) && (-1 === d ? a[s] = a[s].split(h).join("") : -1 === c && (a[s] += " " + h));
                e = a.join(", "), n = l.join(", ")
            }
            return St(t, this.p, e, n, this.clrs, this.dflt, i, this.pr, r, o)
        }, u.parse = function(t, e, n, i, o, s, a) {
            return this.parseComplex(t.style, this.format(et(t, this.p, r, !1, this.dflt)), this.format(e), o, s)
        }, s.registerSpecialProp = function(t, e, n) {
            Ct(t, {
                parser: function(t, i, r, o, s, a, l) {
                    var u = new wt(t, r, 0, 0, s, 2, r, !1, n);
                    return u.plugin = a, u.setRatio = e(t, i, o._tween, r), u
                },
                priority: n
            })
        }, s.useSVGTransformAttr = !0;
        var At, Dt, Pt, Ot, It, Mt = "scaleX,scaleY,scaleZ,x,y,z,skewX,skewY,rotation,rotationX,rotationY,perspective,xPercent,yPercent".split(","),
            Lt = J("transform"),
            jt = Q + "transform",
            Nt = J("transformOrigin"),
            $t = null !== J("perspective"),
            zt = X.Transform = function() {
                this.perspective = parseFloat(s.defaultTransformPerspective) || 0, this.force3D = !(!1 === s.defaultForce3D || !$t) && (s.defaultForce3D || "auto")
            },
            Ft = _gsScope.SVGElement,
            Rt = function(t, e, n) {
                var i, r = q.createElementNS("http://www.w3.org/2000/svg", t),
                    o = /([a-z])([A-Z])/g;
                for (i in n) r.setAttributeNS(null, i.replace(o, "$1-$2").toLowerCase(), n[i]);
                return e.appendChild(r), r
            },
            Ht = q.documentElement || {},
            qt = (It = m || /Android/i.test(Y) && !_gsScope.chrome, q.createElementNS && !It && (Dt = Rt("svg", Ht), Ot = (Pt = Rt("rect", Dt, {
                width: 100,
                height: 50,
                x: 100
            })).getBoundingClientRect().width, Pt.style[Nt] = "50% 50%", Pt.style[Lt] = "scaleX(0.5)", It = Ot === Pt.getBoundingClientRect().width && !(p && $t), Ht.removeChild(Dt)), It),
            Bt = function(t, e, n, i, r, o) {
                var a, l, u, c, d, h, p, f, m, g, y, v, _, b, w = t._gsTransform,
                    x = Yt(t, !0);
                w && (_ = w.xOrigin, b = w.yOrigin), (!i || (a = i.split(" ")).length < 2) && (0 === (p = t.getBBox()).x && 0 === p.y && p.width + p.height === 0 && (p = {
                    x: parseFloat(t.hasAttribute("x") ? t.getAttribute("x") : t.hasAttribute("cx") ? t.getAttribute("cx") : 0) || 0,
                    y: parseFloat(t.hasAttribute("y") ? t.getAttribute("y") : t.hasAttribute("cy") ? t.getAttribute("cy") : 0) || 0,
                    width: 0,
                    height: 0
                }), a = [(-1 !== (e = ut(e).split(" "))[0].indexOf("%") ? parseFloat(e[0]) / 100 * p.width : parseFloat(e[0])) + p.x, (-1 !== e[1].indexOf("%") ? parseFloat(e[1]) / 100 * p.height : parseFloat(e[1])) + p.y]), n.xOrigin = c = parseFloat(a[0]), n.yOrigin = d = parseFloat(a[1]), i && x !== Xt && (h = x[0], p = x[1], f = x[2], m = x[3], g = x[4], y = x[5], (v = h * m - p * f) && (l = c * (m / v) + d * (-f / v) + (f * y - m * g) / v, u = c * (-p / v) + d * (h / v) - (h * y - p * g) / v, c = n.xOrigin = a[0] = l, d = n.yOrigin = a[1] = u)), w && (o && (n.xOffset = w.xOffset, n.yOffset = w.yOffset, w = n), r || !1 !== r && !1 !== s.defaultSmoothOrigin ? (l = c - _, u = d - b, w.xOffset += l * x[0] + u * x[2] - l, w.yOffset += l * x[1] + u * x[3] - u) : w.xOffset = w.yOffset = 0), o || t.setAttribute("data-svg-origin", a.join(" "))
            },
            Ut = function(t) {
                var e, n = B("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"),
                    i = this.parentNode,
                    r = this.nextSibling,
                    o = this.style.cssText;
                if (Ht.appendChild(n), n.appendChild(this), this.style.display = "block", t) try {
                    e = this.getBBox(), this._originalGetBBox = this.getBBox, this.getBBox = Ut
                } catch (t) {} else this._originalGetBBox && (e = this._originalGetBBox());
                return r ? i.insertBefore(this, r) : i.appendChild(this), Ht.removeChild(n), this.style.cssText = o, e
            },
            Wt = function(t) {
                return !(!Ft || !t.getCTM || t.parentNode && !t.ownerSVGElement || ! function(t) {
                    try {
                        return t.getBBox()
                    } catch (e) {
                        return Ut.call(t, !0)
                    }
                }(t))
            },
            Xt = [1, 0, 0, 1, 0, 0],
            Yt = function(t, e) {
                var n, i, r, o, s, a, l = t._gsTransform || new zt,
                    u = t.style;
                if (Lt ? i = et(t, jt, null, !0) : t.currentStyle && (i = (i = t.currentStyle.filter.match(L)) && 4 === i.length ? [i[0].substr(4), Number(i[2].substr(4)), Number(i[1].substr(4)), i[3].substr(4), l.x || 0, l.y || 0].join(",") : ""), n = !i || "none" === i || "matrix(1, 0, 0, 1, 0, 0)" === i, !Lt || !(a = !tt(t) || "none" === tt(t).display) && t.parentNode || (a && (o = u.display, u.display = "block"), t.parentNode || (s = 1, Ht.appendChild(t)), n = !(i = et(t, jt, null, !0)) || "none" === i || "matrix(1, 0, 0, 1, 0, 0)" === i, o ? u.display = o : a && Kt(u, "display"), s && Ht.removeChild(t)), (l.svg || t.getCTM && Wt(t)) && (n && -1 !== (u[Lt] + "").indexOf("matrix") && (i = u[Lt], n = 0), r = t.getAttribute("transform"), n && r && (i = "matrix(" + (r = t.transform.baseVal.consolidate().matrix).a + "," + r.b + "," + r.c + "," + r.d + "," + r.e + "," + r.f + ")", n = 0)), n) return Xt;
                for (r = (i || "").match(b) || [], Tt = r.length; - 1 < --Tt;) o = Number(r[Tt]), r[Tt] = (s = o - (o |= 0)) ? (1e5 * s + (s < 0 ? -.5 : .5) | 0) / 1e5 + o : o;
                return e && 6 < r.length ? [r[0], r[1], r[4], r[5], r[12], r[13]] : r
            },
            Zt = X.getTransform = function(t, n, i, r) {
                if (t._gsTransform && i && !r) return t._gsTransform;
                var o, a, l, u, c, d, h = i && t._gsTransform || new zt,
                    p = h.scaleX < 0,
                    f = $t && (parseFloat(et(t, Nt, n, !1, "0 0 0").split(" ")[2]) || h.zOrigin) || 0,
                    m = parseFloat(s.defaultTransformPerspective) || 0;
                if (h.svg = !(!t.getCTM || !Wt(t)), h.svg && (Bt(t, et(t, Nt, n, !1, "50% 50%") + "", h, t.getAttribute("data-svg-origin")), At = s.useSVGTransformAttr || qt), (o = Yt(t)) !== Xt) {
                    if (16 === o.length) {
                        var g, y, v, _, b, w = o[0],
                            x = o[1],
                            S = o[2],
                            T = o[3],
                            k = o[4],
                            C = o[5],
                            E = o[6],
                            A = o[7],
                            D = o[8],
                            P = o[9],
                            O = o[10],
                            I = o[12],
                            M = o[13],
                            L = o[14],
                            j = o[11],
                            N = Math.atan2(E, O);
                        h.zOrigin && (I = D * (L = -h.zOrigin) - o[12], M = P * L - o[13], L = O * L + h.zOrigin - o[14]), h.rotationX = N * F, N && (g = k * (_ = Math.cos(-N)) + D * (b = Math.sin(-N)), y = C * _ + P * b, v = E * _ + O * b, D = k * -b + D * _, P = C * -b + P * _, O = E * -b + O * _, j = A * -b + j * _, k = g, C = y, E = v), N = Math.atan2(-S, O), h.rotationY = N * F, N && (y = x * (_ = Math.cos(-N)) - P * (b = Math.sin(-N)), v = S * _ - O * b, P = x * b + P * _, O = S * b + O * _, j = T * b + j * _, w = g = w * _ - D * b, x = y, S = v), N = Math.atan2(x, w), h.rotation = N * F, N && (g = w * (_ = Math.cos(N)) + x * (b = Math.sin(N)), y = k * _ + C * b, v = D * _ + P * b, x = x * _ - w * b, C = C * _ - k * b, P = P * _ - D * b, w = g, k = y, D = v), h.rotationX && 359.9 < Math.abs(h.rotationX) + Math.abs(h.rotation) && (h.rotationX = h.rotation = 0, h.rotationY = 180 - h.rotationY), N = Math.atan2(k, C), h.scaleX = (1e5 * Math.sqrt(w * w + x * x + S * S) + .5 | 0) / 1e5, h.scaleY = (1e5 * Math.sqrt(C * C + E * E) + .5 | 0) / 1e5, h.scaleZ = (1e5 * Math.sqrt(D * D + P * P + O * O) + .5 | 0) / 1e5, w /= h.scaleX, k /= h.scaleY, x /= h.scaleX, C /= h.scaleY, 2e-5 < Math.abs(N) ? (h.skewX = N * F, k = 0, "simple" !== h.skewType && (h.scaleY *= 1 / Math.cos(N))) : h.skewX = 0, h.perspective = j ? 1 / (j < 0 ? -j : j) : 0, h.x = I, h.y = M, h.z = L, h.svg && (h.x -= h.xOrigin - (h.xOrigin * w - h.yOrigin * k), h.y -= h.yOrigin - (h.yOrigin * x - h.xOrigin * C))
                    } else if (!$t || r || !o.length || h.x !== o[4] || h.y !== o[5] || !h.rotationX && !h.rotationY) {
                        var $ = 6 <= o.length,
                            z = $ ? o[0] : 1,
                            R = o[1] || 0,
                            H = o[2] || 0,
                            q = $ ? o[3] : 1;
                        h.x = o[4] || 0, h.y = o[5] || 0, l = Math.sqrt(z * z + R * R), u = Math.sqrt(q * q + H * H), c = z || R ? Math.atan2(R, z) * F : h.rotation || 0, d = H || q ? Math.atan2(H, q) * F + c : h.skewX || 0, h.scaleX = l, h.scaleY = u, h.rotation = c, h.skewX = d, $t && (h.rotationX = h.rotationY = h.z = 0, h.perspective = m, h.scaleZ = 1), h.svg && (h.x -= h.xOrigin - (h.xOrigin * z + h.yOrigin * H), h.y -= h.yOrigin - (h.xOrigin * R + h.yOrigin * q))
                    }
                    for (a in 90 < Math.abs(h.skewX) && Math.abs(h.skewX) < 270 && (p ? (h.scaleX *= -1, h.skewX += h.rotation <= 0 ? 180 : -180, h.rotation += h.rotation <= 0 ? 180 : -180) : (h.scaleY *= -1, h.skewX += h.skewX <= 0 ? 180 : -180)), h.zOrigin = f, h) h[a] < 2e-5 && -2e-5 < h[a] && (h[a] = 0)
                }
                return i && (t._gsTransform = h).svg && (At && t.style[Lt] ? e.delayedCall(.001, function() {
                    Kt(t.style, Lt)
                }) : !At && t.getAttribute("transform") && e.delayedCall(.001, function() {
                    t.removeAttribute("transform")
                })), h
            },
            Vt = function(t) {
                var e, n, i = this.data,
                    r = -i.rotation * z,
                    o = r + i.skewX * z,
                    s = 1e5,
                    a = (Math.cos(r) * i.scaleX * s | 0) / s,
                    l = (Math.sin(r) * i.scaleX * s | 0) / s,
                    u = (Math.sin(o) * -i.scaleY * s | 0) / s,
                    c = (Math.cos(o) * i.scaleY * s | 0) / s,
                    d = this.t.style,
                    h = this.t.currentStyle;
                if (h) {
                    n = l, l = -u, u = -n, e = h.filter, d.filter = "";
                    var p, f, g = this.t.offsetWidth,
                        y = this.t.offsetHeight,
                        v = "absolute" !== h.position,
                        _ = "progid:DXImageTransform.Microsoft.Matrix(M11=" + a + ", M12=" + l + ", M21=" + u + ", M22=" + c,
                        b = i.x + g * i.xPercent / 100,
                        w = i.y + y * i.yPercent / 100;
                    if (null != i.ox && (b += (p = (i.oxp ? g * i.ox * .01 : i.ox) - g / 2) - (p * a + (f = (i.oyp ? y * i.oy * .01 : i.oy) - y / 2) * l), w += f - (p * u + f * c)), _ += v ? ", Dx=" + ((p = g / 2) - (p * a + (f = y / 2) * l) + b) + ", Dy=" + (f - (p * u + f * c) + w) + ")" : ", sizingMethod='auto expand')", -1 !== e.indexOf("DXImageTransform.Microsoft.Matrix(") ? d.filter = e.replace(j, _) : d.filter = _ + " " + e, (0 === t || 1 === t) && 1 === a && 0 === l && 0 === u && 1 === c && (v && -1 === _.indexOf("Dx=0, Dy=0") || k.test(e) && 100 !== parseFloat(RegExp.$1) || -1 === e.indexOf(e.indexOf("Alpha")) && d.removeAttribute("filter")), !v) {
                        var x, S, C, E = m < 8 ? 1 : -1;
                        for (p = i.ieOffsetX || 0, f = i.ieOffsetY || 0, i.ieOffsetX = Math.round((g - ((a < 0 ? -a : a) * g + (l < 0 ? -l : l) * y)) / 2 + b), i.ieOffsetY = Math.round((y - ((c < 0 ? -c : c) * y + (u < 0 ? -u : u) * g)) / 2 + w), Tt = 0; Tt < 4; Tt++) C = (n = -1 !== (x = h[S = at[Tt]]).indexOf("px") ? parseFloat(x) : nt(this.t, S, parseFloat(x), x.replace(T, "")) || 0) !== i[S] ? Tt < 2 ? -i.ieOffsetX : -i.ieOffsetY : Tt < 2 ? p - i.ieOffsetX : f - i.ieOffsetY, d[S] = (i[S] = Math.round(n - C * (0 === Tt || 2 === Tt ? 1 : E))) + "px"
                    }
                }
            },
            Gt = X.set3DTransformRatio = X.setTransformRatio = function(t) {
                var e, n, i, r, o, s, a, l, u, c, d, h, f, m, g, y, v, _, b, w, x, S, T, k = this.data,
                    C = this.t.style,
                    E = k.rotation,
                    A = k.rotationX,
                    D = k.rotationY,
                    P = k.scaleX,
                    O = k.scaleY,
                    I = k.scaleZ,
                    M = k.x,
                    L = k.y,
                    j = k.z,
                    N = k.svg,
                    $ = k.perspective,
                    F = k.force3D,
                    R = k.skewY,
                    H = k.skewX;
                if (R && (H += R, E += R), !((1 !== t && 0 !== t || "auto" !== F || this.tween._totalTime !== this.tween._totalDuration && this.tween._totalTime) && F || j || $ || D || A || 1 !== I) || At && N || !$t) E || H || N ? (E *= z, S = H * z, T = 1e5, n = Math.cos(E) * P, o = Math.sin(E) * P, i = Math.sin(E - S) * -O, s = Math.cos(E - S) * O, S && "simple" === k.skewType && (e = Math.tan(S - R * z), i *= e = Math.sqrt(1 + e * e), s *= e, R && (e = Math.tan(R * z), n *= e = Math.sqrt(1 + e * e), o *= e)), N && (M += k.xOrigin - (k.xOrigin * n + k.yOrigin * i) + k.xOffset, L += k.yOrigin - (k.xOrigin * o + k.yOrigin * s) + k.yOffset, At && (k.xPercent || k.yPercent) && (g = this.t.getBBox(), M += .01 * k.xPercent * g.width, L += .01 * k.yPercent * g.height), M < (g = 1e-6) && -g < M && (M = 0), L < g && -g < L && (L = 0)), b = (n * T | 0) / T + "," + (o * T | 0) / T + "," + (i * T | 0) / T + "," + (s * T | 0) / T + "," + M + "," + L + ")", N && At ? this.t.setAttribute("transform", "matrix(" + b) : C[Lt] = (k.xPercent || k.yPercent ? "translate(" + k.xPercent + "%," + k.yPercent + "%) matrix(" : "matrix(") + b) : C[Lt] = (k.xPercent || k.yPercent ? "translate(" + k.xPercent + "%," + k.yPercent + "%) matrix(" : "matrix(") + P + ",0,0," + O + "," + M + "," + L + ")";
                else {
                    if (p && (P < (g = 1e-4) && -g < P && (P = I = 2e-5), O < g && -g < O && (O = I = 2e-5), !$ || k.z || k.rotationX || k.rotationY || ($ = 0)), E || H) E *= z, y = n = Math.cos(E), v = o = Math.sin(E), H && (E -= H * z, y = Math.cos(E), v = Math.sin(E), "simple" === k.skewType && (e = Math.tan((H - R) * z), y *= e = Math.sqrt(1 + e * e), v *= e, k.skewY && (e = Math.tan(R * z), n *= e = Math.sqrt(1 + e * e), o *= e))), i = -v, s = y;
                    else {
                        if (!(D || A || 1 !== I || $ || N)) return void(C[Lt] = (k.xPercent || k.yPercent ? "translate(" + k.xPercent + "%," + k.yPercent + "%) translate3d(" : "translate3d(") + M + "px," + L + "px," + j + "px)" + (1 !== P || 1 !== O ? " scale(" + P + "," + O + ")" : ""));
                        n = s = 1, i = o = 0
                    }
                    c = 1, r = a = l = u = d = h = 0, f = $ ? -1 / $ : 0, m = k.zOrigin, g = 1e-6, w = ",", x = "0", (E = D * z) && (y = Math.cos(E), d = f * (l = -(v = Math.sin(E))), r = n * v, a = o * v, f *= c = y, n *= y, o *= y), (E = A * z) && (e = i * (y = Math.cos(E)) + r * (v = Math.sin(E)), _ = s * y + a * v, u = c * v, h = f * v, r = i * -v + r * y, a = s * -v + a * y, c *= y, f *= y, i = e, s = _), 1 !== I && (r *= I, a *= I, c *= I, f *= I), 1 !== O && (i *= O, s *= O, u *= O, h *= O), 1 !== P && (n *= P, o *= P, l *= P, d *= P), (m || N) && (m && (M += r * -m, L += a * -m, j += c * -m + m), N && (M += k.xOrigin - (k.xOrigin * n + k.yOrigin * i) + k.xOffset, L += k.yOrigin - (k.xOrigin * o + k.yOrigin * s) + k.yOffset), M < g && -g < M && (M = x), L < g && -g < L && (L = x), j < g && -g < j && (j = 0)), b = k.xPercent || k.yPercent ? "translate(" + k.xPercent + "%," + k.yPercent + "%) matrix3d(" : "matrix3d(", b += (n < g && -g < n ? x : n) + w + (o < g && -g < o ? x : o) + w + (l < g && -g < l ? x : l), b += w + (d < g && -g < d ? x : d) + w + (i < g && -g < i ? x : i) + w + (s < g && -g < s ? x : s), A || D || 1 !== I ? (b += w + (u < g && -g < u ? x : u) + w + (h < g && -g < h ? x : h) + w + (r < g && -g < r ? x : r), b += w + (a < g && -g < a ? x : a) + w + (c < g && -g < c ? x : c) + w + (f < g && -g < f ? x : f) + w) : b += ",0,0,0,0,1,0,", b += M + w + L + w + j + w + ($ ? 1 + -j / $ : 1) + ")", C[Lt] = b
                }
            };
        (u = zt.prototype).x = u.y = u.z = u.skewX = u.skewY = u.rotation = u.rotationX = u.rotationY = u.zOrigin = u.xPercent = u.yPercent = u.xOffset = u.yOffset = 0, u.scaleX = u.scaleY = u.scaleZ = 1, Ct("transform,scale,scaleX,scaleY,scaleZ,x,y,z,rotation,rotationX,rotationY,rotationZ,skewX,skewY,shortRotation,shortRotationX,shortRotationY,shortRotationZ,transformOrigin,svgOrigin,transformPerspective,directionalRotation,parseTransform,force3D,skewType,xPercent,yPercent,smoothOrigin", {
            parser: function(t, e, n, i, o, a, l) {
                if (i._lastParsedTransform === l) return o;
                var u, c = (i._lastParsedTransform = l).scale && "function" == typeof l.scale ? l.scale : 0;
                "function" == typeof l[n] && (u = l[n], l[n] = e), c && (l.scale = c(y, t));
                var d, h, p, f, m, v, _, b, w, x = t._gsTransform,
                    S = t.style,
                    T = Mt.length,
                    k = l,
                    C = {},
                    E = "transformOrigin",
                    A = Zt(t, r, !0, k.parseTransform),
                    D = k.transform && ("function" == typeof k.transform ? k.transform(y, g) : k.transform);
                if (A.skewType = k.skewType || A.skewType || s.defaultSkewType, i._transform = A, "rotationZ" in k && (k.rotation = k.rotationZ), D && "string" == typeof D && Lt)(h = U.style)[Lt] = D, h.display = "block", h.position = "absolute", -1 !== D.indexOf("%") && (h.width = et(t, "width"), h.height = et(t, "height")), q.body.appendChild(U), d = Zt(U, null, !1), "simple" === A.skewType && (d.scaleY *= Math.cos(d.skewX * z)), A.svg && (v = A.xOrigin, _ = A.yOrigin, d.x -= A.xOffset, d.y -= A.yOffset, (k.transformOrigin || k.svgOrigin) && (D = {}, Bt(t, ut(k.transformOrigin), D, k.svgOrigin, k.smoothOrigin, !0), v = D.xOrigin, _ = D.yOrigin, d.x -= D.xOffset - A.xOffset, d.y -= D.yOffset - A.yOffset), (v || _) && (b = Yt(U, !0), d.x -= v - (v * b[0] + _ * b[2]), d.y -= _ - (v * b[1] + _ * b[3]))), q.body.removeChild(U), d.perspective || (d.perspective = A.perspective), null != k.xPercent && (d.xPercent = dt(k.xPercent, A.xPercent)), null != k.yPercent && (d.yPercent = dt(k.yPercent, A.yPercent));
                else if ("object" == typeof k) {
                    if (d = {
                            scaleX: dt(null != k.scaleX ? k.scaleX : k.scale, A.scaleX),
                            scaleY: dt(null != k.scaleY ? k.scaleY : k.scale, A.scaleY),
                            scaleZ: dt(k.scaleZ, A.scaleZ),
                            x: dt(k.x, A.x),
                            y: dt(k.y, A.y),
                            z: dt(k.z, A.z),
                            xPercent: dt(k.xPercent, A.xPercent),
                            yPercent: dt(k.yPercent, A.yPercent),
                            perspective: dt(k.transformPerspective, A.perspective)
                        }, null != (m = k.directionalRotation))
                        if ("object" == typeof m)
                            for (h in m) k[h] = m[h];
                        else k.rotation = m;
                    "string" == typeof k.x && -1 !== k.x.indexOf("%") && (d.x = 0, d.xPercent = dt(k.x, A.xPercent)), "string" == typeof k.y && -1 !== k.y.indexOf("%") && (d.y = 0, d.yPercent = dt(k.y, A.yPercent)), d.rotation = ht("rotation" in k ? k.rotation : "shortRotation" in k ? k.shortRotation + "_short" : A.rotation, A.rotation, "rotation", C), $t && (d.rotationX = ht("rotationX" in k ? k.rotationX : "shortRotationX" in k ? k.shortRotationX + "_short" : A.rotationX || 0, A.rotationX, "rotationX", C), d.rotationY = ht("rotationY" in k ? k.rotationY : "shortRotationY" in k ? k.shortRotationY + "_short" : A.rotationY || 0, A.rotationY, "rotationY", C)), d.skewX = ht(k.skewX, A.skewX), d.skewY = ht(k.skewY, A.skewY)
                }
                for ($t && null != k.force3D && (A.force3D = k.force3D, f = !0), (p = A.force3D || A.z || A.rotationX || A.rotationY || d.z || d.rotationX || d.rotationY || d.perspective) || null == k.scale || (d.scaleZ = 1); - 1 < --T;)(1e-6 < (D = d[w = Mt[T]] - A[w]) || D < -1e-6 || null != k[w] || null != R[w]) && (f = !0, o = new wt(A, w, A[w], D, o), w in C && (o.e = C[w]), o.xs0 = 0, o.plugin = a, i._overwriteProps.push(o.n));
                return D = k.transformOrigin, A.svg && (D || k.svgOrigin) && (v = A.xOffset, _ = A.yOffset, Bt(t, ut(D), d, k.svgOrigin, k.smoothOrigin), o = xt(A, "xOrigin", (x ? A : d).xOrigin, d.xOrigin, o, E), o = xt(A, "yOrigin", (x ? A : d).yOrigin, d.yOrigin, o, E), (v !== A.xOffset || _ !== A.yOffset) && (o = xt(A, "xOffset", x ? v : A.xOffset, A.xOffset, o, E), o = xt(A, "yOffset", x ? _ : A.yOffset, A.yOffset, o, E)), D = "0px 0px"), (D || $t && p && A.zOrigin) && (Lt ? (f = !0, w = Nt, D = (D || et(t, w, r, !1, "50% 50%")) + "", (o = new wt(S, w, 0, 0, o, -1, E)).b = S[w], o.plugin = a, $t ? (h = A.zOrigin, D = D.split(" "), A.zOrigin = (2 < D.length && (0 === h || "0px" !== D[2]) ? parseFloat(D[2]) : h) || 0, o.xs0 = o.e = D[0] + " " + (D[1] || "50%") + " 0px", (o = new wt(A, "zOrigin", 0, 0, o, -1, o.n)).b = h, o.xs0 = o.e = A.zOrigin) : o.xs0 = o.e = D) : ut(D + "", A)), f && (i._transformType = A.svg && At || !p && 3 !== this._transformType ? 2 : 3), u && (l[n] = u), c && (l.scale = c), o
            },
            prefix: !0
        }), Ct("boxShadow", {
            defaultValue: "0px 0px 0px 0px #999",
            prefix: !0,
            color: !0,
            multi: !0,
            keyword: "inset"
        }), Ct("borderRadius", {
            defaultValue: "0px",
            parser: function(t, e, n, o, s, a) {
                e = this.format(e);
                var l, u, c, d, h, p, f, m, g, y, v, _, b, w, x, S, T = ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius"],
                    k = t.style;
                for (g = parseFloat(t.offsetWidth), y = parseFloat(t.offsetHeight), l = e.split(" "), u = 0; u < T.length; u++) this.p.indexOf("border") && (T[u] = J(T[u])), -1 !== (h = d = et(t, T[u], r, !1, "0px")).indexOf(" ") && (h = (d = h.split(" "))[0], d = d[1]), p = c = l[u], f = parseFloat(h), _ = h.substr((f + "").length), (b = "=" === p.charAt(1)) ? (m = parseInt(p.charAt(0) + "1", 10), p = p.substr(2), m *= parseFloat(p), v = p.substr((m + "").length - (m < 0 ? 1 : 0)) || "") : (m = parseFloat(p), v = p.substr((m + "").length)), "" === v && (v = i[n] || _), v !== _ && (w = nt(t, "borderLeft", f, _), x = nt(t, "borderTop", f, _), "%" === v ? (h = w / g * 100 + "%", d = x / y * 100 + "%") : "em" === v ? (h = w / (S = nt(t, "borderLeft", 1, "em")) + "em", d = x / S + "em") : (h = w + "px", d = x + "px"), b && (p = parseFloat(h) + m + v, c = parseFloat(d) + m + v)), s = St(k, T[u], h + " " + d, p + " " + c, !1, "0px", s);
                return s
            },
            prefix: !0,
            formatter: vt("0px 0px 0px 0px", !1, !0)
        }), Ct("borderBottomLeftRadius,borderBottomRightRadius,borderTopLeftRadius,borderTopRightRadius", {
            defaultValue: "0px",
            parser: function(t, e, n, i, o, s) {
                return St(t.style, n, this.format(et(t, n, r, !1, "0px 0px")), this.format(e), !1, "0px", o)
            },
            prefix: !0,
            formatter: vt("0px 0px", !1, !0)
        }), Ct("backgroundPosition", {
            defaultValue: "0 0",
            parser: function(t, e, n, i, o, s) {
                var a, l, u, c, d, h, p = "background-position",
                    f = r || tt(t, null),
                    g = this.format((f ? m ? f.getPropertyValue(p + "-x") + " " + f.getPropertyValue(p + "-y") : f.getPropertyValue(p) : t.currentStyle.backgroundPositionX + " " + t.currentStyle.backgroundPositionY) || "0 0"),
                    y = this.format(e);
                if (-1 !== g.indexOf("%") != (-1 !== y.indexOf("%")) && y.split(",").length < 2 && (h = et(t, "backgroundImage").replace(O, "")) && "none" !== h) {
                    for (a = g.split(" "), l = y.split(" "), W.setAttribute("src", h), u = 2; - 1 < --u;)(c = -1 !== (g = a[u]).indexOf("%")) != (-1 !== l[u].indexOf("%")) && (d = 0 === u ? t.offsetWidth - W.width : t.offsetHeight - W.height, a[u] = c ? parseFloat(g) / 100 * d + "px" : parseFloat(g) / d * 100 + "%");
                    g = a.join(" ")
                }
                return this.parseComplex(t.style, g, y, o, s)
            },
            formatter: ut
        }), Ct("backgroundSize", {
            defaultValue: "0 0",
            formatter: function(t) {
                return "co" === (t += "").substr(0, 2) ? t : ut(-1 === t.indexOf(" ") ? t + " " + t : t)
            }
        }), Ct("perspective", {
            defaultValue: "0px",
            prefix: !0
        }), Ct("perspectiveOrigin", {
            defaultValue: "50% 50%",
            prefix: !0
        }), Ct("transformStyle", {
            prefix: !0
        }), Ct("backfaceVisibility", {
            prefix: !0
        }), Ct("userSelect", {
            prefix: !0
        }), Ct("margin", {
            parser: _t("marginTop,marginRight,marginBottom,marginLeft")
        }), Ct("padding", {
            parser: _t("paddingTop,paddingRight,paddingBottom,paddingLeft")
        }), Ct("clip", {
            defaultValue: "rect(0px,0px,0px,0px)",
            parser: function(t, e, n, i, o, s) {
                var a, l, u;
                return m < 9 ? (l = t.currentStyle, u = m < 8 ? " " : ",", a = "rect(" + l.clipTop + u + l.clipRight + u + l.clipBottom + u + l.clipLeft + ")", e = this.format(e).split(",").join(u)) : (a = this.format(et(t, this.p, r, !1, this.dflt)), e = this.format(e)), this.parseComplex(t.style, a, e, o, s)
            }
        }), Ct("textShadow", {
            defaultValue: "0px 0px 0px #999",
            color: !0,
            multi: !0
        }), Ct("autoRound,strictUnits", {
            parser: function(t, e, n, i, r) {
                return r
            }
        }), Ct("border", {
            defaultValue: "0px solid #000",
            parser: function(t, e, n, i, o, s) {
                var a = et(t, "borderTopWidth", r, !1, "0px"),
                    l = this.format(e).split(" "),
                    u = l[0].replace(T, "");
                return "px" !== u && (a = parseFloat(a) / nt(t, "borderTopWidth", 1, u) + u), this.parseComplex(t.style, this.format(a + " " + et(t, "borderTopStyle", r, !1, "solid") + " " + et(t, "borderTopColor", r, !1, "#000")), l.join(" "), o, s)
            },
            color: !0,
            formatter: function(t) {
                var e = t.split(" ");
                return e[0] + " " + (e[1] || "solid") + " " + (t.match(yt) || ["#000"])[0]
            }
        }), Ct("borderWidth", {
            parser: _t("borderTopWidth,borderRightWidth,borderBottomWidth,borderLeftWidth")
        }), Ct("float,cssFloat,styleFloat", {
            parser: function(t, e, n, i, r, o) {
                var s = t.style,
                    a = "cssFloat" in s ? "cssFloat" : "styleFloat";
                return new wt(s, a, 0, 0, r, -1, n, !1, 0, s[a], e)
            }
        });
        var Qt = function(t) {
            var e, n = this.t,
                i = n.filter || et(this.data, "filter") || "",
                r = this.s + this.c * t | 0;
            100 === r && (-1 === i.indexOf("atrix(") && -1 === i.indexOf("radient(") && -1 === i.indexOf("oader(") ? (n.removeAttribute("filter"), e = !et(this.data, "filter")) : (n.filter = i.replace(E, ""), e = !0)), e || (this.xn1 && (n.filter = i = i || "alpha(opacity=" + r + ")"), -1 === i.indexOf("pacity") ? 0 === r && this.xn1 || (n.filter = i + " alpha(opacity=" + r + ")") : n.filter = i.replace(k, "opacity=" + r))
        };
        Ct("opacity,alpha,autoAlpha", {
            defaultValue: "1",
            parser: function(t, e, n, i, o, s) {
                var a = parseFloat(et(t, "opacity", r, !1, "1")),
                    l = t.style,
                    u = "autoAlpha" === n;
                return "string" == typeof e && "=" === e.charAt(1) && (e = ("-" === e.charAt(0) ? -1 : 1) * parseFloat(e.substr(2)) + a), u && 1 === a && "hidden" === et(t, "visibility", r) && 0 !== e && (a = 0), Z ? o = new wt(l, "opacity", a, e - a, o) : ((o = new wt(l, "opacity", 100 * a, 100 * (e - a), o)).xn1 = u ? 1 : 0, l.zoom = 1, o.type = 2, o.b = "alpha(opacity=" + o.s + ")", o.e = "alpha(opacity=" + (o.s + o.c) + ")", o.data = t, o.plugin = s, o.setRatio = Qt), u && ((o = new wt(l, "visibility", 0, 0, o, -1, null, !1, 0, 0 !== a ? "inherit" : "hidden", 0 === e ? "hidden" : "inherit")).xs0 = "inherit", i._overwriteProps.push(o.n), i._overwriteProps.push(n)), o
            }
        });
        var Kt = function(t, e) {
                e && (t.removeProperty ? (("ms" === e.substr(0, 2) || "webkit" === e.substr(0, 6)) && (e = "-" + e), t.removeProperty(e.replace(D, "-$1").toLowerCase())) : t.removeAttribute(e))
            },
            Jt = function(t) {
                if (this.t._gsClassPT = this, 1 === t || 0 === t) {
                    this.t.setAttribute("class", 0 === t ? this.b : this.e);
                    for (var e = this.data, n = this.t.style; e;) e.v ? n[e.p] = e.v : Kt(n, e.p), e = e._next;
                    1 === t && this.t._gsClassPT === this && (this.t._gsClassPT = null)
                } else this.t.getAttribute("class") !== this.e && this.t.setAttribute("class", this.e)
            };
        Ct("className", {
            parser: function(t, e, i, o, s, a, l) {
                var u, c, d, h, p, f = t.getAttribute("class") || "",
                    m = t.style.cssText;
                if ((s = o._classNamePT = new wt(t, i, 0, 0, s, 2)).setRatio = Jt, s.pr = -11, n = !0, s.b = f, c = rt(t, r), d = t._gsClassPT) {
                    for (h = {}, p = d.data; p;) h[p.p] = 1, p = p._next;
                    d.setRatio(1)
                }
                return (t._gsClassPT = s).e = "=" !== e.charAt(1) ? e : f.replace(new RegExp("(?:\\s|^)" + e.substr(2) + "(?![\\w-])"), "") + ("+" === e.charAt(0) ? " " + e.substr(2) : ""), t.setAttribute("class", s.e), u = ot(t, c, rt(t), l, h), t.setAttribute("class", f), s.data = u.firstMPT, t.style.cssText = m, s.xfirst = o.parse(t, u.difs, s, a)
            }
        });
        var te = function(t) {
            if ((1 === t || 0 === t) && this.data._totalTime === this.data._totalDuration && "isFromStart" !== this.data.data) {
                var e, n, i, r, o, s = this.t.style,
                    a = l.transform.parse;
                if ("all" === this.e) r = !(s.cssText = "");
                else
                    for (i = (e = this.e.split(" ").join("").split(",")).length; - 1 < --i;) n = e[i], l[n] && (l[n].parse === a ? r = !0 : n = "transformOrigin" === n ? Nt : l[n].p), Kt(s, n);
                r && (Kt(s, Lt), (o = this.t._gsTransform) && (o.svg && (this.t.removeAttribute("data-svg-origin"), this.t.removeAttribute("transform")), delete this.t._gsTransform))
            }
        };
        for (Ct("clearProps", {
                parser: function(t, e, i, r, o) {
                    return (o = new wt(t, i, 0, 0, o, 2)).setRatio = te, o.e = e, o.pr = -10, o.data = r._tween, n = !0, o
                }
            }), u = "bezier,throwProps,physicsProps,physics2D".split(","), Tt = u.length; Tt--;) Et(u[Tt]);
        (u = s.prototype)._firstPT = u._lastParsedTransform = u._transform = null, u._onInitTween = function(t, e, a, u) {
            if (!t.nodeType) return !1;
            this._target = g = t, this._tween = a, this._vars = e, y = u, c = e.autoRound, n = !1, i = e.suffixMap || s.suffixMap, r = tt(t, ""), o = this._overwriteProps;
            var p, m, v, _, b, w, x, S, T, k = t.style;
            if (d && "" === k.zIndex && ("auto" === (p = et(t, "zIndex", r)) || "" === p) && this._addLazySet(k, "zIndex", 0), "string" == typeof e && (_ = k.cssText, p = rt(t, r), k.cssText = _ + ";" + e, p = ot(t, p, rt(t)).difs, !Z && C.test(e) && (p.opacity = parseFloat(RegExp.$1)), e = p, k.cssText = _), e.className ? this._firstPT = m = l.className.parse(t, e.className, "className", this, null, null, e) : this._firstPT = m = this.parse(t, e, null), this._transformType) {
                for (T = 3 === this._transformType, Lt ? h && (d = !0, "" === k.zIndex && ("auto" === (x = et(t, "zIndex", r)) || "" === x) && this._addLazySet(k, "zIndex", 0), f && this._addLazySet(k, "WebkitBackfaceVisibility", this._vars.WebkitBackfaceVisibility || (T ? "visible" : "hidden"))) : k.zoom = 1, v = m; v && v._next;) v = v._next;
                S = new wt(t, "transform", 0, 0, null, 2), this._linkCSSP(S, null, v), S.setRatio = Lt ? Gt : Vt, S.data = this._transform || Zt(t, r, !0), S.tween = a, S.pr = -1, o.pop()
            }
            if (n) {
                for (; m;) {
                    for (w = m._next, v = _; v && v.pr > m.pr;) v = v._next;
                    (m._prev = v ? v._prev : b) ? m._prev._next = m: _ = m, (m._next = v) ? v._prev = m : b = m, m = w
                }
                this._firstPT = _
            }
            return !0
        }, u.parse = function(t, e, n, o) {
            var s, a, u, d, h, p, f, m, v, _, b = t.style;
            for (s in e) {
                if ("function" == typeof(p = e[s]) && (p = p(y, g)), a = l[s]) n = a.parse(t, p, s, this, n, o, e);
                else {
                    if ("--" === s.substr(0, 2)) {
                        this._tween._propLookup[s] = this._addTween.call(this._tween, t.style, "setProperty", tt(t).getPropertyValue(s) + "", p + "", s, !1, s);
                        continue
                    }
                    h = et(t, s, r) + "", v = "string" == typeof p, "color" === s || "fill" === s || "stroke" === s || -1 !== s.indexOf("Color") || v && A.test(p) ? (v || (p = (3 < (p = mt(p)).length ? "rgba(" : "rgb(") + p.join(",") + ")"), n = St(b, s, h, p, !0, "transparent", n, 0, o)) : v && $.test(p) ? n = St(b, s, h, p, !0, null, n, 0, o) : (f = (u = parseFloat(h)) || 0 === u ? h.substr((u + "").length) : "", ("" === h || "auto" === h) && ("width" === s || "height" === s ? (u = lt(t, s, r), f = "px") : "left" === s || "top" === s ? (u = it(t, s, r), f = "px") : (u = "opacity" !== s ? 0 : 1, f = "")), (_ = v && "=" === p.charAt(1)) ? (d = parseInt(p.charAt(0) + "1", 10), p = p.substr(2), d *= parseFloat(p), m = p.replace(T, "")) : (d = parseFloat(p), m = v ? p.replace(T, "") : ""), "" === m && (m = s in i ? i[s] : f), p = d || 0 === d ? (_ ? d + u : d) + m : e[s], f !== m && ("" !== m || "lineHeight" === s) && (d || 0 === d) && u && (u = nt(t, s, u, f), "%" === m ? (u /= nt(t, s, 100, "%") / 100, !0 !== e.strictUnits && (h = u + "%")) : "em" === m || "rem" === m || "vw" === m || "vh" === m ? u /= nt(t, s, 1, m) : "px" !== m && (d = nt(t, s, d, m), m = "px"), _ && (d || 0 === d) && (p = d + u + m)), _ && (d += u), !u && 0 !== u || !d && 0 !== d ? void 0 !== b[s] && (p || p + "" != "NaN" && null != p) ? (n = new wt(b, s, d || u || 0, 0, n, -1, s, !1, 0, h, p)).xs0 = "none" !== p || "display" !== s && -1 === s.indexOf("Style") ? p : h : G("invalid " + s + " tween value: " + e[s]) : (n = new wt(b, s, u, d - u, n, 0, s, !1 !== c && ("px" === m || "zIndex" === s), 0, h, p)).xs0 = m)
                }
                o && n && !n.plugin && (n.plugin = o)
            }
            return n
        }, u.setRatio = function(t) {
            var e, n, i, r = this._firstPT;
            if (1 !== t || this._tween._time !== this._tween._duration && 0 !== this._tween._time)
                if (t || this._tween._time !== this._tween._duration && 0 !== this._tween._time || -1e-6 === this._tween._rawPrevTime)
                    for (; r;) {
                        if (e = r.c * t + r.s, r.r ? e = r.r(e) : e < 1e-6 && -1e-6 < e && (e = 0), r.type)
                            if (1 === r.type)
                                if (2 === (i = r.l)) r.t[r.p] = r.xs0 + e + r.xs1 + r.xn1 + r.xs2;
                                else if (3 === i) r.t[r.p] = r.xs0 + e + r.xs1 + r.xn1 + r.xs2 + r.xn2 + r.xs3;
                        else if (4 === i) r.t[r.p] = r.xs0 + e + r.xs1 + r.xn1 + r.xs2 + r.xn2 + r.xs3 + r.xn3 + r.xs4;
                        else if (5 === i) r.t[r.p] = r.xs0 + e + r.xs1 + r.xn1 + r.xs2 + r.xn2 + r.xs3 + r.xn3 + r.xs4 + r.xn4 + r.xs5;
                        else {
                            for (n = r.xs0 + e + r.xs1, i = 1; i < r.l; i++) n += r["xn" + i] + r["xs" + (i + 1)];
                            r.t[r.p] = n
                        } else -1 === r.type ? r.t[r.p] = r.xs0 : r.setRatio && r.setRatio(t);
                        else r.t[r.p] = e + r.xs0;
                        r = r._next
                    } else
                        for (; r;) 2 !== r.type ? r.t[r.p] = r.b : r.setRatio(t), r = r._next;
                else
                    for (; r;) {
                        if (2 !== r.type)
                            if (r.r && -1 !== r.type)
                                if (e = r.r(r.s + r.c), r.type) {
                                    if (1 === r.type) {
                                        for (i = r.l, n = r.xs0 + e + r.xs1, i = 1; i < r.l; i++) n += r["xn" + i] + r["xs" + (i + 1)];
                                        r.t[r.p] = n
                                    }
                                } else r.t[r.p] = e + r.xs0;
                        else r.t[r.p] = r.e;
                        else r.setRatio(t);
                        r = r._next
                    }
        }, u._enableTransforms = function(t) {
            this._transform = this._transform || Zt(this._target, r, !0), this._transformType = this._transform.svg && At || !t && 3 !== this._transformType ? 2 : 3
        };
        var ee = function(t) {
            this.t[this.p] = this.e, this.data._linkCSSP(this, this._next, null, !0)
        };
        u._addLazySet = function(t, e, n) {
            var i = this._firstPT = new wt(t, e, 0, 0, this._firstPT, 2);
            i.e = n, i.setRatio = ee, i.data = this
        }, u._linkCSSP = function(t, e, n, i) {
            return t && (e && (e._prev = t), t._next && (t._next._prev = t._prev), t._prev ? t._prev._next = t._next : this._firstPT === t && (this._firstPT = t._next, i = !0), n ? n._next = t : i || null !== this._firstPT || (this._firstPT = t), t._next = e, t._prev = n), t
        }, u._mod = function(t) {
            for (var e = this._firstPT; e;) "function" == typeof t[e.p] && (e.r = t[e.p]), e = e._next
        }, u._kill = function(e) {
            var n, i, r, o = e;
            if (e.autoAlpha || e.alpha) {
                for (i in o = {}, e) o[i] = e[i];
                o.opacity = 1, o.autoAlpha && (o.visibility = 1)
            }
            for (e.className && (n = this._classNamePT) && ((r = n.xfirst) && r._prev ? this._linkCSSP(r._prev, n._next, r._prev._prev) : r === this._firstPT && (this._firstPT = n._next), n._next && this._linkCSSP(n._next, n._next._next, r._prev), this._classNamePT = null), n = this._firstPT; n;) n.plugin && n.plugin !== i && n.plugin._kill && (n.plugin._kill(e), i = n.plugin), n = n._next;
            return t.prototype._kill.call(this, o)
        };
        var ne = function(t, e, n) {
            var i, r, o, s;
            if (t.slice)
                for (r = t.length; - 1 < --r;) ne(t[r], e, n);
            else
                for (r = (i = t.childNodes).length; - 1 < --r;) s = (o = i[r]).type, o.style && (e.push(rt(o)), n && n.push(o)), 1 !== s && 9 !== s && 11 !== s || !o.childNodes.length || ne(o, e, n)
        };
        return s.cascadeTo = function(t, n, i) {
            var r, o, s, a, l = e.to(t, n, i),
                u = [l],
                c = [],
                d = [],
                h = [],
                p = e._internals.reservedProps;
            for (t = l._targets || l.target, ne(t, c, h), l.render(n, !0, !0), ne(t, d), l.render(0, !0, !0), l._enabled(!0), r = h.length; - 1 < --r;)
                if ((o = ot(h[r], c[r], d[r])).firstMPT) {
                    for (s in o = o.difs, i) p[s] && (o[s] = i[s]);
                    for (s in a = {}, o) a[s] = c[r][s];
                    u.push(e.fromTo(h[r], n, a, o))
                } return u
        }, t.activate([s]), s
    }, !0)
}), _gsScope._gsDefine && _gsScope._gsQueue.pop()(),
function(t) {
    "use strict";
    var e = function() {
        return (_gsScope.GreenSockGlobals || _gsScope).CSSPlugin
    };
    "undefined" != typeof module && module.exports ? (require("../TweenLite.min.js"), module.exports = e()) : "function" == typeof define && define.amd && define(["TweenLite"], e)
}();
var _gsScope = "undefined" != typeof module && module.exports && "undefined" != typeof global ? global : this || window;
! function(t) {
"use strict";
var e = t.GreenSockGlobals || t,
    n = function(t) {
        var n, i = t.split("."),
            r = e;
        for (n = 0; n < i.length; n++) r[i[n]] = r = r[i[n]] || {};
        return r
    }("com.greensock.utils"),
    i = function(t) {
        var e = t.nodeType,
            n = "";
        if (1 === e || 9 === e || 11 === e) {
            if ("string" == typeof t.textContent) return t.textContent;
            for (t = t.firstChild; t; t = t.nextSibling) n += i(t)
        } else if (3 === e || 4 === e) return t.nodeValue;
        return n
    },
    r = document,
    o = r.defaultView ? r.defaultView.getComputedStyle : function() {},
    s = /([A-Z])/g,
    a = function(t, e, n, i) {
        var r;
        return (n = n || o(t, null)) ? r = (t = n.getPropertyValue(e.replace(s, "-$1").toLowerCase())) || n.length ? t : n[e] : t.currentStyle && (r = (n = t.currentStyle)[e]), i ? r : parseInt(r, 10) || 0
    },
    l = function(t) {
        return !!(t.length && t[0] && (t[0].nodeType && t[0].style && !t.nodeType || t[0].length && t[0][0]))
    },
    u = /(?:\r|\n|\t\t)/g,
    c = /(?:\s\s+)/g,
    d = 127462,
    h = 127487,
    p = function(t) {
        return (t.charCodeAt(0) - 55296 << 10) + (t.charCodeAt(1) - 56320) + 65536
    },
    f = " style='position:relative;display:inline-block;" + (r.all && !r.addEventListener ? "*display:inline;*zoom:1;'" : "'"),
    m = function(t, e) {
        var n = -1 !== (t = t || "").indexOf("++"),
            i = 1;
        return n && (t = t.split("++").join("")),
            function() {
                return "<" + e + f + (t ? " class='" + t + (n ? i++ : "") + "'>" : ">")
            }
    },
    g = n.SplitText = e.SplitText = function(t, e) {
        if ("string" == typeof t && (t = g.selector(t)), !t) throw "cannot split a null element.";
        this.elements = l(t) ? function(t) {
            var e, n, i, r = [],
                o = t.length;
            for (e = 0; o > e; e++)
                if (n = t[e], l(n))
                    for (i = n.length, i = 0; i < n.length; i++) r.push(n[i]);
                else r.push(n);
            return r
        }(t) : [t], this.chars = [], this.words = [], this.lines = [], this._originals = [], this.vars = e || {}, this.split(e)
    },
    y = function(t, e, n) {
        var i = t.nodeType;
        if (1 === i || 9 === i || 11 === i)
            for (t = t.firstChild; t; t = t.nextSibling) y(t, e, n);
        else(3 === i || 4 === i) && (t.nodeValue = t.nodeValue.split(e).join(n))
    },
    v = function(t, e) {
        for (var n = e.length; --n > -1;) t.push(e[n])
    },
    _ = function(t) {
        var e, n = [],
            i = t.length;
        for (e = 0; e !== i; n.push(t[e++]));
        return n
    },
    b = function(t, e, n) {
        for (var i; t && t !== e;) {
            if (i = t._next || t.nextSibling) return i.textContent.charAt(0) === n;
            t = t.parentNode || t._parent
        }
        return !1
    },
    w = function(t) {
        var e, n, i = _(t.childNodes),
            r = i.length;
        for (e = 0; r > e; e++)(n = i[e])._isSplit ? w(n) : (e && 3 === n.previousSibling.nodeType ? n.previousSibling.nodeValue += 3 === n.nodeType ? n.nodeValue : n.firstChild.nodeValue : 3 !== n.nodeType && t.insertBefore(n.firstChild, n), t.removeChild(n))
    },
    x = function(t, e, n, i, s, l, u) {
        var c, d, h, p, f, m, g, _, x, S, T, k, C = o(t),
            E = a(t, "paddingLeft", C),
            A = -999,
            D = a(t, "borderBottomWidth", C) + a(t, "borderTopWidth", C),
            P = a(t, "borderLeftWidth", C) + a(t, "borderRightWidth", C),
            O = a(t, "paddingTop", C) + a(t, "paddingBottom", C),
            I = a(t, "paddingLeft", C) + a(t, "paddingRight", C),
            M = .2 * a(t, "fontSize"),
            L = a(t, "textAlign", C, !0),
            j = [],
            N = [],
            $ = [],
            z = e.wordDelimiter || " ",
            F = e.span ? "span" : "div",
            R = e.type || e.split || "chars,words,lines",
            H = s && -1 !== R.indexOf("lines") ? [] : null,
            q = -1 !== R.indexOf("words"),
            B = -1 !== R.indexOf("chars"),
            U = "absolute" === e.position || !0 === e.absolute,
            W = e.linesClass,
            X = -1 !== (W || "").indexOf("++"),
            Y = [];
        for (H && 1 === t.children.length && t.children[0]._isSplit && (t = t.children[0]), X && (W = W.split("++").join("")), h = (d = t.getElementsByTagName("*")).length, f = [], c = 0; h > c; c++) f[c] = d[c];
        if (H || U)
            for (c = 0; h > c; c++)((m = (p = f[c]).parentNode === t) || U || B && !q) && (k = p.offsetTop, H && m && Math.abs(k - A) > M && ("BR" !== p.nodeName || 0 === c) && (g = [], H.push(g), A = k), U && (p._x = p.offsetLeft, p._y = k, p._w = p.offsetWidth, p._h = p.offsetHeight), H && ((p._isSplit && m || !B && m || q && m || !q && p.parentNode.parentNode === t && !p.parentNode._isSplit) && (g.push(p), p._x -= E, b(p, t, z) && (p._wordEnd = !0)), "BR" === p.nodeName && (p.nextSibling && "BR" === p.nextSibling.nodeName || 0 === c) && H.push([])));
        for (c = 0; h > c; c++) m = (p = f[c]).parentNode === t, "BR" !== p.nodeName ? (U && (x = p.style, q || m || (p._x += p.parentNode._x, p._y += p.parentNode._y), x.left = p._x + "px", x.top = p._y + "px", x.position = "absolute", x.display = "block", x.width = p._w + 1 + "px", x.height = p._h + "px"), !q && B ? p._isSplit ? (p._next = p.nextSibling, p.parentNode.appendChild(p)) : p.parentNode._isSplit ? (p._parent = p.parentNode, !p.previousSibling && p.firstChild && (p.firstChild._isFirst = !0), p.nextSibling && " " === p.nextSibling.textContent && !p.nextSibling.nextSibling && Y.push(p.nextSibling), p._next = p.nextSibling && p.nextSibling._isFirst ? null : p.nextSibling, p.parentNode.removeChild(p), f.splice(c--, 1), h--) : m || (k = !p.nextSibling && b(p.parentNode, t, z), p.parentNode._parent && p.parentNode._parent.appendChild(p), k && p.parentNode.appendChild(r.createTextNode(" ")), e.span && (p.style.display = "inline"), j.push(p)) : p.parentNode._isSplit && !p._isSplit && "" !== p.innerHTML ? N.push(p) : B && !p._isSplit && (e.span && (p.style.display = "inline"), j.push(p))) : H || U ? (p.parentNode && p.parentNode.removeChild(p), f.splice(c--, 1), h--) : q || t.appendChild(p);
        for (c = Y.length; --c > -1;) Y[c].parentNode.removeChild(Y[c]);
        if (H) {
            for (U && (S = r.createElement(F), t.appendChild(S), T = S.offsetWidth + "px", k = S.offsetParent === t ? 0 : t.offsetLeft, t.removeChild(S)), x = t.style.cssText, t.style.cssText = "display:none;"; t.firstChild;) t.removeChild(t.firstChild);
            for (_ = " " === z && (!U || !q && !B), c = 0; c < H.length; c++) {
                for (g = H[c], (S = r.createElement(F)).style.cssText = "display:block;text-align:" + L + ";position:" + (U ? "absolute;" : "relative;"), W && (S.className = W + (X ? c + 1 : "")), $.push(S), h = g.length, d = 0; h > d; d++) "BR" !== g[d].nodeName && (p = g[d], S.appendChild(p), _ && p._wordEnd && S.appendChild(r.createTextNode(" ")), U && (0 === d && (S.style.top = p._y + "px", S.style.left = E + k + "px"), p.style.top = "0px", k && (p.style.left = p._x - k + "px")));
                0 === h ? S.innerHTML = "&nbsp;" : q || B || (w(S), y(S, String.fromCharCode(160), " ")), U && (S.style.width = T, S.style.height = p._h + "px"), t.appendChild(S)
            }
            t.style.cssText = x
        }
        U && (u > t.clientHeight && (t.style.height = u - O + "px", t.clientHeight < u && (t.style.height = u + D + "px")), l > t.clientWidth && (t.style.width = l - I + "px", t.clientWidth < l && (t.style.width = l + P + "px"))), v(n, j), v(i, N), v(s, $)
    },
    S = function(t, e, n, o) {
        var s, a, l, f, m, g, v, _, b, w = e.span ? "span" : "div",
            x = -1 !== (e.type || e.split || "chars,words,lines").indexOf("chars"),
            S = "absolute" === e.position || !0 === e.absolute,
            T = e.wordDelimiter || " ",
            k = " " !== T ? "" : S ? "&#173; " : " ",
            C = e.span ? "</span>" : "</div>",
            E = !0,
            A = r.createElement("div"),
            D = t.parentNode;
        for (D.insertBefore(A, t), A.textContent = t.nodeValue, D.removeChild(t), v = -1 !== (s = i(t = A)).indexOf("<"), !1 !== e.reduceWhiteSpace && (s = s.replace(c, " ").replace(u, "")), v && (s = s.split("<").join("{{LT}}")), m = s.length, a = (" " === s.charAt(0) ? k : "") + n(), l = 0; m > l; l++)
            if ((g = s.charAt(l)) === T && s.charAt(l - 1) !== T && l) {
                for (a += E ? C : "", E = !1; s.charAt(l + 1) === T;) a += k, l++;
                l === m - 1 ? a += k : ")" !== s.charAt(l + 1) && (a += k + n(), E = !0)
            } else "{" === g && "{{LT}}" === s.substr(l, 6) ? (a += x ? o() + "{{LT}}</" + w + ">" : "{{LT}}", l += 5) : g.charCodeAt(0) >= 55296 && g.charCodeAt(0) <= 56319 || s.charCodeAt(l + 1) >= 65024 && s.charCodeAt(l + 1) <= 65039 ? (_ = p(s.substr(l, 2)), b = p(s.substr(l + 2, 2)), f = (d > _ || _ > h || d > b || b > h) && (127995 > b || b > 127999) ? 2 : 4, a += x && " " !== g ? o() + s.substr(l, f) + "</" + w + ">" : s.substr(l, f), l += f - 1) : a += x && " " !== g ? o() + g + "</" + w + ">" : g;
        t.outerHTML = a + (E ? C : ""), v && y(D, "{{LT}}", "<")
    },
    T = function(t, e, n, i) {
        var r, o, s = _(t.childNodes),
            l = s.length,
            u = "absolute" === e.position || !0 === e.absolute;
        if (3 !== t.nodeType || l > 1) {
            for (e.absolute = !1, r = 0; l > r; r++)(3 !== (o = s[r]).nodeType || /\S+/.test(o.nodeValue)) && (u && 3 !== o.nodeType && "inline" === a(o, "display", null, !0) && (o.style.display = "inline-block", o.style.position = "relative"), o._isSplit = !0, T(o, e, n, i));
            return e.absolute = u, void(t._isSplit = !0)
        }
        S(t, e, n, i)
    },
    k = g.prototype;
k.split = function(t) {
    this.isSplit && this.revert(), this.vars = t = t || this.vars, this._originals.length = this.chars.length = this.words.length = this.lines.length = 0;
    for (var e, n, i, r = this.elements.length, o = t.span ? "span" : "div", s = m(t.wordsClass, o), a = m(t.charsClass, o); --r > -1;) i = this.elements[r], this._originals[r] = i.innerHTML, e = i.clientHeight, n = i.clientWidth, T(i, t, s, a), x(i, t, this.chars, this.words, this.lines, n, e);
    return this.chars.reverse(), this.words.reverse(), this.lines.reverse(), this.isSplit = !0, this
}, k.revert = function() {
    if (!this._originals) throw "revert() call wasn't scoped properly.";
    for (var t = this._originals.length; --t > -1;) this.elements[t].innerHTML = this._originals[t];
    return this.chars = [], this.words = [], this.lines = [], this.isSplit = !1, this
}, g.selector = t.$ || t.jQuery || function(e) {
    var n = t.$ || t.jQuery;
    return n ? (g.selector = n, n(e)) : "undefined" == typeof document ? e : document.querySelectorAll ? document.querySelectorAll(e) : document.getElementById("#" === e.charAt(0) ? e.substr(1) : e)
}, g.version = "0.5.8"
}(_gsScope),
function(t) {
"use strict";
var e = function() {
    return (_gsScope.GreenSockGlobals || _gsScope).SplitText
};
"undefined" != typeof module && module.exports ? module.exports = e() : "function" == typeof define && define.amd && define([], e)
}(),
function(t, e, n) {
"use strict";

function i(n) {
    if (r = e.documentElement, o = e.body, q(), it = this, lt = (n = n || {}).constants || {}, n.easing)
        for (var i in n.easing) W[i] = n.easing[i];
    mt = n.edgeStrategy || "set", st = {
        beforerender: n.beforerender,
        render: n.render,
        keyframe: n.keyframe
    }, (at = !1 !== n.forceHeight) && (It = n.scale || 1), ut = n.mobileDeceleration || S, dt = !1 !== n.smoothScrolling, ht = n.smoothScrollingDuration || k, pt = {
        targetTop: it.getScrollTop()
    }, (Rt = (n.mobileCheck || function() {
        return /Android|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent || navigator.vendor || t.opera)
    })()) ? ((ot = e.getElementById(n.skrollrBody || T)) && nt(), X(), Ct(r, [v, w], [_])) : Ct(r, [v, b], [_]), it.refresh(), vt(t, "resize orientationchange", function() {
        var t = r.clientWidth,
            e = r.clientHeight;
        (e !== $t || t !== Nt) && ($t = e, Nt = t, zt = !0)
    });
    var s = B();
    return function t() {
        Z(), yt = s(t)
    }(), it
}
var r, o, s = {
        get: function() {
            return it
        },
        init: function(t) {
            return it || new i(t)
        },
        VERSION: "0.6.29"
    },
    a = Object.prototype.hasOwnProperty,
    l = t.Math,
    u = t.getComputedStyle,
    c = "touchstart",
    d = "touchmove",
    h = "touchcancel",
    p = "touchend",
    f = "skrollable",
    m = f + "-before",
    g = f + "-between",
    y = f + "-after",
    v = "skrollr",
    _ = "no-" + v,
    b = v + "-desktop",
    w = v + "-mobile",
    x = "linear",
    S = .004,
    T = "skrollr-body",
    k = 200,
    C = "center",
    E = "bottom",
    A = "___skrollable_id",
    D = /^(?:input|textarea|button|select)$/i,
    P = /^\s+|\s+$/g,
    O = /^data(?:-(_\w+))?(?:-?(-?\d*\.?\d+p?))?(?:-?(start|end|top|center|bottom))?(?:-?(top|center|bottom))?$/,
    I = /\s*(@?[\w\-\[\]]+)\s*:\s*(.+?)\s*(?:;|$)/gi,
    M = /^(@?[a-z\-]+)\[(\w+)\]$/,
    L = /-([a-z0-9_])/g,
    j = function(t, e) {
        return e.toUpperCase()
    },
    N = /[\-+]?[\d]*\.?[\d]+/g,
    $ = /\{\?\}/g,
    z = /rgba?\(\s*-?\d+\s*,\s*-?\d+\s*,\s*-?\d+/g,
    F = /[a-z\-]+-gradient/g,
    R = "",
    H = "",
    q = function() {
        var t = /^(?:O|Moz|webkit|ms)|(?:-(?:o|moz|webkit|ms)-)/;
        if (u) {
            var e = u(o, null);
            for (var n in e)
                if (R = n.match(t) || +n == n && e[n].match(t)) break;
            if (!R) return void(R = H = "");
            "-" === (R = R[0]).slice(0, 1) ? (H = R, R = {
                "-webkit-": "webkit",
                "-moz-": "Moz",
                "-ms-": "ms",
                "-o-": "O"
            } [R]) : H = "-" + R.toLowerCase() + "-"
        }
    },
    B = function() {
        var e = t.requestAnimationFrame || t[R.toLowerCase() + "RequestAnimationFrame"],
            n = Dt();
        return (Rt || !e) && (e = function(e) {
            var i = Dt() - n,
                r = l.max(0, 1e3 / 60 - i);
            return t.setTimeout(function() {
                n = Dt(), e()
            }, r)
        }), e
    },
    U = function() {
        var e = t.cancelAnimationFrame || t[R.toLowerCase() + "CancelAnimationFrame"];
        return (Rt || !e) && (e = function(e) {
            return t.clearTimeout(e)
        }), e
    },
    W = {
        begin: function() {
            return 0
        },
        end: function() {
            return 1
        },
        linear: function(t) {
            return t
        },
        quadratic: function(t) {
            return t * t
        },
        cubic: function(t) {
            return t * t * t
        },
        swing: function(t) {
            return -l.cos(t * l.PI) / 2 + .5
        },
        sqrt: function(t) {
            return l.sqrt(t)
        },
        outCubic: function(t) {
            return l.pow(t - 1, 3) + 1
        },
        bounce: function(t) {
            var e;
            if (.5083 >= t) e = 3;
            else if (.8489 >= t) e = 9;
            else if (.96208 >= t) e = 27;
            else {
                if (!(.99981 >= t)) return 1;
                e = 91
            }
            return 1 - l.abs(3 * l.cos(t * e * 1.028) / e)
        }
    };
i.prototype.refresh = function(t) {
    var i, r, o = !1;
    for (t === n ? (o = !0, rt = [], Ft = 0, t = e.getElementsByTagName("*")) : t.length === n && (t = [t]), i = 0, r = t.length; r > i; i++) {
        var s = t[i],
            a = s,
            l = [],
            u = dt,
            c = mt,
            d = !1;
        if (o && A in s && delete s[A], s.attributes) {
            for (var h = 0, p = s.attributes.length; p > h; h++) {
                var m = s.attributes[h];
                if ("data-anchor-target" !== m.name)
                    if ("data-smooth-scrolling" !== m.name)
                        if ("data-edge-strategy" !== m.name)
                            if ("data-emit-events" !== m.name) {
                                var g = m.name.match(O);
                                if (null !== g) {
                                    var y = {
                                        props: m.value,
                                        element: s,
                                        eventType: m.name.replace(L, j)
                                    };
                                    l.push(y);
                                    var v = g[1];
                                    v && (y.constant = v.substr(1));
                                    var _ = g[2];
                                    /p$/.test(_) ? (y.isPercentage = !0, y.offset = (0 | _.slice(0, -1)) / 100) : y.offset = 0 | _;
                                    var b = g[3],
                                        w = g[4] || b;
                                    b && "start" !== b && "end" !== b ? (y.mode = "relative", y.anchors = [b, w]) : (y.mode = "absolute", "end" === b ? y.isEnd = !0 : y.isPercentage || (y.offset = y.offset * It))
                                }
                            } else d = !0;
                else c = m.value;
                else u = "off" !== m.value;
                else if (null === (a = e.querySelector(m.value))) throw 'Unable to find anchor target "' + m.value + '"'
            }
            var x, S, T;
            if (l.length) !o && A in s ? (T = s[A], x = rt[T].styleAttr, S = rt[T].classAttr) : (T = s[A] = Ft++, x = s.style.cssText, S = kt(s)), rt[T] = {
                element: s,
                styleAttr: x,
                classAttr: S,
                anchorTarget: a,
                keyFrames: l,
                smoothScrolling: u,
                edgeStrategy: c,
                emitEvents: d,
                lastFrameIndex: -1
            }, Ct(s, [f], [])
        }
    }
    for (xt(), i = 0, r = t.length; r > i; i++) {
        var k = rt[t[i][A]];
        k !== n && (V(k), Q(k))
    }
    return it
}, i.prototype.relativeToAbsolute = function(t, e, n) {
    var i = r.clientHeight,
        o = t.getBoundingClientRect(),
        s = o.top,
        a = o.bottom - o.top;
    return e === E ? s -= i : e === C && (s -= i / 2), n === E ? s += a : n === C && (s += a / 2), (s += it.getScrollTop()) + .5 | 0
}, i.prototype.animateTo = function(t, e) {
    e = e || {};
    var i = Dt(),
        r = it.getScrollTop(),
        o = e.duration === n ? 1e3 : e.duration;
    return (ct = {
        startTop: r,
        topDiff: t - r,
        targetTop: t,
        duration: o,
        startTime: i,
        endTime: i + o,
        easing: W[e.easing || x],
        done: e.done
    }).topDiff || (ct.done && ct.done.call(it, !1), ct = n), it
}, i.prototype.stopAnimateTo = function() {
    ct && ct.done && ct.done.call(it, !0), ct = n
}, i.prototype.isAnimatingTo = function() {
    return !!ct
}, i.prototype.isMobile = function() {
    return Rt
}, i.prototype.setScrollTop = function(e, n) {
    return ft = !0 === n, Rt ? Ht = l.min(l.max(e, 0), Ot) : t.scrollTo(0, e), it
}, i.prototype.getScrollTop = function() {
    return Rt ? Ht : t.pageYOffset || r.scrollTop || o.scrollTop || 0
}, i.prototype.getMaxScrollTop = function() {
    return Ot
}, i.prototype.on = function(t, e) {
    return st[t] = e, it
}, i.prototype.off = function(t) {
    return delete st[t], it
}, i.prototype.destroy = function() {
    U()(yt), bt(), Ct(r, [_], [v, b, w]);
    for (var t = 0, e = rt.length; e > t; t++) et(rt[t].element);
    r.style.overflow = o.style.overflow = "", r.style.height = o.style.height = "", ot && s.setStyle(ot, "transform", "none"), it = n, ot = n, st = n, at = n, Ot = 0, It = 1, lt = n, ut = n, Mt = "down", Lt = -1, Nt = 0, $t = 0, zt = !1, ct = n, dt = n, ht = n, pt = n, ft = n, Ft = 0, mt = n, Rt = !1, Ht = 0, gt = n
};
var X = function() {
        var i, s, a, u, f, m, g, y, v, _, b;
        vt(r, [c, d, h, p].join(" "), function(t) {
            var r = t.changedTouches[0];
            for (u = t.target; 3 === u.nodeType;) u = u.parentNode;
            switch (f = r.clientY, m = r.clientX, v = t.timeStamp, D.test(u.tagName) || t.preventDefault(), t.type) {
                case c:
                    i && i.blur(), it.stopAnimateTo(), i = u, s = g = f, a = m, v;
                    break;
                case d:
                    D.test(u.tagName) && e.activeElement !== u && t.preventDefault(), y = f - g, b = v - _, it.setScrollTop(Ht - y, !0), g = f, _ = v;
                    break;
                default:
                case h:
                case p:
                    var o = s - f,
                        w = a - m;
                    if (49 > w * w + o * o) {
                        if (!D.test(i.tagName)) {
                            i.focus();
                            var x = e.createEvent("MouseEvents");
                            x.initMouseEvent("click", !0, !0, t.view, 1, r.screenX, r.screenY, r.clientX, r.clientY, t.ctrlKey, t.altKey, t.shiftKey, t.metaKey, 0, null), i.dispatchEvent(x)
                        }
                        return
                    }
                    i = n;
                    var S = y / b;
                    S = l.max(l.min(S, 3), -3);
                    var T = l.abs(S / ut),
                        k = S * T + .5 * ut * T * T,
                        C = it.getScrollTop() - k,
                        E = 0;
                    C > Ot ? (E = (Ot - C) / k, C = Ot) : 0 > C && (E = -C / k, C = 0), T *= 1 - E, it.animateTo(C + .5 | 0, {
                        easing: "outCubic",
                        duration: T
                    })
            }
        }), t.scrollTo(0, 0), r.style.overflow = o.style.overflow = "hidden"
    },
    Y = function(t, e) {
        for (var n = 0, i = rt.length; i > n; n++) {
            var r, o, l = rt[n],
                u = l.element,
                c = l.smoothScrolling ? t : e,
                d = l.keyFrames,
                h = d.length,
                p = d[0],
                v = d[d.length - 1],
                _ = c < p.frame,
                b = c > v.frame,
                w = _ ? p : v,
                x = l.emitEvents,
                S = l.lastFrameIndex;
            if (_ || b) {
                if (_ && -1 === l.edge || b && 1 === l.edge) continue;
                switch (_ ? (Ct(u, [m], [y, g]), x && S > -1 && (wt(u, p.eventType, Mt), l.lastFrameIndex = -1)) : (Ct(u, [y], [m, g]), x && h > S && (wt(u, v.eventType, Mt), l.lastFrameIndex = h)), l.edge = _ ? -1 : 1, l.edgeStrategy) {
                    case "reset":
                        et(u);
                        continue;
                    case "ease":
                        c = w.frame;
                        break;
                    default:
                    case "set":
                        var T = w.props;
                        for (r in T) a.call(T, r) && (o = tt(T[r].value), 0 === r.indexOf("@") ? u.setAttribute(r.substr(1), o) : s.setStyle(u, r, o));
                        continue
                }
            } else 0 !== l.edge && (Ct(u, [f, g], [m, y]), l.edge = 0);
            for (var k = 0; h - 1 > k; k++)
                if (c >= d[k].frame && c <= d[k + 1].frame) {
                    var C = d[k],
                        E = d[k + 1];
                    for (r in C.props)
                        if (a.call(C.props, r)) {
                            var A = (c - C.frame) / (E.frame - C.frame);
                            A = C.props[r].easing(A), o = J(C.props[r].value, E.props[r].value, A), o = tt(o), 0 === r.indexOf("@") ? u.setAttribute(r.substr(1), o) : s.setStyle(u, r, o)
                        } x && S !== k && (wt(u, "down" === Mt ? C.eventType : E.eventType, Mt), l.lastFrameIndex = k);
                    break
                }
        }
    },
    Z = function() {
        zt && (zt = !1, xt());
        var t, e, i = it.getScrollTop(),
            r = Dt();
        if (ct) r >= ct.endTime ? (i = ct.targetTop, t = ct.done, ct = n) : (e = ct.easing((r - ct.startTime) / ct.duration), i = ct.startTop + e * ct.topDiff | 0), it.setScrollTop(i, !0);
        else if (!ft) {
            pt.targetTop - i && (pt = {
                startTop: Lt,
                topDiff: i - Lt,
                targetTop: i,
                startTime: jt,
                endTime: jt + ht
            }), r <= pt.endTime && (e = W.sqrt((r - pt.startTime) / ht), i = pt.startTop + e * pt.topDiff | 0)
        }
        if (ft || Lt !== i) {
            ft = !1;
            var o = {
                curTop: i,
                lastTop: Lt,
                maxTop: Ot,
                direction: Mt = i > Lt ? "down" : Lt > i ? "up" : Mt
            };
            !1 !== (st.beforerender && st.beforerender.call(it, o)) && (Y(i, it.getScrollTop()), Rt && ot && s.setStyle(ot, "transform", "translate(0, " + -Ht + "px) " + gt), Lt = i, st.render && st.render.call(it, o)), t && t.call(it, !1)
        }
        jt = r
    },
    V = function(t) {
        for (var e = 0, n = t.keyFrames.length; n > e; e++) {
            for (var i, r, o, s, a = t.keyFrames[e], l = {}; null !== (s = I.exec(a.props));) o = s[1], r = s[2], null !== (i = o.match(M)) ? (o = i[1], i = i[2]) : i = x, r = r.indexOf("!") ? G(r) : [r.slice(1)], l[o] = {
                value: r,
                easing: W[i]
            };
            a.props = l
        }
    },
    G = function(t) {
        var e = [];
        return z.lastIndex = 0, t = t.replace(z, function(t) {
            return t.replace(N, function(t) {
                return t / 255 * 100 + "%"
            })
        }), H && (F.lastIndex = 0, t = t.replace(F, function(t) {
            return H + t
        })), t = t.replace(N, function(t) {
            return e.push(+t), "{?}"
        }), e.unshift(t), e
    },
    Q = function(t) {
        var e, n, i = {};
        for (e = 0, n = t.keyFrames.length; n > e; e++) K(t.keyFrames[e], i);
        for (i = {}, e = t.keyFrames.length - 1; e >= 0; e--) K(t.keyFrames[e], i)
    },
    K = function(t, e) {
        var n;
        for (n in e) a.call(t.props, n) || (t.props[n] = e[n]);
        for (n in t.props) e[n] = t.props[n]
    },
    J = function(t, e, n) {
        var i, r = t.length;
        if (r !== e.length) throw "Can't interpolate between \"" + t[0] + '" and "' + e[0] + '"';
        var o = [t[0]];
        for (i = 1; r > i; i++) o[i] = t[i] + (e[i] - t[i]) * n;
        return o
    },
    tt = function(t) {
        var e = 1;
        return $.lastIndex = 0, t[0].replace($, function() {
            return t[e++]
        })
    },
    et = function(t, e) {
        for (var n, i, r = 0, o = (t = [].concat(t)).length; o > r; r++) i = t[r], (n = rt[i[A]]) && (e ? (i.style.cssText = n.dirtyStyleAttr, Ct(i, n.dirtyClassAttr)) : (n.dirtyStyleAttr = i.style.cssText, n.dirtyClassAttr = kt(i), i.style.cssText = n.styleAttr, Ct(i, n.classAttr)))
    },
    nt = function() {
        gt = "translateZ(0)", s.setStyle(ot, "transform", gt);
        var t = u(ot),
            e = t.getPropertyValue("transform"),
            n = t.getPropertyValue(H + "transform");
        e && "none" !== e || n && "none" !== n || (gt = "")
    };
s.setStyle = function(t, e, n) {
    var i = t.style;
    if ("zIndex" === (e = e.replace(L, j).replace("-", ""))) isNaN(n) ? i[e] = n : i[e] = "" + (0 | n);
    else if ("float" === e) i.styleFloat = i.cssFloat = n;
    else try {
        R && (i[R + e.slice(0, 1).toUpperCase() + e.slice(1)] = n), i[e] = n
    } catch (t) {}
};
var it, rt, ot, st, at, lt, ut, ct, dt, ht, pt, ft, mt, gt, yt, vt = s.addEvent = function(e, n, i) {
        for (var r, o = function(e) {
                return (e = e || t.event).target || (e.target = e.srcElement), e.preventDefault || (e.preventDefault = function() {
                    e.returnValue = !1, e.defaultPrevented = !0
                }), i.call(this, e)
            }, s = 0, a = (n = n.split(" ")).length; a > s; s++) r = n[s], e.addEventListener ? e.addEventListener(r, i, !1) : e.attachEvent("on" + r, o), qt.push({
            element: e,
            name: r,
            listener: i
        })
    },
    _t = s.removeEvent = function(t, e, n) {
        for (var i = 0, r = (e = e.split(" ")).length; r > i; i++) t.removeEventListener ? t.removeEventListener(e[i], n, !1) : t.detachEvent("on" + e[i], n)
    },
    bt = function() {
        for (var t, e = 0, n = qt.length; n > e; e++) t = qt[e], _t(t.element, t.name, t.listener);
        qt = []
    },
    wt = function(t, e, n) {
        st.keyframe && st.keyframe.call(it, t, e, n)
    },
    xt = function() {
        var t = it.getScrollTop();
        Ot = 0, at && !Rt && (o.style.height = ""),
            function() {
                var t, e, n, i, o, s, a, u, c, d, h, p = r.clientHeight,
                    f = St();
                for (u = 0, c = rt.length; c > u; u++)
                    for (e = (t = rt[u]).element, n = t.anchorTarget, o = 0, s = (i = t.keyFrames).length; s > o; o++) d = (a = i[o]).offset, h = f[a.constant] || 0, a.frame = d, a.isPercentage && (d *= p, a.frame = d), "relative" === a.mode && (et(e), a.frame = it.relativeToAbsolute(n, a.anchors[0], a.anchors[1]) - d, et(e, !0)), a.frame += h, at && !a.isEnd && a.frame > Ot && (Ot = a.frame);
                for (Ot = l.max(Ot, Tt()), u = 0, c = rt.length; c > u; u++) {
                    for (o = 0, s = (i = (t = rt[u]).keyFrames).length; s > o; o++) h = f[(a = i[o]).constant] || 0, a.isEnd && (a.frame = Ot - a.offset + h);
                    t.keyFrames.sort(Pt)
                }
            }(), at && !Rt && (o.style.height = Ot + r.clientHeight + "px"), Rt ? it.setScrollTop(l.min(it.getScrollTop(), Ot)) : it.setScrollTop(t, !0), ft = !0
    },
    St = function() {
        var t, e, n = r.clientHeight,
            i = {};
        for (t in lt) "function" == typeof(e = lt[t]) ? e = e.call(it) : /p$/.test(e) && (e = e.slice(0, -1) / 100 * n), i[t] = e;
        return i
    },
    Tt = function() {
        var t = 0;
        return ot && (t = l.max(ot.offsetHeight, ot.scrollHeight)), l.max(t, o.scrollHeight, o.offsetHeight, r.scrollHeight, r.offsetHeight, r.clientHeight) - r.clientHeight
    },
    kt = function(e) {
        var n = "className";
        return t.SVGElement && e instanceof t.SVGElement && (e = e[n], n = "baseVal"), e[n]
    },
    Ct = function(e, i, r) {
        var o = "className";
        if (t.SVGElement && e instanceof t.SVGElement && (e = e[o], o = "baseVal"), r !== n) {
            for (var s = e[o], a = 0, l = r.length; l > a; a++) s = At(s).replace(At(r[a]), " ");
            s = Et(s);
            for (var u = 0, c = i.length; c > u; u++) - 1 === At(s).indexOf(At(i[u])) && (s += " " + i[u]);
            e[o] = Et(s)
        } else e[o] = i
    },
    Et = function(t) {
        return t.replace(P, "")
    },
    At = function(t) {
        return " " + t + " "
    },
    Dt = Date.now || function() {
        return +new Date
    },
    Pt = function(t, e) {
        return t.frame - e.frame
    },
    Ot = 0,
    It = 1,
    Mt = "down",
    Lt = -1,
    jt = Dt(),
    Nt = 0,
    $t = 0,
    zt = !1,
    Ft = 0,
    Rt = !1,
    Ht = 0,
    qt = [];
"function" == typeof define && define.amd ? define([], function() {
    return s
}) : "undefined" != typeof module && module.exports ? module.exports = s : t.skrollr = s
}(window, document);